webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _buyerAddresses = __webpack_require__(24);

var _buyerAddresses2 = _interopRequireDefault(_buyerAddresses);

var _buyerSpecialPricings = __webpack_require__(25);

var _buyerSpecialPricings2 = _interopRequireDefault(_buyerSpecialPricings);

var _companyCommonWords = __webpack_require__(26);

var _companyCommonWords2 = _interopRequireDefault(_companyCommonWords);

var _demandCreateEdit = __webpack_require__(27);

var _demandCreateEdit2 = _interopRequireDefault(_demandCreateEdit);

var _demandManage = __webpack_require__(28);

var _demandManage2 = _interopRequireDefault(_demandManage);

var _faqManage = __webpack_require__(29);

var _faqManage2 = _interopRequireDefault(_faqManage);

var _itemDialog = __webpack_require__(30);

var _itemDialog2 = _interopRequireDefault(_itemDialog);

var _messageCenter = __webpack_require__(31);

var _messageCenter2 = _interopRequireDefault(_messageCenter);

var _offerActivatePriceDialog = __webpack_require__(44);

var _offerActivatePriceDialog2 = _interopRequireDefault(_offerActivatePriceDialog);

var _offerCampaignAttachments = __webpack_require__(45);

var _offerCampaignAttachments2 = _interopRequireDefault(_offerCampaignAttachments);

var _offerCampaignBasicInfos = __webpack_require__(46);

var _offerCampaignBasicInfos2 = _interopRequireDefault(_offerCampaignBasicInfos);

var _offerCampaignCreateDialog = __webpack_require__(47);

var _offerCampaignCreateDialog2 = _interopRequireDefault(_offerCampaignCreateDialog);

var _offerCampaignCreate = __webpack_require__(48);

var _offerCampaignCreate2 = _interopRequireDefault(_offerCampaignCreate);

var _offerCampaignFields = __webpack_require__(49);

var _offerCampaignFields2 = _interopRequireDefault(_offerCampaignFields);

var _offerCampaignMassSendDialog = __webpack_require__(50);

var _offerCampaignMassSendDialog2 = _interopRequireDefault(_offerCampaignMassSendDialog);

var _offerCampaignMassSendReport = __webpack_require__(51);

var _offerCampaignMassSendReport2 = _interopRequireDefault(_offerCampaignMassSendReport);

var _offerStocklistMassUpdateDialog = __webpack_require__(87);

var _offerStocklistMassUpdateDialog2 = _interopRequireDefault(_offerStocklistMassUpdateDialog);

var _offerCampaignProductSpec = __webpack_require__(52);

var _offerCampaignProductSpec2 = _interopRequireDefault(_offerCampaignProductSpec);

var _offerCampaignRecipientAttachmentsDialog = __webpack_require__(53);

var _offerCampaignRecipientAttachmentsDialog2 = _interopRequireDefault(_offerCampaignRecipientAttachmentsDialog);

var _offerCampaignRecipientsDialog = __webpack_require__(54);

var _offerCampaignRecipientsDialog2 = _interopRequireDefault(_offerCampaignRecipientsDialog);

var _offerCampaignRecipientsPendingGeneral = __webpack_require__(55);

var _offerCampaignRecipientsPendingGeneral2 = _interopRequireDefault(_offerCampaignRecipientsPendingGeneral);

var _offerCampaignRecipientsPendingSpecial = __webpack_require__(56);

var _offerCampaignRecipientsPendingSpecial2 = _interopRequireDefault(_offerCampaignRecipientsPendingSpecial);

var _offerCampaignRecipientsSent = __webpack_require__(57);

var _offerCampaignRecipientsSent2 = _interopRequireDefault(_offerCampaignRecipientsSent);

var _offerCampaignRecipients = __webpack_require__(58);

var _offerCampaignRecipients2 = _interopRequireDefault(_offerCampaignRecipients);

var _offerCampaignSettings = __webpack_require__(59);

var _offerCampaignSettings2 = _interopRequireDefault(_offerCampaignSettings);

var _offerCampaign = __webpack_require__(60);

var _offerCampaign2 = _interopRequireDefault(_offerCampaign);

var _offerCampaigns = __webpack_require__(61);

var _offerCampaigns2 = _interopRequireDefault(_offerCampaigns);

var _offerCharges = __webpack_require__(62);

var _offerCharges2 = _interopRequireDefault(_offerCharges);

var _offerConnectionsItem = __webpack_require__(63);

var _offerConnectionsItem2 = _interopRequireDefault(_offerConnectionsItem);

var _offerConnections = __webpack_require__(64);

var _offerConnections2 = _interopRequireDefault(_offerConnections);

var _offerCreate = __webpack_require__(65);

var _offerCreate2 = _interopRequireDefault(_offerCreate);

var _offerEditCampaigns = __webpack_require__(67);

var _offerEditCampaigns2 = _interopRequireDefault(_offerEditCampaigns);

var _offerEdit = __webpack_require__(68);

var _offerEdit2 = _interopRequireDefault(_offerEdit);

var _offerInventories = __webpack_require__(69);

var _offerInventories2 = _interopRequireDefault(_offerInventories);

var _offerMainBasic = __webpack_require__(70);

var _offerMainBasic2 = _interopRequireDefault(_offerMainBasic);

var _offerMainDescription = __webpack_require__(71);

var _offerMainDescription2 = _interopRequireDefault(_offerMainDescription);

var _offerMainTitle = __webpack_require__(72);

var _offerMainTitle2 = _interopRequireDefault(_offerMainTitle);

var _offerMarketRestrictions = __webpack_require__(73);

var _offerMarketRestrictions2 = _interopRequireDefault(_offerMarketRestrictions);

var _offerMatchingAnalysis = __webpack_require__(74);

var _offerMatchingAnalysis2 = _interopRequireDefault(_offerMatchingAnalysis);

var _offerCutAnalysis = __webpack_require__(66);

var _offerCutAnalysis2 = _interopRequireDefault(_offerCutAnalysis);

var _offerMatchingCriteria = __webpack_require__(75);

var _offerMatchingCriteria2 = _interopRequireDefault(_offerMatchingCriteria);

var _offerMatching = __webpack_require__(76);

var _offerMatching2 = _interopRequireDefault(_offerMatching);

var _offerOsppUsers = __webpack_require__(77);

var _offerOsppUsers2 = _interopRequireDefault(_offerOsppUsers);

var _offerRequestCreate = __webpack_require__(78);

var _offerRequestCreate2 = _interopRequireDefault(_offerRequestCreate);

var _offerRequestItemDialog = __webpack_require__(79);

var _offerRequestItemDialog2 = _interopRequireDefault(_offerRequestItemDialog);

var _offerRequestItemTabs = __webpack_require__(80);

var _offerRequestItemTabs2 = _interopRequireDefault(_offerRequestItemTabs);

var _offerRequestItems = __webpack_require__(81);

var _offerRequestItems2 = _interopRequireDefault(_offerRequestItems);

var _offerRequests = __webpack_require__(82);

var _offerRequests2 = _interopRequireDefault(_offerRequests);

var _offerSectionMenu = __webpack_require__(83);

var _offerSectionMenu2 = _interopRequireDefault(_offerSectionMenu);

var _offerSidebarMenu = __webpack_require__(84);

var _offerSidebarMenu2 = _interopRequireDefault(_offerSidebarMenu);

var _offerStockItemPriceDialog = __webpack_require__(85);

var _offerStockItemPriceDialog2 = _interopRequireDefault(_offerStockItemPriceDialog);

var _offerStocklistCriteria = __webpack_require__(86);

var _offerStocklistCriteria2 = _interopRequireDefault(_offerStocklistCriteria);

var _offerStocklist = __webpack_require__(88);

var _offerStocklist2 = _interopRequireDefault(_offerStocklist);

var _offerSupplierPricing = __webpack_require__(89);

var _offerSupplierPricing2 = _interopRequireDefault(_offerSupplierPricing);

var _offerUpload = __webpack_require__(90);

var _offerUpload2 = _interopRequireDefault(_offerUpload);

var _offers = __webpack_require__(91);

var _offers2 = _interopRequireDefault(_offers);

var _orderArrivals = __webpack_require__(92);

var _orderArrivals2 = _interopRequireDefault(_orderArrivals);

var _orderAttachments = __webpack_require__(93);

var _orderAttachments2 = _interopRequireDefault(_orderAttachments);

var _orderBookingNoteNotifications = __webpack_require__(94);

var _orderBookingNoteNotifications2 = _interopRequireDefault(_orderBookingNoteNotifications);

var _orderBookingNotes = __webpack_require__(95);

var _orderBookingNotes2 = _interopRequireDefault(_orderBookingNotes);

var _orderBuyerDetails = __webpack_require__(96);

var _orderBuyerDetails2 = _interopRequireDefault(_orderBuyerDetails);

var _orderCreate = __webpack_require__(97);

var _orderCreate2 = _interopRequireDefault(_orderCreate);

var _orderDeliveryGeneral = __webpack_require__(98);

var _orderDeliveryGeneral2 = _interopRequireDefault(_orderDeliveryGeneral);

var _orderDocumentsContacts = __webpack_require__(99);

var _orderDocumentsContacts2 = _interopRequireDefault(_orderDocumentsContacts);

var _orderDocuments = __webpack_require__(100);

var _orderDocuments2 = _interopRequireDefault(_orderDocuments);

var _orderMainDocs = __webpack_require__(101);

var _orderMainDocs2 = _interopRequireDefault(_orderMainDocs);

var _orderMainInfos = __webpack_require__(102);

var _orderMainInfos2 = _interopRequireDefault(_orderMainInfos);

var _orderManage = __webpack_require__(103);

var _orderManage2 = _interopRequireDefault(_orderManage);

var _orderNotifications = __webpack_require__(104);

var _orderNotifications2 = _interopRequireDefault(_orderNotifications);

var _orderOverview = __webpack_require__(105);

var _orderOverview2 = _interopRequireDefault(_orderOverview);

var _orderPaymentGeneral = __webpack_require__(106);

var _orderPaymentGeneral2 = _interopRequireDefault(_orderPaymentGeneral);

var _orderPayments = __webpack_require__(107);

var _orderPayments2 = _interopRequireDefault(_orderPayments);

var _orderSellerDetails = __webpack_require__(108);

var _orderSellerDetails2 = _interopRequireDefault(_orderSellerDetails);

var _orderSidebar = __webpack_require__(109);

var _orderSidebar2 = _interopRequireDefault(_orderSidebar);

var _orderStocklist = __webpack_require__(110);

var _orderStocklist2 = _interopRequireDefault(_orderStocklist);

var _orderUpload = __webpack_require__(111);

var _orderUpload2 = _interopRequireDefault(_orderUpload);

var _pendingImportCheck = __webpack_require__(112);

var _pendingImportCheck2 = _interopRequireDefault(_pendingImportCheck);

var _pendingRegistrationCheck = __webpack_require__(113);

var _pendingRegistrationCheck2 = _interopRequireDefault(_pendingRegistrationCheck);

var _pendingRegistrationView = __webpack_require__(114);

var _pendingRegistrationView2 = _interopRequireDefault(_pendingRegistrationView);

var _productBrands = __webpack_require__(115);

var _productBrands2 = _interopRequireDefault(_productBrands);

var _productCategoryGroupsDialog = __webpack_require__(116);

var _productCategoryGroupsDialog2 = _interopRequireDefault(_productCategoryGroupsDialog);

var _productCategorySpecsGroupsDialog = __webpack_require__(117);

var _productCategorySpecsGroupsDialog2 = _interopRequireDefault(_productCategorySpecsGroupsDialog);

var _productExport = __webpack_require__(122);

var _productExport2 = _interopRequireDefault(_productExport);

var _productGroupSpecRanges = __webpack_require__(123);

var _productGroupSpecRanges2 = _interopRequireDefault(_productGroupSpecRanges);

var _productGroupSpecsDialog = __webpack_require__(124);

var _productGroupSpecsDialog2 = _interopRequireDefault(_productGroupSpecsDialog);

var _productGroupSpecs = __webpack_require__(125);

var _productGroupSpecs2 = _interopRequireDefault(_productGroupSpecs);

var _productEndUsesAddDialog = __webpack_require__(118);

var _productEndUsesAddDialog2 = _interopRequireDefault(_productEndUsesAddDialog);

var _productEndUsesAdd = __webpack_require__(119);

var _productEndUsesAdd2 = _interopRequireDefault(_productEndUsesAdd);

var _productEndUsesManage = __webpack_require__(120);

var _productEndUsesManage2 = _interopRequireDefault(_productEndUsesManage);

var _productEndUses = __webpack_require__(121);

var _productEndUses2 = _interopRequireDefault(_productEndUses);

var _productGroups = __webpack_require__(126);

var _productGroups2 = _interopRequireDefault(_productGroups);

var _productImport = __webpack_require__(127);

var _productImport2 = _interopRequireDefault(_productImport);

var _productPriceGroup = __webpack_require__(128);

var _productPriceGroup2 = _interopRequireDefault(_productPriceGroup);

var _productPriceGroups = __webpack_require__(129);

var _productPriceGroups2 = _interopRequireDefault(_productPriceGroups);

var _stocklistSpecsEdit = __webpack_require__(130);

var _stocklistSpecsEdit2 = _interopRequireDefault(_stocklistSpecsEdit);

var _stocklistSpecs = __webpack_require__(131);

var _stocklistSpecs2 = _interopRequireDefault(_stocklistSpecs);

var _supplierProductPricings = __webpack_require__(132);

var _supplierProductPricings2 = _interopRequireDefault(_supplierProductPricings);

var _userAcceptablePaymentTerms = __webpack_require__(133);

var _userAcceptablePaymentTerms2 = _interopRequireDefault(_userAcceptablePaymentTerms);

var _userBuyerEdit = __webpack_require__(134);

var _userBuyerEdit2 = _interopRequireDefault(_userBuyerEdit);

var _userBuyerSectionMenu = __webpack_require__(135);

var _userBuyerSectionMenu2 = _interopRequireDefault(_userBuyerSectionMenu);

var _userBuyerSidebarMenu = __webpack_require__(136);

var _userBuyerSidebarMenu2 = _interopRequireDefault(_userBuyerSidebarMenu);

var _userContactNotificationsDialog = __webpack_require__(137);

var _userContactNotificationsDialog2 = _interopRequireDefault(_userContactNotificationsDialog);

var _userContacts = __webpack_require__(138);

var _userContacts2 = _interopRequireDefault(_userContacts);

var _userCountryCharges = __webpack_require__(139);

var _userCountryCharges2 = _interopRequireDefault(_userCountryCharges);

var _userCreate = __webpack_require__(140);

var _userCreate2 = _interopRequireDefault(_userCreate);

var _userDeliveryTerm = __webpack_require__(141);

var _userDeliveryTerm2 = _interopRequireDefault(_userDeliveryTerm);

var _userDeliveryTerms = __webpack_require__(142);

var _userDeliveryTerms2 = _interopRequireDefault(_userDeliveryTerms);

var _userDetails = __webpack_require__(143);

var _userDetails2 = _interopRequireDefault(_userDetails);

var _userEditCampaigns = __webpack_require__(144);

var _userEditCampaigns2 = _interopRequireDefault(_userEditCampaigns);

var _userExport = __webpack_require__(145);

var _userExport2 = _interopRequireDefault(_userExport);

var _userFaqs = __webpack_require__(146);

var _userFaqs2 = _interopRequireDefault(_userFaqs);

var _userFreightRatesExport = __webpack_require__(147);

var _userFreightRatesExport2 = _interopRequireDefault(_userFreightRatesExport);

var _userFreightRatesImport = __webpack_require__(148);

var _userFreightRatesImport2 = _interopRequireDefault(_userFreightRatesImport);

var _userFreightRates = __webpack_require__(149);

var _userFreightRates2 = _interopRequireDefault(_userFreightRates);

var _userImport = __webpack_require__(150);

var _userImport2 = _interopRequireDefault(_userImport);

var _userIncotermCharges = __webpack_require__(151);

var _userIncotermCharges2 = _interopRequireDefault(_userIncotermCharges);

var _userManageCities = __webpack_require__(152);

var _userManageCities2 = _interopRequireDefault(_userManageCities);

var _userManageCompanies = __webpack_require__(153);

var _userManageCompanies2 = _interopRequireDefault(_userManageCompanies);

var _userManageContacts = __webpack_require__(154);

var _userManageContacts2 = _interopRequireDefault(_userManageContacts);

var _userManageEmailHostnames = __webpack_require__(155);

var _userManageEmailHostnames2 = _interopRequireDefault(_userManageEmailHostnames);

var _userManageMembers = __webpack_require__(156);

var _userManageMembers2 = _interopRequireDefault(_userManageMembers);

var _userMarketRestrictions = __webpack_require__(157);

var _userMarketRestrictions2 = _interopRequireDefault(_userMarketRestrictions);

var _userRestrictedTo = __webpack_require__(182);

var _userRestrictedTo2 = _interopRequireDefault(_userRestrictedTo);

var _userOfferMatching = __webpack_require__(158);

var _userOfferMatching2 = _interopRequireDefault(_userOfferMatching);

var _userOfferRequestItems = __webpack_require__(159);

var _userOfferRequestItems2 = _interopRequireDefault(_userOfferRequestItems);

var _userOffers = __webpack_require__(160);

var _userOffers2 = _interopRequireDefault(_userOffers);

var _userOrders = __webpack_require__(161);

var _userOrders2 = _interopRequireDefault(_userOrders);

var _userOverview = __webpack_require__(162);

var _userOverview2 = _interopRequireDefault(_userOverview);

var _userProductBrandPricing = __webpack_require__(163);

var _userProductBrandPricing2 = _interopRequireDefault(_userProductBrandPricing);

var _userProductCopyFromUserDialog = __webpack_require__(164);

var _userProductCopyFromUserDialog2 = _interopRequireDefault(_userProductCopyFromUserDialog);

var _userProductCopySpecs = __webpack_require__(165);

var _userProductCopySpecs2 = _interopRequireDefault(_userProductCopySpecs);

var _userProductEditSpecs = __webpack_require__(166);

var _userProductEditSpecs2 = _interopRequireDefault(_userProductEditSpecs);

var _userProductEndUses = __webpack_require__(167);

var _userProductEndUses2 = _interopRequireDefault(_userProductEndUses);

var _userProductGroupCharges = __webpack_require__(168);

var _userProductGroupCharges2 = _interopRequireDefault(_userProductGroupCharges);

var _userProductGroupSettings = __webpack_require__(169);

var _userProductGroupSettings2 = _interopRequireDefault(_userProductGroupSettings);

var _userProductGroupSpecs = __webpack_require__(170);

var _userProductGroupSpecs2 = _interopRequireDefault(_userProductGroupSpecs);

var _userProductMassSpecs = __webpack_require__(171);

var _userProductMassSpecs2 = _interopRequireDefault(_userProductMassSpecs);

var _userProductPreview = __webpack_require__(172);

var _userProductPreview2 = _interopRequireDefault(_userProductPreview);

var _userProductPricing = __webpack_require__(173);

var _userProductPricing2 = _interopRequireDefault(_userProductPricing);

var _userProductPricings = __webpack_require__(174);

var _userProductPricings2 = _interopRequireDefault(_userProductPricings);

var _userProductSpecGroups = __webpack_require__(175);

var _userProductSpecGroups2 = _interopRequireDefault(_userProductSpecGroups);

var _userProductSpecialPricings = __webpack_require__(176);

var _userProductSpecialPricings2 = _interopRequireDefault(_userProductSpecialPricings);

var _userProductSpecs = __webpack_require__(177);

var _userProductSpecs2 = _interopRequireDefault(_userProductSpecs);

var _userProductTargetPricings = __webpack_require__(178);

var _userProductTargetPricings2 = _interopRequireDefault(_userProductTargetPricings);

var _userProductViewSpecs = __webpack_require__(179);

var _userProductViewSpecs2 = _interopRequireDefault(_userProductViewSpecs);

var _userProducts = __webpack_require__(180);

var _userProducts2 = _interopRequireDefault(_userProducts);

var _userRegister = __webpack_require__(181);

var _userRegister2 = _interopRequireDefault(_userRegister);

var _userRollMessages = __webpack_require__(183);

var _userRollMessages2 = _interopRequireDefault(_userRollMessages);

var _userSellerEdit = __webpack_require__(184);

var _userSellerEdit2 = _interopRequireDefault(_userSellerEdit);

var _userSellerSectionMenu = __webpack_require__(185);

var _userSellerSectionMenu2 = _interopRequireDefault(_userSellerSectionMenu);

var _userSellerSidebarMenu = __webpack_require__(186);

var _userSellerSidebarMenu2 = _interopRequireDefault(_userSellerSidebarMenu);

var _userSpecialPaymentTerms = __webpack_require__(187);

var _userSpecialPaymentTerms2 = _interopRequireDefault(_userSpecialPaymentTerms);

var _userTradingDetails = __webpack_require__(188);

var _userTradingDetails2 = _interopRequireDefault(_userTradingDetails);

var _userTradingOffer = __webpack_require__(189);

var _userTradingOffer2 = _interopRequireDefault(_userTradingOffer);

var _userTradingOrderBuyer = __webpack_require__(190);

var _userTradingOrderBuyer2 = _interopRequireDefault(_userTradingOrderBuyer);

var _userTradingOrderSeller = __webpack_require__(191);

var _userTradingOrderSeller2 = _interopRequireDefault(_userTradingOrderSeller);

var _userViewSimilar = __webpack_require__(192);

var _userViewSimilar2 = _interopRequireDefault(_userViewSimilar);

var _usersByGroup = __webpack_require__(193);

var _usersByGroup2 = _interopRequireDefault(_usersByGroup);

var _usersByRelation = __webpack_require__(194);

var _usersByRelation2 = _interopRequireDefault(_usersByRelation);

var _users = __webpack_require__(195);

var _users2 = _interopRequireDefault(_users);

var _mills = __webpack_require__(37);

var _mills2 = _interopRequireDefault(_mills);

var _millsAdd = __webpack_require__(35);

var _millsAdd2 = _interopRequireDefault(_millsAdd);

var _millsEdit = __webpack_require__(36);

var _millsEdit2 = _interopRequireDefault(_millsEdit);

var _newsletter = __webpack_require__(42);

var _newsletter2 = _interopRequireDefault(_newsletter);

var _newsletters = __webpack_require__(43);

var _newsletters2 = _interopRequireDefault(_newsletters);

var _newsletterCreate = __webpack_require__(38);

var _newsletterCreate2 = _interopRequireDefault(_newsletterCreate);

var _newsletterRecipients = __webpack_require__(41);

var _newsletterRecipients2 = _interopRequireDefault(_newsletterRecipients);

var _newsletterRecipientsPending = __webpack_require__(39);

var _newsletterRecipientsPending2 = _interopRequireDefault(_newsletterRecipientsPending);

var _newsletterRecipientsSent = __webpack_require__(40);

var _newsletterRecipientsSent2 = _interopRequireDefault(_newsletterRecipientsSent);

var _messages = __webpack_require__(34);

var _messages2 = _interopRequireDefault(_messages);

var _messageCreate = __webpack_require__(32);

var _messageCreate2 = _interopRequireDefault(_messageCreate);

var _messageUpdate = __webpack_require__(33);

var _messageUpdate2 = _interopRequireDefault(_messageUpdate);

var _webGlossaries = __webpack_require__(199);

var _webGlossaries2 = _interopRequireDefault(_webGlossaries);

var _webSources = __webpack_require__(205);

var _webSources2 = _interopRequireDefault(_webSources);

var _webSourcesAdd = __webpack_require__(202);

var _webSourcesAdd2 = _interopRequireDefault(_webSourcesAdd);

var _webSourcesEdit = __webpack_require__(204);

var _webSourcesEdit2 = _interopRequireDefault(_webSourcesEdit);

var _webSourcesCategories = __webpack_require__(203);

var _webSourcesCategories2 = _interopRequireDefault(_webSourcesCategories);

var _webEvents = __webpack_require__(198);

var _webEvents2 = _interopRequireDefault(_webEvents);

var _webEventsAdd = __webpack_require__(196);

var _webEventsAdd2 = _interopRequireDefault(_webEventsAdd);

var _webEventsEdit = __webpack_require__(197);

var _webEventsEdit2 = _interopRequireDefault(_webEventsEdit);

var _webNews = __webpack_require__(201);

var _webNews2 = _interopRequireDefault(_webNews);

var _webNewsCategories = __webpack_require__(200);

var _webNewsCategories2 = _interopRequireDefault(_webNewsCategories);

var _webTopics = __webpack_require__(207);

var _webTopics2 = _interopRequireDefault(_webTopics);

var _webTopicsCategories = __webpack_require__(206);

var _webTopicsCategories2 = _interopRequireDefault(_webTopicsCategories);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var app = _angular2.default.module('app.admin');

app.controller('BuyerAddresses', _buyerAddresses2.default);
app.controller('BuyerSpecialPricings', _buyerSpecialPricings2.default);
app.controller('CompanyCommonWords', _companyCommonWords2.default);
app.controller('DemandCreateEdit', _demandCreateEdit2.default);
app.controller('DemandManage', _demandManage2.default);
app.controller('FaqManage', _faqManage2.default);
app.controller('ItemDialog', _itemDialog2.default);
app.controller('MessageCenter', _messageCenter2.default);
app.controller('OfferActivatePriceDialog', _offerActivatePriceDialog2.default);
app.controller('OfferCampaignAttachments', _offerCampaignAttachments2.default);
app.controller('OfferCampaignBasicInfos', _offerCampaignBasicInfos2.default);
app.controller('OfferCampaignCreateDialog', _offerCampaignCreateDialog2.default);
app.controller('OfferCampaignCreate', _offerCampaignCreate2.default);
app.controller('OfferCampaignFields', _offerCampaignFields2.default);
app.controller('OfferCampaignMassSendDialog', _offerCampaignMassSendDialog2.default);
app.controller('OfferCampaignMassSendReport', _offerCampaignMassSendReport2.default);
app.controller('OfferStocklistMassUpdateDialog', _offerStocklistMassUpdateDialog2.default);
app.controller('OfferCampaignProductSpec', _offerCampaignProductSpec2.default);
app.controller('OfferCampaignRecipientAttachmentsDialog', _offerCampaignRecipientAttachmentsDialog2.default);
app.controller('OfferCampaignRecipientsDialog', _offerCampaignRecipientsDialog2.default);
app.controller('OfferCampaignRecipientsPendingGeneral', _offerCampaignRecipientsPendingGeneral2.default);
app.controller('OfferCampaignRecipientsPendingSpecial', _offerCampaignRecipientsPendingSpecial2.default);
app.controller('OfferCampaignRecipientsSent', _offerCampaignRecipientsSent2.default);
app.controller('OfferCampaignRecipients', _offerCampaignRecipients2.default);
app.controller('OfferCampaignSettings', _offerCampaignSettings2.default);
app.controller('OfferCampaign', _offerCampaign2.default);
app.controller('OfferCampaigns', _offerCampaigns2.default);
app.controller('OfferCharges', _offerCharges2.default);
app.controller('OfferConnectionsItem', _offerConnectionsItem2.default);
app.controller('OfferConnections', _offerConnections2.default);
app.controller('OfferCreate', _offerCreate2.default);
app.controller('OfferEditCampaigns', _offerEditCampaigns2.default);
app.controller('OfferEdit', _offerEdit2.default);
app.controller('OfferInventories', _offerInventories2.default);
app.controller('OfferMainBasic', _offerMainBasic2.default);
app.controller('OfferMainDescription', _offerMainDescription2.default);
app.controller('OfferMainTitle', _offerMainTitle2.default);
app.controller('OfferMarketRestrictions', _offerMarketRestrictions2.default);
app.controller('OfferMatchingAnalysis', _offerMatchingAnalysis2.default);
app.controller('OfferCutAnalysis', _offerCutAnalysis2.default);
app.controller('OfferMatchingCriteria', _offerMatchingCriteria2.default);
app.controller('OfferMatching', _offerMatching2.default);
app.controller('OfferOsppUsers', _offerOsppUsers2.default);
app.controller('OfferRequestCreate', _offerRequestCreate2.default);
app.controller('OfferRequestItemDialog', _offerRequestItemDialog2.default);
app.controller('OfferRequestItemTabs', _offerRequestItemTabs2.default);
app.controller('OfferRequestItems', _offerRequestItems2.default);
app.controller('OfferRequests', _offerRequests2.default);
app.controller('OfferSectionMenu', _offerSectionMenu2.default);
app.controller('OfferSidebarMenu', _offerSidebarMenu2.default);
app.controller('OfferStockItemPriceDialog', _offerStockItemPriceDialog2.default);
app.controller('OfferStocklistCriteria', _offerStocklistCriteria2.default);
app.controller('OfferStocklist', _offerStocklist2.default);
app.controller('OfferSupplierPricing', _offerSupplierPricing2.default);
app.controller('OfferUpload', _offerUpload2.default);
app.controller('Offers', _offers2.default);
app.controller('OrderArrivals', _orderArrivals2.default);
app.controller('OrderAttachments', _orderAttachments2.default);
app.controller('OrderBookingNoteNotifications', _orderBookingNoteNotifications2.default);
app.controller('OrderBookingNotes', _orderBookingNotes2.default);
app.controller('OrderBuyerDetails', _orderBuyerDetails2.default);
app.controller('OrderCreate', _orderCreate2.default);
app.controller('OrderDeliveryGeneral', _orderDeliveryGeneral2.default);
app.controller('OrderDocumentsContacts', _orderDocumentsContacts2.default);
app.controller('OrderDocuments', _orderDocuments2.default);
app.controller('OrderMainDocs', _orderMainDocs2.default);
app.controller('OrderMainInfos', _orderMainInfos2.default);
app.controller('OrderManage', _orderManage2.default);
app.controller('OrderNotifications', _orderNotifications2.default);
app.controller('OrderOverview', _orderOverview2.default);
app.controller('OrderPaymentGeneral', _orderPaymentGeneral2.default);
app.controller('OrderPayments', _orderPayments2.default);
app.controller('OrderSellerDetails', _orderSellerDetails2.default);
app.controller('OrderSidebar', _orderSidebar2.default);
app.controller('OrderStocklist', _orderStocklist2.default);
app.controller('OrderUpload', _orderUpload2.default);
app.controller('PendingImportCheck', _pendingImportCheck2.default);
app.controller('PendingRegistrationCheck', _pendingRegistrationCheck2.default);
app.controller('PendingRegistrationView', _pendingRegistrationView2.default);
app.controller('ProductBrands', _productBrands2.default);
app.controller('ProductCategoryGroupsDialog', _productCategoryGroupsDialog2.default);
app.controller('ProductCategorySpecsGroupsDialog', _productCategorySpecsGroupsDialog2.default);
app.controller('ProductExport', _productExport2.default);
app.controller('ProductGroupSpecRanges', _productGroupSpecRanges2.default);
app.controller('ProductGroupSpecsDialog', _productGroupSpecsDialog2.default);
app.controller('ProductGroupSpecs', _productGroupSpecs2.default);
app.controller('ProductEndUsesAddDialog', _productEndUsesAddDialog2.default);
app.controller('ProductEndUsesAdd', _productEndUsesAdd2.default);
app.controller('ProductEndUsesManage', _productEndUsesManage2.default);
app.controller('ProductEndUses', _productEndUses2.default);
app.controller('ProductGroups', _productGroups2.default);
app.controller('ProductImport', _productImport2.default);
app.controller('ProductPriceGroup', _productPriceGroup2.default);
app.controller('ProductPriceGroups', _productPriceGroups2.default);
app.controller('StocklistSpecsEdit', _stocklistSpecsEdit2.default);
app.controller('StocklistSpecs', _stocklistSpecs2.default);
app.controller('SupplierProductPricings', _supplierProductPricings2.default);
app.controller('UserAcceptablePaymentTerms', _userAcceptablePaymentTerms2.default);
app.controller('UserBuyerEdit', _userBuyerEdit2.default);
app.controller('UserBuyerSectionMenu', _userBuyerSectionMenu2.default);
app.controller('UserBuyerSidebarMenu', _userBuyerSidebarMenu2.default);
app.controller('UserContactNotificationsDialog', _userContactNotificationsDialog2.default);
app.controller('UserContacts', _userContacts2.default);
app.controller('UserCountryCharges', _userCountryCharges2.default);
app.controller('UserCreate', _userCreate2.default);
app.controller('UserDeliveryTerm', _userDeliveryTerm2.default);
app.controller('UserDeliveryTerms', _userDeliveryTerms2.default);
app.controller('UserDetails', _userDetails2.default);
app.controller('UserEditCampaigns', _userEditCampaigns2.default);
app.controller('UserExport', _userExport2.default);
app.controller('UserFaqs', _userFaqs2.default);
app.controller('UserFreightRatesExport', _userFreightRatesExport2.default);
app.controller('UserFreightRatesImport', _userFreightRatesImport2.default);
app.controller('UserFreightRates', _userFreightRates2.default);
app.controller('UserImport', _userImport2.default);
app.controller('UserIncotermCharges', _userIncotermCharges2.default);
app.controller('UserManageCities', _userManageCities2.default);
app.controller('UserManageCompanies', _userManageCompanies2.default);
app.controller('UserManageContacts', _userManageContacts2.default);
app.controller('UserManageEmailHostnames', _userManageEmailHostnames2.default);
app.controller('UserManageMembers', _userManageMembers2.default);
app.controller('UserMarketRestrictions', _userMarketRestrictions2.default);
app.controller('UserRestrictedTo', _userRestrictedTo2.default);
app.controller('UserOfferMatching', _userOfferMatching2.default);
app.controller('UserOfferRequestItems', _userOfferRequestItems2.default);
app.controller('UserOffers', _userOffers2.default);
app.controller('UserOrders', _userOrders2.default);
app.controller('UserOverview', _userOverview2.default);
app.controller('UserProductBrandPricing', _userProductBrandPricing2.default);
app.controller('UserProductCopyFromUserDialog', _userProductCopyFromUserDialog2.default);
app.controller('UserProductCopySpecs', _userProductCopySpecs2.default);
app.controller('UserProductEditSpecs', _userProductEditSpecs2.default);
app.controller('UserProductEndUses', _userProductEndUses2.default);
app.controller('UserProductGroupCharges', _userProductGroupCharges2.default);
app.controller('UserProductGroupSettings', _userProductGroupSettings2.default);
app.controller('UserProductGroupSpecs', _userProductGroupSpecs2.default);
app.controller('UserProductMassSpecs', _userProductMassSpecs2.default);
app.controller('UserProductPreview', _userProductPreview2.default);
app.controller('UserProductPricing', _userProductPricing2.default);
app.controller('UserProductPricings', _userProductPricings2.default);
app.controller('UserProductSpecGroups', _userProductSpecGroups2.default);
app.controller('UserProductSpecialPricings', _userProductSpecialPricings2.default);
app.controller('UserProductSpecs', _userProductSpecs2.default);
app.controller('UserProductTargetPricings', _userProductTargetPricings2.default);
app.controller('UserProductViewSpecs', _userProductViewSpecs2.default);
app.controller('UserProducts', _userProducts2.default);
app.controller('UserRegister', _userRegister2.default);
app.controller('UserRollMessages', _userRollMessages2.default);
app.controller('UserSellerEdit', _userSellerEdit2.default);
app.controller('UserSellerSectionMenu', _userSellerSectionMenu2.default);
app.controller('UserSellerSidebarMenu', _userSellerSidebarMenu2.default);
app.controller('UserSpecialPaymentTerms', _userSpecialPaymentTerms2.default);
app.controller('UserTradingDetails', _userTradingDetails2.default);
app.controller('UserTradingOffer', _userTradingOffer2.default);
app.controller('UserTradingOrderBuyer', _userTradingOrderBuyer2.default);
app.controller('UserTradingOrderSeller', _userTradingOrderSeller2.default);
app.controller('UserViewSimilar', _userViewSimilar2.default);
app.controller('UsersByGroup', _usersByGroup2.default);
app.controller('UsersByRelation', _usersByRelation2.default);
app.controller('Users', _users2.default);
app.controller('Mills', _mills2.default);
app.controller('MillsAdd', _millsAdd2.default);
app.controller('MillsEdit', _millsEdit2.default);
app.controller('Newsletter', _newsletter2.default);
app.controller('Newsletters', _newsletters2.default);
app.controller('NewsletterCreate', _newsletterCreate2.default);
app.controller('NewsletterRecipients', _newsletterRecipients2.default);
app.controller('NewsletterRecipientsPending', _newsletterRecipientsPending2.default);
app.controller('NewsletterRecipientsSent', _newsletterRecipientsSent2.default);
app.controller('Messages', _messages2.default);
app.controller('MessageCreate', _messageCreate2.default);
app.controller('MessageUpdate', _messageUpdate2.default);
app.controller('WebGlossaries', _webGlossaries2.default);
app.controller('WebSources', _webSources2.default);
app.controller('WebSourcesAdd', _webSourcesAdd2.default);
app.controller('WebSourcesEdit', _webSourcesEdit2.default);
app.controller('WebSourcesCategories', _webSourcesCategories2.default);
app.controller('WebEvents', _webEvents2.default);
app.controller('WebEventsAdd', _webEventsAdd2.default);
app.controller('WebEventsEdit', _webEventsEdit2.default);
app.controller('WebNews', _webNews2.default);
app.controller('WebNewsCategories', _webNewsCategories2.default);
app.controller('WebTopics', _webTopics2.default);
app.controller('WebTopicsCategories', _webTopicsCategories2.default);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _date = __webpack_require__(208);

var _date2 = _interopRequireDefault(_date);

var _demand = __webpack_require__(209);

var _demand2 = _interopRequireDefault(_demand);

var _email = __webpack_require__(210);

var _email2 = _interopRequireDefault(_email);

var _faq = __webpack_require__(211);

var _faq2 = _interopRequireDefault(_faq);

var _geo = __webpack_require__(212);

var _geo2 = _interopRequireDefault(_geo);

var _item = __webpack_require__(213);

var _item2 = _interopRequireDefault(_item);

var _messageCenter = __webpack_require__(214);

var _messageCenter2 = _interopRequireDefault(_messageCenter);

var _offerCampaign = __webpack_require__(218);

var _offerCampaign2 = _interopRequireDefault(_offerCampaign);

var _offerMarketRestriction = __webpack_require__(219);

var _offerMarketRestriction2 = _interopRequireDefault(_offerMarketRestriction);

var _offerRequestItem = __webpack_require__(220);

var _offerRequestItem2 = _interopRequireDefault(_offerRequestItem);

var _offerRequest = __webpack_require__(221);

var _offerRequest2 = _interopRequireDefault(_offerRequest);

var _offerSidebar = __webpack_require__(222);

var _offerSidebar2 = _interopRequireDefault(_offerSidebar);

var _offer = __webpack_require__(223);

var _offer2 = _interopRequireDefault(_offer);

var _orderBookingNote = __webpack_require__(224);

var _orderBookingNote2 = _interopRequireDefault(_orderBookingNote);

var _orderPayment = __webpack_require__(225);

var _orderPayment2 = _interopRequireDefault(_orderPayment);

var _orderSidebar = __webpack_require__(226);

var _orderSidebar2 = _interopRequireDefault(_orderSidebar);

var _order = __webpack_require__(227);

var _order2 = _interopRequireDefault(_order);

var _pagination = __webpack_require__(228);

var _pagination2 = _interopRequireDefault(_pagination);

var _productEndUse = __webpack_require__(229);

var _productEndUse2 = _interopRequireDefault(_productEndUse);

var _product = __webpack_require__(230);

var _product2 = _interopRequireDefault(_product);

var _ui = __webpack_require__(231);

var _ui2 = _interopRequireDefault(_ui);

var _userAcceptablePaymentTerm = __webpack_require__(232);

var _userAcceptablePaymentTerm2 = _interopRequireDefault(_userAcceptablePaymentTerm);

var _userAddress = __webpack_require__(233);

var _userAddress2 = _interopRequireDefault(_userAddress);

var _userAdminMessage = __webpack_require__(234);

var _userAdminMessage2 = _interopRequireDefault(_userAdminMessage);

var _userBank = __webpack_require__(235);

var _userBank2 = _interopRequireDefault(_userBank);

var _userContact = __webpack_require__(236);

var _userContact2 = _interopRequireDefault(_userContact);

var _userDeliveryTerm = __webpack_require__(237);

var _userDeliveryTerm2 = _interopRequireDefault(_userDeliveryTerm);

var _userFreightRate = __webpack_require__(238);

var _userFreightRate2 = _interopRequireDefault(_userFreightRate);

var _userMarketRestriction = __webpack_require__(239);

var _userMarketRestriction2 = _interopRequireDefault(_userMarketRestriction);

var _userProductEndUse = __webpack_require__(240);

var _userProductEndUse2 = _interopRequireDefault(_userProductEndUse);

var _userProduct = __webpack_require__(241);

var _userProduct2 = _interopRequireDefault(_userProduct);

var _userRollMessage = __webpack_require__(242);

var _userRollMessage2 = _interopRequireDefault(_userRollMessage);

var _user = __webpack_require__(245);

var _user2 = _interopRequireDefault(_user);

var _mill = __webpack_require__(216);

var _mill2 = _interopRequireDefault(_mill);

var _newsletter = __webpack_require__(217);

var _newsletter2 = _interopRequireDefault(_newsletter);

var _message = __webpack_require__(215);

var _message2 = _interopRequireDefault(_message);

var _userSidebar = __webpack_require__(243);

var _userSidebar2 = _interopRequireDefault(_userSidebar);

var _userSpecialPaymentTerm = __webpack_require__(244);

var _userSpecialPaymentTerm2 = _interopRequireDefault(_userSpecialPaymentTerm);

var _webGlossary = __webpack_require__(247);

var _webGlossary2 = _interopRequireDefault(_webGlossary);

var _webSource = __webpack_require__(249);

var _webSource2 = _interopRequireDefault(_webSource);

var _webEvent = __webpack_require__(246);

var _webEvent2 = _interopRequireDefault(_webEvent);

var _webNew = __webpack_require__(248);

var _webNew2 = _interopRequireDefault(_webNew);

var _webTopic = __webpack_require__(250);

var _webTopic2 = _interopRequireDefault(_webTopic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var app = _angular2.default.module('app.admin');

app.service('DateService', _date2.default);
app.service('DemandService', _demand2.default);
app.service('EmailService', _email2.default);
app.service('FaqService', _faq2.default);
app.service('GeoService', _geo2.default);
app.service('ItemService', _item2.default);
app.service('MessageCenterService', _messageCenter2.default);
app.service('OfferCampaignService', _offerCampaign2.default);
app.service('OfferMarketRestrictionService', _offerMarketRestriction2.default);
app.service('OfferRequestItemService', _offerRequestItem2.default);
app.service('OfferRequestService', _offerRequest2.default);
app.service('OfferSidebarService', _offerSidebar2.default);
app.service('OfferService', _offer2.default);
app.service('OrderBookingNoteService', _orderBookingNote2.default);
app.service('OrderPaymentService', _orderPayment2.default);
app.service('OrderSidebarService', _orderSidebar2.default);
app.service('OrderService', _order2.default);
app.service('PaginationService', _pagination2.default);
app.service('ProductEndUseService', _productEndUse2.default);
app.service('ProductService', _product2.default);
app.service('UiService', _ui2.default);
app.service('UserAcceptablePaymentTermService', _userAcceptablePaymentTerm2.default);
app.service('UserAddressService', _userAddress2.default);
app.service('UserAdminMessageService', _userAdminMessage2.default);
app.service('UserBankService', _userBank2.default);
app.service('UserContactService', _userContact2.default);
app.service('UserDeliveryTermService', _userDeliveryTerm2.default);
app.service('UserFreightRateService', _userFreightRate2.default);
app.service('UserMarketRestrictionService', _userMarketRestriction2.default);
app.service('UserProductEndUseService', _userProductEndUse2.default);
app.service('UserProductService', _userProduct2.default);
app.service('UserRollMessageService', _userRollMessage2.default);
app.service('UserService', _user2.default);
app.service('MillService', _mill2.default);
app.service('NewsletterService', _newsletter2.default);
app.service('MessageService', _message2.default);
app.service('UserSidebarService', _userSidebar2.default);
app.service('UserSpecialPaymentTermService', _userSpecialPaymentTerm2.default);
app.service('WebGlossaryService', _webGlossary2.default);
app.service('WebSourceService', _webSource2.default);
app.service('WebEventService', _webEvent2.default);
app.service('WebNewService', _webNew2.default);
app.service('WebTopicService', _webTopic2.default);

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BuyerAddresses = function BuyerAddresses($scope, GeoService) {
  _classCallCheck(this, BuyerAddresses);

  $scope.tabs = ['Consignee', 'Notify Party', 'Address for Receiving Documents', 'Bank Details'];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.$watch('buyer.consignee_address.country_id', function () {
    if ($scope.buyer.consignee_address.country_id) {
      GeoService.get_cities($scope.buyer.consignee_address.country_id).then(function (data) {
        $scope.consignee_address_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.buyer.consignee_address.city_id })) $scope.buyer.consignee_address.city_id = null;
      });
    }
  });

  $scope.$watch('buyer.notify_address.country_id', function () {
    if ($scope.buyer.notify_address.country_id) {
      GeoService.get_cities($scope.buyer.notify_address.country_id).then(function (data) {
        $scope.notify_address_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.buyer.notify_address.city_id })) $scope.buyer.notify_address.city_id = null;
      });
    }
  });

  $scope.$watch('buyer.docs_address.country_id', function () {
    if ($scope.buyer.docs_address.country_id) {
      GeoService.get_cities($scope.buyer.docs_address.country_id).then(function (data) {
        $scope.docs_address_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.buyer.docs_address.city_id })) $scope.buyer.docs_address.city_id = null;
      });
    }
  });

  $scope.$watch('buyer.bank.country_id', function () {
    if ($scope.buyer.bank.country_id) {
      GeoService.get_cities($scope.buyer.bank.country_id).then(function (data) {
        $scope.bank_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.buyer.bank.city_id })) $scope.buyer.bank.city_id = null;
      });
    }
  });

  $scope.get_address = function () {
    return {
      company_title: null,
      vat: null,
      address_line_1: null,
      address_line_2: null,
      post_code: null,
      country_id: null,
      city_id: null,
      email: null,
      phone: null,
      fax: null
    };
  };

  $scope.get_docs_address = function () {
    return {
      contact_person: null,
      company_title: null,
      address_line_1: null,
      address_line_2: null,
      post_code: null,
      country_id: null,
      city_id: null,
      email: null,
      phone: null,
      fax: null
    };
  };

  $scope.get_bank = function () {
    return {
      title: null,
      branch: null,
      address_line_1: null,
      address_line_2: null,
      post_code: null,
      country_id: null,
      city_id: null,
      email: null,
      phone: null,
      fax: null,
      account_details: null,
      contact_person: null
    };
  };

  $scope.get_buyer_details = function () {
    return {
      consignee_address: $scope.get_address(),
      notify_address: $scope.get_address(),
      docs_address: $scope.get_docs_address(),
      bank: $scope.get_bank()
    };
  };

  $scope.clear_consignee_address = function () {
    $scope.buyer.consignee_address = $scope.get_address();
  };

  $scope.clear_notify_address = function () {
    $scope.buyer.notify_address = $scope.get_address();
  };

  $scope.clear_docs_address = function () {
    $scope.buyer.docs_address = $scope.get_docs_address();
  };

  $scope.clear_bank = function () {
    $scope.buyer.bank = $scope.get_bank();
  };

  $scope.autofill_consignee_address = function () {
    if (window.consignee_address) {
      $scope.buyer.consignee_address.company_title = window.consignee_address.company_title;
      $scope.buyer.consignee_address.vat = window.consignee_address.vat;
      $scope.buyer.consignee_address.address_line_1 = window.consignee_address.address_line_1;
      $scope.buyer.consignee_address.address_line_2 = window.consignee_address.address_line_2;
      $scope.buyer.consignee_address.post_code = window.consignee_address.post_code;
      $scope.buyer.consignee_address.country_id = window.consignee_address.country_id;
      $scope.buyer.consignee_address.city_id = window.consignee_address.city_id;
      $scope.buyer.consignee_address.email = window.consignee_address.email;
      $scope.buyer.consignee_address.phone = window.consignee_address.phone;
      $scope.buyer.consignee_address.fax = window.consignee_address.fax;
    } else {
      $scope.buyer.consignee_address = $scope.get_address();
    }
  };

  $scope.autofill_notify_address = function () {
    if (window.notify_address) {
      $scope.buyer.notify_address.company_title = window.notify_address.company_title;
      $scope.buyer.notify_address.vat = window.notify_address.vat;
      $scope.buyer.notify_address.address_line_1 = window.notify_address.address_line_1;
      $scope.buyer.notify_address.address_line_2 = window.notify_address.address_line_2;
      $scope.buyer.notify_address.post_code = window.notify_address.post_code;
      $scope.buyer.notify_address.country_id = window.notify_address.country_id;
      $scope.buyer.notify_address.city_id = window.notify_address.city_id;
      $scope.buyer.notify_address.email = window.notify_address.email;
      $scope.buyer.notify_address.phone = window.notify_address.phone;
      $scope.buyer.notify_address.fax = window.notify_address.fax;
    } else {
      $scope.buyer.notify_address = $scope.get_address();
    }
  };

  $scope.autofill_docs_address = function () {
    if (window.docs_address) {
      $scope.buyer.docs_address.contact_person = window.docs_address.contact_person;
      $scope.buyer.docs_address.company_title = window.docs_address.company_title;
      $scope.buyer.docs_address.address_line_1 = window.docs_address.address_line_1;
      $scope.buyer.docs_address.address_line_2 = window.docs_address.address_line_2;
      $scope.buyer.docs_address.post_code = window.docs_address.post_code;
      $scope.buyer.docs_address.country_id = window.docs_address.country_id;
      $scope.buyer.docs_address.city_id = window.docs_address.city_id;
      $scope.buyer.docs_address.email = window.docs_address.email;
      $scope.buyer.docs_address.phone = window.docs_address.phone;
      $scope.buyer.docs_address.fax = window.docs_address.fax;
    } else {
      $scope.buyer.docs_address = $scope.get_docs_address();
    }
  };

  $scope.autofill_bank = function () {
    if (window.trading_bank) {
      $scope.buyer.bank.title = window.trading_bank.title;
      $scope.buyer.bank.branch = window.trading_bank.branch;
      $scope.buyer.bank.address_line_1 = window.trading_bank.address_line_1;
      $scope.buyer.bank.address_line_2 = window.trading_bank.address_line_2;
      $scope.buyer.bank.post_code = window.trading_bank.post_code;
      $scope.buyer.bank.country_id = window.trading_bank.country_id;
      $scope.buyer.bank.city_id = window.trading_bank.city_id;
      $scope.buyer.bank.email = window.trading_bank.email;
      $scope.buyer.bank.phone = window.trading_bank.phone;
      $scope.buyer.bank.fax = window.trading_bank.fax;
      $scope.buyer.bank.account_details = window.trading_bank.account_details;
      $scope.buyer.bank.contact_person = window.trading_bank.contact_person;
    } else {
      $scope.buyer.bank = $scope.get_bank();
    }
  };

  $scope.selected_tab = 0;
  $scope.consignee_address_countries = _angular2.default.copy(window.countries);
  $scope.notify_address_countries = _angular2.default.copy(window.countries);
  $scope.docs_address_countries = _angular2.default.copy(window.countries);
  $scope.bank_countries = _angular2.default.copy(window.countries);
  $scope.buyer = !_underscore2.default.isEmpty(window.buyer_details) ? window.buyer_details : $scope.get_buyer_details();
  $scope.$emit('publish_data', $scope.buyer);
};

exports.default = BuyerAddresses;


BuyerAddresses.$inject = ['$scope', 'GeoService'];

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BuyerSpecialPricings = function BuyerSpecialPricings($scope, ProductService, GeoService, UserService) {
  _classCallCheck(this, BuyerSpecialPricings);

  $scope.parseInt = function (value) {
    return parseInt(value);
  };

  $scope.tabs = [{
    title: 'Product Prices',
    items: [],
    count: 0
  }, {
    title: 'Price Group Prices',
    items: [],
    count: 0
  }, {
    title: 'Check Product Prices',
    items: [],
    count: 0
  }, {
    title: 'Check Price Group Prices',
    items: [],
    count: 0
  }];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.$watch('pricing.shipment_country_id', function () {
    if ($scope.pricing && $scope.pricing.shipment_country_id) {
      GeoService.get_cities($scope.pricing.shipment_country_id).then(function (data) {
        $scope.shipment_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.pricing.shipment_city_id })) $scope.pricing.shipment_city_id = null;
      });
    }
  });

  $scope.$watch('pricing.delivery_country_id', function () {
    if ($scope.pricing && $scope.pricing.delivery_country_id) {
      GeoService.get_cities($scope.pricing.delivery_country_id).then(function (data) {
        $scope.delivery_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.pricing.delivery_city_id })) $scope.pricing.delivery_city_id = null;
      });
    }
  });

  $scope.$watch('pricing.product_id', function () {
    if ($scope.pricing && $scope.pricing.product_id) {
      var product = _underscore2.default.findWhere($scope.products, {
        id: $scope.pricing.product_id
      });
      if (product) $scope.load_product_group_ranges(product.product_group_id);
    }
  });

  $scope.$watch('pricing.product_price_group_id', function () {
    if ($scope.pricing && $scope.pricing.product_price_group_id) {
      var price_group = _underscore2.default.findWhere($scope.price_groups, {
        id: $scope.pricing.product_price_group_id
      });
      if (price_group) $scope.load_product_group_ranges(price_group.product_group_id);
    }
  });

  $scope.set_user_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Buyer', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.pricing.buyer_id = ui.item.id;
        $scope.buyer_user_company = ui.item.value;
        (0, _jquery2.default)(this).val('');
        $scope.$apply();
        if ($scope.mode === 0) $scope.load_buyer_products(ui.item.id);else $scope.load_buyer_price_groups(ui.item.id);
      }
    });
  };

  $scope.load_buyer_products = function (user_id) {
    UserService.get_buyer_preference_products(user_id).success(function (data) {
      $scope.products = data.products;
      if (!_underscore2.default.findWhere(data.products, { id: $scope.pricing.product_id })) $scope.pricing.product_id = null;
      if ($scope.pricing.product_id) {
        var product = _underscore2.default.findWhere($scope.products, {
          id: $scope.pricing.product_id
        });
        $scope.load_product_group_ranges(product.product_group_id);
      }
    });
  };

  $scope.load_buyer_price_groups = function (user_id) {
    UserService.get_buyer_preference_price_groups(user_id).success(function (data) {
      $scope.price_groups = data.price_groups;
      if (!_underscore2.default.findWhere(data.price_groups, { id: $scope.pricing.product_price_group_id })) $scope.pricing.product_price_group_id = null;
      if ($scope.pricing.product_price_group_id) {
        var price_group = _underscore2.default.findWhere($scope.price_groups, {
          id: $scope.pricing.product_price_group_id
        });
        $scope.load_product_group_ranges(price_group.product_group_id);
      }
    });
  };

  $scope.load_product_group_ranges = function (product_group_id) {
    ProductService.get_product_group_ranges(product_group_id, $scope.pricing.is_reels).success(function (data) {
      $scope.ranges = data.ranges;
      if (!_underscore2.default.findWhere($scope.ranges, { id: $scope.pricing.range_id })) $scope.pricing.range_id = null;
    });
  };

  $scope.remove_user = function () {
    $scope.pricing.buyer_id = null;
    $scope.buyer_user_company = null;
    (0, _jquery2.default)('input.user_company').val('');
    if ($scope.mode === 0) {
      $scope.pricing.product_id = null;
      $scope.products = [];
    } else {
      $scope.pricing.product_price_group_id = null;
      $scope.price_groups = [];
    }
    $scope.range_id = null;
    $scope.ranges = [];
  };

  $scope.get_range_label = function (range) {
    var label = 'Substance: ' + range.substance_min + ' - ' + range.substance_max;
    if ($scope.pricing.is_reels) label = label + ', Range: ' + range.rw_min + ' - ' + range.rw_max;
    return label;
  };

  $scope.load_prices = function () {
    $scope.loading = true;
    UserService.get_buyer_prices(window.user_id).success(function (data) {
      $scope.set_products(data.product_prices);
      $scope.set_price_groups(data.price_group_prices);
      $scope.product_users = data.product_users;
      $scope.price_group_users = data.price_group_users;
      $scope.loading = false;
    });
  };

  $scope.set_products = function (prices) {
    var default_prices = _underscore2.default.where(prices, {
      check_manual: false
    });
    var check_prices = _underscore2.default.where(prices, {
      check_manual: true
    });
    $scope.tabs[0].count = default_prices.length;
    $scope.tabs[2].count = check_prices.length;
    if (window.user_type == 'Buyer') {
      $scope.tabs[0].items = _underscore2.default.groupBy(default_prices, 'supplier_id');
      $scope.tabs[2].items = _underscore2.default.groupBy(check_prices, 'supplier_id');
    } else {
      $scope.tabs[0].items = _underscore2.default.groupBy(default_prices, 'buyer_id');
      $scope.tabs[2].items = _underscore2.default.groupBy(check_prices, 'buyer_id');
    }
  };

  $scope.set_price_groups = function (prices) {
    var default_prices = _underscore2.default.where(prices, {
      check_manual: false
    });
    var check_prices = _underscore2.default.where(prices, {
      check_manual: true
    });
    $scope.tabs[1].count = default_prices.length;
    $scope.tabs[3].count = check_prices.length;
    if (window.user_type == 'Buyer') {
      $scope.tabs[1].items = _underscore2.default.groupBy(default_prices, 'supplier_id');
      $scope.tabs[3].items = _underscore2.default.groupBy(check_prices, 'supplier_id');
    } else {
      $scope.tabs[1].items = _underscore2.default.groupBy(default_prices, 'buyer_id');
      $scope.tabs[3].items = _underscore2.default.groupBy(check_prices, 'buyer_id');
    }
  };

  $scope.save_price = function () {
    if (!$scope.pricing.buyer_id) {
      alert('Please select a buyer!');
    } else if ($scope.mode === 0 && !$scope.pricing.product_id) {
      alert('Please select a product!');
    } else if ($scope.mode === 1 && !$scope.pricing.product_price_group_id) {
      alert('Please select a price group!');
    } else {
      $scope.saving_pricing = true;
      UserService.save_buyer_price($scope.mode, $scope.pricing).success(function (data) {
        if (data.success) {
          $scope.saving_pricing = false;
          _jquery2.default.fancybox.close();
          $scope.load_prices();
        }
      });
    }
  };

  $scope.add_price = function (mode) {
    $scope.mode = mode;
    if ($scope.mode === 0) {
      $scope.products = [];
      $scope.pricing = _angular2.default.copy(window.product_price);
    } else {
      $scope.price_groups = [];
      $scope.pricing = _angular2.default.copy(window.price_group_price);
    }
    $scope.range_id = null;
    $scope.ranges = [];
    $scope.buyer_user_company = null;
    (0, _jquery2.default)('input.user_company').val('');
    window.openFancyboxDialog('div#pricing_dialog');
  };

  $scope.edit_price = function (mode, price) {
    $scope.pricing = {
      id: price.id,
      buyer_id: price.buyer_id,
      supplier_id: price.supplier_id,
      range_id: price.range_id,
      delivery_term_id: price.delivery_term_id,
      delivery_country_id: price.delivery_country_id,
      delivery_city_id: price.delivery_city_id,
      shipment_term_id: price.shipment_term_id,
      shipment_country_id: price.shipment_country_id,
      shipment_city_id: price.shipment_city_id,
      currency_id: price.currency_id,
      price: price.price,
      charge: price.charge,
      price_date: price.price_date,
      admin_expire_date: price.admin_expire_date,
      auto_activation: price.auto_activation,
      is_reels: price.is_reels
    };
    $scope.mode = mode;
    if ($scope.mode === 0) {
      $scope.pricing.product_id = price.product_id;
      $scope.products = [];
      $scope.load_buyer_products(price.buyer_id);
    } else {
      $scope.pricing.product_price_group_id = price.product_price_group_id;
      $scope.price_groups = [];
      $scope.load_buyer_price_groups(price.buyer_id);
    }
    $scope.buyer_user_company = price.buyer_name;
    $scope.range_id = null;
    $scope.ranges = [];
    window.openFancyboxDialog('div#pricing_dialog');
  };

  $scope.delete_product_price = function (price_id) {
    if (confirm('Are you sure you want to delete this pricing?')) {
      UserService.delete_buyer_product_price(price_id).success(function (data) {
        if (data.success) $scope.load_prices();
      });
    }
  };

  $scope.delete_price_group_price = function (price_id) {
    if (confirm('Are you sure you want to delete this pricing?')) {
      UserService.delete_buyer_price_group_price(price_id).success(function (data) {
        if (data.success) $scope.load_prices();
      });
    }
  };

  $scope.delivery_terms = [{
    id: 3,
    title: 'FCA'
  }, {
    id: 1,
    title: 'CFR'
  }, {
    id: 2,
    title: 'DAP'
  }];

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.item_modes = [{
    title: 'Reels',
    value: true
  }, {
    title: 'Sheets',
    value: false
  }];

  $scope.selected_tab = 0;
  $scope._ = _underscore2.default;
  $scope.products = [];
  $scope.price_groups = [];
  $scope.ranges = [];
  $scope.countries = window.countries;
  $scope.set_user_autocomplete((0, _jquery2.default)('input.user_company'));
  $scope.user_type = window.user_type;
  $scope.load_prices();
};

exports.default = BuyerSpecialPricings;


BuyerSpecialPricings.$inject = ['$scope', 'ProductService', 'GeoService', 'UserService'];

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CompanyCommonWords = function CompanyCommonWords($scope, UserService) {
  _classCallCheck(this, CompanyCommonWords);

  $scope.common_words = window.common_words;

  $scope.add_common_word = function () {
    $scope.adding = true;
    $scope.add_error = '';
    var common_word = {
      id: null,
      word: $scope.common_word
    };
    UserService.save_company_common_word(common_word).then(function (data) {
      if (data.success) {
        $scope.add_error = 'Word added!';
        $scope.push_word(data.id, common_word.word);
      } else {
        $scope.add_error = data.message;
      }
      $scope.adding = false;
    });
  };

  $scope.push_word = function (id, word) {
    var common_word = {
      company_common_word: {
        id: id,
        word: word
      }
    };
    $scope.common_words.push(common_word);
  };
};

exports.default = CompanyCommonWords;


CompanyCommonWords.$inject = ['$scope', 'UserService'];

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DemandCreateEdit = function DemandCreateEdit($scope, $filter, UserService, GeoService, ProductService, UserProductService, DemandService) {
  _classCallCheck(this, DemandCreateEdit);

  $scope.tabs = ['1. Title', '2. Synopsis', '3. Basic Infos', '4. Product Specs', '5. More Infos'];

  $scope.sections = [{
    title: 'Main Infos',
    tabs: ['Title', 'Synopsis', 'Basic Infos', 'Product Specs', 'More Infos'],
    selected_tab: 0
  }, {
    title: 'Advanced',
    tabs: ['Tags & Keywords', 'Country Restrictions'],
    selected_tab: 0
  }];

  $scope.set_selected_tab = function (index) {
    if (window.on_create_page) $scope.selected_tab = index;else $scope.sections[$scope.selected_section].selected_tab = index;
  };

  $scope.get_selected_tab = function () {
    if (window.on_create_page) return $scope.selected_tab;else return $scope.sections[$scope.selected_section].selected_tab;
  };

  $scope.set_selected_section = function (index) {
    $scope.selected_section = index;
  };

  $scope.select2_options = {
    containerCssClass: 'multiselect2',
    dropdownCssClass: 'multiselect2',
    width: '300px'
  };

  $scope.set_user_company_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Buyer', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.demand.user_id = ui.item.id;
        $scope.demand.user_contact_id = null;
        $scope.demand.buyer_company = ui.item.value;
        $scope.$apply();
        $scope.update_buyer_data(ui.item.id, true);
      }
    });
  };

  $scope.update_buyer_data = function (user_id, set_delivery_terms) {
    UserService.get_contacts(user_id).success(function (data) {
      $scope.user_contacts = data.contacts;
    });
    UserService.get_demand_data(user_id).then(function (data) {
      $scope.buyer_origin = data.origin;
      if (set_delivery_terms) {
        $scope.demand.currency_id = data.currency_id;
        $scope.demand.cfr_country_id = data.cfr_country_id;
        $scope.demand.cfr_city_id = data.cfr_city_id;
        $scope.demand.dap_country_id = data.dap_country_id;
        $scope.demand.dap_city_id = data.dap_city_id;
        $scope.demand.fob_country_id = data.fob_country_id;
        $scope.demand.fob_city_id = data.fob_city_id;
      }
    });
  };

  $scope.$watch('demand.cfr_country_id', function () {
    if ($scope.demand.cfr_country_id) {
      GeoService.get_cities($scope.demand.cfr_country_id).then(function (data) {
        $scope.cfr_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.demand.cfr_city_id })) $scope.demand.cfr_city_id = null;
      });
    }
  });

  $scope.$watch('demand.dap_country_id', function () {
    if ($scope.demand.dap_country_id) {
      GeoService.get_cities($scope.demand.dap_country_id).then(function (data) {
        $scope.dap_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.demand.dap_city_id })) $scope.demand.dap_city_id = null;
      });
    }
  });

  $scope.$watch('demand.fob_country_id', function () {
    if ($scope.demand.fob_country_id) {
      GeoService.get_cities($scope.demand.fob_country_id).then(function (data) {
        $scope.fob_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.demand.fob_city_id })) $scope.demand.fob_city_id = null;
      });
    }
  });

  $scope.$watch('demand.product_category_id', function () {
    ProductService.get_groups($scope.demand.product_category_id).then(function (data) {
      $scope.product_groups = data.groups;
    });
    ProductService.get_product_properties_by_category($scope.demand.product_category_id).then(function (data) {
      $scope.product_grades = data.product_grades;
      $scope.product_finishes = data.product_finishes;
      $scope.product_types = data.product_types;
      $scope.product_printing_methods = data.product_printing_methods;
      $scope.product_colors = window.product_colors;
    });
  });

  $scope.$watch('demand.product_group_id', function () {
    ProductService.get_products($scope.demand.product_group_id).then(function (data) {
      $scope.products = data.products;
    });
    if ($scope.demand.product_group_id) {
      ProductService.get_product_properties_by_group($scope.demand.product_group_id).then(function (data) {
        $scope.product_grades = data.product_grades;
        $scope.product_finishes = data.product_finishes;
        $scope.product_types = data.product_types;
        $scope.product_printing_methods = data.product_printing_methods;
        $scope.product_colors = data.product_colors;
      });
    }
  });

  $scope.$watch('demand.product_id', function () {
    $scope.product_end_uses = [];
    if ($scope.demand.product_id) {
      ProductService.get_product_end_uses($scope.demand.product_id).then(function (data) {
        _angular2.default.forEach(data.end_uses, function (object) {
          var checked = $scope.demand.end_uses.epaper.indexOf(object.id) > -1;
          var end_use = {
            id: object.id,
            title: object.title,
            checked: checked
          };
          $scope.product_end_uses.push(end_use);
        });
      });
      var item = $filter('filter')($scope.products, {
        product: {
          id: $scope.demand.product_id
        }
      });
      if (item) {
        var product = item[0].product;
        $scope.demand.product_grade_id = product.product_grade_id;
        $scope.demand.product_finish_id = product.product_finish_id;
        $scope.demand.product_type_id = product.product_type_id;
        $scope.demand.product_printing_methods.printing_methods = product.printing_methods;
        $scope.demand.product_colors.colors = product.colors;
      }
    }
  });

  $scope.load_user_notes = function () {
    if ($scope.demand.user_id) {
      UserService.get_notes($scope.demand.user_id).then(function (data) {
        $scope.demand.notes = data.notes;
      });
    } else {
      alert('Please select a buyer!');
    }
  };

  $scope.add_accurate = function (property) {
    property.push('0');
  };

  $scope.add_range = function (property) {
    property.push({
      from: '0',
      to: '0'
    });
  };

  $scope.add_substance_accurate = function (property) {
    property.push({
      value: '0',
      reel_combinations: [],
      sheet_combinations: []
    });
  };

  $scope.add_substance_range = function (property) {
    property.push({
      from: '0',
      to: '0',
      reel_combinations: [],
      sheet_combinations: []
    });
  };

  $scope.has_reel_combinations = function (substance) {
    return substance.reel_combinations.length > 0;
  };

  $scope.has_sheet_combinations = function (substance) {
    return substance.sheet_combinations.length > 0;
  };

  $scope.get_combination_str = function (value) {
    return UserProductService.get_combination_str(value);
  };

  $scope.open_dialog = function (dialog_id) {
    window.openFancyboxDialog('div#' + dialog_id);
  };

  $scope.set_reel_combination_edit = function (substance) {
    $scope.reel_combination_edit = {
      substance: substance
    };
    $scope.reel_combination_edit.reel_rw_accurate = $scope.get_rw_combined_values($scope.demand.product_specs.reel_rw_accurate);
    $scope.reel_combination_edit.reel_rw_range = $scope.get_rw_combined_values($scope.demand.product_specs.reel_rw_range);
  };

  $scope.set_sheet_combination_edit = function (substance) {
    $scope.sheet_combination_edit = {
      substance: substance
    };
    $scope.sheet_combination_edit.sheet_size_range = $scope.get_size_combined_values($scope.demand.product_specs.sheet_size_range);
  };

  $scope.get_rw_combined_values = function (values) {
    var object = [];
    _angular2.default.forEach(values, function (value) {
      var checked = $scope.reel_combination_exists(value);
      if (typeof value == 'string') object.push({
        value: value,
        checked: checked
      });else object.push({
        from: value.from,
        to: value.to,
        checked: checked
      });
    });
    return object;
  };

  $scope.get_size_combined_values = function (values) {
    var object = [];
    _angular2.default.forEach(values, function (value) {
      var checked = $scope.sheet_combination_exists(value);
      object.push({
        from: value.from,
        to: value.to,
        checked: checked
      });
    });
    return object;
  };

  $scope.get_reel_combination_edit_substance = function () {
    if ($scope.reel_combination_edit) {
      if ($scope.reel_combination_edit.substance.value) return $scope.reel_combination_edit.substance.value;else return $scope.reel_combination_edit.substance.from + ' - ' + $scope.reel_combination_edit.substance.to;
    }
  };

  $scope.reel_combination_exists = function (rw) {
    var lookup = null;
    if (typeof rw == 'string') lookup = rw;else lookup = {
      from: rw.from,
      to: rw.to
    };
    var index = $scope.reel_combination_edit.substance.reel_combinations.indexOf($filter('filter')($scope.reel_combination_edit.substance.reel_combinations, lookup)[0]);
    return index > -1;
  };

  $scope.sheet_combination_exists = function (size) {
    var lookup = {
      from: size.from,
      to: size.to
    };
    var index = $scope.sheet_combination_edit.substance.sheet_combinations.indexOf($filter('filter')($scope.sheet_combination_edit.substance.sheet_combinations, lookup)[0]);
    return index > -1;
  };

  $scope.update_reel_combinations = function () {
    $scope.reel_combination_edit.substance.reel_combinations = [];
    _angular2.default.forEach($scope.reel_combination_edit.reel_rw_accurate, function (value) {
      if (value.checked) $scope.reel_combination_edit.substance.reel_combinations.push(value.value);
    });
    _angular2.default.forEach($scope.reel_combination_edit.reel_rw_range, function (value) {
      if (value.checked) $scope.reel_combination_edit.substance.reel_combinations.push({
        from: value.from,
        to: value.to
      });
    });
    $scope.reel_combination_edit = null;
  };

  $scope.update_sheet_combinations = function () {
    $scope.sheet_combination_edit.substance.sheet_combinations = [];
    _angular2.default.forEach($scope.sheet_combination_edit.sheet_size_range, function (value) {
      if (value.checked) $scope.sheet_combination_edit.substance.sheet_combinations.push({
        from: value.from,
        to: value.to
      });
    });
    $scope.sheet_combination_edit = null;
  };

  $scope.get_epaper_end_use = function (end_use_id) {
    return $filter('filter')(window.epaper_end_uses, {
      id: end_use_id
    })[0];
  };

  $scope.add_custom_end_use = function () {
    $scope.demand.end_uses.custom.push($scope.custom_end_use);
    $scope.custom_end_use = null;
  };

  $scope.delete_custom_end_use = function (end_use) {
    var index = $scope.demand.end_uses.custom.indexOf(end_use);
    if (index > -1) $scope.demand.end_uses.custom.splice(index, 1);
  };

  $scope.delete_epaper_end_use = function (end_use) {
    var index = $scope.demand.end_uses.epaper.indexOf(end_use);
    if (index > -1) $scope.demand.end_uses.epaper.splice(index, 1);
    var checked_index = $scope.product_end_uses.indexOf($filter('filter')($scope.product_end_uses, {
      id: end_use
    })[0]);
    if (checked_index > -1) $scope.product_end_uses[checked_index].checked = false;
  };

  $scope.$watch('product_end_uses | json', function () {
    _angular2.default.forEach($scope.product_end_uses, function (object) {
      var index = $scope.demand.end_uses.epaper.indexOf(object.id);
      if (object.checked && index < 0) $scope.demand.end_uses.epaper.push(object.id);else if (!object.checked && index > -1) $scope.demand.end_uses.epaper.splice(index, 1);
    });
  });

  $scope.create_demand = function () {
    DemandService.save($scope.demand).then(function (data) {
      if (data.success) {
        $scope.created_demand_id = data.demand_id;
        $scope.create_mode = false;
      }
    });
  };

  $scope.update_demand = function () {
    $scope.updating_demand = true;
    DemandService.save($scope.demand).then(function (data) {
      if (data.success) $scope.updating_demand = false;
    });
  };

  $scope.create_new_demand = function () {
    $scope.demand = _angular2.default.copy(window.demand);
    $scope.selected_tab = 0;
    $scope.create_mode = true;
  };

  $scope.init_create = function () {
    $scope.selected_tab = 0;
    $scope.create_mode = true;
    window.demand.product_printing_methods = {
      printing_methods: []
    };
    window.demand.product_colors = {
      colors: []
    };
    window.demand.product_specs = {
      substance_accurate: [{
        value: '0',
        reel_combinations: [],
        sheet_combinations: []
      }],
      substance_range: [{
        from: '0',
        to: '0',
        reel_combinations: [],
        sheet_combinations: []
      }],
      reel_rw_accurate: ['0'],
      reel_rw_range: [{
        from: '0',
        to: '0'
      }],
      reel_diameter_range: [{
        from: '0',
        to: '0'
      }],
      reel_core_range: [{
        from: '0',
        to: '0'
      }],
      sheet_size_range: [{
        from: '0',
        to: '0'
      }]
    };
    window.demand.end_uses = {
      custom: [],
      epaper: []
    };
    window.demand.pricings = {
      reel_cfr_min: '0',
      reel_cfr_max: '0',
      reel_dap_min: '0',
      reel_dap_max: '0',
      sheet_cfr_min: '0',
      sheet_cfr_max: '0',
      sheet_dap_min: '0',
      sheet_dap_max: '0'
    };
    $scope.demand = _angular2.default.copy(window.demand);
  };

  $scope.selected_section = 0;
  $scope.product_colors = window.product_colors;
  if (window.on_create_page) $scope.init_create();else $scope.init_edit();
  $scope.set_user_company_autocomplete((0, _jquery2.default)('input.user_company'));
};

exports.default = DemandCreateEdit;


DemandCreateEdit.$inject = ['$scope', '$filter', 'UserService', 'GeoService', 'ProductService', 'UserProductService', 'DemandService'];

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DemandManage = function DemandManage($scope, DemandService, PaginationService, UserService, ProductService) {
  _classCallCheck(this, DemandManage);

  $scope.set_user_company_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Buyer', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.filter.user_id = ui.item.id;
        $scope.$apply();
      }
    });
  };

  $scope.$watch('filter.product_category_id', function () {
    ProductService.get_groups($scope.filter.product_category_id).then(function (data) {
      $scope.product_groups = data.groups;
    });
  });

  $scope.select2_options = {
    containerCssClass: 'multiselect2',
    dropdownCssClass: 'multiselect2',
    width: '300px'
  };

  $scope.delete_demand = function (demand) {
    if (confirm('Are you sure you want to delete this demand?')) {
      var index = $scope.demands.indexOf(demand);
      if (index > -1) {
        DemandService.delete($scope.demands[index].id).then(function (data) {
          if (data.success) $scope.demands.splice(index, 1);
        });
      }
    }
  };

  $scope.get_demands = function () {
    DemandService.get_manage_data($scope.filter).then(function (data) {
      $scope.demands = data.demands;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
    });
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.get_demands();
  };

  $scope.filter = {
    page: 1,
    title: '',
    user_id: '',
    product_category_id: '',
    product_group_id: '',
    has_epaper_title: 'all',
    user_countries: [],
    is_visible: 'all',
    based_to: 'all'
  };

  $scope.init = function () {
    $scope.set_user_company_autocomplete((0, _jquery2.default)('input.user_company'));
    $scope.get_demands();
  };

  $scope.init();
};

exports.default = DemandManage;


DemandManage.$inject = ['$scope', 'DemandService', 'PaginationService', 'UserService', 'ProductService'];

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FaqManage = function FaqManage($scope, $filter, FaqService) {
  _classCallCheck(this, FaqManage);

  $scope.types = [{
    id: 1,
    title: 'Users'
  }, {
    id: 2,
    title: 'Offers'
  }, {
    id: 3,
    title: 'Demands'
  }, {
    id: 4,
    title: 'Orders'
  }];

  $scope.show_section_faqs = function (type, section) {
    $scope.selected_section = section;
    $scope.section_breadcrumb = $scope.get_section_breadcrumb();
    $scope.selected_type = type;
    $scope.loading = true;
    FaqService.get_section_faqs(section).then(function (data) {
      $scope.faqs = data.faqs;
      $scope.loading = false;
    });
  };

  $scope.get_section_breadcrumb = function () {
    if (!$scope.selected_section.parent_id) {
      return $scope.selected_section.title;
    } else {
      var section = $filter('filter')($scope.sections, {
        id: $scope.selected_section.parent_id
      })[0];
      return section.title + ' / ' + $scope.selected_section.title;
    }
  };

  $scope.open_dialog = function (dialog_id) {
    window.openFancyboxDialog('div#' + dialog_id);
  };

  $scope.add_faq = function () {
    $scope.dialog_faq = {
      faq_type_id: 1,
      faq_sections: [4, null],
      question: null,
      answer: null,
      weight: 0,
      is_visible: 1
    };
    $scope.open_dialog('faq_dialog');
  };

  $scope.edit_faq = function (faq) {
    $scope.dialog_faq = faq;
    var faq_section = $filter('filter')($scope.sections, {
      id: faq.faq_section_id
    })[0];
    if (!faq_section.parent_id) $scope.dialog_faq.faq_sections = [faq_section.id, null];else $scope.dialog_faq.faq_sections = [faq_section.parent_id, faq_section.id];
    $scope.open_dialog('faq_dialog');
  };

  $scope.delete_faq = function (index) {
    if (confirm('Are you sure you want to delete this FAQ?')) {
      FaqService.delete($scope.faqs[index].id).then(function (data) {
        if (data.success) $scope.faqs.splice(index, 1);
      });
    }
  };

  $scope.save_faq = function () {
    $scope.updating = true;
    $scope.dialog_faq.faq_section_id = $scope.dialog_faq.faq_sections[1] ? $scope.dialog_faq.faq_sections[1] : $scope.dialog_faq.faq_sections[0];
    FaqService.save($scope.dialog_faq).then(function (data) {
      if (data.success) {
        $scope.updating = false;
        _jquery2.default.fancybox.close();
        var type = $filter('filter')($scope.types, {
          id: $scope.dialog_faq.faq_type_id
        })[0];
        var section = $filter('filter')($scope.sections, {
          id: $scope.dialog_faq.faq_section_id
        })[0];
        $scope.show_section_faqs(type, section);
      }
    });
  };

  $scope.init = function () {
    $scope.sections = window.sections;
    $scope.show_section_faqs($scope.types[0], $scope.sections[0]);
  };

  $scope.init();
};

exports.default = FaqManage;


FaqManage.$inject = ['$scope', '$filter', 'FaqService'];

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ItemDialog = function ItemDialog($scope, $rootScope, ItemService, ProductService, UiService) {
  _classCallCheck(this, ItemDialog);

  function get_dialog_data() {
    ItemService.get_dialog_data().success(function (data) {
      $scope.product_categories = data.product_categories;
      $scope.product_brands = data.product_brands;
      $scope.product_colors = data.product_colors;
    });
  }

  function set_product_data() {
    if ($scope.products && $scope.item && $scope.item.product_id) {
      var product = _underscore2.default.findWhere($scope.products, {
        id: $scope.item.product_id
      });
      if (product) {
        var product_grade = _underscore2.default.findWhere($scope.product_grades, {
          id: product.product_grade_id
        });
        if (product_grade) $scope.item.product_grade = product_grade.title;

        var product_type = _underscore2.default.findWhere($scope.product_types, {
          id: product.product_type_id
        });
        if (product_type) $scope.item.product_type = product_type.title;

        var product_finish = _underscore2.default.findWhere($scope.product_finishes, {
          id: product.product_finish_id
        });
        if (product_finish) $scope.item.product_finish = product_finish.title;
      }
    }
  }

  $scope.$watch('item.product_category_id', function () {
    if ($scope.item && $scope.item.product_category_id) {
      ProductService.get_groups($scope.item.product_category_id).then(function (data) {
        $scope.product_groups = data.groups;
        if (!_underscore2.default.findWhere(data.groups, { id: $scope.item.product_group_id })) {
          $scope.item.product_group_id = null;
        }
      });
    } else if ($scope.item) {
      $scope.item.product_group_id = null;
      $scope.product_groups = [];
      $scope.products = [];
    }
    ProductService.get_product_properties_by_category($scope.item ? $scope.item.product_category_id : null).then(function (data) {
      $scope.product_grades = data.product_grades;
      $scope.product_types = data.product_types;
      $scope.product_finishes = data.product_finishes;
      $scope.product_printing_methods = data.product_printing_methods;
    });
  });

  $scope.$watch('item.product_group_id', function () {
    if ($scope.item && $scope.item.product_group_id) {
      ProductService.get_products($scope.item.product_group_id).then(function (data) {
        $scope.products = data.products;
        if (!_underscore2.default.findWhere(data.products, { id: $scope.item.product_id })) $scope.item.product_id = null;
        set_product_data();
      });
    } else if ($scope.item) {
      $scope.item.product_id = null;
      $scope.products = [];
    }
  });

  $scope.$watch('item.product_id', function () {
    set_product_data();
  });

  $scope.$on('show_item_dialog', function (event, data) {
    $scope.item = _angular2.default.copy(data.item);
    $scope.edit_items = data.items || null;
    window.openFancyboxDialog('div#item_dialog');
  });

  $scope.save = function () {
    $scope.saving = true;
    if (!$scope.edit_items) {
      ItemService.save($scope.item).success(function (data) {
        if (data.success) {
          $rootScope.$broadcast('load_items');
          $scope.saving = false;
          _jquery2.default.fancybox.close();
        }
      });
    } else {
      ItemService.mass_save($scope.item, $scope.edit_items).success(function (data) {
        if (data.success) {
          $rootScope.$broadcast('load_items', {
            selected_items: $scope.edit_items,
            item_key: 'item_id'
          });
          $scope.saving = false;
          _jquery2.default.fancybox.close();
        }
      });
    }
  };

  $scope.init = function () {
    $scope.select2_options = UiService.select2_options(100);
    $scope.stock_types = ItemService.get_stock_types();
    get_dialog_data();
  };

  $scope.init();
};

exports.default = ItemDialog;


ItemDialog.$inject = ['$scope', '$rootScope', 'ItemService', 'ProductService', 'UiService'];

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserOverview = function () {
  function UserOverview($scope, MessageCenterService) {
    _classCallCheck(this, UserOverview);

    $scope.selected_tab = 0;
    $scope.set_selected_tab = this.set_selected_tab.bind(this);

    this.MessageCenterService = MessageCenterService;
    this.$scope = $scope;
    this.load_data();
  }

  _createClass(UserOverview, [{
    key: 'set_selected_tab',
    value: function set_selected_tab(index) {
      this.$scope.selected_tab = index;
    }
  }, {
    key: 'load_data',
    value: function load_data() {
      var _this = this;

      this.$scope.messages = [];
      this.$scope.message_count = 0;
      this.$scope.loading = true;

      this.MessageCenterService.get_data().then(function (res) {
        _this.$scope.messages = res.data.messages;
        _this.$scope.message_count = _underscore2.default.reduce(res.data.messages, function (memo, msg) {
          return memo + msg.value;
        }, 0);
        _this.$scope.loading = false;
      });
    }
  }]);

  return UserOverview;
}();

exports.default = UserOverview;


UserOverview.$inject = ['$scope', 'MessageCenterService'];

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MessageCreate = function MessageCreate($scope, $rootScope, MessageService, ProductService, UserService) {
  _classCallCheck(this, MessageCreate);

  $scope.create = function () {
    $scope.creating = true;
    update_business_types();
    update_user_groups();
    update_business_relations();
    update_products();
    update_product_groups();
    update_product_categories();
    update_suppliers();
    MessageService.create($scope.message).success(function (data) {
      if (data.success) window.location = '/admin/marketplace/messages';
    });
  };

  $scope.set_buyer_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Buyer', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.message.user_id = ui.item.id;
        $scope.buyer_company = ui.item.value;
        console.log($scope.message);
      }
    });
  };

  $scope.set_supplier_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Seller', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        if (!_underscore2.default.findWhere($scope.suppliers, { id: ui.item.id })) $scope.suppliers.push({
          id: ui.item.id,
          title: ui.item.value
        });
        (0, _jquery2.default)(this).val('');
        $scope.$apply();
        return false;
      }
    });
  };

  function update_business_types() {
    $scope.message.business_types = [];
    _angular2.default.forEach($scope.business_types, function (business_type) {
      if (business_type.checked) $scope.message.business_types.push(business_type.id);
    });
  }

  function update_user_groups() {
    $scope.message.user_groups = [];
    _angular2.default.forEach($scope.user_groups, function (group) {
      if (group.checked) $scope.message.user_groups.push(group.id);
    });
  }

  function update_business_relations() {
    $scope.message.business_relations = [];
    _angular2.default.forEach($scope.business_relations, function (group) {
      if (group.checked) $scope.message.business_relations.push(group.id);
    });
  }

  function update_products() {
    $scope.message.products = [];
    _angular2.default.forEach($scope.epaper_products, function (group) {
      $scope.message.products.push(group.id);
    });
  }

  function update_product_groups() {
    $scope.message.product_groups = [];
    _angular2.default.forEach($scope.product_groups, function (group) {
      $scope.message.product_groups.push(group.id);
    });
  }

  function update_product_categories() {
    $scope.message.product_categories = [];
    _angular2.default.forEach($scope.product_categories, function (group) {
      if (group.checked) $scope.message.product_categories.push(group.id);
    });
  }

  function update_suppliers() {
    $scope.message.suppliers = [];
    _angular2.default.forEach($scope.suppliers, function (supplier) {
      $scope.message.suppliers.push(supplier.id);
    });
  }

  $scope.set_product_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        ProductService.search_products_by_title(request.term).then(function (data) {
          response(data.products);
        });
      },
      select: function select(event, ui) {
        if (!_underscore2.default.findWhere($scope.epaper_products, { id: ui.item.id })) $scope.epaper_products.push({
          id: ui.item.id,
          title: ui.item.value
        });
        (0, _jquery2.default)(this).val('');
        $scope.$apply();
        return false;
      }
    });
  };

  $scope.set_product_group_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        ProductService.search_product_groups_by_title(request.term).then(function (data) {
          response(data.groups);
        });
      },
      select: function select(event, ui) {
        if (!_underscore2.default.findWhere($scope.product_groups, { id: ui.item.id })) $scope.product_groups.push({
          id: ui.item.id,
          title: ui.item.value
        });
        (0, _jquery2.default)(this).val('');
        $scope.$apply();
        return false;
      }
    });
  };

  $scope.remove_epaper_product = function (product_id) {
    $scope.epaper_products = _underscore2.default.reject($scope.epaper_products, function (product) {
      return product.id == product_id;
    });
    (0, _jquery2.default)('input.epaper_product').val('');
  };

  $scope.remove_product_group = function (group_id) {
    $scope.product_groups = _underscore2.default.reject($scope.product_groups, function (group) {
      return group.id == group_id;
    });
    (0, _jquery2.default)('input.group').val('');
  };

  $scope.remove_supplier = function (supplier_id) {
    $scope.suppliers = _underscore2.default.reject($scope.suppliers, function (supplier) {
      return supplier.id == supplier_id;
    });
    (0, _jquery2.default)('input.supplier').val('');
  };

  $scope.init = function () {
    $scope.message = {
      title: window.message_title
    };

    $scope.business_types = _angular2.default.copy(window.business_types);
    $scope.user_groups = _angular2.default.copy(window.user_groups);
    $scope.business_relations = _angular2.default.copy(window.business_relations);
    $scope.product_categories = _angular2.default.copy(window.product_categories);
    $scope.product_groups = [];
    $scope.epaper_products = [];
    $scope.suppliers = [];

    $scope.set_product_autocomplete((0, _jquery2.default)('input.epaper_product'));
    $scope.set_product_group_autocomplete((0, _jquery2.default)('input.group'));
    $scope.set_buyer_autocomplete((0, _jquery2.default)('input.buyer_company'));
    $scope.set_supplier_autocomplete((0, _jquery2.default)('input.supplier'));
  };

  $scope.init();
};

exports.default = MessageCreate;


MessageCreate.$inject = ['$scope', '$rootScope', 'MessageService', 'ProductService', 'UserService'];

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MessageUpdate = function MessageUpdate($scope, MessageService, UiService, ProductService, UserService) {
  _classCallCheck(this, MessageUpdate);

  $scope.update = function () {
    $scope.creating = true;
    update_business_types();
    update_user_groups();
    update_business_relations();
    update_products();
    update_product_groups();
    update_product_categories();
    update_suppliers();
    MessageService.update($scope.message).success(function (data) {
      if (data.success) window.location = '/admin/marketplace/messages';
    });
  };

  $scope.set_buyer_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Buyer', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.message.user_id = ui.item.id;
      }
    });
  };

  $scope.set_supplier_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Seller', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        if (!_underscore2.default.findWhere($scope.suppliers, { id: ui.item.id })) $scope.suppliers.push({
          id: ui.item.id,
          title: ui.item.value
        });
        (0, _jquery2.default)(this).val('');
        $scope.$apply();
        return false;
      }
    });
  };

  function update_business_types() {
    $scope.message.business_types = [];
    _angular2.default.forEach($scope.business_types, function (business_type) {
      if (business_type.checked) $scope.message.business_types.push(business_type.id);
    });
  }

  function update_user_groups() {
    $scope.message.user_groups = [];
    _angular2.default.forEach($scope.user_groups, function (group) {
      if (group.checked) $scope.message.user_groups.push(group.id);
    });
  }

  function update_business_relations() {
    $scope.message.business_relations = [];
    _angular2.default.forEach($scope.business_relations, function (group) {
      if (group.checked) $scope.message.business_relations.push(group.id);
    });
  }

  function update_products() {
    $scope.message.products = [];
    _angular2.default.forEach($scope.epaper_products, function (group) {
      $scope.message.products.push(group.id);
    });
  }

  function update_product_groups() {
    $scope.message.product_groups = [];
    _angular2.default.forEach($scope.product_groups, function (group) {
      $scope.message.product_groups.push(group.id);
    });
  }

  function update_product_categories() {
    $scope.message.product_categories = [];
    _angular2.default.forEach($scope.product_categories, function (group) {
      if (group.checked) $scope.message.product_categories.push(group.id);
    });
  }

  function update_suppliers() {
    $scope.message.suppliers = [];
    _angular2.default.forEach($scope.suppliers, function (supplier) {
      $scope.message.suppliers.push(supplier.id);
    });
  }

  $scope.set_product_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        ProductService.search_products_by_title(request.term).then(function (data) {
          response(data.products);
        });
      },
      select: function select(event, ui) {
        if (!_underscore2.default.findWhere($scope.epaper_products, { id: ui.item.id })) $scope.epaper_products.push({
          id: ui.item.id,
          title: ui.item.value
        });
        (0, _jquery2.default)(this).val('');
        $scope.$apply();
        return false;
      }
    });
  };

  $scope.set_product_group_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        ProductService.search_product_groups_by_title(request.term).then(function (data) {
          response(data.groups);
        });
      },
      select: function select(event, ui) {
        if (!_underscore2.default.findWhere($scope.product_groups, { id: ui.item.id })) $scope.product_groups.push({
          id: ui.item.id,
          title: ui.item.value
        });
        (0, _jquery2.default)(this).val('');
        $scope.$apply();
        return false;
      }
    });
  };

  $scope.remove_epaper_product = function (product_id) {
    $scope.epaper_products = _underscore2.default.reject($scope.epaper_products, function (product) {
      return product.id == product_id;
    });
    (0, _jquery2.default)('input.epaper_product').val('');
  };

  $scope.remove_product_group = function (group_id) {
    $scope.product_groups = _underscore2.default.reject($scope.product_groups, function (group) {
      return group.id == group_id;
    });
    (0, _jquery2.default)('input.group').val('');
  };

  $scope.remove_supplier = function (supplier_id) {
    $scope.suppliers = _underscore2.default.reject($scope.suppliers, function (supplier) {
      return supplier.id == supplier_id;
    });
    (0, _jquery2.default)('input.supplier').val('');
  };

  $scope.init = function () {
    $scope.message = window.message;
    $scope.buyer = window.buyer;
    $scope.tinymceOptions = UiService.tinymceOptions();
    if ($scope.message.appear_at) {
      $scope.message.appear_at = $scope.message.appear_at.toString();
    }
    if ($scope.message.has_preferences) {
      $scope.message.has_preferences = $scope.message.has_preferences.toString();
    }

    $scope.business_types = _angular2.default.copy(window.business_types);
    $scope.user_groups = _angular2.default.copy(window.user_groups);
    $scope.business_relations = _angular2.default.copy(window.business_relations);
    $scope.epaper_products = _angular2.default.copy(window.products);
    $scope.product_groups = _angular2.default.copy(window.product_groups);
    $scope.product_categories = _angular2.default.copy(window.product_categories);
    $scope.suppliers = _angular2.default.copy(window.suppliers);

    $scope.set_product_autocomplete((0, _jquery2.default)('input.epaper_product'));
    $scope.set_product_group_autocomplete((0, _jquery2.default)('input.group'));
    $scope.set_buyer_autocomplete((0, _jquery2.default)('input.buyer_company'));
    $scope.set_supplier_autocomplete((0, _jquery2.default)('input.supplier'));
  };

  $scope.init();
};

exports.default = MessageUpdate;


MessageUpdate.$inject = ['$scope', 'MessageService', 'UiService', 'ProductService', 'UserService'];

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Messages = function Messages($scope, $rootScope, MessageService) {
  _classCallCheck(this, Messages);

  $scope.tabs = [{
    title: 'Messages',
    items: []
  }, {
    title: 'User Messages',
    items: []
  }, {
    title: 'Offer Messages',
    items: []
  }];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.load_data = function () {
    $scope.loading = true;
    MessageService.get($scope.filter).success(function (data) {
      $scope.tabs[0].items = data.messages;
      $scope.tabs[1].items = data.user_messages;
      $scope.tabs[2].items = data.offer_messages;
      $scope.loading = false;
    });
  };

  $scope.delete_message = function (message_id) {
    if (confirm('Are you sure you want to delete this message?')) {
      MessageService.delete(message_id).success(function (data) {
        if (data.success) $scope.load_data();
      });
    }
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.load_data();
  };

  $scope.$on('reload_message_data', function () {
    $scope.load_data();
  });

  $scope.quick_search = function () {
    window.filter_table('table.data', $scope.quick_filter);
  };

  $scope.init_filter = function () {
    $scope.filter = {
      page: 1,
      per_page: 40
    };
  };

  $scope.init = function () {
    $scope.init_filter();
    $scope.load_data();
    $scope.selected_tab = 0;
  };

  $scope.init();
};

exports.default = Messages;


Messages.$inject = ['$scope', '$rootScope', 'MessageService'];

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MillsAdd = function MillsAdd($scope, $rootScope, GeoService) {
  _classCallCheck(this, MillsAdd);

  $scope.$watch('country_id', function () {
    if ($scope.country_id) $scope.mill_country_name = (0, _jquery2.default)('#country option[value="' + $scope.country_id + '"]').html();else $scope.mill_country_name = '';
    if ($scope.country_id) {
      GeoService.get_cities($scope.country_id).then(function (data) {
        $scope.cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.city_id })) $scope.city_id = null;
      });
    }
  });

  $scope.$watch('city_id', function () {
    if ($scope.city_id) $scope.mill_city_name = (0, _jquery2.default)('#city option:selected').text();else $scope.mill_city_name = '';
  });
};

exports.default = MillsAdd;


MillsAdd.$inject = ['$scope', '$rootScope', 'GeoService'];

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MillsEdit = function MillsEdit($scope, $rootScope, GeoService) {
  _classCallCheck(this, MillsEdit);

  $scope.$watch('mill.country_id', function () {
    if ($scope.mill.country_id) {
      GeoService.get_cities($scope.mill.country_id).then(function (data) {
        $scope.cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.mill.city_id })) $scope.mill.city_id = null;
      });
    }
  });

  $scope.init = function () {
    $scope.mill = window.mill;
    $scope.countries = window.countries;
  };

  $scope.init();
};

exports.default = MillsEdit;


MillsEdit.$inject = ['$scope', '$rootScope', 'GeoService'];

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Mills = function Mills($scope, $rootScope, MillService, PaginationService) {
  _classCallCheck(this, Mills);

  $scope.load_data = function () {
    $scope.loading = true;
    MillService.get($scope.filter).success(function (data) {
      $scope.mills = data.mills;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
      if ($scope.selected_mills) {
        _underscore2.default.each($scope.selected_sources, function (mill_id) {
          var mill = _underscore2.default.findWhere($scope.mills, {
            id: mill_id
          });
          if (mill) mill.checked = true;
        });
      }
      $scope.loading = false;
    });
  };

  $scope.init_filter = function () {
    $scope.filter = {
      page: 1,
      per_page: 40
    };
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.load_data();
  };

  $scope.quick_search = function () {
    window.filter_table('table.data', $scope.quick_filter);
  };

  $scope.init = function () {
    $scope.mills = [];
    $scope.pagination = {};
    $scope.init_filter();
    $scope.load_data();
  };

  $scope.init();
};

exports.default = Mills;


Mills.$inject = ['$scope', '$rootScope', 'MillService', 'PaginationService'];

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NewsletterCreate = function NewsletterCreate($scope, NewsletterService) {
  _classCallCheck(this, NewsletterCreate);

  $scope.create = function () {
    $scope.creating = true;
    NewsletterService.create($scope.newsletter).success(function (data) {
      if (data.success) window.location = '/admin/marketplace/newsletters';
    });
  };

  $scope.init = function () {
    $scope.newsletter = {
      title: window.newsletter_title
    };
  };

  $scope.init();
};

exports.default = NewsletterCreate;


NewsletterCreate.$inject = ['$scope', 'NewsletterService'];

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NewsletterRecipientsPending = function NewsletterRecipientsPending($scope, $timeout, NewsletterService) {
  _classCallCheck(this, NewsletterRecipientsPending);

  $scope.tabs = [{
    title: 'Ready to Send',
    recipients: []
  }];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.check_items = function (tab_index, property) {
    _underscore2.default.each($scope.tabs[tab_index].recipients, function (recipient) {
      recipient[property] = $scope.tabs[tab_index].checked;
    });
  };

  $scope.load_recipients = function () {
    for (var i = 0; i < $scope.tabs.length; i++) {
      $scope.tabs[i].recipients = [];
    }$scope.loading = true;
    NewsletterService.get_recipients(window.newsletter.id, 1).success(function (data) {
      _underscore2.default.each(data.recipients, function (recipient) {
        $scope.allocate_recipient(recipient);
      });
      $scope.loading = false;
    });
  };

  $scope.allocate_recipient = function (recipient) {
    for (var i = 0; i < $scope.tabs.length; i++) {
      $scope.remove_tab_recipient(i, recipient);
    }if (recipient.is_pending) {
      $scope.add_tab_recipient(0, recipient);
    }
  };

  $scope.add_tab_recipient = function (index, recipient) {
    if (_underscore2.default.indexOf($scope.tabs[index].recipients, recipient) < 0) $scope.tabs[index].recipients.push(recipient);
  };

  $scope.remove_tab_recipient = function (index, recipient) {
    var recipient_index = _underscore2.default.indexOf($scope.tabs[index].recipients, recipient);
    if (recipient_index >= 0) $scope.tabs[index].recipients.splice(recipient_index, 1);
  };

  $scope.select_contacts = function (recipient) {
    $scope.dialog_select_contacts_recipient = recipient;
    _jquery2.default.fancybox((0, _jquery2.default)('div#select_recipient_contacts'), {
      padding: '5',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      topRatio: 0.15,
      scrolling: 'no'
    });
  };

  $scope.save_contacts = function () {
    $scope.saving_contacts = true;
    var recipient = $scope.dialog_select_contacts_recipient;
    var contacts = _underscore2.default.pluck(_underscore2.default.where(recipient.contacts, {
      checked: true
    }), 'id');
    NewsletterService.set_recipient_contacts(recipient.id, contacts).success(function (data) {
      if (data.success) {
        $scope.saving_contacts = false;
        _jquery2.default.fancybox.close();
      }
    });
  };

  $scope.auto_select_contacts = function (recipient) {
    recipient.auto_selecting_contacts = true;
    NewsletterService.auto_select_contacts(recipient.id).success(function (data) {
      if (data.success) {
        recipient.auto_selecting_contacts = false;
        recipient.contacts = data.contacts;
      }
    });
  };

  $scope.mass_auto_select_contacts = function (index) {
    if (index === null) {
      $scope.auto_select_recipients = _underscore2.default.where($scope.tabs[0].recipients, {
        checked_send: true
      });
      if ($scope.auto_select_recipients.length > 0) $scope.mass_auto_select_contacts(0);
    } else {
      var recipient = $scope.auto_select_recipients[index];
      recipient.auto_selecting_contacts = true;
      if (recipient.contacts.length > 0) {
        NewsletterService.auto_select_contacts(recipient.id).success(function (data) {
          if (data.success) {
            recipient.auto_selecting_contacts = false;
            recipient.contacts = data.contacts;
            if (index < $scope.auto_select_recipients.length - 1) $scope.mass_auto_select_contacts(index + 1);
          }
        });
      } else {
        recipient.auto_selecting_contacts = false;
        if (index < $scope.auto_select_recipients.length - 1) $scope.mass_auto_select_contacts(index + 1);
      }
    }
  };

  $scope.mass_select_contacts = function (index) {
    if (index === null) {
      $scope.mass_select_recipients = _underscore2.default.where($scope.tabs[0].recipients, {
        checked_send: true
      });
      if ($scope.mass_select_recipients.length > 0) $scope.mass_select_contacts(0);
    } else {
      var recipient = $scope.mass_select_recipients[index];
      var contacts = _underscore2.default.pluck(recipient.contacts, 'id');
      recipient.auto_selecting_contacts = true;
      if (recipient.contacts.length > 0) {
        NewsletterService.set_recipient_contacts(recipient.id, contacts).success(function (data) {
          if (data.success) {
            recipient.auto_selecting_contacts = false;
            recipient.contacts = data.contacts;
            if (index < $scope.mass_select_recipients.length - 1) $scope.mass_select_contacts(index + 1);
          }
        });
      } else {
        recipient.auto_selecting_contacts = false;
        if (index < $scope.mass_select_recipients.length - 1) $scope.mass_select_contacts(index + 1);
      }
    }
  };

  $scope.send = function (recipient) {
    recipient.sending = true;
    NewsletterService.send_email(window.newsletter.id, recipient.id, $scope.test_send, $scope.test_send_email).success(function (data) {
      if (data.success) {
        recipient.sending = false;
        recipient.is_pending = false;
        $scope.allocate_recipient(recipient);
      }
    });
  };

  $scope.mass_send = function (index) {
    if (index === null) {
      $scope.mass_send_recipients = _underscore2.default.where($scope.tabs[0].recipients, {
        checked_send: true
      });
      if ($scope.mass_send_recipients.length > 0) $scope.mass_send(0);
    } else {
      var recipient = $scope.mass_send_recipients[index];
      if (_underscore2.default.where(recipient.contacts, { checked: true }).length > 0) {
        recipient.sending = true;
        NewsletterService.send_email(window.newsletter.id, recipient.id, $scope.test_send, $scope.test_send_email).success(function (data) {
          if (data.success) {
            recipient.sending = false;
            recipient.is_pending = false;
            $scope.allocate_recipient(recipient);
            if (index < $scope.mass_send_recipients.length - 1) $scope.mass_send(index + 1);
          }
        });
      } else {
        if (index < $scope.mass_send_recipients.length - 1) $scope.mass_send(index + 1);
      }
    }
  };

  $scope.quick_search = function (tab_index) {
    window.filter_table('table.tab' + tab_index, $scope.tabs[tab_index].query);
  };

  $scope.$on('load_newsletter_recipients', function () /*event, args*/{
    $scope.load_recipients();
  });

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.newsletter = window.newsletter;
    $scope.current_page = 'recipients_pending';
    $scope.test_send = true;
    $scope.test_send_email = 'p.tsolpagas@epsilon-paper.com';
    $scope.load_recipients();
    $scope._ = _underscore2.default;
  };

  $scope.init();
};

exports.default = NewsletterRecipientsPending;


NewsletterRecipientsPending.$inject = ['$scope', '$timeout', 'NewsletterService'];

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NewsletterRecipientsSent = function NewsletterRecipientsSent($scope, $timeout, NewsletterService) {
  _classCallCheck(this, NewsletterRecipientsSent);

  $scope.tabs = [{
    title: 'Users',
    recipients: []
  }];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.load_recipients = function () {
    $scope.loading = true;
    NewsletterService.get_recipients(window.newsletter.id, 0).success(function (data) {
      _underscore2.default.each(data.recipients, function (recipient) {
        $scope.allocate_recipient(recipient);
      });
      $scope.loading = false;
    });
  };

  $scope.allocate_recipient = function (recipient) {
    $scope.add_tab_recipient(recipient.is_special ? 1 : 0, recipient);
  };

  $scope.add_tab_recipient = function (index, recipient) {
    if (_underscore2.default.indexOf($scope.tabs[index].recipients, recipient) < 0) $scope.tabs[index].recipients.push(recipient);
  };

  $scope.get_xls = function (recipient, xls_filename) {
    $timeout(function () {
      (0, _jquery2.default)('form#getXLS input[name="user_id"]').val(recipient.user_id);
      (0, _jquery2.default)('form#getXLS input[name="xls_filename"]').val(xls_filename);
      (0, _jquery2.default)('form#getXLS').submit();
    }, 300);
  };

  $scope.move_to_pending = function (recipient) {
    recipient.moving_to_pending = true;
    NewsletterService.set_recipient_pending(recipient.id, true).success(function (data) {
      if (data.success) {
        $scope.tabs[0].recipients.splice(_underscore2.default.indexOf($scope.tabs[0].recipients, recipient), 1);
        recipient.moving_to_pending = false;
      }
    });
  };

  $scope.quick_search = function (tab_index) {
    window.filter_table('table.tab' + tab_index, $scope.tabs[tab_index].query);
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.newsletter = window.newsletter;
    $scope.current_page = 'recipients_sent';
    $scope._ = _underscore2.default;
    $scope.load_recipients();
  };

  $scope.init();
};

exports.default = NewsletterRecipientsSent;


NewsletterRecipientsSent.$inject = ['$scope', '$timeout', 'NewsletterService'];

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NewsletterRecipients = function NewsletterRecipients($scope, $rootScope, NewsletterService) {
  _classCallCheck(this, NewsletterRecipients);

  $scope.filter = {
    user_type_buyers: true,
    user_type_sellers: true,
    user_countries: []
  };

  $scope.tabs = [{
    title: 'General',
    buyers: []
  }];

  $scope.toggleEUcountries = function toggleEUcountries(check_eu_countries) {
    if (check_eu_countries) {
      if (!$scope.filter.user_countries) {
        $scope.filter.user_countries = [];
      }
      $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.eu_countries);
    } else {
      $scope.filter.user_countries = _underscore2.default.difference($scope.filter.user_countries, $scope.eu_countries);
    }
    (0, _jquery2.default)('#countries').select2('val', $scope.filter.user_countries);
  };

  $scope.toggleAsiacountries = function toggleAsiacountries(check_asia_countries) {
    if (check_asia_countries) {
      if (!$scope.filter.user_countries) {
        $scope.filter.user_countries = [];
      }
      $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.asia_countries);
    } else {
      $scope.filter.user_countries = _underscore2.default.difference($scope.filter.user_countries, $scope.asia_countries);
    }
    (0, _jquery2.default)('#countries').select2('val', $scope.filter.user_countries);
  };

  $scope.toggleAfricacountries = function toggleAfricacountries(check_africa_countries) {
    if (check_africa_countries) {
      if (!$scope.filter.user_countries) {
        $scope.filter.user_countries = [];
      }
      $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.africa_countries);
    } else {
      $scope.filter.user_countries = _underscore2.default.difference($scope.filter.user_countries, $scope.africa_countries);
    }
    (0, _jquery2.default)('#countries').select2('val', $scope.filter.user_countries);
  };

  $scope.toggleNAmericacountries = function toggleNAmericacountries(check_n_america_countries) {
    if (check_n_america_countries) {
      if (!$scope.filter.user_countries) {
        $scope.filter.user_countries = [];
      }
      $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.n_america_countries);
    } else {
      $scope.filter.user_countries = _underscore2.default.difference($scope.filter.user_countries, $scope.n_america_countries);
    }
    (0, _jquery2.default)('#countries').select2('val', $scope.filter.user_countries);
  };

  $scope.toggleSAmericacountries = function toggleSAmericacountries(check_s_america_countries) {
    if (check_s_america_countries) {
      if (!$scope.filter.user_countries) {
        $scope.filter.user_countries = [];
      }
      $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.s_america_countries);
    } else {
      $scope.filter.user_countries = _underscore2.default.difference($scope.filter.user_countries, $scope.s_america_countries);
    }
    (0, _jquery2.default)('#countries').select2('val', $scope.filter.user_countries);
  };

  $scope.check_items = function (tab_index) {
    _underscore2.default.each($scope.get_users($scope.tabs[tab_index]), function (user) {
      user.checked = $scope.tabs[tab_index].checked;
    });
  };

  $scope.select2_options = {
    containerCssClass: 'multiselect2',
    dropdownCssClass: 'multiselect2',
    width: '600px'
  };

  $scope.select2_options_447 = {
    containerCssClass: 'multiselect2',
    dropdownCssClass: 'multiselect2',
    width: '600px'
  };

  $scope.search = function () {
    $scope.searching = true;
    NewsletterService.find_recipients($scope.newsletter.id, $scope.filter).success(function (data) {
      $scope.tabs[0].users = data.recipients.users;
      $scope.searching = false;
    });
  };

  $scope.add_recipients = function () {
    var users = _underscore2.default.where($scope.tabs[0].users, {
      checked: true
    });
    if (!$scope.adding && users.length > 0) {
      $scope.adding = true;
      $scope.recipients_added = false;
      NewsletterService.add_recipients(window.newsletter.id, users).success(function (data) {
        if (data.success) {
          $scope.tabs[0].users = _underscore2.default.difference($scope.tabs[0].users, users);
          $scope.tabs[0].checked = false;
          $scope.adding = false;
          $scope.recipients_added = true;
        }
      });
    }
  };

  $scope.automate_recipients = function () {
    var buyers = _underscore2.default.where($scope.tabs[0].users, {
      checked: true
    });
    if (buyers.length > 0) {
      var data = {
        newsletter_id: window.newsletter.id,
        buyers: buyers,
        min_quantity: $scope.min_quantity
      };
      $rootScope.$broadcast('show_recipients_dialog', data);
    }
  };

  $scope.$on('remove_automated_recipients', function (event, data) {
    $scope.tabs[0].users = _underscore2.default.difference($scope.tabs[0].users, data.buyers);
    $scope.tabs[0].checked = false;
  });

  $scope.get_users = function (tab) {
    var users = tab.users;

    return users;
  };

  $scope.uncheck_items = function () {
    _underscore2.default.each($scope.tabs, function (tab) {
      tab.checked = false;
      _underscore2.default.each(tab.users, function (buyer) {
        buyer.checked = false;
      });
    });
  };

  $scope.get_newsletter_criteria = function (newsletter_criteria) {
    var status = _underscore2.default.findWhere(window.newsletter_criteria_statuses, {
      id: newsletter_criteria
    });
    return status.title;
  };

  $scope.quick_search = function (tab_index) {
    window.filter_table('table.tab' + tab_index, $scope.tabs[tab_index].query);
  };

  $scope.remove_user = function (user_id) {
    $scope.filter.users = _underscore2.default.reject($scope.filter.users, function (user) {
      return user.id == user_id;
    });
  };

  $scope.quick_search_end_uses = function () {
    if ($scope.quick_filter) {
      var regex = new RegExp($scope.quick_filter, 'i');
      _underscore2.default.each($scope.product_end_uses, function (end_use) {
        end_use.visible = end_use.title.search(regex) > -1;
      });

      $scope.search_filter = {
        visible: true
      };
    } else {
      $scope.search_filter = {};
    }
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.newsletter = window.newsletter;
    $scope.current_page = 'recipients_find';
    $scope.eu_countries = window.eu.countries.map(function (a) {
      return String(a.id);
    });
    $scope.asia_countries = window.asia.countries.map(function (a) {
      return String(a.id);
    });
    $scope.africa_countries = window.africa.countries.map(function (a) {
      return String(a.id);
    });
    $scope.n_america_countries = window.n_america.countries.map(function (a) {
      return String(a.id);
    });
    $scope.s_america_countries = window.s_america.countries.map(function (a) {
      return String(a.id);
    });
    if (_underscore2.default.difference($scope.eu_countries, $scope.filter.user_countries).length === 0) {
      $scope.check_eu_countries = true;
    }
    if (_underscore2.default.difference($scope.asia_countries, $scope.filter.user_countries).length === 0) {
      $scope.check_asia_countries = true;
    }
    if (_underscore2.default.difference($scope.africa_countries, $scope.filter.user_countries).length === 0) {
      $scope.check_africa_countries = true;
    }
    if (_underscore2.default.difference($scope.n_america_countries, $scope.filter.user_countries).length === 0) {
      $scope.check_n_america_countries = true;
    }
    if (_underscore2.default.difference($scope.s_america_countries, $scope.filter.user_countries).length === 0) {
      $scope.check_s_america_countries = true;
    }

    (0, _jquery2.default)('#countries').select2('val', $scope.eu_countries);
  };

  $scope.init();
};

exports.default = NewsletterRecipients;


NewsletterRecipients.$inject = ['$scope', '$rootScope', 'NewsletterService'];

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Newsletter = function Newsletter($scope, NewsletterService, UiService, EmailService) {
  _classCallCheck(this, Newsletter);

  $scope.update_title = function () {
    $scope.updating_title = true;
    var newsletter = {
      id: $scope.newsletter.id,
      title: $scope.new_title
    };
    NewsletterService.update(newsletter).success(function (data) {
      if (data.success) {
        $scope.newsletter.title = $scope.new_title;
        $scope.edit_title = false;
        $scope.updating_title = false;
      }
    });
  };

  $scope.update_template_id = function () {
    $scope.updating_template_id = true;
    var newsletter = {
      id: $scope.newsletter.id,
      template_id: $scope.new_template_id
    };
    NewsletterService.update(newsletter).success(function (data) {
      if (data.success) {
        $scope.newsletter.template_id = $scope.new_template_id;
        $scope.edit_template_id = false;
        $scope.updating_template_id = false;
      }
    });
  };

  $scope.update_general_text = function () {
    $scope.updating_general_text = true;
    var newsletter = {
      id: $scope.newsletter.id,
      general_text: $scope.new_general_text
    };
    NewsletterService.update(newsletter).success(function (data) {
      if (data.success) {
        $scope.newsletter.general_text = $scope.new_general_text;
        $scope.edit_general_text = false;
        $scope.updating_general_text = false;
      }
    });
  };

  $scope.update_general_text_el = function () {
    $scope.updating_general_text_el = true;
    var newsletter = {
      id: $scope.newsletter.id,
      general_text_el: $scope.new_general_text_el
    };
    NewsletterService.update(newsletter).success(function (data) {
      if (data.success) {
        $scope.newsletter.general_text_el = $scope.new_general_text_el;
        $scope.edit_general_text_el = false;
        $scope.updating_general_text_el = false;
      }
    });
  };

  $scope.update_supplier_text = function () {
    $scope.updating_supplier_text = true;
    var newsletter = {
      id: $scope.newsletter.id,
      supplier_text: $scope.new_supplier_text
    };
    NewsletterService.update(newsletter).success(function (data) {
      if (data.success) {
        $scope.newsletter.supplier_text = $scope.new_supplier_text;
        $scope.edit_supplier_text = false;
        $scope.updating_supplier_text = false;
      }
    });
  };

  $scope.update_supplier_text_el = function () {
    $scope.updating_supplier_text_el = true;
    var newsletter = {
      id: $scope.newsletter.id,
      supplier_text_el: $scope.new_supplier_text_el
    };
    NewsletterService.update(newsletter).success(function (data) {
      if (data.success) {
        $scope.newsletter.supplier_text_el = $scope.new_supplier_text_el;
        $scope.edit_supplier_text_el = false;
        $scope.updating_supplier_text_el = false;
      }
    });
  };

  $scope.update_supplier_text_el_per = function () {
    $scope.updating_supplier_text_el_per = true;
    var newsletter = {
      id: $scope.newsletter.id,
      supplier_text_el_per: $scope.new_supplier_text_el_per
    };
    NewsletterService.update(newsletter).success(function (data) {
      if (data.success) {
        $scope.newsletter.supplier_text_el_per = $scope.new_supplier_text_el_per;
        $scope.edit_supplier_text_el_per = false;
        $scope.updating_supplier_text_el_per = false;
      }
    });
  };

  $scope.update_sender_name = function () {
    $scope.updating_sender_name = true;
    var newsletter = {
      id: $scope.newsletter.id,
      sender_name: $scope.new_sender_name
    };
    NewsletterService.update(newsletter).success(function (data) {
      if (data.success) {
        $scope.newsletter.sender_name = $scope.new_sender_name;
        $scope.edit_sender_name = false;
        $scope.updating_sender_name = false;
      }
    });
  };

  $scope.update_sender_name_el = function () {
    $scope.updating_sender_name_el = true;
    var newsletter = {
      id: $scope.newsletter.id,
      sender_name_el: $scope.new_sender_name_el
    };
    NewsletterService.update(newsletter).success(function (data) {
      if (data.success) {
        $scope.newsletter.sender_name_el = $scope.new_sender_name_el;
        $scope.edit_sender_name_el = false;
        $scope.updating_sender_name_el = false;
      }
    });
  };

  $scope.sender_names = EmailService.get_sender_names_en();
  $scope.sender_names_el = EmailService.get_sender_names_el();

  $scope.$watch('select_sender_name', function () {
    if ($scope.select_sender_name) $scope.new_sender_name = $scope.select_sender_name;
  });

  $scope.$watch('select_sender_name_el', function () {
    if ($scope.select_sender_name_el) $scope.new_sender_name_el = $scope.select_sender_name_el;
  });

  $scope.update_newsletter = function (field, loader) {
    $scope[loader] = true;
    var newsletter = {
      id: $scope.newsletter.id
    };
    newsletter[field] = $scope.newsletter[field];
    NewsletterService.update(newsletter).success(function (data) {
      if (data.success) $scope[loader] = false;
    });
  };

  $scope.init = function () {
    $scope.tinymceOptions = UiService.tinymceOptions();
    $scope.newsletter = window.newsletter;
    $scope.current_page = 'basic_infos';
  };

  $scope.init();
};

exports.default = Newsletter;


Newsletter.$inject = ['$scope', 'NewsletterService', 'UiService', 'EmailService'];

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Newsletters = function Newsletters($scope, $rootScope, NewsletterService, PaginationService, UserService, DateService) {
  _classCallCheck(this, Newsletters);

  $scope.load_data = function () {
    $scope.loading = true;
    NewsletterService.get($scope.filter).success(function (data) {
      $scope.newsletters = data.newsletters;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
      if ($scope.selected_newsletters) {
        _underscore2.default.each($scope.selected_newsletters, function (newsletter_id) {
          var newsletter = _underscore2.default.findWhere($scope.newsletters, {
            id: newsletter_id
          });
          if (newsletter) newsletter.checked = true;
        });
      }
      $scope.loading = false;
    });
  };

  $scope.delete_newsletter = function (newsletter_id) {
    if (confirm('Are you sure you want to delete this newsletter?')) {
      NewsletterService.delete(newsletter_id).success(function (data) {
        if (data.success) $scope.load_data();
      });
    }
  };

  $scope.init_filter = function () {
    $scope.supplier_company = null;
    $scope.buyer_company = null;
    var now = new Date();
    var date_from = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 60);
    var date_to = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    $scope.filter = {
      page: 1,
      per_page: 40,
      supplier_id: null,
      buyer_id: null,
      is_buyer_pending: false,
      status: 0,
      date_from: DateService.get_date_str(date_from),
      date_to: DateService.get_date_str(date_to)
    };
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.load_data();
  };

  $scope.$on('reload_newsletter_data', function () {
    $scope.load_data();
  });

  $scope.status_options = [{
    id: 0,
    title: 'All'
  }, {
    id: 1,
    title: 'Executed Newsletters'
  }, {
    id: 2,
    title: 'Pending Newsletters'
  }];

  $scope.quick_search = function () {
    window.filter_table('table.data', $scope.quick_filter);
  };

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.init = function () {
    $scope.newsletters = [];
    $scope.pagination = {};
    $scope.init_filter();
    $scope.load_data();
  };

  $scope.init();
};

exports.default = Newsletters;


Newsletters.$inject = ['$scope', '$rootScope', 'NewsletterService', 'PaginationService', 'UserService', 'DateService'];

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferActivatePriceDialog = function OfferActivatePriceDialog($scope, OfferService) {
  _classCallCheck(this, OfferActivatePriceDialog);

  $scope.$on('open_activate_price_dialog', function (event, args) {
    $scope.offer_id = args.offer_id;
    $scope.supplier_id = args.supplier_id;
    $scope.buyer_id = args.buyer_id;
    $scope.country_id = args.country_id;
    $scope.open_dialog();
  });

  $scope.open_dialog = function () {
    $scope.activate_loading = true;
    OfferService.get_prices_for_activation($scope.offer_id, $scope.supplier_id, $scope.buyer_id, $scope.country_id).then(function (data) {
      $scope.uspp_prices = data.uspp_prices;
      $scope.uspc_prices = data.uspc_prices;
      $scope.activate_loading = false;
    });
    window.openFancyboxDialog('div#activate_price_dialog');
  };

  $scope.update_uspp_activation = function (price) {
    price.updating = true;
    OfferService.set_uspp_activation(price.id, !price.auto_activation).then(function (response) {
      if (response.data.success) {
        price.auto_activation = !price.auto_activation;
        price.updating = false;
      }
    });
  };

  $scope.update_uspc_activation = function (price) {
    price.updating = true;
    OfferService.set_uspc_activation(price.id, !price.auto_activation).then(function (response) {
      if (response.data.success) {
        price.auto_activation = !price.auto_activation;
        price.updating = false;
      }
    });
  };

  $scope.init = function () {
    $scope.uspp_prices = [];
    $scope.uspc_prices = [];
  };

  $scope.init();
};

exports.default = OfferActivatePriceDialog;


OfferActivatePriceDialog.$inject = ['$scope', 'OfferService'];

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferCampaignAttachments = function OfferCampaignAttachments($scope, OfferCampaignService, FileUploader) {
  _classCallCheck(this, OfferCampaignAttachments);

  function set_uploaders() {
    var uploaders = [{
      name: 'attachment_uploader',
      url: '/admin/marketplace/campaigns/upload_offer_campaign_attachment/' + window.offer_campaign.id,
      element: 'attachment_file'
    }];
    _underscore2.default.each(uploaders, function (uploader) {
      var f = new FileUploader({
        url: uploader.url,
        formData: [{
          authenticity_token: window.token
        }],
        removeAfterUpload: true
      });
      f.file_element = uploader.element;
      f.onBeforeUploadItem = function () /*item*/{
        f.processing = true;
      };
      f.onCompleteItem = function (fileItem, response /*, status, headers*/) {
        if (response.success) {
          f.processing = false;
          f.clearQueue();
          (0, _jquery2.default)('input.' + f.file_element).val(null);
          load_data();
        }
      };
      $scope[uploader.name] = f;
    });
  }

  function load_data() {
    OfferCampaignService.get_attachments(window.offer_campaign.id).success(function (data) {
      if (data.success) $scope.attachments = data.attachments;
    });
  }

  $scope.init = function () {
    set_uploaders();
    load_data();
  };

  $scope.init();
};

exports.default = OfferCampaignAttachments;


OfferCampaignAttachments.$inject = ['$scope', 'OfferCampaignService', 'FileUploader'];

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferCampaignBasicInfos = function OfferCampaignBasicInfos($scope, OfferService, OfferCampaignService, UiService, EmailService) {
  _classCallCheck(this, OfferCampaignBasicInfos);

  $scope.save = function () {
    $scope.saving = true;
    OfferService.save_offer_campaign_settings(window.offer_id, $scope.settings).success(function (data) {
      if (data.success) $scope.saving = false;
    });
  };

  $scope.copy_fields = function () {
    $scope.copying_fields = true;
    OfferService.copy_text_fields($scope.similar_campaign_id, window.offer_id).success(function (data) {
      if (data.success) {
        location.reload();
      }
    });
  };

  $scope.init = function () {
    $scope.tinymceOptions = UiService.tinymceOptions();
    $scope.settings = window.campaign_settings || OfferCampaignService.get_default_settings(window.offer_title);
    $scope.settings = OfferCampaignService.set_default_settings($scope.settings);
    $scope.currency_symbols = window.currency_symbols;
    $scope.sender_names = EmailService.get_sender_names_en();
    $scope.sender_names_el = EmailService.get_sender_names_el();
    $scope.similar_campaigns = window.similar_campaigns;
    if ($scope.similar_campaigns.length > 0) {
      $scope.similar_campaign_id = $scope.similar_campaigns[0].id;
    }
  };

  $scope.init();
};

exports.default = OfferCampaignBasicInfos;


OfferCampaignBasicInfos.$inject = ['$scope', 'OfferService', 'OfferCampaignService', 'UiService', 'EmailService'];

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferCampaignCreateDialog = function OfferCampaignCreateDialog($scope, $rootScope, $q, OfferCampaignService) {
  _classCallCheck(this, OfferCampaignCreateDialog);

  $scope.$on('show_create_campaign', function (event, data) {
    $scope.total_count = data.total_count;
    $scope.current_index = data.current_index;
    $scope.send = data.send || 0;
    _underscore2.default.each($scope.steps, function (step) {
      step.processing = false;
      step.completed = false;
      step.progress_started = false;
      step.progress = 0;
      $scope.offer_campaign_id = null;
    });
    window.openFancyboxDialog('div#offer_campaign_create_dialog');
    create_campaign(data.offer_id, data.campaign_settings, data.deferred || null);
  });

  $scope.steps = [{
    id: 1,
    title: 'Create Offer Campaign'
  }, {
    id: 2,
    title: 'Copy Basic Infos'
  }, {
    id: 3,
    title: 'Find and Add Recipients'
  }, {
    id: 4,
    title: 'Create XLS for General Recipients'
  }, {
    id: 5,
    title: 'Calculate Qty for Special Recipients'
  }, {
    id: 6,
    title: 'Embed matched for Special Recipients'
  }, {
    id: 7,
    title: 'Create XLS for Special Recipients'
  }, {
    id: 8,
    title: 'Ignore PI XLS for Special Recipients'
  }, {
    id: 9,
    title: 'Mark template done for Special Recipients'
  }];

  function set_processing(step_index) {
    if (step_index > 0) {
      $scope.steps[step_index - 1].processing = false;
      $scope.steps[step_index - 1].completed = true;
    }
    $scope.steps[step_index].processing = true;
  }

  function create_general_xls(recipients) {
    $scope.steps[3].progress = 0;
    $scope.steps[3].progress_started = true;
    return recipients.reduce(function (promise, recipient, index) {
      return promise.then(function () {
        $scope.steps[3].progress = Math.ceil(index / recipients.length * 100);
        return OfferCampaignService.create_general_xls($scope.offer_campaign_id, recipient.user_id, recipient.attachments.delivery_country_id);
      });
    }, $q.when(true));
  }

  function calculate_special_qty(recipients) {
    $scope.steps[4].progress = 0;
    $scope.steps[4].progress_started = true;
    return recipients.reduce(function (promise, recipient, index) {
      return promise.then(function (response) {
        if (response && response.data) {
          recipients[index - 1].matched_quantity = response.data.matched_quantity;
          recipients[index - 1].matched_items = response.data.matched_items;
        }
        $scope.steps[4].progress = Math.ceil(index / recipients.length * 100);
        return OfferCampaignService.get_matched_quantity($scope.offer_campaign_id, recipient.user_id, recipient.attachments.delivery_country_id);
      });
    }, $q.when(true));
  }

  function embed_matched_special(recipients, min_quantity, max_embedded_matched_rows) {
    $scope.steps[5].progress = 0;
    $scope.steps[5].progress_started = true;
    return recipients.reduce(function (promise, recipient, index) {
      return promise.then(function (response) {
        update_recipient_with_text(index - 1, response);
        $scope.steps[5].progress = Math.ceil(index / recipients.length * 100);
        console.log(recipient);
        var quantity_pass = false;
        var rows_pass = false;
        if (recipient.min_qty) {
          min_quantity = recipient.min_qty;
        }
        if (recipient.max_rows) {
          max_embedded_matched_rows = recipient.max_rows;
        }

        console.log(min_quantity);
        console.log(max_embedded_matched_rows);
        if (min_quantity > 0 && recipient.matched_quantity > min_quantity) {
          quantity_pass = true;
        }
        if (max_embedded_matched_rows > 0 && recipient.matched_items <= max_embedded_matched_rows) {
          rows_pass = true;
        }
        console.log(quantity_pass);
        console.log(rows_pass);
        if (quantity_pass && rows_pass || rows_pass && !(min_quantity > 0) || quantity_pass && !(max_embedded_matched_rows > 0)) {
          console.log('embed stocklist!');
          return OfferCampaignService.update_recipient_embed_matched(recipient.id, true);
        } else {
          return true;
        }
      });
    }, $q.when(true));
  }

  function create_special_xls(recipients) {
    $scope.steps[6].progress = 0;
    $scope.steps[6].progress_started = true;
    return recipients.reduce(function (promise, recipient, index) {
      return promise.then(function () {
        $scope.steps[6].progress = Math.ceil(index / recipients.length * 100);
        return OfferCampaignService.create_special_xls($scope.offer_campaign_id, recipient.user_id, recipient.attachments.delivery_country_id, true, false);
      });
    }, $q.when(true));
  }

  function ignore_pi_xls(recipients) {
    $scope.steps[7].progress = 0;
    $scope.steps[7].progress_started = true;
    return recipients.reduce(function (promise, recipient, index) {
      return promise.then(function (response) {
        update_recipient_with_text(index - 1, response);
        $scope.steps[7].progress = Math.ceil(index / recipients.length * 100);
        if (recipient.user_data.is_pi) return OfferCampaignService.set_recipient_attachment(recipient.id, [{
          key: 'ignore_pi_xls',
          value: true
        }, {
          key: 'stocklist_pi_xls',
          value: false
        }]);else return true;
      });
    }, $q.when(true));
  }

  function mark_template_done(recipients) {
    $scope.steps[8].progress = 0;
    $scope.steps[8].progress_started = true;
    return recipients.reduce(function (promise, recipient, index) {
      return promise.then(function () {
        $scope.steps[8].progress = Math.ceil(index / recipients.length * 100);
        return OfferCampaignService.update_recipient_template_text(recipient.id, recipient.template_text, recipient.template_text_per, true);
      });
    }, $q.when(true));
  }

  function update_recipient_with_text(index, response) {
    if (response.data && response.data.template_text) $scope.special_recipients[index].template_text = response.data.template_text;
    if (response.data && response.data.template_text_per) $scope.special_recipients[index].template_text_per = response.data.template_text_per;
  }

  function create_campaign(offer_id, settings, deferred) {
    var t0 = performance.now();
    set_processing(0);
    var create_data = {
      offer_id: offer_id,
      title: settings.campaign_title,
      title_el: settings.campaign_title_el,
      embed_stocklist: settings.embed_stocklist || false,
      related_offer_id: settings.related_offer_id || null,
      related_offer_prices: settings.related_offer_prices || false,
      hide_offer_prices: settings.hide_offer_prices || false,
      hide_cfr_prices: settings.hide_cfr_prices || false,
      hide_dap_prices: settings.hide_dap_prices || false,
      product_group_specs: settings.product_group_specs || false,
      currency_symbol: settings.currency_symbol || 0,
      use_product_name: settings.use_product_name || false,
      sort_items: settings.sort_items || false,
      sort_items_by_parent_id: settings.sort_items_by_parent_id || false,
      use_custom_template: settings.use_custom_template || false,
      general_text: settings.general_text || null,
      general_text_el: settings.general_text_el || null,
      supplier_text: settings.supplier_text || null,
      supplier_text_el: settings.supplier_text_el || null,
      supplier_text_el_per: settings.supplier_text_el_per || null,
      supplier_text_greeting: settings.supplier_text_greeting || null,
      supplier_text_greeting_el: settings.supplier_text_greeting_el || null,
      supplier_text_greeting_el_per: settings.supplier_text_greeting_el_per || null,
      sender_name: settings.sender_name || null,
      sender_name_el: settings.sender_name_el || null,
      filename_stocklist: settings.filename_stocklist || null,
      filename_stocklist_pi: settings.filename_stocklist_pi || null,
      max_embedded_matched_rows: settings.max_embedded_matched_rows || 0,
      special_notes: settings.special_notes || null,
      target_recipients: settings.target_recipients || null
    };
    OfferCampaignService.create(create_data).then(function (response) {
      $scope.offer_campaign_id = response.data.offer_campaign_id;
      set_processing(1);
      if (settings.campaign_id) {
        return OfferCampaignService.copy_basic_infos(settings.campaign_id, $scope.offer_campaign_id);
      } else {
        return true;
      }
    }).then(function () /*response*/{
      set_processing(2);
      return OfferCampaignService.find_and_add_recipients($scope.offer_campaign_id, settings.filter);
    }).then(function () /*response*/{
      set_processing(3);
      return OfferCampaignService.get_recipients($scope.offer_campaign_id, 0, 1);
    }).then(function (response) {
      return create_general_xls(response.data.recipients);
    }).then(function () {
      $scope.steps[3].progress = 100;
      set_processing(4);
      return OfferCampaignService.get_recipients($scope.offer_campaign_id, 1, 1);
    }).then(function (response) {
      $scope.special_recipients = response.data.recipients;
      return calculate_special_qty($scope.special_recipients);
    }).then(function (response) {
      if (response && response.data) {
        $scope.special_recipients[$scope.special_recipients.length - 1].matched_quantity = response.data.matched_quantity;
        $scope.special_recipients[$scope.special_recipients.length - 1].matched_items = response.data.matched_items;
      }

      $scope.steps[4].progress = 100;
      set_processing(5);
      return embed_matched_special($scope.special_recipients, settings.min_quantity, settings.max_embedded_matched_rows);
    }).then(function (response) {
      update_recipient_with_text($scope.special_recipients.length - 1, response);
      $scope.steps[5].progress = 100;
      set_processing(6);
      return create_special_xls($scope.special_recipients);
    }).then(function () {
      $scope.steps[6].progress = 100;
      set_processing(7);
      return ignore_pi_xls($scope.special_recipients);
    }).then(function (response) {
      update_recipient_with_text($scope.special_recipients.length - 1, response);
      $scope.steps[7].progress = 100;
      set_processing(8);
      return mark_template_done($scope.special_recipients);
    }).then(function () {
      $scope.steps[8].progress = 100;

      var t1 = performance.now();
      $scope.created_time = [(t1 - t0) / 1000];
      if (deferred) {
        _jquery2.default.fancybox.close();
        $rootScope.$broadcast('update_offer_data', {
          offer_id: offer_id,
          campaign_id: $scope.offer_campaign_id
        });
        deferred.resolve({
          campaign_id: $scope.offer_campaign_id
        });
      } else if (!$scope.send) {
        OfferCampaignService.send_created_campaigns_email([$scope.offer_campaign_id], $scope.created_time);
      }
    }).then(function () {
      _jquery2.default.fancybox.close();
      if ($scope.send) {
        $scope.filter = {
          offer_campaign_id: $scope.offer_campaign_id
        };
        OfferCampaignService.get($scope.filter).success(function (data) {
          $rootScope.$broadcast('show_mass_send_dialog', {
            campaigns: data.campaigns,
            created_times: $scope.created_time,
            deferred: $q.defer()
          });
        });
      }
    });
  }
};

exports.default = OfferCampaignCreateDialog;


OfferCampaignCreateDialog.$inject = ['$scope', '$rootScope', '$q', 'OfferCampaignService'];

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferCampaignCreate = function OfferCampaignCreate($scope, OfferCampaignService) {
  _classCallCheck(this, OfferCampaignCreate);

  $scope.create = function () {
    $scope.creating = true;
    OfferCampaignService.create($scope.campaign).success(function (data) {
      if (data.success) window.location = '/admin/marketplace/campaigns/offers/' + data.offer_campaign_id;
    });
  };

  $scope.init = function () {
    $scope.campaign = {
      offer_id: window.offer_id,
      title: window.offer_title,
      max_embedded_matched_rows: 12
    };
  };

  $scope.init();
};

exports.default = OfferCampaignCreate;


OfferCampaignCreate.$inject = ['$scope', 'OfferCampaignService'];

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferCampaignFields = function OfferCampaignFields($scope, OfferCampaignService, UiService) {
  _classCallCheck(this, OfferCampaignFields);

  $scope.fields = [{
    name: 'general_text_en',
    description: 'General Text (English)'
  }, {
    name: 'general_text_el',
    description: 'General Text (Greek)'
  }, {
    name: 'general_text_el_per',
    description: 'General Text (Greek) (Personal)'
  }, {
    name: 'matched_text_en',
    description: 'Matched Text (English)'
  }, {
    name: 'matched_text_el',
    description: 'Matched Text (Greek)'
  }, {
    name: 'matched_text_el_per',
    description: 'Matched Text (Greek) (Personal)'
  }, {
    name: 'ospp_text_en',
    description: 'OSPP Text (English)'
  }, {
    name: 'ospp_text_el',
    description: 'OSPP Text (Greek)'
  }, {
    name: 'ospp_text_el_per',
    description: 'OSPP Text (Greek) (Personal)'
  }, {
    name: 'pi_text_en',
    description: 'PI Text (English)'
  }, {
    name: 'pi_text_el',
    description: 'PI Text (Greek)'
  }, {
    name: 'pi_text_el_per',
    description: 'PI Text (Greek) (Personal)'
  }, {
    name: 'matched_ospp_text_en',
    description: 'Matched + OSPP Text (English)'
  }, {
    name: 'matched_ospp_text_el',
    description: 'Matched + OSPP Text (Greek)'
  }, {
    name: 'matched_ospp_text_el_per',
    description: 'Matched + OSPP Text (Greek) (Personal)'
  }, {
    name: 'matched_pi_text_en',
    description: 'Matched + PI Text (English)'
  }, {
    name: 'matched_pi_text_el',
    description: 'Matched + PI Text (Greek)'
  }, {
    name: 'matched_pi_text_el_per',
    description: 'Matched + PI Text (Greek) (Personal)'
  }, {
    name: 'ospp_pi_text_en',
    description: 'OSPP + PI Text (English)'
  }, {
    name: 'ospp_pi_text_el',
    description: 'OSPP + PI Text (Greek)'
  }, {
    name: 'ospp_pi_text_el_per',
    description: 'OSPP + PI Text (Greek) (Personal)'
  }, {
    name: 'matched_ospp_pi_text_en',
    description: 'Matched + OSPP + PI Text (English)'
  }, {
    name: 'matched_ospp_pi_text_el',
    description: 'Matched + OSPP + PI Text (Greek)'
  }, {
    name: 'matched_ospp_pi_text_el_per',
    description: 'Matched + OSPP + PI Text (Greek) (Personal)'
  }, {
    name: 'embedded_offer_text_en',
    description: 'Recipient + Embedded Offer Text (English)'
  }, {
    name: 'embedded_offer_text_el',
    description: 'Recipient + Embedded Offer Text (Greek)'
  }, {
    name: 'embedded_offer_text_el_per',
    description: 'Recipient + Embedded Offer Text (Greek) (Personal)'
  }, {
    name: 'pi_embedded_pi_text_en',
    description: 'PI Recipient + Embedded PI Text (English)'
  }, {
    name: 'pi_embedded_pi_text_el',
    description: 'PI Recipient + Embedded PI Text (Greek)'
  }, {
    name: 'pi_embedded_pi_text_el_per',
    description: 'PI Recipient + Embedded PI Text (Greek) (Personal)'
  }, {
    name: 'pi_embedded_offer_text_en',
    description: 'PI Recipient + Embedded Offer Text (English)'
  }, {
    name: 'pi_embedded_offer_text_el',
    description: 'PI Recipient + Embedded Offer Text (Greek)'
  }, {
    name: 'pi_embedded_offer_text_el_per',
    description: 'PI Recipient + Embedded Offer Text (Greek) (Personal)'
  }, {
    name: 'pi_embedded_pi_ignored_xls_text_en',
    description: 'PI Recipient + Embedded PI + Ignored XLS Text (English)'
  }, {
    name: 'pi_embedded_pi_ignored_xls_text_el',
    description: 'PI Recipient + Embedded PI + Ignored XLS Text (Greek)'
  }, {
    name: 'pi_embedded_pi_ignored_xls_text_el_per',
    description: 'PI Recipient + Embedded PI + Ignored XLS Text (Greek) (Personal)'
  }, {
    name: 'pi_ignored_xls_text_en',
    description: 'PI Recipient + Ignored XLS Text (English)'
  }, {
    name: 'pi_ignored_xls_text_el',
    description: 'PI Recipient + Ignored XLS Text (Greek)'
  }, {
    name: 'pi_ignored_xls_text_el_per',
    description: 'PI Recipient + Ignored XLS Text (Greek) (Personal)'
  }, {
    name: 'related_offer_en',
    description: 'Related Offer Text (English)'
  }, {
    name: 'related_offer_el',
    description: 'Related Offer Text (Greek)'
  }, {
    name: 'related_offer_el_per',
    description: 'Related Offer Text (Greek) (Personal)'
  }];

  $scope.load_data = function () {
    $scope.loading = true;
    OfferCampaignService.get_fields().success(function (data) {
      _underscore2.default.each(data.fields, function (f) {
        var field = _underscore2.default.findWhere($scope.fields, {
          name: f.name
        });
        if (field) {
          field.id = f.id;
          field.value = f.value;
        }
      });
      $scope.loading = false;
    });
  };

  $scope.update_field = function (field) {
    field.updating = true;
    var field_data = {
      id: field.id || null,
      name: field.name,
      value: field.new_value
    };
    OfferCampaignService.update_field(field_data).success(function (data) {
      if (data.success) {
        if (data.field_id) field.id = data.field_id;
        field.value = field.new_value;
        field.edit_mode = false;
        field.updating = false;
      }
    });
  };

  $scope.init = function () {
    $scope.tinymceOptions = UiService.tinymceOptions();
    $scope.load_data();
  };

  $scope.init();
};

exports.default = OfferCampaignFields;


OfferCampaignFields.$inject = ['$scope', 'OfferCampaignService', 'UiService'];

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

//import $ from 'jquery';

var OfferCampaignMassSendDialog = function OfferCampaignMassSendDialog($scope, $rootScope, $q, OfferCampaignService) {
  _classCallCheck(this, OfferCampaignMassSendDialog);

  $scope.$on('show_mass_send_dialog', function (event, data) {
    window.openFancyboxDialog('div#offer_campaign_mass_send_dialog');
    $scope.campaigns = data.campaigns;
    $scope.proc_campaigns = [];
    $scope.created_times = data.created_times;
    $scope.times = [];
    mass_send_campaigns();
  });

  $scope.steps = [{
    id: 1,
    title: 'Campaigns - Special',
    counter: 0
  }, {
    id: 2,
    title: 'Send Special Recipients',
    counter: 0
  }, {
    id: 3,
    title: 'Campaigns - General',
    counter: 0
  }, {
    id: 4,
    title: 'Send General Recipients',
    counter: 0
  }];

  function get_special_ready_to_send(recipients) {
    var filtered_recipients = [];
    _underscore2.default.each(recipients, function (recipient) {
      var has_xls = recipient.attachments && recipient.attachments.stocklist_xls;
      var has_pi_xls = recipient.attachments && recipient.attachments.stocklist_pi_xls;
      //var ignored_xls = recipient.attachments && recipient.attachments.ignore_xls;
      var ignored_pi_xls = recipient.attachments && recipient.attachments.ignore_pi_xls;
      var is_pi = recipient.user_data.is_pi;
      var has_template = !recipient.template_pending;
      var is_pi_ready = !is_pi || has_pi_xls || ignored_pi_xls;

      if ((has_xls || has_pi_xls) && has_template && is_pi_ready) filtered_recipients.push(recipient);
    });

    return filtered_recipients;
  }

  function get_general_ready_to_send(recipients) {
    var filtered_recipients = [];
    _underscore2.default.each(recipients, function (recipient) {
      var has_xls = recipient.attachments && recipient.attachments.stocklist_xls;
      if (has_xls) filtered_recipients.push(recipient);
    });

    return filtered_recipients;
  }

  function send_recipients(campaign_id, recipients, is_special) {
    return recipients.reduce(function (promise, recipient, index) {
      return promise.then(function () {
        var step_id = is_special ? 1 : 3;
        $scope.steps[step_id].progress = Math.ceil((index + 1) / recipients.length * 100);

        if ($scope.steps[step_id].counter == 0) {
          $scope.steps[step_id].counter = 1;
          return OfferCampaignService.send_email_and_test(campaign_id, recipient.id, true, 'p.tsolpagas@epsilon-paper.com');
        }
        $scope.steps[step_id].counter = $scope.steps[step_id].counter + 1;
        return OfferCampaignService.send_email(campaign_id, recipient.id, false, null);
      });
    }, $q.when(true));
  }

  function process_campaign(campaign_id, index, is_special, deferred) {
    var t0 = performance.now();
    $scope.steps[is_special ? 0 : 2].progress = Math.ceil((index + 1) / $scope.campaigns.length * 100);
    $scope.steps[is_special ? 1 : 3].progress = 0;

    OfferCampaignService.get_recipients(campaign_id, is_special ? 1 : 0, 1).then(function (response) {
      var recipients = null;
      if (is_special) recipients = get_special_ready_to_send(response.data.recipients);else recipients = get_general_ready_to_send(response.data.recipients);
      return send_recipients(campaign_id, recipients, is_special);
    }).then(function () {
      var t1 = performance.now();
      $scope.times.push((t1 - t0) / 1000);

      deferred.resolve();
    });
  }

  function process_campaigns(is_special) {
    $scope.times = [];
    return $scope.campaigns.reduce(function (promise, campaign, index) {
      return promise.then(function () {
        var deferred = $q.defer();
        process_campaign(campaign.id, index, is_special, deferred);
        if (is_special) {
          $scope.proc_campaigns.push(campaign.id);
        }
        return deferred.promise;
      });
    }, $q.when()).then(function () {});
  }

  function mass_send_campaigns() {
    _underscore2.default.each($scope.steps, function (step) {
      step.progress = 0;
      step.progress_started = true;
    });

    process_campaigns(true).then(function () {
      return process_campaigns(false);
    }).then(function () {
      OfferCampaignService.send_campaigns_sent_email($scope.proc_campaigns, $scope.times, $scope.created_times);

      $rootScope.$broadcast('show_mass_send_report', {
        campaigns: $scope.proc_campaigns,
        sent_times: $scope.times,
        created_times: $scope.created_times
      });
    });
  }
};

exports.default = OfferCampaignMassSendDialog;


OfferCampaignMassSendDialog.$inject = ['$scope', '$rootScope', '$q', 'OfferCampaignService'];

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferCampaignMassSendReport = function OfferCampaignMassSendReport($scope, OfferCampaignService) {
  _classCallCheck(this, OfferCampaignMassSendReport);

  $scope.$on('show_mass_send_report', function (event, data) {

    _jquery2.default.fancybox.close();
    $scope.filter = {
      offer_campaign_id: data.campaigns
    };
    $scope.created_times = data.created_times.map(Number);
    $scope.sent_times = data.sent_times.map(Number);
    $scope.sum_sent_times = _underscore2.default.reduce(data.sent_times, function (memo, num) {
      return memo + num;
    }, 0).toFixed(2);
    $scope.sum_created_times = _underscore2.default.reduce(data.created_times, function (memo, num) {
      return memo + num;
    }, 0).toFixed(2);
    $scope.sum_all_times = $scope.sum_time($scope.sum_sent_times, $scope.sum_created_times);
    OfferCampaignService.get($scope.filter).success(function (data) {
      $scope.campaigns = data.campaigns;
      $scope.links = [];
      $scope.links_all_rec = [];
      $scope.links_gen_rec = [];
      $scope.links_spec_rec = [];
      $scope.links_sent_rec = [];
      _underscore2.default.each($scope.campaigns, function (campaign) {
        $scope.links.push('http://demo.epsilon-paper.com/admin/marketplace/campaigns/offers/' + campaign.id);
        $scope.links_all_rec.push('http://demo.epsilon-paper.com/admin/marketplace/campaigns/offers/recipients/' + campaign.id);
        $scope.links_gen_rec.push('http://demo.epsilon-paper.com/admin/marketplace/campaigns/offers/recipients/pending/general/' + campaign.id);
        $scope.links_spec_rec.push('http://demo.epsilon-paper.com/admin/marketplace/campaigns/offers/recipients/pending/special/' + campaign.id);
        $scope.links_sent_rec.push('http://demo.epsilon-paper.com/admin/marketplace/campaigns/offers/recipients/sent/' + campaign.id);
      });
      window.openFancyboxDialog('div#offer_campaign_mass_send_report');
      _jquery2.default.fancybox.open();
    });
  });

  $scope.sum = function (a, b) {
    return parseInt(a) + parseInt(b);
  };

  $scope.sum_time = function (a, b) {
    return (Number(a) + Number(b)).toFixed(2);
  };

  $scope.sub = function (a, b) {
    return parseInt(a) - parseInt(b);
  };
};

exports.default = OfferCampaignMassSendReport;


OfferCampaignMassSendReport.$inject = ['$scope', 'OfferCampaignService'];

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferCampaignProductSpec = function OfferCampaignProductSpec($scope, ProductService) {
  _classCallCheck(this, OfferCampaignProductSpec);

  $scope.$watch('spec.product_category_id', function () {
    if ($scope.spec.product_category_id) {
      ProductService.get_groups($scope.spec.product_category_id).then(function (data) {
        $scope.product_groups = data.groups;
      });
    }
  });

  $scope.$watch('spec.product_group_id', function () {
    if ($scope.spec.product_group_id) {
      ProductService.get_products($scope.spec.product_group_id).then(function (data) {
        $scope.products = data.products;
      });
    }
  });

  $scope.init = function () {
    $scope.product_groups = [];
    $scope.products = [];
  };

  $scope.init();
};

exports.default = OfferCampaignProductSpec;


OfferCampaignProductSpec.$inject = ['$scope', 'ProductService'];

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferCampaignRecipientAttachmentsDialog = function OfferCampaignRecipientAttachmentsDialog($scope, $rootScope, OfferCampaignService) {
  _classCallCheck(this, OfferCampaignRecipientAttachmentsDialog);

  function get_dialog_data() {
    OfferCampaignService.get_attachments(window.offer_campaign.id).success(function (data) {
      $scope.attachments = data.attachments;
    });
  }

  $scope.$on('show_select_attachments', function (event, data) {
    $scope.select_all = false;
    $scope.recipients = data.recipients;
    if ($scope.recipients.length == 1) {
      var attachments = _underscore2.default.pluck($scope.recipients[0].campaign_attachments, 'id');
      _underscore2.default.each($scope.attachments, function (a) {
        a.checked = _underscore2.default.contains(attachments, a.id);
      });
    } else {
      _underscore2.default.each($scope.attachments, function (a) {
        a.checked = false;
      });
    }
    window.openFancyboxDialog('div#offer_campaign_recipient_attachments_dialog');
  });

  $scope.check_attachments = function () {
    _underscore2.default.each($scope.attachments, function (a) {
      a.checked = $scope.select_all;
    });
  };

  $scope.save = function () {
    var attachments = _underscore2.default.where($scope.attachments, {
      checked: true
    });
    $scope.saving = true;
    OfferCampaignService.save_attachments(_underscore2.default.pluck($scope.recipients, 'id'), _underscore2.default.pluck(attachments, 'id')).success(function (data) {
      if (data.success) {
        $rootScope.$broadcast('load_offer_campaign_recipients');
        $scope.saving = false;
        _jquery2.default.fancybox.close();
      }
    });
  };

  $scope.init = function () {
    get_dialog_data();
  };

  $scope.init();
};

exports.default = OfferCampaignRecipientAttachmentsDialog;


OfferCampaignRecipientAttachmentsDialog.$inject = ['$scope', '$rootScope', 'OfferCampaignService'];

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferCampaignRecipientsDialog = function OfferCampaignRecipientsDialog($scope, $rootScope, $q, OfferCampaignService) {
  _classCallCheck(this, OfferCampaignRecipientsDialog);

  $scope.$on('show_recipients_dialog', function (event, data) {
    window.openFancyboxDialog('div#offer_campaign_recipients_dialog');
    $scope.offer_campaign_id = data.offer_campaign_id;
    add_recipients(data.general_buyers, data.special_buyers, data.min_quantity);
  });

  $scope.steps = [{
    id: 1,
    title: 'Add Selected Recipients'
  }, {
    id: 2,
    title: 'Create XLS for General Recipients'
  }, {
    id: 3,
    title: 'Calculate Qty for Special Recipients'
  }, {
    id: 4,
    title: 'Embed matched for Special Recipients'
  }, {
    id: 5,
    title: 'Create XLS for Special Recipients'
  }, {
    id: 6,
    title: 'Ignore PI XLS for Special Recipients'
  }, {
    id: 7,
    title: 'Mark template done for Special Recipients'
  }];

  function set_processing(step_index) {
    if (step_index > 0) {
      $scope.steps[step_index - 1].processing = false;
      $scope.steps[step_index - 1].completed = true;
    }
    $scope.steps[step_index].processing = true;
  }

  function create_general_xls(recipients) {
    $scope.steps[1].progress = 0;
    $scope.steps[1].progress_started = true;
    return recipients.reduce(function (promise, recipient, index) {
      return promise.then(function () {
        $scope.steps[1].progress = Math.ceil(index / recipients.length * 100);
        return OfferCampaignService.create_general_xls($scope.offer_campaign_id, recipient.user_id, recipient.attachments.delivery_country_id);
      });
    }, $q.when(true));
  }

  function calculate_special_qty(recipients) {
    $scope.steps[2].progress = 0;
    $scope.steps[2].progress_started = true;
    return recipients.reduce(function (promise, recipient, index) {
      return promise.then(function (response) {
        if (response && response.data) recipients[index - 1].matched_quantity = response.data.matched_quantity;
        $scope.steps[2].progress = Math.ceil(index / recipients.length * 100);
        return OfferCampaignService.get_matched_quantity($scope.offer_campaign_id, recipient.user_id, recipient.attachments.delivery_country_id);
      });
    }, $q.when(true));
  }

  function embed_matched_special(recipients, min_quantity) {
    $scope.steps[3].progress = 0;
    $scope.steps[3].progress_started = true;
    return recipients.reduce(function (promise, recipient, index) {
      return promise.then(function (response) {
        update_recipient_with_text(index - 1, response);
        $scope.steps[3].progress = Math.ceil(index / recipients.length * 100);
        if (min_quantity > 0 && recipient.matched_quantity > min_quantity) return OfferCampaignService.update_recipient_embed_matched(recipient.id, true);else return true;
      });
    }, $q.when(true));
  }

  function create_special_xls(recipients) {
    $scope.steps[4].progress = 0;
    $scope.steps[4].progress_started = true;
    return recipients.reduce(function (promise, recipient, index) {
      return promise.then(function () {
        $scope.steps[4].progress = Math.ceil(index / recipients.length * 100);
        return OfferCampaignService.create_special_xls($scope.offer_campaign_id, recipient.user_id, recipient.attachments.delivery_country_id, true, false);
      });
    }, $q.when(true));
  }

  function ignore_pi_xls(recipients) {
    $scope.steps[5].progress = 0;
    $scope.steps[5].progress_started = true;
    return recipients.reduce(function (promise, recipient, index) {
      return promise.then(function (response) {
        update_recipient_with_text(index - 1, response);
        $scope.steps[5].progress = Math.ceil(index / recipients.length * 100);
        if (recipient.user_data.is_pi) return OfferCampaignService.set_recipient_attachment(recipient.id, [{
          key: 'ignore_pi_xls',
          value: true
        }, {
          key: 'stocklist_pi_xls',
          value: false
        }]);else return true;
      });
    }, $q.when(true));
  }

  function mark_template_done(recipients) {
    $scope.steps[6].progress = 0;
    $scope.steps[6].progress_started = true;
    return recipients.reduce(function (promise, recipient, index) {
      return promise.then(function () {
        $scope.steps[6].progress = Math.ceil(index / recipients.length * 100);
        return OfferCampaignService.update_recipient_template_text(recipient.id, recipient.template_text, recipient.template_text_per, true);
      });
    }, $q.when(true));
  }

  function filter_recipients(buyers, all_recipients) {
    var recipients = [];
    _underscore2.default.each(_underscore2.default.pluck(buyers, 'id'), function (buyer_id) {
      var recipient = _underscore2.default.findWhere(all_recipients, {
        user_id: buyer_id
      });
      recipients.push(recipient);
    });
    return recipients;
  }

  function update_recipient_with_text(index, response) {
    if (response.data && response.data.template_text) $scope.special_recipients[index].template_text = response.data.template_text;
    if (response.data && response.data.template_text_per) $scope.special_recipients[index].template_text_per = response.data.template_text_per;
  }

  function add_recipients(general_buyers, special_buyers, min_quantity) {
    set_processing(0);
    OfferCampaignService.add_recipients($scope.offer_campaign_id, general_buyers, special_buyers).then(function () /*response*/{
      set_processing(1);
      return OfferCampaignService.get_recipients($scope.offer_campaign_id, 0, 1);
    }).then(function (response) {
      var recipients = filter_recipients(general_buyers, response.data.recipients);
      return create_general_xls(recipients);
    }).then(function () {
      $scope.steps[1].progress = 100;
      set_processing(2);
      return OfferCampaignService.get_recipients($scope.offer_campaign_id, 1, 1);
    }).then(function (response) {
      $scope.special_recipients = filter_recipients(special_buyers, response.data.recipients);
      return calculate_special_qty($scope.special_recipients);
    }).then(function (response) {
      if (response && response.data) $scope.special_recipients[$scope.special_recipients.length - 1].matched_quantity = response.data.matched_quantity;

      $scope.steps[2].progress = 100;
      set_processing(3);
      return embed_matched_special($scope.special_recipients, min_quantity);
    }).then(function (response) {
      update_recipient_with_text($scope.special_recipients.length - 1, response);
      $scope.steps[3].progress = 100;
      set_processing(4);
      return create_special_xls($scope.special_recipients);
    }).then(function () {
      $scope.steps[4].progress = 100;
      set_processing(5);
      return ignore_pi_xls($scope.special_recipients);
    }).then(function (response) {
      update_recipient_with_text($scope.special_recipients.length - 1, response);
      $scope.steps[5].progress = 100;
      set_processing(6);
      return mark_template_done($scope.special_recipients);
    }).then(function () {
      $scope.steps[6].progress = 100;
      var data = {
        general_buyers: general_buyers,
        special_buyers: special_buyers
      };
      $rootScope.$broadcast('remove_automated_recipients', data);
    });
  }
};

exports.default = OfferCampaignRecipientsDialog;


OfferCampaignRecipientsDialog.$inject = ['$scope', '$rootScope', '$q', 'OfferCampaignService'];

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferCampaignRecipientsPendingGeneral = function OfferCampaignRecipientsPendingGeneral($scope, $timeout, OfferCampaignService) {
  _classCallCheck(this, OfferCampaignRecipientsPendingGeneral);

  $scope.tabs = [{
    title: 'Attachments Pending',
    recipients: []
  }, {
    title: 'Ready to Send',
    recipients: []
  }];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.check_items = function (tab_index, property) {
    _underscore2.default.each($scope.tabs[tab_index].recipients, function (recipient) {
      recipient[property] = $scope.tabs[tab_index].checked;
    });
  };

  $scope.load_recipients = function () {
    for (var i = 0; i < $scope.tabs.length; i++) {
      $scope.tabs[i].recipients = [];
    }$scope.loading = true;
    OfferCampaignService.get_recipients(window.offer_campaign.id, 0, 1).success(function (data) {
      _underscore2.default.each(data.recipients, function (recipient) {
        $scope.allocate_recipient(recipient);
      });
      $scope.loading = false;
    });
  };

  $scope.allocate_recipient = function (recipient) {
    for (var i = 0; i < $scope.tabs.length; i++) {
      $scope.remove_tab_recipient(i, recipient);
    }if (recipient.is_pending) {
      var has_xls = recipient.attachments && recipient.attachments.stocklist_xls;
      $scope.add_tab_recipient(has_xls ? 1 : 0, recipient);
    }
  };

  $scope.add_tab_recipient = function (index, recipient) {
    if (_underscore2.default.indexOf($scope.tabs[index].recipients, recipient) < 0) $scope.tabs[index].recipients.push(recipient);
  };

  $scope.remove_tab_recipient = function (index, recipient) {
    var recipient_index = _underscore2.default.indexOf($scope.tabs[index].recipients, recipient);
    if (recipient_index >= 0) $scope.tabs[index].recipients.splice(recipient_index, 1);
  };

  $scope.create_xls = function (recipient) {
    recipient.creating_xls = true;
    OfferCampaignService.create_general_xls(window.offer_campaign.id, recipient.user_id, recipient.attachments.delivery_country_id).success(function (data) {
      if (data.success) {
        recipient.creating_xls = false;
        recipient.attachments = data.attachments;
        $scope.allocate_recipient(recipient);
      }
    });
  };

  $scope.get_xls = function (recipient) {
    $timeout(function () {
      (0, _jquery2.default)('form#getXLS input[name="user_id"]').val(recipient.user_id);
      (0, _jquery2.default)('form#getXLS').submit();
    }, 300);
  };

  $scope.mass_create_xls = function (index) {
    if (index === null) {
      $scope.xls_recipients = _underscore2.default.where($scope.tabs[0].recipients, {
        checked_xls: true
      });
      if ($scope.xls_recipients.length > 0) $scope.mass_create_xls(0);
    } else {
      var recipient = $scope.xls_recipients[index];
      recipient.creating_xls = true;
      OfferCampaignService.create_general_xls(window.offer_campaign.id, recipient.user_id, recipient.attachments.delivery_country_id).success(function (data) {
        if (data.success) {
          recipient.creating_xls = false;
          recipient.attachments = data.attachments;
          $scope.allocate_recipient(recipient);
          if (index < $scope.xls_recipients.length - 1) $scope.mass_create_xls(index + 1);
        }
      });
    }
  };

  $scope.select_contacts = function (recipient) {
    $scope.dialog_select_contacts_recipient = recipient;
    _jquery2.default.fancybox((0, _jquery2.default)('div#select_recipient_contacts'), {
      padding: '5',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      topRatio: 0.15,
      scrolling: 'no'
    });
  };

  $scope.save_contacts = function () {
    $scope.saving_contacts = true;
    var recipient = $scope.dialog_select_contacts_recipient;
    var contacts = _underscore2.default.pluck(_underscore2.default.where(recipient.contacts, {
      checked: true
    }), 'id');
    OfferCampaignService.set_recipient_contacts(recipient.id, contacts).success(function (data) {
      if (data.success) {
        $scope.saving_contacts = false;
        _jquery2.default.fancybox.close();
      }
    });
  };

  $scope.auto_select_contacts = function (recipient) {
    recipient.auto_selecting_contacts = true;
    OfferCampaignService.auto_select_contacts(recipient.id).success(function (data) {
      if (data.success) {
        recipient.auto_selecting_contacts = false;
        recipient.contacts = data.contacts;
      }
    });
  };

  $scope.mass_auto_select_contacts = function (index) {
    if (index === null) {
      $scope.auto_select_recipients = _underscore2.default.where($scope.tabs[1].recipients, {
        checked_send: true
      });
      if ($scope.auto_select_recipients.length > 0) $scope.mass_auto_select_contacts(0);
    } else {
      var recipient = $scope.auto_select_recipients[index];
      recipient.auto_selecting_contacts = true;
      if (recipient.contacts.length > 0) {
        OfferCampaignService.auto_select_contacts(recipient.id).success(function (data) {
          if (data.success) {
            recipient.auto_selecting_contacts = false;
            recipient.contacts = data.contacts;
            if (index < $scope.auto_select_recipients.length - 1) $scope.mass_auto_select_contacts(index + 1);
          }
        });
      } else {
        recipient.auto_selecting_contacts = false;
        if (index < $scope.auto_select_recipients.length - 1) $scope.mass_auto_select_contacts(index + 1);
      }
    }
  };

  $scope.mass_select_contacts = function (index) {
    if (index === null) {
      $scope.mass_select_recipients = _underscore2.default.where($scope.tabs[1].recipients, {
        checked_send: true
      });
      if ($scope.mass_select_recipients.length > 0) $scope.mass_select_contacts(0);
    } else {
      var recipient = $scope.mass_select_recipients[index];
      var contacts = _underscore2.default.pluck(recipient.contacts, 'id');
      recipient.auto_selecting_contacts = true;
      if (recipient.contacts.length > 0) {
        OfferCampaignService.set_recipient_contacts(recipient.id, contacts).success(function (data) {
          if (data.success) {
            recipient.auto_selecting_contacts = false;
            recipient.contacts = data.contacts;
            if (index < $scope.mass_select_recipients.length - 1) $scope.mass_select_contacts(index + 1);
          }
        });
      } else {
        recipient.auto_selecting_contacts = false;
        if (index < $scope.mass_select_recipients.length - 1) $scope.mass_select_contacts(index + 1);
      }
    }
  };

  $scope.select_attachments = function (recipient) {
    $scope.$broadcast('show_select_attachments', {
      recipients: [recipient]
    });
  };

  $scope.mass_select_attachments = function () {
    var recipients = _underscore2.default.where($scope.tabs[1].recipients, {
      checked_send: true
    });
    if (recipients.length === 0) {
      alert('Please select at least one recipient!');
    } else {
      $scope.$broadcast('show_select_attachments', {
        recipients: recipients
      });
    }
  };

  $scope.send = function (recipient) {
    recipient.sending = true;
    OfferCampaignService.send_email(window.offer_campaign.id, recipient.id, $scope.test_send, $scope.test_send_email).success(function (data) {
      if (data.success) {
        recipient.sending = false;
        recipient.is_pending = false;
        $scope.allocate_recipient(recipient);
      }
    });
  };

  $scope.mass_send = function (index) {
    if (index === null) {
      $scope.mass_send_recipients = _underscore2.default.where($scope.tabs[1].recipients, {
        checked_send: true
      });
      if ($scope.mass_send_recipients.length > 0) $scope.mass_send(0);
    } else {
      var recipient = $scope.mass_send_recipients[index];
      if (_underscore2.default.where(recipient.contacts, { checked: true }).length > 0) {
        recipient.sending = true;
        OfferCampaignService.send_email(window.offer_campaign.id, recipient.id, $scope.test_send, $scope.test_send_email).success(function (data) {
          if (data.success) {
            recipient.sending = false;
            recipient.is_pending = false;
            $scope.allocate_recipient(recipient);
            if (index < $scope.mass_send_recipients.length - 1) $scope.mass_send(index + 1);
          }
        });
      } else {
        if (index < $scope.mass_send_recipients.length - 1) $scope.mass_send(index + 1);
      }
    }
  };

  $scope.update_embed_stocklist_matched = function (recipient) {
    recipient.updating_embed_stocklist_matched = true;
    OfferCampaignService.update_recipient_embed_matched(recipient.id, recipient.attachments.embed_stocklist_matched).success(function (data) {
      if (data.success) {
        recipient.updating_embed_stocklist_matched = false;
        recipient.template_text = data.template_text;
        recipient.template_text_per = data.template_text_per;
      }
    });
  };

  $scope.mass_show_matched_quantity = function (index) {
    if (index === null) {
      $scope.xls_recipients = _underscore2.default.where($scope.tabs[0].recipients, {
        checked_xls: true
      });
      if ($scope.xls_recipients.length > 0) $scope.mass_show_matched_quantity(0);
    } else {
      var recipient = $scope.xls_recipients[index];
      OfferCampaignService.get_matched_quantity(window.offer_campaign.id, recipient.user_id, recipient.attachments.delivery_country_id, $scope.product_specs_for_all).success(function (data) {
        if (data.success) {
          recipient.matched_quantity = data.matched_quantity;
          if (index < $scope.xls_recipients.length - 1) $scope.mass_show_matched_quantity(index + 1);
        }
      });
    }
  };

  $scope.quick_search = function (tab_index) {
    window.filter_table('table.tab' + tab_index, $scope.tabs[tab_index].query);
  };

  $scope.$on('load_offer_campaign_recipients', function () /*event, args*/{
    $scope.load_recipients();
  });

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.offer_campaign = window.offer_campaign;
    $scope.current_page = 'recipients_pending_general';
    $scope.test_send = true;
    $scope.test_send_email = 'p.tsolpagas@epsilon-paper.com';
    $scope.product_specs_for_all = false;
    $scope.load_recipients();
    $scope._ = _underscore2.default;
  };

  $scope.init();
};

exports.default = OfferCampaignRecipientsPendingGeneral;


OfferCampaignRecipientsPendingGeneral.$inject = ['$scope', '$timeout', 'OfferCampaignService'];

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferCampaignRecipientsPendingSpecial = function OfferCampaignRecipientsPendingSpecial($scope, $timeout, OfferCampaignService, UiService) {
  _classCallCheck(this, OfferCampaignRecipientsPendingSpecial);

  $scope.tabs = [{
    title: 'Attachments Pending - Non PI',
    recipients: []
  }, {
    title: 'Attachments Pending - PI',
    recipients: []
  }, {
    title: 'Template Pending',
    recipients: []
  }, {
    title: 'Ready to Send',
    recipients: []
  }];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.check_items = function (tab_index, property) {
    _underscore2.default.each($scope.tabs[tab_index].recipients, function (recipient) {
      recipient[property] = $scope.tabs[tab_index].checked;
    });
  };

  $scope.load_recipients = function () {
    for (var i = 0; i < $scope.tabs.length; i++) {
      $scope.tabs[i].recipients = [];
    }$scope.loading = true;
    OfferCampaignService.get_recipients(window.offer_campaign.id, 1, 1).success(function (data) {
      $scope.tabs[0].recipients = _underscore2.default.filter(data.recipients, function (recipient) {
        return recipient.user_data.is_pi === false;
      });
      _underscore2.default.each(data.recipients, function (recipient) {
        $scope.allocate_recipient(recipient);
      });
      $scope.loading = false;
    });
  };

  $scope.allocate_recipient = function (recipient) {
    for (var i = 0; i < $scope.tabs.length; i++) {
      $scope.remove_tab_recipient(i, recipient);
    }if (!recipient.is_pending) return;

    var has_xls = recipient.attachments && recipient.attachments.stocklist_xls;
    var has_pi_xls = recipient.attachments && recipient.attachments.stocklist_pi_xls;
    var ignored_xls = recipient.attachments && recipient.attachments.ignore_xls;
    var ignored_pi_xls = recipient.attachments && recipient.attachments.ignore_pi_xls;
    var is_pi = recipient.user_data.is_pi;
    var has_template = !recipient.template_pending;
    var is_pi_ready = !is_pi || has_pi_xls || ignored_pi_xls;

    if ((has_xls || has_pi_xls) && has_template && is_pi_ready) {
      $scope.add_tab_recipient(3, recipient);
    } else {
      if (!is_pi && !has_xls) $scope.add_tab_recipient(0, recipient);
      if (is_pi && (!has_xls && !ignored_xls || ignored_xls && ignored_pi_xls || !is_pi_ready)) $scope.add_tab_recipient(1, recipient);
      if (!has_template) $scope.add_tab_recipient(2, recipient);
    }
  };

  $scope.add_tab_recipient = function (index, recipient) {
    if (_underscore2.default.indexOf($scope.tabs[index].recipients, recipient) < 0) $scope.tabs[index].recipients.push(recipient);
  };

  $scope.remove_tab_recipient = function (index, recipient) {
    var recipient_index = _underscore2.default.indexOf($scope.tabs[index].recipients, recipient);
    if (recipient_index >= 0) $scope.tabs[index].recipients.splice(recipient_index, 1);
  };

  $scope.create_xls = function (recipient, create_stocklist_xls, create_pi_xls) {
    if (create_stocklist_xls) recipient.creating_xls = true;
    if (create_pi_xls) recipient.creating_pi_xls = true;
    OfferCampaignService.create_special_xls(window.offer_campaign.id, recipient.user_id, recipient.attachments.delivery_country_id, create_stocklist_xls, create_pi_xls).success(function (data) {
      if (data.success) {
        if (create_stocklist_xls) recipient.creating_xls = false;
        if (create_pi_xls) recipient.creating_pi_xls = false;
        recipient.attachments = data.attachments;
        $scope.allocate_recipient(recipient);
      }
    });
  };

  $scope.mass_create_xls = function (tab_index, index, create_stocklist_xls, create_pi_xls) {
    if (index === null) {
      $scope.xls_recipients = _underscore2.default.where($scope.tabs[tab_index].recipients, {
        checked_xls: true
      });
      if ($scope.xls_recipients.length > 0) $scope.mass_create_xls(tab_index, 0, create_stocklist_xls, create_pi_xls);
    } else {
      var recipient = $scope.xls_recipients[index];
      if (create_stocklist_xls) recipient.creating_xls = true;
      if (create_pi_xls) recipient.creating_pi_xls = true;
      OfferCampaignService.create_special_xls(window.offer_campaign.id, recipient.user_id, recipient.attachments.delivery_country_id, create_stocklist_xls, create_pi_xls).success(function (data) {
        if (data.success) {
          if (create_stocklist_xls) recipient.creating_xls = false;
          if (create_pi_xls) recipient.creating_pi_xls = false;
          recipient.attachments = data.attachments;
          $scope.allocate_recipient(recipient);
          if (index < $scope.xls_recipients.length - 1) $scope.mass_create_xls(tab_index, index + 1, create_stocklist_xls, create_pi_xls);
        }
      });
    }
  };

  $scope.get_xls = function (recipient, xls_filename) {
    $timeout(function () {
      (0, _jquery2.default)('form#getXLS input[name="user_id"]').val(recipient.user_id);
      (0, _jquery2.default)('form#getXLS input[name="xls_filename"]').val(xls_filename);
      (0, _jquery2.default)('form#getXLS').submit();
    }, 300);
  };

  $scope.set_recipient_attachment = function (recipient, attachments, loader_name) {
    recipient[loader_name] = true;
    OfferCampaignService.set_recipient_attachment(recipient.id, attachments).success(function (data) {
      if (data.success) {
        recipient.attachments = data.attachments;
        recipient[loader_name] = false;
        if (data.template_text) recipient.template_text = data.template_text;
        if (data.template_text_per) recipient.template_text_per = data.template_text_per;
        $scope.allocate_recipient(recipient);
      }
    });
  };

  $scope.mass_set_recipient_attachment = function (tab_index, index, attachments, loader_name) {
    if (index === null) {
      $scope.xls_recipients = _underscore2.default.where($scope.tabs[tab_index].recipients, {
        checked_xls: true
      });
      if ($scope.xls_recipients.length > 0) $scope.mass_set_recipient_attachment(tab_index, 0, attachments, loader_name);
    } else {
      var recipient = $scope.xls_recipients[index];
      recipient[loader_name] = true;
      OfferCampaignService.set_recipient_attachment(recipient.id, attachments).success(function (data) {
        if (data.success) {
          recipient[loader_name] = false;
          recipient.attachments = data.attachments;
          if (data.template_text) recipient.template_text = data.template_text;
          if (data.template_text_per) recipient.template_text_per = data.template_text_per;
          $scope.allocate_recipient(recipient);
          if (index < $scope.xls_recipients.length - 1) $scope.mass_set_recipient_attachment(tab_index, index + 1, attachments, loader_name);
        }
      });
    }
  };

  $scope.get_recipient_status = function (recipient) {
    var statuses = [];
    if (recipient.user_data.is_matched) statuses.push('Matched');
    if (recipient.user_data.ospp_policies) statuses.push('OSPP');
    if (recipient.user_data.is_pi) statuses.push('PI');
    return statuses.join(' + ');
  };

  $scope.edit_template = function (recipient) {
    $scope.dialog_edit_template_recipient = recipient;
    _jquery2.default.fancybox((0, _jquery2.default)('div#edit_template'), {
      padding: '5',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      topRatio: 0.15,
      scrolling: 'no',
      afterShow: function afterShow() {
        $scope.$broadcast('$tinymce:refresh');
      }
    });
  };

  $scope.save_template = function (is_done) {
    $scope.saving_template = true;
    var recipient = $scope.dialog_edit_template_recipient;
    OfferCampaignService.update_recipient_template_text(recipient.id, recipient.template_text, recipient.template_text_per, is_done).success(function (data) {
      if (data.success) {
        if (is_done) {
          recipient.template_pending = false;
          $scope.allocate_recipient(recipient);
        }
        $scope.saving_template = false;
        _jquery2.default.fancybox.close();
      }
    });
  };

  $scope.select_contacts = function (recipient) {
    $scope.dialog_select_contacts_recipient = recipient;
    _jquery2.default.fancybox((0, _jquery2.default)('div#select_recipient_contacts'), {
      padding: '5',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      topRatio: 0.15,
      scrolling: 'no'
    });
  };

  $scope.save_contacts = function () {
    $scope.saving_contacts = true;
    var recipient = $scope.dialog_select_contacts_recipient;
    var contacts = _underscore2.default.pluck(_underscore2.default.where(recipient.contacts, {
      checked: true
    }), 'id');
    OfferCampaignService.set_recipient_contacts(recipient.id, contacts).success(function (data) {
      if (data.success) {
        $scope.saving_contacts = false;
        _jquery2.default.fancybox.close();
      }
    });
  };

  $scope.auto_select_contacts = function (recipient) {
    recipient.auto_selecting_contacts = true;
    OfferCampaignService.auto_select_contacts(recipient.id).success(function (data) {
      if (data.success) {
        recipient.auto_selecting_contacts = false;
        recipient.contacts = data.contacts;
      }
    });
  };

  $scope.mass_auto_select_contacts = function (index) {
    if (index === null) {
      $scope.auto_select_recipients = _underscore2.default.where($scope.tabs[3].recipients, {
        checked_send: true
      });
      if ($scope.auto_select_recipients.length > 0) $scope.mass_auto_select_contacts(0);
    } else {
      var recipient = $scope.auto_select_recipients[index];
      recipient.auto_selecting_contacts = true;
      if (recipient.contacts.length > 0) {
        OfferCampaignService.auto_select_contacts(recipient.id).success(function (data) {
          if (data.success) {
            recipient.auto_selecting_contacts = false;
            recipient.contacts = data.contacts;
            if (index < $scope.auto_select_recipients.length - 1) $scope.mass_auto_select_contacts(index + 1);
          }
        });
      } else {
        recipient.auto_selecting_contacts = false;
        if (index < $scope.auto_select_recipients.length - 1) $scope.mass_auto_select_contacts(index + 1);
      }
    }
  };

  $scope.mass_select_contacts = function (index) {
    if (index === null) {
      $scope.mass_select_recipients = _underscore2.default.where($scope.tabs[3].recipients, {
        checked_send: true
      });
      if ($scope.mass_select_recipients.length > 0) $scope.mass_select_contacts(0);
    } else {
      var recipient = $scope.mass_select_recipients[index];
      var contacts = _underscore2.default.pluck(recipient.contacts, 'id');
      recipient.auto_selecting_contacts = true;
      if (recipient.contacts.length > 0) {
        OfferCampaignService.set_recipient_contacts(recipient.id, contacts).success(function (data) {
          if (data.success) {
            recipient.auto_selecting_contacts = false;
            recipient.contacts = data.contacts;
            if (index < $scope.mass_select_recipients.length - 1) $scope.mass_select_contacts(index + 1);
          }
        });
      } else {
        recipient.auto_selecting_contacts = false;
        if (index < $scope.mass_select_recipients.length - 1) $scope.mass_select_contacts(index + 1);
      }
    }
  };

  $scope.mass_mark_template_done = function (index) {
    if (index === null) {
      $scope.mark_done_recipients = _underscore2.default.where($scope.tabs[2].recipients, {
        checked_template: true
      });
      if ($scope.mark_done_recipients.length > 0) $scope.mass_mark_template_done(0);
    } else {
      var recipient = $scope.mark_done_recipients[index];
      recipient.marking_done = true;
      OfferCampaignService.update_recipient_template_text(recipient.id, recipient.template_text, recipient.template_text_per, true).success(function (data) {
        if (data.success) {
          recipient.template_pending = false;
          $scope.allocate_recipient(recipient);
          recipient.marking_done = false;
          if (index < $scope.mark_done_recipients.length - 1) $scope.mass_mark_template_done(index + 1);
        }
      });
    }
  };

  $scope.select_attachments = function (recipient) {
    $scope.$broadcast('show_select_attachments', {
      recipients: [recipient]
    });
  };

  $scope.mass_select_attachments = function () {
    var recipients = _underscore2.default.where($scope.tabs[3].recipients, {
      checked_send: true
    });
    if (recipients.length === 0) {
      alert('Please select at least one recipient!');
    } else {
      $scope.$broadcast('show_select_attachments', {
        recipients: recipients
      });
    }
  };

  $scope.send = function (recipient) {
    recipient.sending = true;
    OfferCampaignService.send_email(window.offer_campaign.id, recipient.id, $scope.test_send, $scope.test_send_email).success(function (data) {
      if (data.success) {
        recipient.sending = false;
        recipient.is_pending = false;
        $scope.allocate_recipient(recipient);
      }
    });
  };

  $scope.mass_send = function (index) {
    if (index === null) {
      $scope.mass_send_recipients = _underscore2.default.where($scope.tabs[3].recipients, {
        checked_send: true
      });
      if ($scope.mass_send_recipients.length > 0) $scope.mass_send(0);
    } else {
      var recipient = $scope.mass_send_recipients[index];
      if (_underscore2.default.where(recipient.contacts, { checked: true }).length > 0) {
        recipient.sending = true;
        OfferCampaignService.send_email(window.offer_campaign.id, recipient.id, $scope.test_send, $scope.test_send_email).success(function (data) {
          if (data.success) {
            recipient.sending = false;
            recipient.is_pending = false;
            $scope.allocate_recipient(recipient);
            if (index < $scope.mass_send_recipients.length - 1) $scope.mass_send(index + 1);
          }
        });
      } else {
        if (index < $scope.mass_send_recipients.length - 1) $scope.mass_send(index + 1);
      }
    }
  };

  $scope.update_embed_stocklist_pi = function (recipient) {
    recipient.updating_embed_stocklist_pi = true;
    OfferCampaignService.update_recipient_embed_pi(recipient.id, recipient.attachments.embed_stocklist_pi).success(function (data) {
      if (data.success) {
        recipient.updating_embed_stocklist_pi = false;
        recipient.template_text = data.template_text;
        recipient.template_text_per = data.template_text_per;
      }
    });
  };

  $scope.update_embed_stocklist_matched = function (recipient) {
    recipient.updating_embed_stocklist_matched = true;
    OfferCampaignService.update_recipient_embed_matched(recipient.id, recipient.attachments.embed_stocklist_matched).success(function (data) {
      if (data.success) {
        recipient.updating_embed_stocklist_matched = false;
        recipient.template_text = data.template_text;
        recipient.template_text_per = data.template_text_per;
      }
    });
  };

  $scope.mass_show_matched_quantity = function (tab_index, index) {
    if (index === null) {
      $scope.xls_recipients = _underscore2.default.where($scope.tabs[tab_index].recipients, {
        checked_xls: true
      });
      if ($scope.xls_recipients.length > 0) $scope.mass_show_matched_quantity(tab_index, 0);
    } else {
      var recipient = $scope.xls_recipients[index];
      OfferCampaignService.get_matched_quantity(window.offer_campaign.id, recipient.user_id, recipient.attachments.delivery_country_id).success(function (data) {
        if (data.success) {
          recipient.matched_quantity = data.matched_quantity;
          if (index < $scope.xls_recipients.length - 1) $scope.mass_show_matched_quantity(tab_index, index + 1);
        }
      });
    }
  };

  $scope.quick_search = function (tab_index) {
    window.filter_table('table.tab' + tab_index, $scope.tabs[tab_index].query);
  };

  $scope.$on('load_offer_campaign_recipients', function () /*event, args*/{
    $scope.load_recipients();
  });

  $scope.init = function () {
    $scope.tinymceOptions = UiService.tinymceOptions();
    $scope.selected_tab = 0;
    $scope.offer_campaign = window.offer_campaign;
    $scope.current_page = 'recipients_pending_special';
    $scope.test_send = true;
    $scope.test_send_email = 'p.tsolpagas@epsilon-paper.com';
    $scope._ = _underscore2.default;
    $scope.load_recipients();
  };

  $scope.init();
};

exports.default = OfferCampaignRecipientsPendingSpecial;


OfferCampaignRecipientsPendingSpecial.$inject = ['$scope', '$timeout', 'OfferCampaignService', 'UiService'];

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferCampaignRecipientsSent = function OfferCampaignRecipientsSent($scope, $timeout, OfferCampaignService) {
  _classCallCheck(this, OfferCampaignRecipientsSent);

  $scope.tabs = [{
    title: 'General',
    recipients: []
  }, {
    title: 'Special',
    recipients: []
  }];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.load_recipients = function () {
    $scope.loading = true;
    OfferCampaignService.get_recipients(window.offer_campaign.id, null, 0).success(function (data) {
      _underscore2.default.each(data.recipients, function (recipient) {
        $scope.allocate_recipient(recipient);
      });
      $scope.loading = false;
    });
  };

  $scope.allocate_recipient = function (recipient) {
    $scope.add_tab_recipient(recipient.is_special ? 1 : 0, recipient);
  };

  $scope.add_tab_recipient = function (index, recipient) {
    if (_underscore2.default.indexOf($scope.tabs[index].recipients, recipient) < 0) $scope.tabs[index].recipients.push(recipient);
  };

  $scope.get_xls = function (recipient, xls_filename) {
    $timeout(function () {
      (0, _jquery2.default)('form#getXLS input[name="user_id"]').val(recipient.user_id);
      (0, _jquery2.default)('form#getXLS input[name="xls_filename"]').val(xls_filename);
      (0, _jquery2.default)('form#getXLS').submit();
    }, 300);
  };

  $scope.move_to_pending = function (recipient) {
    recipient.moving_to_pending = true;
    OfferCampaignService.set_recipient_pending(recipient.id, true).success(function (data) {
      if (data.success) {
        $scope.tabs[0].recipients.splice(_underscore2.default.indexOf($scope.tabs[0].recipients, recipient), 1);
        recipient.moving_to_pending = false;
      }
    });
  };

  $scope.quick_search = function (tab_index) {
    window.filter_table('table.tab' + tab_index, $scope.tabs[tab_index].query);
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.offer_campaign = window.offer_campaign;
    $scope.current_page = 'recipients_sent';
    $scope._ = _underscore2.default;
    $scope.load_recipients();
  };

  $scope.init();
};

exports.default = OfferCampaignRecipientsSent;


OfferCampaignRecipientsSent.$inject = ['$scope', '$timeout', 'OfferCampaignService'];

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferCampaignRecipients = function OfferCampaignRecipients($scope, $rootScope, OfferCampaignService, UserService) {
  _classCallCheck(this, OfferCampaignRecipients);

  $scope.tabs = [{
    title: 'General',
    buyers: []
  }, {
    title: 'Special',
    buyers: []
  }, {
    title: 'Restricted',
    buyers: []
  }];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.check_items = function (tab_index) {
    _underscore2.default.each($scope.get_buyers($scope.tabs[tab_index]), function (buyer) {
      buyer.checked = $scope.tabs[tab_index].checked;
    });
  };

  $scope.select2_options = {
    containerCssClass: 'multiselect2',
    dropdownCssClass: 'multiselect2',
    width: '600px'
  };

  $scope.select2_options_447 = {
    containerCssClass: 'multiselect2',
    dropdownCssClass: 'multiselect2',
    width: '600px'
  };

  $scope.add_product_spec = function () {
    $scope.filter.product_specs.push({
      product_category_id: null,
      product_group_id: null,
      product_id: null
    });
  };

  $scope.remove_product_spec = function (spec) {
    $scope.filter.product_specs.splice(_underscore2.default.indexOf($scope.filter.product_specs, spec), 1);
  };

  $scope.search = function () {
    $scope.searching = true;
    $scope.filter.min_quality_accuracy = $scope.filter.pre_min_quality_accuracy;
    $scope.filter.min_specs_accuracy = $scope.filter.pre_min_specs_accuracy;
    $scope.filter.excluded_user_groups = _underscore2.default.pluck(_underscore2.default.where($scope.excluded_groups, {
      checked: true
    }), 'id');
    $scope.filter.product_end_uses = _underscore2.default.pluck(_underscore2.default.where($scope.product_end_uses, {
      checked: true
    }), 'id');
    OfferCampaignService.find_recipients($scope.offer_campaign.id, $scope.filter).success(function (data) {
      $scope.tabs[0].buyers = data.recipients.general;
      $scope.tabs[1].buyers = data.recipients.special;
      $scope.searching = false;
    });
  };

  $scope.add_recipients = function () {
    var general_buyers = _underscore2.default.where($scope.tabs[0].buyers, {
      checked: true
    });
    var special_buyers = _underscore2.default.where($scope.tabs[1].buyers, {
      checked: true
    });
    if (!$scope.adding && (general_buyers.length > 0 || special_buyers.length > 0)) {
      $scope.adding = true;
      $scope.recipients_added = false;
      OfferCampaignService.add_recipients(window.offer_campaign.id, general_buyers, special_buyers).success(function (data) {
        if (data.success) {
          $scope.tabs[0].buyers = _underscore2.default.difference($scope.tabs[0].buyers, general_buyers);
          $scope.tabs[1].buyers = _underscore2.default.difference($scope.tabs[1].buyers, special_buyers);
          $scope.tabs[0].checked = false;
          $scope.tabs[1].checked = false;
          $scope.adding = false;
          $scope.recipients_added = true;
        }
      });
    }
  };

  $scope.automate_recipients = function () {
    var general_buyers = _underscore2.default.where($scope.tabs[0].buyers, {
      checked: true
    });
    var special_buyers = _underscore2.default.where($scope.tabs[1].buyers, {
      checked: true
    });
    if (general_buyers.length > 0 || special_buyers.length > 0) {
      var data = {
        offer_campaign_id: window.offer_campaign.id,
        general_buyers: general_buyers,
        special_buyers: special_buyers,
        min_quantity: $scope.min_quantity
      };
      $rootScope.$broadcast('show_recipients_dialog', data);
    }
  };

  $scope.$on('remove_automated_recipients', function (event, data) {
    $scope.tabs[0].buyers = _underscore2.default.difference($scope.tabs[0].buyers, data.general_buyers);
    $scope.tabs[1].buyers = _underscore2.default.difference($scope.tabs[1].buyers, data.special_buyers);
    $scope.tabs[0].checked = false;
    $scope.tabs[1].checked = false;
  });

  $scope.percentages = [{
    value: 0,
    title: '0%'
  }, {
    value: 1,
    title: '1%'
  }, {
    value: 20,
    title: '20%'
  }, {
    value: 40,
    title: '40%'
  }, {
    value: 60,
    title: '60%'
  }, {
    value: 80,
    title: '80%'
  }, {
    value: 100,
    title: '100%'
  }];

  $scope.operators = [{
    value: 1,
    title: '+'
  }, {
    value: 2,
    title: '+/-'
  }];

  $scope.specs = [{
    value: 0,
    title: 'ALL'
  }, {
    value: 1,
    title: 'Only Yes'
  }, {
    value: 2,
    title: 'Unknown or Yes'
  }];

  $scope.cuts = [{
    value: 1,
    title: '1'
  }, {
    value: 2,
    title: '2'
  }, {
    value: 3,
    title: '3'
  }];

  $scope.wastes = [{
    value: 0,
    title: '0'
  }, {
    value: 1,
    title: '1'
  }, {
    value: 2,
    title: '2'
  }];

  $scope.ranges = [{
    value: 0,
    title: '0'
  }, {
    value: 1,
    title: '+-0.5'
  }, {
    value: 2,
    title: '+-1'
  }];

  $scope.specs_status_options = [{
    id: 0,
    title: 'All'
  }, {
    id: 1,
    title: 'Reels'
  }, {
    id: 2,
    title: 'Sheets'
  }];

  $scope.get_buyers = function (tab) {
    var buyers = tab.buyers;

    if (tab.title === 'Restricted') {
      return buyers;
    }

    if ($scope.attention_filter > 0) {
      var needs_attention = $scope.attention_filter === 1;
      buyers = _underscore2.default.where(buyers, {
        needs_attention: needs_attention
      });
    }

    if ($scope.special_handling_filter > 0) {
      var special_handling = $scope.special_handling_filter === 1;
      buyers = _underscore2.default.where(buyers, {
        special_handling: special_handling
      });
    }

    if ($scope.epr_marketing_campaigns_filter > 0) {
      if ($scope.epr_marketing_campaigns_filter === 1) {
        buyers = _underscore2.default.filter(buyers, function (x) {
          return x.epr_marketing_campaigns && x.epr_marketing_campaigns.includes('Yes');
        });
      } else {
        buyers = _underscore2.default.filter(buyers, function (x) {
          return x.epr_marketing_campaigns && x.epr_marketing_campaigns.includes('No');
        });
      }
    }

    return buyers;
  };

  $scope.uncheck_items = function () {
    _underscore2.default.each($scope.tabs, function (tab) {
      tab.checked = false;
      _underscore2.default.each(tab.buyers, function (buyer) {
        buyer.checked = false;
      });
    });
  };

  $scope.attention_filter_options = [{
    id: 0,
    title: 'All'
  }, {
    id: 1,
    title: 'Yes'
  }, {
    id: 2,
    title: 'No'
  }];

  $scope.get_campaign_criteria = function (offer_campaign_criteria) {
    var status = _underscore2.default.findWhere(window.offer_campaign_criteria_statuses, {
      id: offer_campaign_criteria
    });
    return status.title;
  };

  $scope.quick_search = function (tab_index) {
    window.filter_table('table.tab' + tab_index, $scope.tabs[tab_index].query);
  };

  function set_buyer_company_autocomplete(input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Buyer', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        if (!_underscore2.default.findWhere($scope.filter.buyers, { id: ui.item.id })) {
          $scope.filter.buyers.push({
            id: ui.item.id,
            title: ui.item.value
          });
        }
        $scope.buyer_company = null;
        $scope.$apply();
        return false;
      }
    });
  }

  $scope.remove_buyer = function (buyer_id) {
    $scope.filter.buyers = _underscore2.default.reject($scope.filter.buyers, function (buyer) {
      return buyer.id == buyer_id;
    });
  };

  $scope.quick_search_end_uses = function () {
    if ($scope.quick_filter) {
      var regex = new RegExp($scope.quick_filter, 'i');
      _underscore2.default.each($scope.product_end_uses, function (end_use) {
        end_use.visible = end_use.title.search(regex) > -1;
      });

      $scope.search_filter = {
        visible: true
      };
    } else {
      $scope.search_filter = {};
    }
  };

  $scope.toggleEUcountries = function toggleEUcountries(check_eu_countries) {
    if (check_eu_countries) {
      if (!$scope.filter.user_countries) {
        $scope.filter.user_countries = [];
      }
      $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.eu_countries);
    } else {
      $scope.filter.user_countries = _underscore2.default.difference($scope.filter.user_countries, $scope.eu_countries);
    }
    (0, _jquery2.default)('#buyer_countries').select2('val', $scope.filter.user_countries);
  };

  $scope.toggleAsiacountries = function toggleAsiacountries(check_asia_countries) {
    if (check_asia_countries) {
      if (!$scope.filter.user_countries) {
        $scope.filter.user_countries = [];
      }
      $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.asia_countries);
    } else {
      $scope.filter.user_countries = _underscore2.default.difference($scope.filter.user_countries, $scope.asia_countries);
    }
    (0, _jquery2.default)('#buyer_countries').select2('val', $scope.filter.user_countries);
  };

  $scope.toggleAfricacountries = function toggleAfricacountries(check_africa_countries) {
    if (check_africa_countries) {
      if (!$scope.filter.user_countries) {
        $scope.filter.user_countries = [];
      }
      $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.africa_countries);
    } else {
      $scope.filter.user_countries = _underscore2.default.difference($scope.filter.user_countries, $scope.africa_countries);
    }
    (0, _jquery2.default)('#buyer_countries').select2('val', $scope.filter.user_countries);
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.offer_campaign = window.offer_campaign;
    $scope.filter = OfferCampaignService.get_default_filter();
    if (window.offer_campaign.search_criteria) {
      $scope.filter = window.offer_campaign.search_criteria;
      if (!$scope.filter.product_specs) $scope.filter.product_specs = [];
      if (!$scope.filter.excluded_user_countries) $scope.filter.excluded_user_countries = [];
      if (!$scope.filter.specs_status) $scope.filter.specs_status = 0;
      if (!$scope.filter.excluded_user_groups) $scope.filter.excluded_user_groups = [];
      if (!$scope.filter.buyers) {
        $scope.filter.buyers = [];
      }
      if (!$scope.filter.product_end_uses) {
        $scope.filter.product_end_uses = [];
      }
    }
    $scope.excluded_groups = OfferCampaignService.get_groups();
    OfferCampaignService.update_excluded_groups($scope.excluded_groups, $scope.filter);
    $scope.current_page = 'recipients_find';
    $scope.product_categories = window.product_categories;
    if ($scope.filter.product_specs.length === 0) $scope.add_product_spec();
    $scope.attention_filter = 0;
    $scope.special_handling_filter = 0;
    $scope.epr_marketing_campaigns_filter = 0;
    $scope.tabs[2].buyers = window.restricted_buyers;
    $scope.min_quantity = 0;
    $scope.offer_id = window.offer_campaign.offer_id;
    $scope.show_all_product_end_uses = false;
    $scope.show_suggested_product_end_uses = false;
    $scope.eu_countries = window.eu.countries.map(function (a) {
      return String(a.id);
    });
    $scope.asia_countries = window.asia.countries.map(function (a) {
      return String(a.id);
    });
    $scope.africa_countries = window.africa.countries.map(function (a) {
      return String(a.id);
    });
    if (_underscore2.default.difference($scope.eu_countries, $scope.filter.user_countries).length === 0) {
      $scope.check_eu_countries = true;
    }
    if (_underscore2.default.difference($scope.asia_countries, $scope.filter.user_countries).length === 0) {
      $scope.check_asia_countries = true;
    }
    if (_underscore2.default.difference($scope.africa_countries, $scope.filter.user_countries).length === 0) {
      $scope.check_africa_countries = true;
    }
    set_buyer_company_autocomplete((0, _jquery2.default)('input.buyer_company'));
    $scope.product_end_uses = window.product_end_uses;
    _underscore2.default.each($scope.filter.product_end_uses, function (end_use) {
      var product_end_use = _underscore2.default.findWhere($scope.product_end_uses, {
        id: end_use
      });
      if (product_end_use) {
        product_end_use.checked = true;
      }
    });
    _underscore2.default.each(window.suggested_product_end_uses, function (end_use) {
      var product_end_use = _underscore2.default.findWhere($scope.product_end_uses, {
        id: end_use.id
      });
      if (product_end_use) {
        product_end_use.suggested = true;
      }
    });
  };

  $scope.init();
};

exports.default = OfferCampaignRecipients;


OfferCampaignRecipients.$inject = ['$scope', '$rootScope', 'OfferCampaignService', 'UserService'];

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferCampaignSettings = function OfferCampaignSettings($scope, OfferService, OfferMarketRestrictionService, OfferCampaignService, UserService) {
  _classCallCheck(this, OfferCampaignSettings);

  $scope.tabs = [{
    title: 'General',
    buyers: []
  }, {
    title: 'Special',
    buyers: []
  }, {
    title: 'Restricted',
    buyers: []
  }];

  $scope.selection = [];

  $scope.toggleSelection = function toggleSelection(relation) {
    var idx = $scope.filter.business_relations.indexOf(relation);

    // Is currently selected
    if (idx > -1) {
      $scope.selection.splice(idx, 1);
      $scope.filter.business_relations.splice(idx, 1);
    }

    // Is newly selected
    else {
        $scope.selection.push(relation);
        $scope.filter.business_relations.push(relation);
      }
  };

  $scope.toggleEUcountries = function toggleEUcountries(check_eu_countries) {
    if (check_eu_countries) {
      if (!$scope.filter.user_countries) {
        $scope.filter.user_countries = [];
      }
      $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.eu_countries);
    } else {
      $scope.filter.user_countries = _underscore2.default.difference($scope.filter.user_countries, $scope.eu_countries);
    }
    (0, _jquery2.default)('#buyer_countries').select2('val', $scope.filter.user_countries);
  };

  $scope.toggleAsiacountries = function toggleAsiacountries(check_asia_countries) {
    if (check_asia_countries) {
      if (!$scope.filter.user_countries) {
        $scope.filter.user_countries = [];
      }
      $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.asia_countries);
    } else {
      $scope.filter.user_countries = _underscore2.default.difference($scope.filter.user_countries, $scope.asia_countries);
    }
    (0, _jquery2.default)('#buyer_countries').select2('val', $scope.filter.user_countries);
  };

  $scope.toggleAfricacountries = function toggleAfricacountries(check_africa_countries) {
    if (check_africa_countries) {
      if (!$scope.filter.user_countries) {
        $scope.filter.user_countries = [];
      }
      $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.africa_countries);
    } else {
      $scope.filter.user_countries = _underscore2.default.difference($scope.filter.user_countries, $scope.africa_countries);
    }
    (0, _jquery2.default)('#buyer_countries').select2('val', $scope.filter.user_countries);
  };

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.save = function () {
    $scope.filter.excluded_user_groups = _underscore2.default.pluck(_underscore2.default.where($scope.excluded_groups, {
      checked: true
    }), 'id');
    $scope.filter.business_relations = _underscore2.default.pluck(_underscore2.default.where($scope.business_relations, {
      checked: true
    }), 'id');
    $scope.filter.product_end_uses = _underscore2.default.pluck(_underscore2.default.where($scope.product_end_uses, {
      checked: true
    }), 'id');
    $scope.saving = true;
    OfferService.save_offer_campaign_settings(window.offer_id, $scope.settings).success(function (data) {
      if (data.success) $scope.saving = false;
    });
  };

  $scope.select2_options = {
    containerCssClass: 'multiselect2',
    dropdownCssClass: 'multiselect2',
    width: '600px'
  };

  $scope.select2_options_447 = {
    containerCssClass: 'multiselect2',
    dropdownCssClass: 'multiselect2',
    width: '447px'
  };

  $scope.add_product_spec = function () {
    $scope.filter.product_specs.push({
      product_category_id: null,
      product_group_id: null,
      product_id: null
    });
  };

  $scope.remove_product_spec = function (spec) {
    $scope.filter.product_specs.splice(_underscore2.default.indexOf($scope.filter.product_specs, spec), 1);
  };

  $scope.percentages = [{
    value: 0,
    title: '0%'
  }, {
    value: 1,
    title: '1%'
  }, {
    value: 20,
    title: '20%'
  }, {
    value: 40,
    title: '40%'
  }, {
    value: 60,
    title: '60%'
  }, {
    value: 80,
    title: '80%'
  }, {
    value: 100,
    title: '100%'
  }];

  $scope.operators = [{
    value: 1,
    title: '+'
  }, {
    value: 2,
    title: '+/-'
  }];

  $scope.specs = [{
    value: 0,
    title: 'ALL'
  }, {
    value: 1,
    title: 'Only Yes'
  }, {
    value: 2,
    title: 'Unknown or Yes'
  }];

  $scope.cuts = [{
    value: 1,
    title: '1'
  }, {
    value: 2,
    title: '2'
  }, {
    value: 3,
    title: '3'
  }];

  $scope.wastes = [{
    value: 0,
    title: '0'
  }, {
    value: 1,
    title: '1'
  }, {
    value: 2,
    title: '2'
  }];

  $scope.ranges = [{
    value: 0,
    title: '0'
  }, {
    value: 1,
    title: '+-0.5'
  }, {
    value: 2,
    title: '+-1'
  }];

  $scope.specs_status_options = [{
    id: 0,
    title: 'All'
  }, {
    id: 1,
    title: 'Reels'
  }, {
    id: 2,
    title: 'Sheets'
  }];

  $scope.attention_filter_options = [{
    id: 0,
    title: 'All'
  }, {
    id: 1,
    title: 'Yes'
  }, {
    id: 2,
    title: 'No'
  }];

  $scope.check_items = function (tab_index) {
    _underscore2.default.each($scope.get_buyers($scope.tabs[tab_index]), function (buyer) {
      buyer.checked = $scope.tabs[tab_index].checked;
    });
  };

  $scope.uncheck_items = function () {
    _underscore2.default.each($scope.tabs, function (tab) {
      tab.checked = false;
      _underscore2.default.each(tab.buyers, function (buyer) {
        buyer.checked = false;
      });
    });
  };

  $scope.search = function () {
    $scope.searching = true;
    $scope.filter.min_quality_accuracy = $scope.filter.pre_min_quality_accuracy;
    $scope.filter.min_specs_accuracy = $scope.filter.pre_min_specs_accuracy;
    $scope.filter.excluded_user_groups = _underscore2.default.pluck(_underscore2.default.where($scope.excluded_groups, {
      checked: true
    }), 'id');
    $scope.filter.business_relations = _underscore2.default.pluck(_underscore2.default.where($scope.business_relations, {
      checked: true
    }), 'id');
    $scope.filter.product_end_uses = _underscore2.default.pluck(_underscore2.default.where($scope.product_end_uses, {
      checked: true
    }), 'id');
    OfferService.find_campaign_recipients(window.offer_id, $scope.filter).success(function (data) {
      $scope.tabs[0].buyers = data.recipients.general;
      $scope.tabs[1].buyers = data.recipients.special;
      $scope.tabs[2].buyers = data.recipients.restricted;
      $scope.searching = false;
    });
  };

  $scope.get_buyers = function (tab) {
    var buyers = tab.buyers;

    if (tab.title === 'Restricted') {
      return buyers;
    }

    if ($scope.attention_filter > 0) {
      var needs_attention = $scope.attention_filter === 1;
      buyers = _underscore2.default.where(buyers, {
        needs_attention: needs_attention
      });
    }

    if ($scope.special_handling_filter > 0) {
      var special_handling = $scope.special_handling_filter === 1;
      buyers = _underscore2.default.where(buyers, {
        special_handling: special_handling
      });
    }

    if ($scope.epr_marketing_campaigns_filter > 0) {
      if ($scope.epr_marketing_campaigns_filter === 1) {
        buyers = _underscore2.default.filter(buyers, function (x) {
          return x.epr_marketing_campaigns && x.epr_marketing_campaigns.includes('Yes');
        });
      } else {
        buyers = _underscore2.default.filter(buyers, function (x) {
          return x.epr_marketing_campaigns && x.epr_marketing_campaigns.includes('No');
        });
      }
    }

    return buyers;
  };

  $scope.exclude_recipients = function () {
    var general_buyers = _underscore2.default.where($scope.tabs[0].buyers, {
      checked: true
    });
    var special_buyers = _underscore2.default.where($scope.tabs[1].buyers, {
      checked: true
    });
    if (!$scope.excluding && (general_buyers.length > 0 || special_buyers.length > 0)) {
      $scope.excluding = true;
      var buyers = _underscore2.default.union(_underscore2.default.pluck(general_buyers, 'id'), _underscore2.default.pluck(special_buyers, 'id'));
      OfferMarketRestrictionService.add_member_restrictions(window.offer_id, buyers).success(function (data) {
        if (data.success) {
          $scope.tabs[0].buyers = _underscore2.default.difference($scope.tabs[0].buyers, general_buyers);
          $scope.tabs[1].buyers = _underscore2.default.difference($scope.tabs[1].buyers, special_buyers);
          $scope.tabs[0].checked = false;
          $scope.tabs[1].checked = false;
          $scope.tabs[2].buyers = data.restricted_buyers;
          $scope.excluding = false;
        }
      });
    }
  };

  $scope.get_campaign_criteria = function (offer_campaign_criteria) {
    var status = _underscore2.default.findWhere(window.offer_campaign_criteria_statuses, {
      id: offer_campaign_criteria
    });
    return status.title;
  };

  $scope.quick_search = function (tab_index) {
    window.filter_table('table.tab' + tab_index, $scope.tabs[tab_index].query);
  };

  function set_buyer_company_autocomplete(input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Buyer', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        if (!_underscore2.default.findWhere($scope.filter.buyers, { id: ui.item.id })) {
          $scope.filter.buyers.push({
            id: ui.item.id,
            title: ui.item.value
          });
        }
        $scope.buyer_company = null;
        $scope.$apply();
        return false;
      }
    });
  }

  $scope.remove_buyer = function (buyer_id) {
    $scope.filter.buyers = _underscore2.default.reject($scope.filter.buyers, function (buyer) {
      return buyer.id == buyer_id;
    });
  };

  $scope.quick_search_end_uses = function () {
    if ($scope.quick_filter) {
      var regex = new RegExp($scope.quick_filter, 'i');
      _underscore2.default.each($scope.product_end_uses, function (end_use) {
        end_use.visible = end_use.title.search(regex) > -1;
      });

      $scope.search_filter = {
        visible: true
      };
    } else {
      $scope.search_filter = {};
    }
  };

  $scope.toggleEUcountries = function toggleEUcountries(check_eu_countries) {
    if (check_eu_countries) {
      if (!$scope.filter.user_countries) {
        $scope.filter.user_countries = [];
      }
      $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.eu_countries);
    } else {
      $scope.filter.user_countries = _underscore2.default.difference($scope.filter.user_countries, $scope.eu_countries);
    }
    (0, _jquery2.default)('#buyer_countries').select2('val', $scope.filter.user_countries);
  };

  $scope.toggleAsiacountries = function toggleAsiacountries(check_asia_countries) {
    if (check_asia_countries) {
      if (!$scope.filter.user_countries) {
        $scope.filter.user_countries = [];
      }
      $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.asia_countries);
    } else {
      $scope.filter.user_countries = _underscore2.default.difference($scope.filter.user_countries, $scope.asia_countries);
    }
    (0, _jquery2.default)('#buyer_countries').select2('val', $scope.filter.user_countries);
  };

  $scope.toggleAfricacountries = function toggleAfricacountries(check_africa_countries) {
    if (check_africa_countries) {
      if (!$scope.filter.user_countries) {
        $scope.filter.user_countries = [];
      }
      $scope.filter.user_countries = $scope.filter.user_countries.concat($scope.africa_countries);
    } else {
      $scope.filter.user_countries = _underscore2.default.difference($scope.filter.user_countries, $scope.africa_countries);
    }
    (0, _jquery2.default)('#buyer_countries').select2('val', $scope.filter.user_countries);
  };

  $scope.init = function () {
    $scope.settings = window.campaign_settings || OfferCampaignService.get_default_settings(window.offer_title);
    console.log($scope.settings);
    $scope.settings = OfferCampaignService.set_default_settings($scope.settings);
    $scope.filter = $scope.settings.filter;
    $scope.business_relations = window.business_relations;
    OfferCampaignService.update_business_relations($scope.business_relations, $scope.filter);
    $scope.excluded_groups = OfferCampaignService.get_groups();
    OfferCampaignService.update_excluded_groups($scope.excluded_groups, $scope.filter);
    $scope.current_page = 'recipients_find';
    $scope.product_categories = window.product_categories;
    $scope.selected_tab = 0;
    $scope.attention_filter = 0;
    $scope.special_handling_filter = 0;
    $scope.epr_marketing_campaigns_filter = 0;
    $scope.tabs[2].buyers = window.restricted_buyers;
    $scope.offer_id = window.offer_id;
    set_buyer_company_autocomplete((0, _jquery2.default)('input.buyer_company'));
    $scope.show_all_product_end_uses = false;
    $scope.show_suggested_product_end_uses = false;
    $scope.eu_countries = window.eu.countries.map(function (a) {
      return String(a.id);
    });
    $scope.asia_countries = window.asia.countries.map(function (a) {
      return String(a.id);
    });
    $scope.africa_countries = window.africa.countries.map(function (a) {
      return String(a.id);
    });
    if (_underscore2.default.difference($scope.eu_countries, $scope.filter.user_countries).length === 0) {
      $scope.check_eu_countries = true;
    }
    if (_underscore2.default.difference($scope.asia_countries, $scope.filter.user_countries).length === 0) {
      $scope.check_asia_countries = true;
    }
    if (_underscore2.default.difference($scope.africa_countries, $scope.filter.user_countries).length === 0) {
      $scope.check_africa_countries = true;
    }
    $scope.product_end_uses = window.product_end_uses;
    _underscore2.default.each($scope.filter.product_end_uses, function (end_use) {
      var product_end_use = _underscore2.default.findWhere($scope.product_end_uses, {
        id: end_use
      });
      if (product_end_use) {
        product_end_use.checked = true;
      }
    });
    _underscore2.default.each(window.suggested_product_end_uses, function (end_use) {
      var product_end_use = _underscore2.default.findWhere($scope.product_end_uses, {
        id: end_use.id
      });
      if (product_end_use) {
        product_end_use.suggested = true;
      }
    });
  };

  $scope.init();
};

exports.default = OfferCampaignSettings;


OfferCampaignSettings.$inject = ['$scope', 'OfferService', 'OfferMarketRestrictionService', 'OfferCampaignService', 'UserService'];

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferCampaign = function OfferCampaign($scope, OfferCampaignService, UiService, EmailService) {
  _classCallCheck(this, OfferCampaign);

  $scope.update_title = function () {
    $scope.updating_title = true;
    var campaign = {
      id: $scope.offer_campaign.id,
      title: $scope.new_title
    };
    OfferCampaignService.update(campaign).success(function (data) {
      if (data.success) {
        $scope.offer_campaign.title = $scope.new_title;
        $scope.edit_title = false;
        $scope.updating_title = false;
      }
    });
  };

  $scope.update_title_el = function () {
    $scope.update_title_el = true;
    var campaign = {
      id: $scope.offer_campaign.id,
      title_el: $scope.new_title_el
    };
    OfferCampaignService.update(campaign).success(function (data) {
      if (data.success) {
        $scope.offer_campaign.title_el = $scope.new_title_el;
        $scope.edit_title_el = false;
        $scope.updating_title_el = false;
      }
    });
  };

  $scope.update_general_text = function () {
    $scope.updating_general_text = true;
    var campaign = {
      id: $scope.offer_campaign.id,
      general_text: $scope.new_general_text
    };
    OfferCampaignService.update(campaign).success(function (data) {
      if (data.success) {
        $scope.offer_campaign.general_text = $scope.new_general_text;
        $scope.edit_general_text = false;
        $scope.updating_general_text = false;
      }
    });
  };

  $scope.update_general_text_el = function () {
    $scope.updating_general_text_el = true;
    var campaign = {
      id: $scope.offer_campaign.id,
      general_text_el: $scope.new_general_text_el
    };
    OfferCampaignService.update(campaign).success(function (data) {
      if (data.success) {
        $scope.offer_campaign.general_text_el = $scope.new_general_text_el;
        $scope.edit_general_text_el = false;
        $scope.updating_general_text_el = false;
      }
    });
  };

  $scope.update_supplier_text = function () {
    $scope.updating_supplier_text = true;
    var campaign = {
      id: $scope.offer_campaign.id,
      supplier_text: $scope.new_supplier_text
    };
    OfferCampaignService.update(campaign).success(function (data) {
      if (data.success) {
        $scope.offer_campaign.supplier_text = $scope.new_supplier_text;
        $scope.edit_supplier_text = false;
        $scope.updating_supplier_text = false;
      }
    });
  };

  $scope.update_supplier_text_greeting = function () {
    $scope.updating_supplier_text_greeting = true;
    var campaign = {
      id: $scope.offer_campaign.id,
      supplier_text_greeting: $scope.new_supplier_text_greeting
    };
    OfferCampaignService.update(campaign).success(function (data) {
      if (data.success) {
        $scope.offer_campaign.supplier_text_greeting = $scope.new_supplier_text_greeting;
        $scope.edit_supplier_text_greeting = false;
        $scope.updating_supplier_text_greeting = false;
      }
    });
  };

  $scope.update_supplier_text_el = function () {
    $scope.updating_supplier_text_el = true;
    var campaign = {
      id: $scope.offer_campaign.id,
      supplier_text_el: $scope.new_supplier_text_el
    };
    OfferCampaignService.update(campaign).success(function (data) {
      if (data.success) {
        $scope.offer_campaign.supplier_text_el = $scope.new_supplier_text_el;
        $scope.edit_supplier_text_el = false;
        $scope.updating_supplier_text_el = false;
      }
    });
  };

  $scope.update_supplier_text_greeting_el = function () {
    $scope.updating_supplier_text_greeting_el = true;
    var campaign = {
      id: $scope.offer_campaign.id,
      supplier_text_greeting_el: $scope.new_supplier_text_greeting_el
    };
    OfferCampaignService.update(campaign).success(function (data) {
      if (data.success) {
        $scope.offer_campaign.supplier_text_greeting_el = $scope.new_supplier_text_greeting_el;
        $scope.edit_supplier_text_greeting_el = false;
        $scope.updating_supplier_text_greeting_el = false;
      }
    });
  };

  $scope.update_supplier_text_el_per = function () {
    $scope.updating_supplier_text_el_per = true;
    var campaign = {
      id: $scope.offer_campaign.id,
      supplier_text_el_per: $scope.new_supplier_text_el_per
    };
    OfferCampaignService.update(campaign).success(function (data) {
      if (data.success) {
        $scope.offer_campaign.supplier_text_el_per = $scope.new_supplier_text_el_per;
        $scope.edit_supplier_text_el_per = false;
        $scope.updating_supplier_text_el_per = false;
      }
    });
  };

  $scope.update_supplier_text_greeting_el_per = function () {
    $scope.updating_supplier_text_greeting_el_per = true;
    var campaign = {
      id: $scope.offer_campaign.id,
      supplier_text_greeting_el_per: $scope.new_supplier_text_greeting_el_per
    };
    OfferCampaignService.update(campaign).success(function (data) {
      if (data.success) {
        $scope.offer_campaign.supplier_text_greeting_el_per = $scope.new_supplier_text_greeting_el_per;
        $scope.edit_supplier_text_greeting_el_per = false;
        $scope.updating_supplier_text_greeting_el_per = false;
      }
    });
  };

  $scope.update_sender_name = function () {
    $scope.updating_sender_name = true;
    var campaign = {
      id: $scope.offer_campaign.id,
      sender_name: $scope.new_sender_name
    };
    OfferCampaignService.update(campaign).success(function (data) {
      if (data.success) {
        $scope.offer_campaign.sender_name = $scope.new_sender_name;
        $scope.edit_sender_name = false;
        $scope.updating_sender_name = false;
      }
    });
  };

  $scope.update_sender_name_el = function () {
    $scope.updating_sender_name_el = true;
    var campaign = {
      id: $scope.offer_campaign.id,
      sender_name_el: $scope.new_sender_name_el
    };
    OfferCampaignService.update(campaign).success(function (data) {
      if (data.success) {
        $scope.offer_campaign.sender_name_el = $scope.new_sender_name_el;
        $scope.edit_sender_name_el = false;
        $scope.updating_sender_name_el = false;
      }
    });
  };

  $scope.update_filename_stocklist = function () {
    $scope.updating_filename_stocklist = true;
    var campaign = {
      id: $scope.offer_campaign.id,
      filename_stocklist: $scope.new_filename_stocklist
    };
    OfferCampaignService.update(campaign).success(function (data) {
      if (data.success) {
        $scope.offer_campaign.filename_stocklist = data.filename_stocklist;
        $scope.edit_filename_stocklist = false;
        $scope.updating_filename_stocklist = false;
      }
    });
  };

  $scope.update_filename_stocklist_pi = function () {
    $scope.updating_filename_stocklist_pi = true;
    var campaign = {
      id: $scope.offer_campaign.id,
      filename_stocklist_pi: $scope.new_filename_stocklist_pi
    };
    OfferCampaignService.update(campaign).success(function (data) {
      if (data.success) {
        $scope.offer_campaign.filename_stocklist_pi = data.filename_stocklist_pi;
        $scope.edit_filename_stocklist_pi = false;
        $scope.updating_filename_stocklist_pi = false;
      }
    });
  };

  $scope.update_related_offer = function () {
    $scope.updating_related_offer = true;
    var campaign = {
      id: $scope.offer_campaign.id,
      related_offer_id: $scope.new_related_offer
    };
    OfferCampaignService.update(campaign).success(function (data) {
      if (data.success) {
        $scope.offer_campaign.related_offer_id = $scope.new_related_offer;
        $scope.edit_related_offer = false;
        $scope.updating_related_offer = false;
      }
    });
  };

  $scope.update_max_embedded_matched_rows = function () {
    $scope.updating_max_embedded_matched_rows = true;
    var campaign = {
      id: $scope.offer_campaign.id,
      max_embedded_matched_rows: $scope.new_max_embedded_matched_rows
    };
    OfferCampaignService.update(campaign).success(function (data) {
      if (data.success) {
        $scope.offer_campaign.max_embedded_matched_rows = $scope.new_max_embedded_matched_rows;
        $scope.edit_max_embedded_matched_rows = false;
        $scope.updating_max_embedded_matched_rows = false;
      }
    });
  };

  $scope.update_special_notes = function () {
    $scope.updating_special_notes = true;
    var campaign = {
      id: $scope.offer_campaign.id,
      special_notes: $scope.new_special_notes
    };
    OfferCampaignService.update(campaign).success(function (data) {
      if (data.success) {
        $scope.offer_campaign.special_notes = $scope.new_special_notes;
        $scope.edit_special_notes = false;
        $scope.updating_special_notes = false;
      }
    });
  };

  $scope.update_target_recipients = function () {
    $scope.updating_target_recipients = true;
    var campaign = {
      id: $scope.offer_campaign.id,
      target_recipients: $scope.new_target_recipients
    };
    OfferCampaignService.update(campaign).success(function (data) {
      if (data.success) {
        $scope.offer_campaign.target_recipients = $scope.new_target_recipients;
        $scope.edit_target_recipients = false;
        $scope.updating_target_recipients = false;
      }
    });
  };

  $scope.sender_names = EmailService.get_sender_names_en();
  $scope.sender_names_el = EmailService.get_sender_names_el();

  $scope.$watch('select_sender_name', function () {
    if ($scope.select_sender_name) $scope.new_sender_name = $scope.select_sender_name;
  });

  $scope.$watch('select_sender_name_el', function () {
    if ($scope.select_sender_name_el) $scope.new_sender_name_el = $scope.select_sender_name_el;
  });

  $scope.copy_fields = function () {
    $scope.copying_fields = true;
    OfferCampaignService.copy_text_fields($scope.similar_campaign_id, window.offer_campaign.id).success(function (data) {
      if (data.success) location.reload();
    });
  };

  $scope.update_offer_campaign = function (field, loader) {
    $scope[loader] = true;
    var campaign = {
      id: $scope.offer_campaign.id
    };
    campaign[field] = $scope.offer_campaign[field];
    OfferCampaignService.update(campaign).success(function (data) {
      if (data.success) $scope[loader] = false;
    });
  };

  $scope.init = function () {
    $scope.tinymceOptions = UiService.tinymceOptions();
    $scope.offer_campaign = window.offer_campaign;
    $scope.current_page = 'basic_infos';
    $scope.similar_campaigns = window.similar_campaigns;
    $scope.currency_symbols = window.currency_symbols;
    if ($scope.similar_campaigns.length > 0) $scope.similar_campaign_id = $scope.similar_campaigns[0].id;
  };

  $scope.init();
};

exports.default = OfferCampaign;


OfferCampaign.$inject = ['$scope', 'OfferCampaignService', 'UiService', 'EmailService'];

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferCampaigns = function OfferCampaigns($scope, $rootScope, OfferCampaignService, PaginationService, UserService, DateService) {
  _classCallCheck(this, OfferCampaigns);

  function set_supplier_company_autocomplete(input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Seller', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.filter.supplier_id = ui.item.id;
        $scope.$apply();
      }
    });
  }

  function set_buyer_company_autocomplete(input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Buyer', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.filter.buyer_id = ui.item.id;
        $scope.$apply();
      }
    });
  }

  $scope.load_data = function () {
    $scope.loading = true;
    OfferCampaignService.get($scope.filter).success(function (data) {
      $scope.campaigns = data.campaigns;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
      if ($scope.selected_campaigns) {
        _underscore2.default.each($scope.selected_campaigns, function (campaign_id) {
          var campaign = _underscore2.default.findWhere($scope.campaigns, {
            id: campaign_id
          });
          if (campaign) campaign.checked = true;
        });
      }
      $scope.loading = false;
    });
  };

  $scope.delete_offer_campaign = function (offer_campaign_id) {
    if (confirm('Are you sure you want to delete this campaign?')) {
      OfferCampaignService.delete(offer_campaign_id).success(function (data) {
        if (data.success) $scope.load_data();
      });
    }
  };

  $scope.init_filter = function () {
    $scope.supplier_company = null;
    $scope.buyer_company = null;
    var now = new Date();
    var date_from = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 60);
    var date_to = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    $scope.filter = {
      page: 1,
      per_page: 40,
      offer_id: null,
      supplier_id: null,
      buyer_id: null,
      is_buyer_pending: false,
      status: 0,
      date_from: DateService.get_date_str(date_from),
      date_to: DateService.get_date_str(date_to)
    };
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.load_data();
  };

  $scope.check_campaigns = function () {
    _underscore2.default.each($scope.campaigns, function (c) {
      c.checked = $scope.select_all;
    });
  };

  $scope.mass_send_campaigns = function () {
    var campaigns = _underscore2.default.where($scope.campaigns, {
      checked: true
    });
    if (campaigns.length === 0) {
      alert('Please select at least one campaign!');
      return false;
    }

    $scope.selected_campaigns = _underscore2.default.pluck(campaigns, 'id');

    $rootScope.$broadcast('show_mass_send_dialog', {
      campaigns: campaigns
    });
  };

  $scope.$on('reload_campaign_data', function () {
    $scope.load_data();
  });

  $scope.status_options = [{
    id: 0,
    title: 'All'
  }, {
    id: 1,
    title: 'Executed Campaigns'
  }, {
    id: 2,
    title: 'Pending Campaigns'
  }];

  $scope.quick_search = function () {
    window.filter_table('table.data', $scope.quick_filter);
  };

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.init = function () {
    $scope.campaigns = [];
    $scope.pagination = {};
    set_supplier_company_autocomplete((0, _jquery2.default)('input.supplier_company'));
    set_buyer_company_autocomplete((0, _jquery2.default)('input.buyer_company'));
    $scope.init_filter();
    $scope.load_data();
  };

  $scope.init();
};

exports.default = OfferCampaigns;


OfferCampaigns.$inject = ['$scope', '$rootScope', 'OfferCampaignService', 'PaginationService', 'UserService', 'DateService'];

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferCharges = function OfferCharges($scope, OfferService, UserService) {
  _classCallCheck(this, OfferCharges);

  $scope.tabs = [{
    title: 'By Delivery Term'
  }, {
    title: 'By Country'
  }, {
    title: 'By User'
  }];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.select2_options = {
    containerCssClass: 'multiselect2',
    dropdownCssClass: 'multiselect2',
    width: '600px'
  };

  $scope.check_items = function (is_reels) {
    _angular2.default.forEach($scope.items, function (item) {
      if (is_reels && item.is_reels) item.checked = $scope.reels_checked;else if (!is_reels && !item.is_reels) item.checked = $scope.sheets_checked;
    });
  };

  $scope.get_stocklist = function () {
    $scope.previous_items = _angular2.default.copy($scope.items);
    $scope.items = [];
    $scope.loading = true;
    OfferService.get_stocklist_for_charges(window.offer_id).then(function (data) {
      $scope.items = data.items;
      $scope.has_reels = _underscore2.default.select(data.items, function (i) {
        return i.is_reels === true;
      }).length > 0;
      $scope.has_sheets = _underscore2.default.select(data.items, function (i) {
        return i.is_reels === false;
      }).length > 0;
      $scope.loading = false;
      _angular2.default.forEach($scope.items, function (item) {
        var previous_item = _underscore2.default.find($scope.previous_items, function (i) {
          return item.id == i.id;
        });
        if (previous_item && previous_item.checked) item.checked = true;
      });
    });
  };

  $scope.apply_charge = function () {
    var items = [];
    _angular2.default.forEach($scope.items, function (item) {
      if (item.checked) items.push({
        id: item.id,
        charge: $scope.charge,
        term: $scope.charge_term
      });
    });
    if (items.length === 0) {
      alert('Please select at least one item!');
    } else {
      $scope.applying_charges = true;
      OfferService.set_item_term_charges(window.offer_id, items).then(function (data) {
        if (data.success) {
          $scope.applying_charges = false;
          $scope.get_stocklist();
        }
      });
    }
  };

  $scope.$watch('continent', function () {
    $scope.countries = [];
    if ($scope.continent && $scope.continent !== '') {
      var group = (0, _jquery2.default)('select#countries').find('optgroup[label="' + $scope.continent + '"]');
      group.find('option').each(function () {
        $scope.countries.push((0, _jquery2.default)(this).attr('value'));
      });
    }
  });

  $scope.apply_country_charge = function () {
    if ($scope.countries.length === 0) {
      alert('Please select at least one country!');
    } else {
      $scope.applying_country_charges = true;
      OfferService.set_offer_country_charges(window.offer_id, $scope.country_charge, $scope.countries).then(function (data) {
        if (data.success) {
          $scope.applying_country_charges = false;
          $scope.country_charges = data.country_charges;
          $scope.preview_data = null;
        }
      });
    }
  };

  $scope.delete_country_charge = function (charge_id) {
    OfferService.delete_country_charge(window.offer_id, charge_id).then(function (data) {
      if (data.success) {
        $scope.country_charges = data.country_charges;
        $scope.preview_data = null;
      }
    });
  };

  $scope.preview_country_charge = function (country_charge) {
    $scope.preview_data = country_charge;
  };

  $scope.filter_supplier_country_charges = function (charge) {
    return typeof _underscore2.default.findWhere($scope.country_charges, {
      country_id: charge.country_id
    }) == 'undefined';
  };

  function set_user_company_autocomplete(input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Buyer', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.user_charge.user_id = ui.item.id;
        $scope.buyer_user_company = ui.item.value;
        (0, _jquery2.default)(this).val('');
        $scope.$apply();
      }
    });
  }

  $scope.remove_user = function () {
    $scope.user_charge.user_id = null;
    $scope.buyer_user_company = null;
    (0, _jquery2.default)('input.user_company').val('');
  };

  function get_user_charge() {
    return {
      offer_id: window.offer_id,
      user_id: null,
      charge: 0
    };
  }

  $scope.add_user_charge = function () {
    if (!$scope.user_charge.user_id) {
      alert('Please select a buyer!');
      return false;
    }
    if ($scope.user_charge.charge === 0) {
      alert('Please input a valid charge!');
      return false;
    }
    if (_underscore2.default.findWhere($scope.user_charges, { user_id: $scope.user_charge.user_id })) {
      alert('User has an existing charge!');
      return false;
    }
    $scope.adding_user_charge = true;
    OfferService.save_user_charge($scope.user_charge).success(function (data) {
      if (data.success) {
        $scope.user_charges = data.user_charges;
        $scope.adding_user_charge = false;
        $scope.remove_user();
      }
    });
  };

  $scope.edit_user_charge = function (user_charge) {
    $scope.dialog_user_charge = _angular2.default.copy(user_charge);
    _jquery2.default.fancybox((0, _jquery2.default)('div#edit_user_charge'), {
      padding: '5',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      topRatio: 0.15,
      scrolling: 'no'
    });
  };

  $scope.update_user_charge = function () {
    OfferService.save_user_charge($scope.dialog_user_charge).success(function (data) {
      if (data.success) {
        $scope.user_charges = data.user_charges;
        _jquery2.default.fancybox.close();
      }
    });
  };

  $scope.delete_user_charge = function (user_charge) {
    OfferService.delete_user_charge(user_charge.id).success(function (data) {
      if (data.success) $scope.user_charges.splice(_underscore2.default.indexOf($scope.user_charges, user_charge), 1);
    });
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.offer_id = window.offer_id;
    $scope.show_fca = true;
    $scope.show_fas = false;
    $scope.show_cfr = false;
    $scope.show_dap = false;
    $scope.show_fob = false;
    $scope.charge_term = 3;
    $scope.charge = 0;
    $scope.items = [];
    $scope.get_stocklist();
    $scope.countries = [];
    $scope.country_charges = window.country_charges;
    $scope.supplier_country_charges = window.supplier_country_charges;
    $scope.user_charges = window.user_charges;
    $scope.user_charge = get_user_charge();
    set_user_company_autocomplete((0, _jquery2.default)('input.user_company'));
  };

  $scope.init();
};

exports.default = OfferCharges;


OfferCharges.$inject = ['$scope', 'OfferService', 'UserService'];

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferConnectionsItem = function OfferConnectionsItem($scope, OfferService) {
  _classCallCheck(this, OfferConnectionsItem);

  $scope.get_status_css_class = function (offer) {
    if (offer.is_deleted) return 'red';else if (offer.is_visible && offer.is_active) return 'green';else if (!offer.is_visible && offer.is_active) return 'orange';else return '';
  };

  $scope.update_stocklist = function (offer) {
    offer.updating = true;
    OfferService.update_stocklist_from_parent(offer.id).then(function (data) {
      if (data.success) {
        offer.updating = false;
        $scope.load_offers();
      }
    });
  };
};

exports.default = OfferConnectionsItem;


OfferConnectionsItem.$inject = ['$scope', 'OfferService'];

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferConnections = function OfferConnections($scope, $rootScope, $q, OfferService, OfferCampaignService) {
  _classCallCheck(this, OfferConnections);

  $scope.tabs = [{}, {}];
  $scope.times = [];

  $scope.load_offers = function () {
    $scope.loading = true;
    OfferService.get_connections(window.offer.id).then(function (data) {
      $scope.general_count = _underscore2.default.where(data.offers, {
        buyer_id: null
      }).length;
      $scope.personalized_count = data.offers.length - $scope.general_count;
      $scope.offers = data.offers;
      $scope.loading = false;
    });
  };

  $scope.filter_offers = function (offer) {
    if (!$scope.offer.parent_offer_id) {
      return $scope.selected_tab === 0 ? offer.buyer_id === null : offer.buyer_id !== null;
    } else {
      return true;
    }
  };

  $scope.delete_offer = function (offer) {
    if (confirm('Are you sure you want to delete this offer?')) {
      offer.deleting = true;
      OfferService.delete(offer.id).success(function (data) {
        if (data.success) {
          offer.deleting = false;
          $scope.offers.splice(_underscore2.default.indexOf($scope.offers, offer), 1);
        }
      });
    }
  };

  $scope.update_stocklists = function () {
    var offers = _underscore2.default.filter($scope.offers, function (o) {
      if ($scope.selected_tab === 0) {
        return o.buyer_id === null;
      } else {
        return o.buyer_id !== null;
      }
    });
    if (offers.length > 0) {
      $scope.updating_stocklists = true;
      $rootScope.$broadcast('show_mass_update_dialog', {
        offers: offers
      });

      $scope.updating_stocklists = false;
    }
  };

  $scope.check_offers = function () {
    _underscore2.default.each($scope.offers, function (o) {
      if ($scope.selected_tab === 0 && o.buyer_id === null) {
        o.checked = $scope.tabs[0].select_all;
      } else if ($scope.selected_tab === 1 && o.buyer_id !== null) {
        o.checked = $scope.tabs[1].select_all;
      }
    });
  };

  $scope.create_offer_campaigns = function (send) {
    $scope.times = [];
    var offers = _underscore2.default.where($scope.offers, {
      checked: true
    });
    if (offers.length === 0) {
      alert('Please select at least one offer!');
      return false;
    }

    var campaigns = [];

    offers.reduce(function (promise, offer, index) {
      var t0 = performance.now();
      return promise.then(function (result) {
        if (result) {
          campaigns.push(result.campaign_id);
        }

        var deferred = $q.defer();

        var settings = offer.offer_campaign_settings || $scope.offer.offer_campaign_settings;

        var data = {
          offer_id: offer.id,
          campaign_settings: settings,
          deferred: deferred,
          total_count: offers.length,
          current_index: index
        };
        $rootScope.$broadcast('show_create_campaign', data);

        var t1 = performance.now();
        $scope.times.push((t1 - t0) / 1000);
        return deferred.promise;
      });
    }, $q.when()).then(function (result) {
      campaigns.push(result.campaign_id);

      if (send) {
        $scope.filter = {
          offer_campaign_id: campaigns
        };
        OfferCampaignService.get($scope.filter).success(function (data) {
          $rootScope.$broadcast('show_mass_send_dialog', {
            created_times: $scope.times,
            campaigns: data.campaigns
          });
        });
      } else {
        OfferCampaignService.send_created_campaigns_email(campaigns, $scope.times);
      }
    });
  };

  $scope.mass_check_campaigns = function (index) {

    if (index === null) {
      $scope.mass_check_offers = _underscore2.default.filter($scope.offers, function (offer) {
        return offer.checked && offer.offer_campaign_settings;
      });
      if ($scope.mass_check_offers.length > 0) {
        $scope.mass_check_campaigns(0);
      }
    } else {
      var offer = $scope.mass_check_offers[index];
      var campaign_settings = offer.offer_campaign_settings;
      var filter = campaign_settings.filter;
      filter.min_quality_accuracy = filter.pre_min_quality_accuracy;
      filter.min_specs_accuracy = filter.pre_min_specs_accuracy;
      offer.checking_campaigns = true;
      OfferService.find_campaign_recipients(offer.id, filter).success(function (data) {
        offer.recipients_count = data.recipients.general.length + data.recipients.special.length;
        offer.restricted_count = data.recipients.restricted.length;
        offer.checking_campaigns = false;
        if (index < $scope.mass_check_offers.length - 1) {
          $scope.mass_check_campaigns(index + 1);
        }
      });
    }
  };

  $scope.$on('update_offer_data', function (event, data) {
    var offer = _underscore2.default.find($scope.offers, {
      id: data.offer_id
    });
    offer.created_campaign_id = data.campaign_id;
  });

  $scope.init = function () {
    $scope.offer = window.offer;
    $scope.selected_tab = 0;
    $scope.filter = {
      offer_id: window.offer ? window.offer.id : null
    };
    $scope.load_offers();
  };

  $scope.init();
};

exports.default = OfferConnections;


OfferConnections.$inject = ['$scope', '$rootScope', '$q', 'OfferService', 'OfferCampaignService'];

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferCreate = function OfferCreate($scope, OfferService, UserService, GeoService) {
  _classCallCheck(this, OfferCreate);

  $scope.tabs = ['1. Title & Synopsis', '2. Basic Infos', '3. Description'];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.set_supplier_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Seller', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.offer.supplier_id = ui.item.id;
        $scope.offer.user_contact_id = null;
        $scope.supplier_company = ui.item.value;
        $scope.$apply();
        $scope.update_supplier_data(ui.item.id);
      }
    });
  };

  $scope.update_supplier_data = function (user_id) {
    UserService.get_contacts(user_id).success(function (data) {
      $scope.supplier_contacts = data.contacts;
    });

    UserService.get_seller_trading_data(user_id).then(function (data) {
      $scope.offer.currency_id = data.currency_id;
      $scope.offer.origin = data.origin;
      $scope.offer.delivery = data.delivery;
      $scope.offer.packaging = data.packaging;
      $scope.offer.sample_available = data.sample_available;
      $scope.offer.min_quantity_truck = data.min_quantity_truck;
      $scope.offer.min_quantity_ship = data.min_quantity_ship;
      $scope.offer.min_quantity_self = data.min_quantity_self;
      $scope.offer.dap_country_id = data.dap_country_id;
      $scope.offer.dap_port = data.dap_port;
    });
  };

  $scope.$watch('offer.dap_country_id', function () {
    if ($scope.offer.dap_country_id) {
      GeoService.get_cities($scope.offer.dap_country_id).then(function (data) {
        $scope.shipment_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.offer.dap_port })) $scope.offer.dap_port = null;
      });
    }
  });

  $scope.load_user_notes = function () {
    if ($scope.offer.supplier_id) {
      UserService.get_notes($scope.offer.supplier_id).then(function (data) {
        $scope.offer.notes = data.notes;
      });
    } else {
      alert('Please select a supplier first!');
    }
  };

  $scope.create_offer = function () {
    $scope.creating_offer = true;
    if (!$scope.offer.supplier_id) {
      $scope.form_error = 'Please select a supplier!';
      $scope.creating_offer = false;
    } else if (!$scope.offer.titleEN) {
      $scope.form_error = 'Please insert a Title (Megaepsilon)!';
      $scope.creating_offer = false;
    } else {
      $scope.form_error = '';
      $scope.offer.incoterms = {
        incoterms: _underscore2.default.pluck(_underscore2.default.filter($scope.incoterms, function (t) {
          return t.checked === true;
        }), 'id')
      };
      $scope.offer.cfr_countries = $scope.incoterms[0].checked ? $scope.cfr_countries : [];
      $scope.offer.dap_countries = $scope.incoterms[0].checked ? $scope.dap_countries : [];

      OfferService.save($scope.offer).then(function (data) {
        if (data.success) {
          $scope.created_offer_id = data.offer_id;
          $scope.create_mode = false;
        } else {
          $scope.form_error = data.message;
        }
        $scope.creating_offer = false;
      });
    }
  };

  $scope.create_new_offer = function () {
    $scope.offer = _angular2.default.copy(window.offer);
    $scope.selected_tab = 0;
    $scope.create_mode = true;
    $scope.supplier_company = '';
    (0, _jquery2.default)('.supplier_company').val('');
    $scope.offer.offer_type = $scope.offer_types[0].id;
    $scope.offer.quality = $scope.offer_qualities[0].id;
    $scope.offer.transaction_type = $scope.transaction_types[0].id;
    $scope.offer.bid_type = $scope.bid_types[0].id;
    $scope.offer.short_description = $scope.short_descriptions[0].id;
    $scope.offer.quantity = 0;
  };

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.select2_options = {
    containerCssClass: 'multiselect2',
    dropdownCssClass: 'multiselect2',
    width: '800px'
  };

  $scope.$watch('cfr_continent', function () {
    if ($scope.cfr_continent && $scope.cfr_continent !== '') {
      var group = (0, _jquery2.default)('select#cfr_countries').find('optgroup[label="' + $scope.cfr_continent + '"]');
      group.find('option').each(function () {
        $scope.cfr_countries.push((0, _jquery2.default)(this).attr('value'));
      });
    }
  });

  $scope.$watch('dap_continent', function () {
    if ($scope.dap_continent && $scope.dap_continent !== '') {
      var group = (0, _jquery2.default)('select#dap_countries').find('optgroup[label="' + $scope.dap_continent + '"]');
      group.find('option').each(function () {
        $scope.dap_countries.push((0, _jquery2.default)(this).attr('value'));
      });
    }
  });

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.create_mode = true;
    $scope.set_supplier_autocomplete((0, _jquery2.default)('input.supplier_company'));
    $scope.offer_types = window.offer_types;
    $scope.offer_qualities = window.offer_qualities;
    $scope.transaction_types = window.transaction_types;
    $scope.bid_types = window.bid_types;
    $scope.short_descriptions = window.short_descriptions;
    $scope.currencies = window.currencies;
    $scope.incoterms = window.incoterms;
    $scope.create_new_offer();
    $scope.cfr_countries = [];
    $scope.dap_countries = [];
  };

  $scope.init();
};

exports.default = OfferCreate;


OfferCreate.$inject = ['$scope', 'OfferService', 'UserService', 'GeoService'];

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferCutAnalysis = function OfferCutAnalysis($scope, $timeout, OfferService, ProductService, UserProductService) {
  _classCallCheck(this, OfferCutAnalysis);

  $scope.quick_search = function () {
    window.filter_table('table#reels', $scope.query);
    window.filter_table('table#sheets', $scope.query);
  };

  $scope.combinations = [{
    value: 1,
    title: '1'
  }, {
    value: 2,
    title: '2'
  }, {
    value: 3,
    title: '3'
  }];

  $scope.sort_by_options = [{
    value: 0,
    title: 'Combinations'
  }, {
    value: 1,
    title: 'Sawed Paper Price'
  }];

  $scope.value_sideruns_options = [{
    value: 0,
    title: 'Yes'
  }, {
    value: 1,
    title: 'No'
  }];

  $scope.create_offer = function () {
    $scope.checked_results = [];
    _underscore2.default.each($scope.results, function (item) {
      _underscore2.default.each(item.results, function (result) {
        if (result.checked == true) {
          $scope.checked_results.push(result);
        }
      });
    });
    OfferService.create_offer_from_cut_analysis($scope.checked_results, $scope.offer_id).then(function (data) {
      if (data.data.success) {
        window.open('/admin/marketplace/offers/edit_main_title/' + data.data.offer_id, '_blank').focus();
      }
    });
  };

  $scope.get_results = function () {
    $scope.items = [];
    $scope.loading = true;
    $scope.filter.widths = $scope.validate_specs($scope.filter.widths);
    OfferService.get_cut_pricing_results($scope.offer_stock_item_ids, $scope.filter).success(function (data) {
      console.log(data);
      $scope.results = data.results;
      $scope.results_string = JSON.stringify($scope.results);
      $scope.offer_stock_item = data.offer_stock_item;
      $scope.epaper_title = data.offer_stock_item_epaper_title;
      $scope.has_results = true;
      $scope.loading = false;
    });
  };

  $scope.load_specs = function () {
    if ($scope.product_group_ids) {
      ProductService.get_product_group_specs($scope.product_group_ids, null).success(function (data) {
        $scope.filter.widths = data.specs;
        $scope.filter.widths = $scope.validate_specs($scope.filter.widths);
      });
    }
  };

  $scope.show_suggested = function (bool) {
    if (bool) {
      $scope.suggested_reels = [];
      $scope.loading_suggested_reels = true;
      ProductService.get_product_group_specs($scope.product_group_ids, null).success(function (data) {
        $scope.suggested_reels = data.specs;
        UserProductService.get_product_group_specs($scope.product_group_ids, true).success(function (data) {
          $scope.suggested_reels = _underscore2.default.union($scope.suggested_reels, data.specs);
          $scope.loading_suggested_reels = false;

          $scope.suggested_reels = $scope.validate_specs($scope.suggested_reels);
          $scope.showing_suggested = true;
          $scope.loading_suggested_reels = false;
        });
      });
    } else {
      $scope.showing_suggested = false;
    }
  };

  $scope.add_suggested = function () {
    var specs = null;
    specs = _underscore2.default.where($scope.suggested_reels, {
      checked: true
    });

    if (specs.length === 0) {
      alert('Please select at least one spec!');
    } else {
      _underscore2.default.each(specs, function (s) {
        var spec = {
          id: null,
          is_reels: true,
          spec_type: 1,
          is_accurate: true,
          value: s.value
        };
        $scope.filter.widths.push(spec);
      });
    }
    $scope.filter.widths = $scope.validate_specs($scope.filter.widths);
  };

  $scope.add_spec = function () {
    var spec = {
      id: null,
      is_reels: true,
      spec_type: 1,
      is_accurate: true,
      value: 0
    };
    $scope.filter.widths.push(spec);
  };

  $scope.validate_specs = function (specs) {
    var valid_specs = _underscore2.default.map(specs, function (o) {
      if (o.value != 0 && o.value <= _underscore2.default.max($scope.offer_stock_item_widths)) return o;
    });
    var validated_specs = [];
    validated_specs = _underscore2.default.without(valid_specs, undefined);
    validated_specs = _underscore2.default.uniq(validated_specs, 'value');

    validated_specs = _underscore2.default.sortBy(validated_specs, ['value']);

    return validated_specs;
  };

  $scope.export_xls = function () {
    OfferService.get_cut_analysis_xls($scope.offer_stock_item_ids, $scope.results).success(function (data) {
      console.log(data);
    });
  };

  $scope.get_filter = function () {
    return {
      widths: [],
      cuts: 0,
      combinations: 1,
      value_sideruns: 0,
      mode: 'cutting'
    };
  };

  $scope.reset_filter = function () {
    $scope.filter = $scope.get_filter();
  };

  $scope.get_analysis_url = function () {
    $scope.offer_stock_item_ids.push($scope.search_offer_stock_item_id);
    console.log($scope.offer_stock_item_ids);
    window.location.href = '/admin/marketplace/offers/edit_cut_pricing/' + $scope.offer_id + '?items=' + $scope.offer_stock_item_ids.join(',');
  };

  $scope.sort = function () {
    if ($scope.sort_by == 0) {
      _underscore2.default.each($scope.results, function (item, i) {
        $scope.results[i].results = _underscore2.default.sortBy($scope.results[i].results, 'combination_count');
      });
    } else if ($scope.sort_by == 1) {
      _underscore2.default.each($scope.results, function (item, i) {
        $scope.results[i].results = _underscore2.default.sortBy($scope.results[i].results, 'price_sawed_paper');
      });
    }
  };

  $scope.init = function () {
    $scope._ = _underscore2.default;
    $scope.offer_id = window.offer_id;
    $scope.showing_suggested = false;
    $scope.product_group_ids = window.product_group_ids;
    $scope.offer_stock_item_ids = window.offer_stock_item_ids;
    $scope.offer_stock_item_widths = window.offer_stock_item_widths;
    $scope.filter = window.filter ? window.filter : $scope.get_filter();
    $scope.sort_by = 0;
    $scope.offer_stock_item_product_titles = window.offer_stock_item_product_titles;
    $scope.page_title = '';
    $scope.items_count = 0;
    _underscore2.default.each($scope.offer_stock_item_ids, function (id, i) {
      if (i > 0) {
        $scope.page_title = $scope.page_title + ', ';
      }
      $scope.page_title = $scope.page_title + $scope.offer_stock_item_product_titles[i] + '(' + id + ')';
      $scope.items_count++;
    });
  };

  $scope.init();
  //$scope.load_specs();
  $scope.loading = false;
};

exports.default = OfferCutAnalysis;


OfferCutAnalysis.$inject = ['$scope', '$timeout', 'OfferService', 'ProductService', 'UserProductService'];

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferEditCampaigns = function OfferEditCampaigns($scope, OfferCampaignService, PaginationService) {
  _classCallCheck(this, OfferEditCampaigns);

  $scope.load_data = function () {
    $scope.loading = true;
    OfferCampaignService.get($scope.filter).success(function (data) {
      $scope.campaigns = data.campaigns;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
      $scope.loading = false;
    });
  };

  $scope.filter = {
    page: 1,
    offer_id: window.offer_id
  };

  $scope.init = function () {
    $scope.campaigns = [];
    $scope.pagination = {};
    $scope.load_data();
  };

  $scope.init();
};

exports.default = OfferEditCampaigns;


OfferEditCampaigns.$inject = ['$scope', 'OfferCampaignService', 'PaginationService'];

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferEdit = function OfferEdit($scope) {
  _classCallCheck(this, OfferEdit);

  var hide_pages = ['edit_supplier_pricing', 'edit_matching', 'edit_main_connections', 'edit_user_pricing'];
  $scope.show_sidebar = !_underscore2.default.contains(hide_pages, window.app_data.action);
};

exports.default = OfferEdit;


OfferEdit.$inject = ['$scope'];

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferInventories = function OfferInventories($scope, OfferService, UserService, UserProductService) {
  _classCallCheck(this, OfferInventories);

  $scope.tabs = [{
    title: 'Search Results',
    offers: [],
    items: [],
    has_reels: false,
    has_sheets: false,
    reels_checked: false,
    sheets_checked: false,
    filter: {
      offer_id: null
    }
  }, {
    title: 'Selected Items',
    offers: [],
    items: [],
    has_reels: false,
    has_sheets: false,
    reels_checked: false,
    sheets_checked: false
  }];

  $scope.filter_items_by_offer = function (tab_index) {
    var offer_id = $scope.tabs[tab_index].filter.offer_id;
    _angular2.default.forEach($scope.tabs[tab_index].items, function (item) {
      if (offer_id) item.visible = item.offer_id == offer_id;else item.visible = true;
    });
  };

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.get_shipment_cities = function () {
    $scope.filter.shipment_city_id = null;
    $scope.shipment_cities = [];
    OfferService.get_supplier_shipment_cities($scope.filter.supplier_id).then(function (data) {
      if (data.success && data.cities.length > 0) {
        $scope.shipment_cities = data.cities;
        $scope.filter.shipment_city_id = data.cities[0].id;
      }
    });
  };

  $scope.set_supplier_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Seller', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.filter.supplier_id = ui.item.id;
        $scope.supplier_company = ui.item.value;
        (0, _jquery2.default)(this).val('');
        $scope.$apply();
        $scope.get_shipment_cities();
        return false;
      }
    });
  };

  $scope.set_buyer_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Buyer', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.filter.buyer_id = ui.item.id;
        $scope.buyer_company = ui.item.value;
        (0, _jquery2.default)(this).val('');
        $scope.$apply();
        $scope.load_buyer_user_products(ui.item.id);
        return false;
      }
    });
  };

  $scope.load_buyer_user_products = function (buyer_id) {
    UserProductService.get_user_products(buyer_id).then(function (data) {
      _underscore2.default.each(data.user_products, function (user_product) {
        if (user_product.product) {
          $scope.buyer_user_products.push({
            id: user_product.id,
            title: user_product.product.title,
            checked: false
          });
        }
      });
    });
  };

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.set_filter = function () {
    $scope.filter = {
      supplier_id: null,
      buyer_id: null,
      title: null,
      date_from: null,
      date_to: null,
      shipment_city_id: null,
      offer_id: window.offer ? window.offer.id : null,
      personal_search_mode: null,
      specs: []
    };
  };

  $scope.remove_supplier = function () {
    $scope.filter.supplier_id = null;
    $scope.supplier_company = null;
    (0, _jquery2.default)('input.supplier_company').val('');
  };

  $scope.remove_buyer = function () {
    $scope.filter.buyer_id = null;
    $scope.buyer_company = null;
    (0, _jquery2.default)('input.buyer_company').val('');
    $scope.buyer_user_products = [];
  };

  $scope.search = function () {
    if (!$scope.filter.supplier_id && !window.offer) {
      alert('Please select a supplier first!');
      return false;
    }
    $scope.searching = true;
    $scope.tabs[0].offers = [];
    $scope.tabs[0].items = [];
    $scope.tabs[0].filter.offer_id = null;
    OfferService.search_for_inventories($scope.filter).then(function (data) {
      if (data.success) {
        $scope.tabs[0].offers = data.offers;
        $scope.tabs[0].items = data.items;
        $scope.set_tab_properties(0);
        $scope.searching = false;
      }
    });
  };

  $scope.check_items = function (tab_index, is_reels) {
    _angular2.default.forEach($scope.tabs[tab_index].items, function (item) {
      if (is_reels && item.is_reels && item.visible) item.checked = $scope.tabs[tab_index].reels_checked;else if (!is_reels && !item.is_reels && item.visible) item.checked = $scope.tabs[tab_index].sheets_checked;
    });
  };

  $scope.select_items = function () {
    _angular2.default.forEach($scope.tabs[0].items, function (item) {
      if (item.checked) {
        var item_copy = _underscore2.default.findWhere($scope.tabs[1].items, {
          id: item.id
        });
        if (typeof item_copy == 'undefined') $scope.tabs[1].items.push(_angular2.default.copy(item));
      }
    });
    $scope.set_tab_properties(1);
  };

  $scope.remove_items = function () {
    var temp_items = [];
    _angular2.default.forEach($scope.tabs[1].items, function (item) {
      if (item.checked) temp_items.push(item);
    });
    _angular2.default.forEach(temp_items, function (item) {
      $scope.tabs[1].items = _underscore2.default.reject($scope.tabs[1].items, function (i) {
        return i.id == item.id;
      });
    });
    $scope.set_tab_properties(1);
  };

  $scope.set_tab_properties = function (tab_index) {
    $scope.tabs[tab_index].has_reels = _underscore2.default.select($scope.tabs[tab_index].items, function (i) {
      return i.is_reels === true;
    }).length > 0;
    $scope.tabs[tab_index].has_sheets = _underscore2.default.select($scope.tabs[tab_index].items, function (i) {
      return i.is_reels === false;
    }).length > 0;
  };

  $scope.create_offer = function () {
    if (!window.offer && !$scope.filter.supplier_id && !window.personal_mode) {
      alert('Please select a supplier!');
    } else if (window.offer && !$scope.filter.buyer_id && window.personal_mode) {
      alert('Please select a buyer!');
    } else {
      var items = [];
      _angular2.default.forEach($scope.tabs[1].items, function (item) {
        items.push(item.id);
      });
      $scope.creating_offer = true;
      OfferService.create_offer_from_items(items, $scope.filter, $scope.offer_options).then(function (data) {
        if (data.data.success) {
          $scope.creating_offer = false;
          window.location = '/admin/marketplace/offers/edit_main_title/' + data.data.offer_id;
        }
      });
    }
  };

  $scope.offer_options = {
    is_connected: false,
    is_inventory: false
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.personal_mode = window.personal_mode;
    $scope.show_fca = true;
    $scope.show_fas = false;
    $scope.show_cfr = false;
    $scope.show_dap = false;
    $scope.set_supplier_autocomplete((0, _jquery2.default)('input.supplier_company'));
    if (window.personal_mode) {
      $scope.set_buyer_autocomplete((0, _jquery2.default)('input.buyer_company'));
    }
    $scope.buyer_user_products = [];
    $scope.offer = window.offer;
    $scope.set_filter();
  };

  $scope.init();
};

exports.default = OfferInventories;


OfferInventories.$inject = ['$scope', 'OfferService', 'UserService', 'UserProductService'];

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferMainBasic = function OfferMainBasic($scope, $rootScope, OfferService, GeoService) {
  _classCallCheck(this, OfferMainBasic);

  $scope.$watch('offer.dap_country_id', function () {
    if ($scope.offer.dap_country_id) {
      GeoService.get_cities($scope.offer.dap_country_id).then(function (data) {
        $scope.shipment_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.offer.dap_port })) $scope.offer.dap_port = null;
      });
    }
  });

  $scope.set_basic_data = function () {
    var count = 0;
    if ($scope.offer.origin) count++;
    if ($scope.offer.currency_id) count++;
    if ($scope.offer.dap_country_id) count++;
    if ($scope.offer.dap_port) count++;
    if ($scope.offer.delivery) count++;
    if ($scope.offer.packaging) count++;
    if ($scope.offer.payment_terms) count++;
    if ($scope.offer.sample_available) count++;
    if ($scope.offer.min_quantity_self || $scope.offer.min_quantity_ship || $scope.offer.min_quantity_truck) count++;
    var percentage = Math.floor(count / 9 * 100.0);
    $rootScope.$broadcast('set_sidebar_data', [1, 1, [{
      type: 'percentage',
      value: percentage
    }, null]]);
  };

  $scope.select2_options = {
    containerCssClass: 'multiselect2',
    dropdownCssClass: 'multiselect2',
    width: '800px'
  };

  $scope.$watch('cfr_continent', function () {
    if ($scope.cfr_continent && $scope.cfr_continent != '') {
      var group = (0, _jquery2.default)('select#cfr_countries').find('optgroup[label="' + $scope.cfr_continent + '"]');
      group.find('option').each(function () {
        $scope.cfr_countries.push((0, _jquery2.default)(this).attr('value'));
      });
    }
  });

  $scope.$watch('dap_continent', function () {
    if ($scope.dap_continent && $scope.dap_continent != '') {
      var group = (0, _jquery2.default)('select#dap_countries').find('optgroup[label="' + $scope.dap_continent + '"]');
      group.find('option').each(function () {
        $scope.dap_countries.push((0, _jquery2.default)(this).attr('value'));
      });
    }
  });

  $scope.update_offer = function () {
    $scope.updating = true;
    $scope.form_error = '';
    $scope.offer.incoterms = {
      incoterms: _underscore2.default.pluck(_underscore2.default.filter($scope.incoterms, function (t) {
        return t.checked == true;
      }), 'id')
    };
    $scope.offer.cfr_countries = $scope.incoterms[0].checked ? $scope.cfr_countries : [];
    $scope.offer.dap_countries = $scope.incoterms[0].checked ? $scope.dap_countries : [];
    OfferService.save($scope.offer).then(function (data) {
      if (!data.success) $scope.form_error = data.message;else $scope.set_basic_data();
      $scope.updating = false;
    });
  };

  $scope.init = function () {
    $scope.currencies = window.currencies;
    $scope.offer = window.offer;
    $scope.incoterms = window.incoterms;
    $scope.countries = window.countries;
    $scope.cfr_countries = window.cfr_countries;
    $scope.dap_countries = window.dap_countries;
  };

  $scope.init();
};

exports.default = OfferMainBasic;


OfferMainBasic.$inject = ['$scope', '$rootScope', 'OfferService', 'GeoService'];

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferMainDescription = function OfferMainDescription($scope, $rootScope, OfferService, UserService) {
  _classCallCheck(this, OfferMainDescription);

  $scope.load_user_notes = function () {
    if ($scope.offer.supplier_id) {
      UserService.get_notes($scope.offer.supplier_id).then(function (data) {
        $scope.offer.notes = data.notes;
      });
    } else {
      alert('Please select a supplier first!');
    }
  };

  $scope.set_description_data = function () {
    var count = 0;
    if ($scope.offer.subtitleEN) count++;
    if ($scope.offer.full_description) count++;
    if ($scope.offer.notes) count++;
    var percentage = Math.floor(count / 3 * 100.0);
    $rootScope.$broadcast('set_sidebar_data', [1, 2, [{
      type: 'percentage',
      value: percentage
    }, null]]);
  };

  $scope.update_offer = function () {
    $scope.updating = true;
    $scope.form_error = '';
    OfferService.save($scope.offer).then(function (data) {
      if (!data.success) $scope.form_error = data.message;else $scope.set_description_data();
      $scope.updating = false;
    });
  };

  $scope.init = function () {
    $scope.offer = window.offer;
  };

  $scope.init();
};

exports.default = OfferMainDescription;


OfferMainDescription.$inject = ['$scope', '$rootScope', 'OfferService', 'UserService'];

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferMainTitle = function OfferMainTitle($scope, $rootScope, OfferService, UserService) {
  _classCallCheck(this, OfferMainTitle);

  $scope.set_supplier_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Seller', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.offer.supplier_id = ui.item.id;
        $scope.offer.user_contact_id = null;
        $scope.supplier_company = ui.item.value;
        $scope.$apply();
        $scope.update_supplier_data(ui.item.id);
      }
    });
  };

  $scope.update_supplier_data = function (user_id) {
    UserService.get_contacts(user_id).success(function (data) {
      $scope.supplier_contacts = data.contacts;
    });
  };

  $scope.set_title_data = function () {
    var count = 0;
    if ($scope.offer.supplier_offer_id) count++;
    if ($scope.offer.published_at) count++;
    if ($scope.offer.titleEN) count++;
    if ($scope.offer.supplier_id) count++;
    if ($scope.offer.user_contact_id) count++;
    if ($scope.offer.offer_type) count++;
    if ($scope.offer.quality) count++;
    if ($scope.offer.short_description) count++;
    if ($scope.offer.bid_type) count++;
    var percentage = Math.floor(count / 9 * 100.0);
    $rootScope.$broadcast('set_sidebar_data', [1, 0, [{
      type: 'percentage',
      value: percentage
    }, null]]);
  };

  $scope.update_offer = function () {
    $scope.updating = true;
    if (!$scope.offer.supplier_id) {
      $scope.form_error = 'Please select a supplier!';
      $scope.updating = false;
    } else if (!$scope.offer.titleEN) {
      $scope.form_error = 'Please insert a Title (Megaepsilon)!';
      $scope.updating = false;
    } else {
      $scope.form_error = '';
      OfferService.save($scope.offer).then(function (data) {
        if (!data.success) $scope.form_error = data.message;else $scope.set_title_data();
        $scope.updating = false;
      });
    }
  };

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.init = function () {
    $scope.offer_types = window.offer_types;
    $scope.offer_qualities = window.offer_qualities;
    $scope.transaction_types = window.transaction_types;
    $scope.bid_types = window.bid_types;
    $scope.short_descriptions = window.short_descriptions;
    $scope.offer = window.offer;
    $scope.supplier_company = window.supplier_company;
    $scope.update_supplier_data(window.offer.supplier_id);
    $scope.set_supplier_autocomplete((0, _jquery2.default)('input.supplier_company'));
  };

  $scope.init();
};

exports.default = OfferMainTitle;


OfferMainTitle.$inject = ['$scope', '$rootScope', 'OfferService', 'UserService'];

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferMarketRestrictions = function OfferMarketRestrictions($scope, $rootScope, OfferMarketRestrictionService, UserService) {
  _classCallCheck(this, OfferMarketRestrictions);

  $scope.tabs = ['Country', 'Group', 'Member', 'Product/Member', 'Product/Country'];

  $scope.check_member_restrictions = function () {
    _underscore2.default.each($scope.offer.member_restrictions, function (c) {
      c.checked = $scope.select_all;
    });
  };

  $scope.delete_member_restrictions = function () {
    var member_restrictions = _underscore2.default.where($scope.offer.member_restrictions, {
      checked: true
    });
    if (member_restrictions.length === 0) {
      alert('Please select at least one member restriction!');
      return;
    }

    if (confirm('Are you sure you want to delete these member restrictions?')) {
      member_restrictions = _underscore2.default.pluck(member_restrictions, 'id');
      OfferMarketRestrictionService.delete_member_restrictions(member_restrictions).then(function (data) {
        if (data.success) {
          $scope.offer.member_restrictions = _underscore2.default.filter($scope.offer.member_restrictions, function (v) {
            return _underscore2.default.indexOf(member_restrictions, v.id) === -1;
          });
          $rootScope.$broadcast('set_sidebar_data', [3, 0, [{
            type: 'counter',
            value: data.offer_restrictions_count
          }, null]]);
        }
      });
    }
  };

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.get_selected_tab = function () {
    return $scope.selected_tab;
  };

  $scope.open_dialog = function (dialog_id) {
    window.openFancyboxDialog('div#' + dialog_id);
  };

  $scope.select2_options = {
    containerCssClass: 'multiselect2',
    dropdownCssClas: 'multiselect2',
    width: '500px'
  };

  $scope.update_continent_countries = function (continent) {
    if (continent.title == 'EU Countries') {
      var europe = $scope.continents.filter(function (continent) {
        return continent.title == 'Europe';
      });
      _angular2.default.forEach(continent.countries, function (country) {
        var eu_country = europe[0].countries.filter(function (europe_country) {
          return europe_country.title == country.title;
        });
        eu_country[0].checked = continent.checked;
      });
    } else {
      _angular2.default.forEach(continent.countries, function (country) {
        country.checked = continent.checked;
      });
    }
  };

  $scope.update_data = function () {
    $scope.offer.country_restrictions = [];
    _angular2.default.forEach(window.continents, function (continent) {
      _angular2.default.forEach(continent.countries, function (country) {
        if (country.checked) $scope.offer.country_restrictions.push(country.id);
      });
    });

    $scope.offer.group_restrictions = [];
    _angular2.default.forEach(window.groups, function (group) {
      if (group.checked) $scope.offer.group_restrictions.push(group.id);
    });

    $scope.offer.business_relation_restrictions = [];
    $scope.offer.business_relation_restrictions = _underscore2.default.pluck(_underscore2.default.where($scope.business_relations, {
      checked: true
    }), 'id');
  };

  $scope.update_restrictions = function () {
    $scope.updating = true;
    $scope.update_data();
    OfferMarketRestrictionService.update($scope.offer).then(function (data) {
      if (data.success) {
        $scope.updating = false;
        $rootScope.$broadcast('set_sidebar_data', [3, 0, [{
          type: 'counter',
          value: data.offer_restrictions_count
        }, null]]);
      }
    });
  };

  $scope.set_user_company_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company(null, request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.dialog_member_restriction.member_id = ui.item.id;
        $scope.dialog_member_restriction.member_company = ui.item.value;
        $scope.$apply();
      }
    });
  };

  $scope.add_member_restriction = function () {
    $scope.dialog_member_restriction = _angular2.default.copy(window.member_restriction);
    $scope.user_company = '';
    $scope.open_dialog('offer_member_restriction_dialog');
  };

  $scope.edit_member_restriction = function (member_restriction) {
    $scope.dialog_member_restriction = member_restriction;
    $scope.user_company = '';
    $scope.open_dialog('offer_member_restriction_dialog');
  };

  $scope.delete_member_restriction = function (index) {
    if (confirm('Are you sure you want to delete this member restriction?')) {
      OfferMarketRestrictionService.delete_member_restriction($scope.offer.member_restrictions[index].id).then(function (data) {
        if (data.success) {
          $scope.offer.member_restrictions.splice(index, 1);
          $rootScope.$broadcast('set_sidebar_data', [3, 0, [{
            type: 'counter',
            value: data.offer_restrictions_count
          }, null]]);
        }
      });
    }
  };

  $scope.save_member_restriction = function () {
    $scope.updating_member_restriction = true;
    OfferMarketRestrictionService.save_member_restriction($scope.dialog_member_restriction).then(function (data) {
      if (data.success) {
        $scope.updating_member_restriction = false;
        _jquery2.default.fancybox.close();
        $scope.offer.member_restrictions = data.offer_member_restrictions;
        $rootScope.$broadcast('set_sidebar_data', [3, 0, [{
          type: 'counter',
          value: data.offer_restrictions_count
        }, null]]);
      }
    });
  };

  $scope.quick_search = function () {
    window.filter_table('table.data', $scope.quick_filter);
  };

  $scope.add_product_member_restrictions = function () {
    $scope.dialog_member_restriction = _angular2.default.copy(window.product_member_restrictions);
    $scope.user_company = '';
    $scope.open_dialog('offer_product_member_restriction_dialog');
  };

  $scope.save_product_member_restrictions = function () {
    if (!$scope.dialog_member_restriction.member_id || $scope.dialog_member_restriction.products.length === 0) {
      alert('Please select at least one product and member!');
      return false;
    }
    $scope.updating_member_restriction = true;
    OfferMarketRestrictionService.save_product_member_restrictions($scope.dialog_member_restriction).success(function (data) {
      if (data.success) {
        $scope.updating_member_restriction = false;
        _jquery2.default.fancybox.close();
        $scope.offer.product_member_restrictions = _underscore2.default.groupBy(data.offer_product_member_restrictions, 'product_id');
        $rootScope.$broadcast('set_sidebar_data', [3, 0, [{
          type: 'counter',
          value: data.offer_restrictions_count
        }, null]]);
      }
    });
  };

  $scope.delete_product_member_restriction = function (restrictions, restriction) {
    if (confirm('Are you sure you want to delete this product/member restriction?')) {
      OfferMarketRestrictionService.delete_product_member_restriction($scope.offer.id, restriction.id).success(function (data) {
        if (data.success) {
          restrictions.splice(_underscore2.default.indexOf(restrictions, restriction), 1);
          $rootScope.$broadcast('set_sidebar_data', [3, 0, [{
            type: 'counter',
            value: data.offer_restrictions_count
          }, null]]);
        }
      });
    }
  };

  $scope.add_product_country_restriction = function () {
    $scope.dialog_product_country_restrictions = _angular2.default.copy(window.product_country_restrictions);
    $scope.open_dialog('offer_product_country_restrictions_dialog');
  };

  $scope.save_product_country_restrictions = function () {
    if ($scope.countries.length === 0 || $scope.dialog_product_country_restrictions.products.length === 0) {
      alert('Please select at least one product and country!');
      return false;
    }
    $scope.updating_product_country_restrictions = true;
    _underscore2.default.each($scope.countries, function (country) {
      $scope.dialog_product_country_restrictions.countries.push(parseInt(country));
    });
    OfferMarketRestrictionService.save_product_country_restrictions($scope.dialog_product_country_restrictions).success(function (data) {
      if (data.success) {
        $scope.updating_product_country_restrictions = false;
        _jquery2.default.fancybox.close();
        $scope.offer.product_country_restrictions = _underscore2.default.groupBy(data.offer_product_country_restrictions, 'product_id');
        $rootScope.$broadcast('set_sidebar_data', [3, 0, [{
          type: 'counter',
          value: data.offer_restrictions_count
        }, null]]);
      }
    });
  };

  $scope.delete_product_country_restriction = function (restrictions, restriction) {
    if (confirm('Are you sure you want to delete this product/country restriction?')) {
      OfferMarketRestrictionService.delete_product_country_restriction($scope.offer.id, restriction.id).success(function (data) {
        if (data.success) {
          restrictions.splice(_underscore2.default.indexOf(restrictions, restriction), 1);
          $rootScope.$broadcast('set_sidebar_data', [3, 0, [{
            type: 'counter',
            value: data.offer_restrictions_count
          }, null]]);
        }
      });
    }
  };

  $scope.add_product = function (products, product) {
    if (product && !_underscore2.default.contains(products, product)) products.push(product);
  };

  $scope.remove_product = function (products, product) {
    products.splice(_underscore2.default.indexOf(products, product), 1);
  };

  $scope.select2_options = {
    containerCssClass: 'multiselect2',
    dropdownCssClass: 'multiselect2',
    width: '600px'
  };

  $scope.$watch('continent', function () {
    $scope.countries = [];
    if ($scope.continent && $scope.continent !== '') {
      var group = (0, _jquery2.default)('select#countries').find('optgroup[label="' + $scope.continent + '"]');
      group.find('option').each(function () {
        $scope.countries.push((0, _jquery2.default)(this).attr('value'));
      });
    }
  });

  $scope.remove_all_country_restrictions = function () {
    _underscore2.default.each($scope.continents, function (continent) {
      _underscore2.default.each(continent.countries, function (country) {
        country.checked = false;
      });
    });
  };

  $scope.init = function () {
    $scope.business_relations = window.business_relations;
    $scope.selected_tab = 0;
    window.offer.product_country_restrictions = _underscore2.default.groupBy(window.offer.product_country_restrictions, 'product_id');
    window.offer.product_member_restrictions = _underscore2.default.groupBy(window.offer.product_member_restrictions, 'product_id');
    $scope.offer = window.offer;
    $scope.continents = window.continents;
    $scope.eu_countries = window.eu_countries;
    $scope.groups = window.groups;
    $scope.dialog_member_restriction = _angular2.default.copy(window.member_restriction);
    $scope.set_user_company_autocomplete((0, _jquery2.default)('input.user_company'));
  };

  $scope.init();
};

exports.default = OfferMarketRestrictions;


OfferMarketRestrictions.$inject = ['$scope', '$rootScope', 'OfferMarketRestrictionService', 'UserService'];

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferMatchingAnalysis = function OfferMatchingAnalysis($scope, $timeout, OfferService, UserService, OfferRequestService) {
  _classCallCheck(this, OfferMatchingAnalysis);

  $scope.quick_search = function () {
    window.filter_table('table#reels', $scope.query);
    window.filter_table('table#sheets', $scope.query);
  };

  $scope.get_matched_stocklist = function () {
    $scope.items = [];
    $scope.loading = true;
    OfferService.get_matched_items(window.offer_id, window.user_id, $scope.filter, true).then(function (data) {
      $scope.items = data.items;
      $scope.has_reels = _underscore2.default.select(data.items, function (i) {
        return i.is_reels === true;
      }).length > 0;
      $scope.has_sheets = _underscore2.default.select(data.items, function (i) {
        return i.is_reels === false;
      }).length > 0;
      $scope.loading = false;
    });
  };

  $scope.get_filter = function () {
    return {
      min_quality_accuracy: 1,
      min_specs_accuracy: 1,
      specs_method_operator: 2,
      specs_method_percentage: 5,
      specs_method_standard: true,
      specs_method_relative: false,
      specs_method_special: false,
      specs_method_advanced: false,
      specs_matching_accurate: true,
      specs_matching_flexible: true,
      specs_matching_basic_only: false,
      special_matching_method: 0, // 0 = quick, 1 = analytical
      special_matching_cuts: 1,
      special_matching_waste: 2,
      special_matching_range: 2,
      buyer_country_id: window.delivery_countries.length > 0 ? window.delivery_countries[0].id : null
    };
  };

  $scope.reset_filter = function () {
    $scope.filter = $scope.get_filter();
  };

  $scope.check_items = function (is_reels) {
    _angular2.default.forEach($scope.items, function (item) {
      if (!$scope.show_only_matched || $scope.show_only_matched && item.is_matched) {
        if (is_reels && item.is_reels) item.checked = $scope.reels_checked;else if (!is_reels && !item.is_reels) item.checked = $scope.sheets_checked;
      }
    });
  };

  $scope.uncheck_items = function () {
    _angular2.default.forEach($scope.items, function (item) {
      if ($scope.show_only_matched && item.checked && !item.is_matched) item.checked = false;
    });
  };

  $scope.get_analysis_url = function () {
    return '/admin/marketplace/offers/edit_user_pricing/' + window.offer_id + '?user_id=' + $scope.switch_buyer_id;
  };

  $scope.set_user_company_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Buyer', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.switch_buyer_id = ui.item.id;
        $scope.$apply();
      }
    });
  };

  $scope.create_stocklist_xls = function () {
    var items = [];
    _angular2.default.forEach($scope.items, function (item) {
      if (item.checked) items.push(item);
    });
    if (items.length === 0) {
      alert('Please select at least one item!');
    } else {
      $scope.selected_items = [];
      _angular2.default.forEach(items, function (item) {
        $scope.selected_items.push({
          id: item.id,
          is_matched: item.is_matched
        });
      });
    }
  };

  $scope.create_campaign_stocklist_xls = function () {
    return OfferService.create_campaign_xls($scope.offer_id, $scope.user_id, $scope.user_company_title, $scope.user_country_id, $scope.filter);
  };

  $scope.create_personalized_offer = function () {
    var items = [];
    _angular2.default.forEach($scope.items, function (item) {
      if (item.checked) items.push(item.id);
    });
    if (items.length === 0) {
      alert('Please select at least one item!');
    } else {
      $scope.creating_offer = true;
      OfferService.create_personalized_offer(window.offer_id, items, window.user_id).then(function (data) {
        if (data.success) $scope.creating_offer = false;
      });
    }
  };

  $scope.mass_edit_prices = function () {
    var items = _underscore2.default.pluck(_underscore2.default.where($scope.items, {
      checked: true
    }), 'id');
    if (items.length === 0) {
      alert('Please select at least one item!');
    } else {
      $scope.ospp_items = items;
      _jquery2.default.fancybox((0, _jquery2.default)('div#mass_edit_prices'), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        scrolling: 'no'
      });
    }
  };

  $scope.mass_edit_prices_with_charge = function () {
    var items = _underscore2.default.pluck(_underscore2.default.where($scope.items, {
      checked: true
    }), 'id');
    if (items.length === 0) {
      alert('Please select at least one item!');
    } else {
      $scope.ospp_items = items;
      _jquery2.default.fancybox((0, _jquery2.default)('div#mass_edit_prices_with_charge'), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        scrolling: 'no'
      });
    }
  };

  $scope.activate_prices = function () {
    $scope.$broadcast('open_activate_price_dialog', {
      offer_id: window.offer_id,
      supplier_id: window.supplier_id,
      buyer_id: window.user_id,
      country_id: $scope.filter.buyer_country_id
    });
  };

  $scope.copy_to_fca = function (source) {
    var items = _underscore2.default.where($scope.items, {
      checked: true
    });
    if (items.length === 0) {
      alert('Please select at least one item!');
    } else {
      var updated_items = [];
      _underscore2.default.each(items, function (item) {
        var exw = null;
        if (source == 'last_avg_price') {
          if (item.last_avg_price) exw = item.last_avg_price.price;
        } else {
          exw = item[source];
        }
        if (exw && source == 'order_fca') {
          if (item.order_charge) exw = exw - item.order_charge;else exw = exw - $scope.order_charge;
        } else if (exw && source == 'ospp_fca') {
          if (item.ospp_charge) exw = exw - item.ospp_charge;else exw = exw - $scope.order_charge;
        }
        if (exw) updated_items.push({
          id: item.id,
          exw: exw
        });
      });
      if (updated_items.length > 0) {
        $scope.updating = true;
        OfferService.update_stock_items_user_fca(updated_items, window.user_id, window.offer_id, $scope.country_id).success(function (data) {
          if (data.success) {
            $scope.get_matched_stocklist();
            $scope.updating = false;
          }
        });
      }
    }
  };

  $scope.submit_mass_edit_price = function () {
    if ($scope.mass_edit_price > 0) {
      _jquery2.default.fancybox.close();
      OfferService.submit_ospp_price(window.offer_id, $scope.ospp_items, window.user_id, $scope.filter.buyer_country_id, $scope.mass_edit_price, $scope.mass_edit_incoterm).then(function () {
        $scope.get_matched_stocklist();
      });
    }
  };

  $scope.submit_mass_edit_price_with_charge = function () {
    $scope.submitting_price_charge = true;
    OfferService.submit_ospp_price_charge(window.offer_id, $scope.ospp_items, window.user_id, $scope.filter.buyer_country_id, $scope.mass_edit_price_charge, $scope.mass_edit_incoterm).then(function () {
      $scope.submitting_price_charge = false;
      $scope.get_matched_stocklist();
      _jquery2.default.fancybox.close();
    });
  };

  $scope.$watch('selected_items', function () {
    $timeout(function () {
      if ($scope.selected_items && $scope.selected_items.length > 0) (0, _jquery2.default)('form#createXLS').submit();
    }, 300);
  });

  $scope.get_matched_method = function (item) {
    if (item.is_matched) {
      var method = '';

      if (item.matched_by === 0) method = 'Brand';else if (item.matched_by == 1) method = 'Product';else if (item.matched_by == 2) method = 'Group';

      if (item.matched_method === 0) method = method + ' Standard';else if (item.matched_method == 1) method = method + ' Relative';else if (item.matched_method == 2) method = method + ' Special (RW)';else if (item.matched_method == 3) method = method + ' Advanced (RW)';

      return method;
    } else {
      return '';
    }
  };

  $scope.$watch('filter.buyer_country_id', function () {
    $scope.supplier_freight_rates = [];
    if ($scope.filter.buyer_country_id && $scope.filter.buyer_country_id > 0) {
      OfferService.get_freight_rates_for_buyer(window.offer_id, $scope.filter.buyer_country_id).then(function (data) {
        $scope.supplier_freight_rates = data.freight_rates;
      });
    }
  });

  $scope.get_buyer_delivery_terms = function () {
    OfferService.get_delivery_terms_for_buyer(window.user_id).then(function (data) {
      $scope.buyer_delivery_terms = data.user_delivery_terms;
    });
  };

  $scope.get_country_extra_charge = function () {
    OfferService.get_country_extra_charge(window.offer_id, window.supplier_id, $scope.filter.buyer_country_id).then(function (data) {
      $scope.country_extra_charge = data.country_extra_charge;
    });
  };

  $scope.operators = [{
    value: 1,
    title: '+'
  }, {
    value: 2,
    title: '+/-'
  }];

  $scope.cuts = [{
    value: 1,
    title: '1'
  }, {
    value: 2,
    title: '2'
  }, {
    value: 3,
    title: '3'
  }];

  $scope.wastes = [{
    value: 0,
    title: '0'
  }, {
    value: 1,
    title: '1'
  }, {
    value: 2,
    title: '2'
  }];

  $scope.ranges = [{
    value: 0,
    title: '0'
  }, {
    value: 1,
    title: '+-0.5'
  }, {
    value: 2,
    title: '+-1'
  }];

  $scope.mass_edit_incoterms = [{
    id: 3,
    name: 'FCA'
  }, {
    id: 1,
    name: 'CFR'
  }, {
    id: 2,
    name: 'DAP'
  }];

  $scope.edit_item = function (item) {
    $scope.$broadcast('open_item_price_dialog', {
      item: item
    });
  };

  $scope.add_user_to_offer_campaign = function () {
    var users = [{
      id: window.user_id,
      company_title: window.user_company_title,
      business_relation: window.user_business_relation,
      country_id: window.user_country_id,
      country_name: window.user_country_name
    }];
    $scope.adding_user_to_campaign = true;
    OfferService.add_users_to_offer_campaign(window.offer_id, users, $scope.filter).success(function (data) {
      if (data.success) $scope.adding_user_to_campaign = false;
    });
  };

  $scope.review_selection = function () {
    var items = _underscore2.default.filter($scope.items, function (item) {
      return item.selection_quantity > 0;
    });
    if (items.length > 0) {
      $scope.has_selection_reels = _underscore2.default.findWhere(items, {
        is_reels: true
      });
      $scope.has_selection_sheets = _underscore2.default.findWhere(items, {
        is_reels: false
      });
      $scope.selection_items = items;
      $scope.existing_offer_requests = [];
      $scope.existing_offer_request = null;
      var filter = {
        page: 1,
        supplier_id: window.supplier_id,
        buyer_id: window.user_id,
        status: 1,
        order_status: 2,
        per_page: 100
      };
      OfferRequestService.get(filter).success(function (data) {
        _underscore2.default.each(data.offer_requests, function (offer_request) {
          $scope.existing_offer_requests.push({
            id: offer_request.id,
            title: '#' + offer_request.id + ' ' + offer_request.title
          });
          if (data.offer_requests.length > 0) $scope.existing_offer_request = data.offer_requests[0].id;
        });
      });
      _jquery2.default.fancybox((0, _jquery2.default)('div#review_selection'), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        scrolling: 'no'
      });
    }
  };

  $scope.check_selection_items = function (is_reels) {
    _underscore2.default.each($scope.selection_items, function (item) {
      if (is_reels && item.is_reels) item.selection_checked = $scope.selections_reels_checked;else if (!is_reels && !item.is_reels) item.selection_checked = $scope.selection_sheets_checked;
    });
  };

  $scope.cancel_all_selection_items = function () {
    _underscore2.default.each($scope.selection_items, function (item) {
      item.selection_quantity = 0;
    });
    $scope.selection_items = [];
    $scope.selection_mode = false;
    _jquery2.default.fancybox.close();
  };

  $scope.cancel_selected_selection_items = function () {
    _underscore2.default.each($scope.selection_items, function (item) {
      if (item.selection_checked) item.selection_quantity = 0;
    });
    $scope.selection_items = _underscore2.default.reject($scope.selection_items, function (item) {
      return item.selection_checked;
    });
    if ($scope.selection_items.length === 0) {
      _jquery2.default.fancybox.close();
    }
  };

  $scope.create_offer_request = function () {
    $scope.creating_offer_request = true;
    OfferRequestService.create_from_offer_items(window.offer_id, window.user_id, $scope.selection_items).success(function (data) {
      if (data.success) {
        $scope.creating_offer_request = false;
        $scope.cancel_all_selection_items();
        window.location = '/admin/marketplace/offer_requests/items/' + data.offer_request_id;
      }
    });
  };

  $scope.add_to_offer_request = function () {
    $scope.adding_to_offer_request = true;
    OfferRequestService.add_offer_items($scope.existing_offer_request, $scope.selection_items).success(function (data) {
      if (data.success) {
        $scope.adding_to_offer_request = false;
        $scope.cancel_all_selection_items();
        window.location = '/admin/marketplace/offer_requests/items/' + data.offer_request_id;
      }
    });
  };

  $scope.init = function () {
    $scope._ = _underscore2.default;
    $scope.offer_id = window.offer_id;
    $scope.user_id = window.user_id;
    $scope.supplier_id = window.supplier_id;
    if (window.filter) window.filter.buyer_country_id = window.delivery_countries.length > 0 ? window.delivery_countries[0].id : null;
    $scope.filter = window.filter ? window.filter : $scope.get_filter();
    $scope.delivery_countries = window.delivery_countries;
    $scope.set_user_company_autocomplete((0, _jquery2.default)('input.user_company'));
    $scope.show_prices = true;
    $scope.show_fca = true;
    $scope.show_cfr = true;
    $scope.show_dap = true;
    $scope.mode = 'matching';
    $scope.user_company_title = window.user_company_title;
    $scope.user_country_id = window.user_country_id;
    $scope.supplier_freight_rates = [];
    $scope.buyer_delivery_terms = [];
    $scope.country_extra_charge = {};
    if (window.user_id > 0) {
      $scope.get_buyer_delivery_terms();
      $scope.get_matched_stocklist();
      $scope.get_country_extra_charge();
    }
    $scope.mass_edit_price = 0;
    $scope.mass_edit_incoterm = 3;
    $scope.show_ospp_prices = false;
    $scope.show_ospp_country_prices = false;
    $scope.show_order_prices = false;
    $scope.order_charge = 0;
  };

  $scope.init();
};

exports.default = OfferMatchingAnalysis;


OfferMatchingAnalysis.$inject = ['$scope', '$timeout', 'OfferService', 'UserService', 'OfferRequestService'];

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferMatchingCriteria = function OfferMatchingCriteria($scope, OfferService, UserProductService) {
  _classCallCheck(this, OfferMatchingCriteria);

  $scope.search_items = function () {
    if (!$scope.filter.buyer_id) {
      alert('Please select a buyer first!');
      return false;
    }
    $scope.filter.buyer_user_products = _underscore2.default.pluck(_underscore2.default.where($scope.buyer_user_products, {
      checked: true
    }), 'id');
    $scope.filter.personal_search_mode = 1;
    $scope.searching_match = true;
    $scope.tabs[0].offers = [];
    $scope.tabs[0].items = [];
    $scope.tabs[0].filter.offer_id = null;
    OfferService.get_buyer_matched_items($scope.filter).then(function (response) {
      $scope.tabs[0].offers = [{
        id: window.offer.id,
        title: window.offer.titleEN + ' (' + window.offer.id + ')'
      }];
      $scope.tabs[0].items = response.data.items;
      $scope.set_tab_properties(0);
      $scope.searching_match = false;
    });
  };

  $scope.set_filters = function () {
    $scope.filter.min_quality_accuracy = 1;
    $scope.filter.min_specs_accuracy = 1;
    $scope.filter.specs_method_standard = true;
    $scope.filter.specs_method_relative = false;
    $scope.filter.specs_method_special = false;
    $scope.filter.specs_method_advanced = false;
    $scope.filter.specs_matching_accurate = true;
    $scope.filter.specs_matching_flexible = true;
    $scope.filter.specs_matching_basic_only = false;
    $scope.filter.buyer_user_products = [];
  };

  $scope.load_buyer_user_products = function (buyer_id) {
    UserProductService.get_user_products(buyer_id).then(function (data) {
      _underscore2.default.each(data.user_products, function (user_product) {
        if (user_product.product) {
          $scope.buyer_user_products.push({
            id: user_product.id,
            title: user_product.product.title,
            checked: _underscore2.default.contains($scope.filter.buyer_user_products, user_product.id)
          });
        }
      });
    });
  };

  $scope.update_criteria = function () {
    $scope.updating_criteria = true;
    $scope.filter.buyer_user_products = _underscore2.default.pluck(_underscore2.default.where($scope.buyer_user_products, {
      checked: true
    }), 'id');
    OfferService.update_create_filters($scope.filter).then(function (data) {
      if (data.success) $scope.updating_criteria = false;
    });
  };

  $scope.init = function () {
    $scope.manage_criteria = window.manage_criteria;
    if (window.manage_criteria && window.offer.create_filters) _angular2.default.extend($scope.filter, window.offer.create_filters.filters);else $scope.set_filters();
    if (window.offer.parent_offer_id && window.offer.buyer_id) {
      $scope.buyer_user_products = [];
      $scope.load_buyer_user_products(window.offer.buyer_id);
    }
  };

  $scope.init();
};

exports.default = OfferMatchingCriteria;


OfferMatchingCriteria.$inject = ['$scope', 'OfferService', 'UserProductService'];

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferMatching = function OfferMatching($scope, $timeout, OfferService, UiService) {
  _classCallCheck(this, OfferMatching);

  $scope.tabs = [{
    title: 'Matched Buyers',
    users: [],
    loading: false,
    checked: false
  }];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
    $scope.query = '';
  };

  $scope.quick_search = function () {
    window.filter_table('table#users', $scope.query);
  };

  $scope.get_matched_buyers = function () {
    var tab = 0;
    $scope.query = '';
    $scope.tabs[tab].users = [];
    $scope.tabs[tab].loading = true;
    $scope.tabs[tab].checked = false;
    $scope.prematching_timing = null;
    OfferService.get_matched_buyers($scope.offer_id, $scope.filter).then(function (data) {
      $scope.matched_buyers = data.users.length;
      $scope.total_buyers = data.total_buyers;
      $scope.tabs[tab].users = data.users;
      $scope.tabs[tab].loading = false;
      $scope.prematching_timing = data.time_elapsed;
    });
  };

  $scope.check_users = function () {
    var tab = $scope.tabs[$scope.selected_tab];
    _angular2.default.forEach(tab.users, function (user) {
      user.checked = tab.checked;
    });
  };

  $scope.operators = [{
    value: 1,
    title: '+'
  }, {
    value: 2,
    title: '+/-'
  }];

  $scope.cuts = [{
    value: 1,
    title: '1'
  }, {
    value: 2,
    title: '2'
  }, {
    value: 3,
    title: '3'
  }];

  $scope.wastes = [{
    value: 0,
    title: '0'
  }, {
    value: 1,
    title: '1'
  }, {
    value: 2,
    title: '2'
  }];

  $scope.ranges = [{
    value: 0,
    title: '0'
  }, {
    value: 1,
    title: '+-0.5'
  }, {
    value: 2,
    title: '+-1'
  }];

  $scope.get_user_matched_items = function (index) {
    var user = $scope.analysis_users[index];
    OfferService.get_matched_items($scope.offer_id, user.id, $scope.filter, false).then(function (data) {
      console.log(data);
      $scope.analysis_timings.push({
        time: data.time_elapsed,
        user_id: user.id
      });
      user.items = data.items;
      user.items_quantity = window.roundToTwo(_underscore2.default.reduce(_underscore2.default.pluck(data.items, 'quantity'), function (quantity, num) {
        return quantity + num;
      }, 0));
      user.items_quality_accuracy = Math.floor(_underscore2.default.reduce(_underscore2.default.pluck(data.items, 'quality_accuracy'), function (accuracy, num) {
        return accuracy + num;
      }, 0) / data.items.length);
      user.items_specs_accuracy = Math.floor(_underscore2.default.reduce(_underscore2.default.pluck(data.items, 'specs_accuracy'), function (accuracy, num) {
        return accuracy + num;
      }, 0) / data.items.length);
      user.unique_products = _underscore2.default.uniq(_underscore2.default.compact(_underscore2.default.pluck(data.items, 'product_id')));
      user.accurate_items = _underscore2.default.filter(data.items, function (item) {
        return item.specs_accuracy >= 80;
      });
      user.accurate_items_quantity = window.roundToTwo(_underscore2.default.reduce(_underscore2.default.pluck(user.accurate_items, 'quantity'), function (quantity, num) {
        return quantity + num;
      }, 0));
      if (window.is_single_product && data.items.length > 0) {
        user.last_avg_price = data.items[0].last_avg_price;
        user.fca_price_charge = data.items[0].fca_price_charge;
        user.fca_price = data.items[0].fca_price;
        user.cfr_price = data.items[0].cfr_price;
        user.dap_price = data.items[0].dap_price;
      }
      user.price_diff = window.roundToTwo(_underscore2.default.reduce(_underscore2.default.pluck(data.items, 'price_diff'), function (price, num) {
        return price + num;
      }, 0) / data.items.length);
      if (index < $scope.analysis_users.length - 1) $scope.get_user_matched_items(index + 1);
    });
  };

  $scope.standard_analysis = function () {
    var tab = $scope.tabs[0];
    $scope.analysis_users = [];
    $scope.analysis_timings = [];
    _angular2.default.forEach(tab.users, function (user) {
      if (user.checked) {
        user.items = null;
        user.items_quantity = null;
        user.items_quality_accuracy = null;
        user.items_specs_accuracy = null;
        user.unique_products = null;
        user.accurate_items = null;
        user.accurate_items_quantity = null;
        user.fca_price_charge = null;
        user.fca_price = null;
        user.cfr_price = null;
        user.dap_price = null;
        user.last_avg_price = null;
        user.price_diff = null;
        $scope.analysis_users.push(user);
      }
    });
    if ($scope.analysis_users.length > 0) $scope.get_user_matched_items(0);
  };

  $scope.create_users_csv = function () {
    var users = [];
    var tab = $scope.tabs[0];
    _angular2.default.forEach(tab.users, function (user) {
      if (user.checked) users.push(user);
    });
    if (users.length === 0) alert('Please select at least one user!');else $scope.csv_users = users;
  };

  $scope.$watch('csv_users', function () {
    $timeout(function () {
      if ($scope.csv_users && $scope.csv_users.length > 0) (0, _jquery2.default)('form#createCSV').submit();
    });
  });

  $scope.get_analysis_url = function (user_id) {
    return '/admin/marketplace/offers/edit_user_pricing/' + window.offer_id + '?user_id=' + user_id;
  };

  $scope.show_send_matching_data = function () {
    var users = _underscore2.default.where($scope.tabs[0].users, {
      checked: true
    });
    if (users.length === 0) {
      alert('Please select at least one user!');
      return false;
    }
    _jquery2.default.fancybox((0, _jquery2.default)('div#send_matching_data'), {
      padding: '5',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      topRatio: 0.15,
      scrolling: 'no',
      afterShow: function afterShow() {
        $scope.$broadcast('$tinymce:refresh');
      }
    });
  };

  $scope.send_matching_data = function () {
    if (!$scope.email_recipient) return false;
    $scope.sending_matching_data = true;
    $scope.mass_create_xls(null);
  };

  $scope.mass_create_xls = function (index) {
    if (index === null) {
      $scope.xls_users = _underscore2.default.where($scope.tabs[0].users, {
        checked: true
      });
      $scope.mass_create_xls(0);
    } else {
      var user = $scope.xls_users[index];
      OfferService.create_matching_data_xls(window.offer_id, user.id, user.company_title, user.country_id, $scope.filter).success(function (data) {
        if (data.success) {
          user.xls = data.xls;
          if (index < $scope.xls_users.length - 1) {
            $scope.mass_create_xls(index + 1);
          } else {
            OfferService.send_matching_data(window.offer_id, _underscore2.default.where($scope.tabs[0].users, {
              checked: true
            }), $scope.email_custom_text, $scope.email_recipient).success(function (data) {
              if (data.success) {
                $scope.sending_matching_data = false;
                _jquery2.default.fancybox.close();
              }
            });
          }
        }
      });
    }
  };

  $scope.add_users_to_offer_campaign = function () {
    var users = _underscore2.default.where($scope.tabs[0].users, {
      checked: true
    });
    if (users.length === 0) {
      alert('Please select at least one user!');
      return false;
    }
    $scope.adding_users_to_campaign = true;
    OfferService.add_users_to_offer_campaign(window.offer_id, users, $scope.filter).success(function (data) {
      if (data.success) $scope.adding_users_to_campaign = false;
    });
  };

  $scope.select2_options = {
    containerCssClass: 'multiselect2',
    dropdownCssClass: 'multiselect2',
    width: '300px'
  };

  $scope.show_by_min_quantity = function (user) {
    var min_quantity = parseInt($scope.filter.min_quantity);
    if (!isNaN(min_quantity) && user.items_quantity) return user.items_quantity >= min_quantity;else return true;
  };

  $scope.filter = {
    user_countries: [],
    has_specs: 'all',
    user_group: 'all',
    business_relation: -1,
    pre_min_quality_accuracy: 1,
    pre_min_specs_accuracy: 1,
    min_quality_accuracy: 1,
    min_specs_accuracy: 1,
    specs_method_operator: 2,
    specs_method_percentage: 5,
    specs_method_standard: true,
    specs_method_relative: false,
    specs_method_special: false,
    specs_method_advanced: false,
    specs_matching_accurate: true,
    specs_matching_flexible: true,
    specs_matching_basic_only: false,
    special_matching_method: 0, // 0 = quick, 1 = analytical
    special_matching_cuts: 1,
    special_matching_waste: 2,
    special_matching_range: 2,
    min_quantity: 0
  };

  $scope.columns = {
    buyer: true,
    relation: true
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.offer_id = window.offer_id;
    $scope.is_single_product = window.is_single_product;
    $scope.email_recipient = 'p.tsolpagas@epsilon-paper.com';
    $scope.tinymceOptions = UiService.tinymceOptions();
    $scope.tinymceOptions.height = 100;
    $scope.email_custom_text = '';
  };

  $scope.init();
};

exports.default = OfferMatching;


OfferMatching.$inject = ['$scope', '$timeout', 'OfferService', 'UiService'];

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferOsppUsers = function OfferOsppUsers($scope, OfferService) {
  _classCallCheck(this, OfferOsppUsers);

  $scope.tabs = [{
    title: 'Activated OSPP',
    buyers: []
  }, {
    title: 'Need Activation',
    buyers: []
  }, {
    title: 'Expired Policy',
    buyers: []
  }, {
    title: 'Special Group',
    buyers: []
  }];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.load_data = function () {
    $scope.loading = true;
    OfferService.get_ospp_users(window.offer_id).then(function (response) {
      $scope.tabs[0].buyers = response.data.activated_buyers;
      $scope.tabs[1].buyers = response.data.need_activation_buyers;
      $scope.tabs[2].buyers = response.data.expired_policy_buyers;
      $scope.tabs[3].buyers = response.data.special_group_buyers;
      $scope.loading = false;
    });
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.offer_id = window.offer_id;
    $scope.load_data();
  };

  $scope.init();
};

exports.default = OfferOsppUsers;


OfferOsppUsers.$inject = ['$scope', 'OfferService'];

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferRequestCreate = function OfferRequestCreate($scope, OfferRequestService, UserService) {
  _classCallCheck(this, OfferRequestCreate);

  $scope.set_supplier_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Seller', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.offer_request.supplier_id = ui.item.id;
        $scope.supplier_company = ui.item.value;
        $scope.$apply();
      }
    });
  };

  $scope.set_buyer_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Buyer', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.offer_request.buyer_id = ui.item.id;
        $scope.buyer_company = ui.item.value;
        $scope.$apply();
      }
    });
  };

  $scope.create = function () {
    if (!($scope.offer_request.title && $scope.offer_request.supplier_id && $scope.offer_request.buyer_id)) {
      $scope.form_error = 'Please complete all fields!';
    } else {
      $scope.creating = true;
      OfferRequestService.create($scope.offer_request).success(function (data) {
        if (data.success) {
          $scope.creating = false;
          window.location = '/admin/marketplace/offer_requests';
        } else {
          $scope.form_error = data.message;
        }
      });
    }
  };

  $scope.offer_request = {
    id: null,
    title: null,
    supplier_id: null,
    buyer_id: null,
    status: 1
  };

  $scope.init = function () {
    $scope.set_supplier_autocomplete((0, _jquery2.default)('input.supplier_company'));
    $scope.set_buyer_autocomplete((0, _jquery2.default)('input.buyer_company'));
    $scope.status_options = OfferRequestService.get_status_options();
  };

  $scope.init();
};

exports.default = OfferRequestCreate;


OfferRequestCreate.$inject = ['$scope', 'OfferRequestService', 'UserService'];

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferRequestItemDialog = function OfferRequestItemDialog($scope, $rootScope, OfferRequestItemService, UserService, UiService) {
  _classCallCheck(this, OfferRequestItemDialog);

  function load_contacts(user_id) {
    UserService.get_contacts(user_id).success(function (data) {
      $scope.contacts = data.contacts;
    });
  }

  $scope.$on('show_offer_request_item_dialog', function (event, data) {
    $scope.item = _angular2.default.copy(data.item);
    $scope.edit_items = data.items || null;
    if ($scope.item.supplier_id) load_contacts($scope.item.supplier_id);else $scope.contacts = [];
    window.openFancyboxDialog('div#offer_request_item_dialog');
  });

  $scope.save = function () {
    $scope.saving = true;
    if (!$scope.edit_items) {
      OfferRequestItemService.save($scope.item).success(function (data) {
        if (data.success) {
          $rootScope.$broadcast('load_items');
          $scope.saving = false;
          _jquery2.default.fancybox.close();
        }
      });
    } else {
      OfferRequestItemService.mass_save($scope.item, $scope.edit_items).success(function (data) {
        if (data.success) {
          $rootScope.$broadcast('load_items', {
            selected_items: $scope.edit_items,
            item_key: 'id'
          });
          $scope.saving = false;
          _jquery2.default.fancybox.close();
        }
      });
    }
  };

  $scope.init = function () {
    $scope.date_options = UiService.dateOptions;
    $scope.status_options = _underscore2.default.filter(OfferRequestItemService.get_status_options(), function (o) {
      return o.id < 3;
    });
  };

  $scope.init();
};

exports.default = OfferRequestItemDialog;


OfferRequestItemDialog.$inject = ['$scope', '$rootScope', 'OfferRequestItemService', 'UserService', 'UiService'];

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferRequestItemTabs = function OfferRequestItemTabs($scope, $rootScope, $timeout, OfferRequestService, OfferRequestItemService, EmailService, UiService) {
  _classCallCheck(this, OfferRequestItemTabs);

  $scope.tabs = [{
    title: 'Selections',
    items: []
  }, {
    title: 'Reservations',
    items: []
  }, {
    title: 'Order Confirmations',
    order_confirmations: []
  }, {
    title: 'Orders',
    order_confirmations: []
  }];

  $scope.oc_fields = function (field) {
    var oc_fields = ['Basic Com', 'Basic Com %', 'Total Amount', 'Commission Unit', 'Commission Amount'];
    if (oc_fields.indexOf(field)) {
      return true;
    } else {
      return false;
    }
  };

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  function update_data() {
    $scope.tabs[0].items = _underscore2.default.filter($scope.items, function (i) {
      return i.status < 2;
    });
    $scope.tabs[1].items = _underscore2.default.filter($scope.items, function (i) {
      return i.status === 2;
    });
    $scope.tabs[2].order_confirmations = _underscore2.default.filter($scope.order_confirmations, function (c) {
      return c.order_id === null;
    });
    $scope.tabs[3].order_confirmations = _underscore2.default.filter($scope.order_confirmations, function (c) {
      return c.order_id !== null;
    });
  }

  $scope.get_status_title = function (status) {
    return _underscore2.default.findWhere($scope.status_options, {
      id: status
    }).title;
  };

  $scope.$on('update_offer_request_item_tabs', function () {
    update_data();
  });

  $scope.edit_offer_request_item = function (item) {
    $scope.$broadcast('show_offer_request_item_dialog', {
      item: item
    });
  };

  $scope.edit_item = function (item) {
    $scope.$broadcast('show_item_dialog', {
      item: item
    });
  };

  $scope.delete_item = function (item) {
    if (confirm('Are you sure you want to delete this item?')) {
      OfferRequestItemService.delete(item.id).success(function (data) {
        if (data.success) {
          $scope.items.splice(_underscore2.default.indexOf($scope.items, item), 1);
          update_data();
        }
      });
    }
  };

  $scope.add_item = function () {
    $scope.$broadcast('show_offer_request_item_dialog', {
      item: {
        offer_request_id: $scope.offer_request.id,
        status: 0,
        supplier_id: $scope.offer_request.supplier_id
      }
    });
  };

  $scope.check_items = function (tab) {
    _underscore2.default.each($scope.tabs[tab].items, function (i) {
      i.checked = $scope.tabs[tab].checked;
    });
  };

  $scope.delete_items = function (tab) {
    var items = _underscore2.default.where($scope.tabs[tab].items, {
      checked: true
    });
    if (items.length === 0) {
      alert('Please select at least one item!');
    } else {
      if (confirm('Are you sure you want to delete the selected items?')) {
        OfferRequestItemService.mass_delete(_underscore2.default.pluck(items, 'id')).success(function (data) {
          if (data.success) {
            $scope.tabs[tab].checked = false;
            $rootScope.$broadcast('load_items');
          }
        });
      }
    }
  };

  $scope.edit_offer_request_items = function (tab) {
    var items = _underscore2.default.where($scope.tabs[tab].items, {
      checked: true
    });
    if (items.length === 0) {
      alert('Please select at least one item!');
    } else {
      $scope.$broadcast('show_offer_request_item_dialog', {
        item: {
          supplier_id: $scope.offer_request.supplier_id
        },
        items: _underscore2.default.pluck(items, 'id')
      });
    }
  };

  $scope.edit_items = function (tab) {
    var items = _underscore2.default.where($scope.tabs[tab].items, {
      checked: true
    });
    if (items.length === 0) {
      alert('Please select at least one item!');
    } else {
      $scope.$broadcast('show_item_dialog', {
        item: {
          is_reels: null
        },
        items: _underscore2.default.pluck(items, 'item_id')
      });
    }
  };

  $scope.create_order_confirmation = function () {
    var items = _underscore2.default.where($scope.tabs[1].items, {
      checked: true
    });
    if (items.length === 0) {
      alert('Please select at least one item!');
    } else {
      $scope.creating_order_confirmation = true;
      OfferRequestService.create_order_confirmation(window.offer_request.id, _underscore2.default.pluck(items, 'id')).success(function (data) {
        if (data.success) {
          $scope.creating_order_confirmation = false;
          $rootScope.$broadcast('load_items');
        }
      });
    }
  };

  $scope.add_items_to_order_confirmation = function () {
    var items = _underscore2.default.where($scope.tabs[1].items, {
      checked: true
    });
    if (items.length === 0) {
      alert('Please select at least one item!');
    } else {
      $scope.adding_items_to_order_confirmation = true;
      var oc_items = _underscore2.default.union(_underscore2.default.pluck(items, 'id'), _underscore2.default.pluck($scope.order_confirmation.items, 'id'));
      OfferRequestService.update_order_confirmation($scope.order_confirmation.id, oc_items).success(function (data) {
        if (data.success) {
          $scope.adding_items_to_order_confirmation = false;
          $rootScope.$broadcast('load_items');
        }
      });
    }
  };

  $scope.remove_item_from_order_confirmation = function (order_confirmation, item) {
    item.removing = true;
    OfferRequestService.remove_order_confirmation_items(order_confirmation.id, [item.id]).success(function (data) {
      if (data.success) {
        item.removing = false;
        $rootScope.$broadcast('load_items');
      }
    });
  };

  $scope.remove_items_from_order_confirmation = function (order_confirmation) {
    order_confirmation.mass_removing_items = true;
    window.items = _underscore2.default.pluck(_underscore2.default.where(order_confirmation.items, {
      checked: true
    }), 'id');
    OfferRequestService.remove_order_confirmation_items(order_confirmation.id, window.items).success(function (data) {
      if (data.success) {
        order_confirmation.mass_removing_items = false;
        $rootScope.$broadcast('load_items');
      }
    });
  };

  $scope.create_order_confirmation_docs = function (order_confirmation) {
    order_confirmation.creating_order_confirmation_docs = true;
    OfferRequestService.create_order_confirmation_docs(order_confirmation.id).success(function (data) {
      if (data.success) {
        order_confirmation.creating_order_confirmation_docs = false;
        $rootScope.$broadcast('load_items');
      }
    });
  };

  $scope.create_order_confirmation_docs_with_sc_id = function (order_confirmation) {
    order_confirmation.creating_order_confirmation_docs_with_sc_id = true;
    OfferRequestService.create_order_confirmation_docs(order_confirmation.id, true).success(function (data) {
      if (data.success) {
        order_confirmation.creating_order_confirmation_docs_with_sc_id = false;
        $rootScope.$broadcast('load_items');
      }
    });
  };

  $scope.create_order = function (order_confirmation) {
    order_confirmation.creating_order = true;
    OfferRequestService.create_order(order_confirmation.id).success(function (data) {
      if (data.success) {
        order_confirmation.creating_order = false;
        $rootScope.$broadcast('load_items');
      }
    });
  };

  $scope.send_order_confirmation = function (order_confirmation) {
    $scope.dialog_order_confirmation = order_confirmation;
    _jquery2.default.fancybox((0, _jquery2.default)('div#send_order_confirmation'), {
      padding: '5',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      topRatio: 0.15,
      scrolling: 'yes',
      afterShow: function afterShow() {
        $scope.$broadcast('$tinymce:refresh');
      }
    });
  };

  $scope.check_supplier_contacts = function () {
    _underscore2.default.each($scope.offer_request.supplier_contacts, function (contact) {
      contact.checked = $scope.checked_all_supplier_contacts;
    });
  };

  $scope.send_order_confirmation_notification = function () {
    var contacts = _underscore2.default.where($scope.offer_request.supplier_contacts, {
      checked: true
    });
    if (!$scope.doc_details && !$scope.doc_specs) {
      alert('Please select at least one attachment!');
      return false;
    }
    if (contacts.length === 0) {
      alert('Please select at least one supplier contact!');
      return false;
    }
    $scope.sending_order_confirmation_notification = true;
    OfferRequestService.send_order_confirmation_notification($scope.dialog_order_confirmation.id, $scope.doc_details, $scope.doc_specs, $scope.supplier_custom_text, contacts, $scope.sender_name_en, $scope.sender_name_el, $scope.test_send, $scope.test_send_email).success(function (data) {
      if (data.success) {
        $scope.sending_order_confirmation_notification = false;
        _jquery2.default.fancybox.close();
      }
    });
  };

  $scope.view_sent_notifications = function (order_confirmation) {
    $scope.dialog_notifications = order_confirmation.notifications;
    _jquery2.default.fancybox((0, _jquery2.default)('div#order_confirmation_notifications'), {
      padding: '5',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      topRatio: 0.15,
      scrolling: 'no'
    });
  };

  $scope.update_order_confirmation_field = function (order_confirmation, field, loader) {
    order_confirmation[loader] = true;
    OfferRequestService.update_order_confirmation_field(order_confirmation.id, field, order_confirmation[field]).success(function (data) {
      if (data.success) order_confirmation[loader] = false;
    });
  };

  $scope.set_order_confirmation_items_checked = function (order_confirmation) {
    _underscore2.default.each(order_confirmation.items, function (item) {
      item.checked = order_confirmation.checked_all;
    });
  };

  $scope.order_confirmation_items_checked = function (order_confirmation) {
    return _underscore2.default.findWhere(order_confirmation.items, {
      checked: true
    });
  };

  $scope.delete_order_confirmation = function (order_confirmation) {
    if (confirm('Are you sure you want to delete this OC?')) {
      order_confirmation.deleting_order_confirmation = true;
      OfferRequestService.delete_order_confirmation(order_confirmation.id).success(function (data) {
        if (data.success) {
          order_confirmation.deleting_order_confirmation = false;
          $rootScope.$broadcast('load_items');
        }
      });
    }
  };

  $scope.get_fields = function () {
    return _underscore2.default.filter($scope.fields, function (f) {
      return $scope.item_view === 1 || f.standard !== false;
    });
  };

  $scope.get_request_fields = function () {
    return _underscore2.default.filter($scope.request_fields, function (f) {
      return $scope.item_view === 1 || f.standard !== false;
    });
  };

  /*function price_incoterm_match(request_field) {
    if (!request_field.is_price || !$scope.offer_request.delivery_term_id)
      return true;
    else if (request_field.is_price)
      return request_field.name === $scope.offer_request.delivery_term;
  }*/

  $scope.export_items = function (tab) {
    var items = _underscore2.default.where($scope.tabs[tab].items, {
      checked: true
    });
    if (items.length === 0) {
      alert('Please select at least one item!');
    } else {
      $scope.export_items_mode = 'default';
      $scope.selected_items = _underscore2.default.pluck(items, 'id');
    }
  };

  $scope.export_items_for_suppliers = function (tab) {
    var items = _underscore2.default.where($scope.tabs[tab].items, {
      checked: true
    });
    if (items.length === 0) {
      alert('Please select at least one item!');
    } else {
      $scope.export_items_mode = 'suppliers';
      $scope.selected_items = _underscore2.default.pluck(items, 'id');
    }
  };

  $scope.update_item_prices = function (tab) {
    var items = _underscore2.default.where($scope.tabs[tab].items, {
      checked: true
    });
    if (items.length === 0) {
      alert('Please select at least one item!');
    } else {
      $scope.mass_updating_prices = true;
      OfferRequestItemService.mass_update_prices(window.offer_request.id, _underscore2.default.pluck(items, 'id')).success(function (data) {
        if (data.success) {
          $scope.mass_updating_prices = false;
          $scope.tabs[tab].checked = false;
          $rootScope.$broadcast('load_items');
        }
      });
    }
  };

  $scope.$watch('selected_items', function () {
    $timeout(function () {
      if ($scope.selected_items && $scope.selected_items.length > 0) (0, _jquery2.default)('form#createXLS').submit();
    }, 300);
  });

  $scope.item_views = [{
    id: 0,
    title: 'Standard View'
  }, {
    id: 1,
    title: 'Full View'
  }];

  $scope.show_connect_order = function (order_confirmation) {
    $scope.connect_order_dialog = {
      order_confirmation: order_confirmation,
      order: null,
      copy_items: false
    };
    _jquery2.default.fancybox((0, _jquery2.default)('div#connect_order'), {
      padding: '5',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      topRatio: 0.15
    });
  };

  $scope.connect_order = function () {
    if (!$scope.connect_order_dialog.order) {
      alert('Please input a valid order!');
      return false;
    }
    $scope.connecting_order = true;
    OfferRequestService.connect_order($scope.connect_order_dialog.order_confirmation.id, $scope.connect_order_dialog.order, $scope.connect_order_dialog.copy_items).success(function (data) {
      if (data.success) {
        $scope.connecting_order = false;
        $rootScope.$broadcast('load_items');
        _jquery2.default.fancybox.close();
      }
    });
  };

  $scope.update_buyer_preferences = function () {
    $scope.updating_buyer_preferences = true;
    OfferRequestService.update_buyer_preferences($scope.offer_request.id).success(function (data) {
      if (data.success) $scope.updating_buyer_preferences = false;
    });
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.status_options = OfferRequestItemService.get_status_options();
    $scope.tinymceOptions = UiService.tinymceOptions();
    $scope.tinymceOptions.height = 100;
    $scope.custom_text = '';
    $scope.test_send = true;
    $scope.test_send_email = 'p.tsolpagas@epsilon-paper.com';
    $scope.recipient_modes = EmailService.get_recipient_modes();
    $scope.sender_names_en = EmailService.get_sender_names_en();
    $scope.sender_names_el = EmailService.get_sender_names_el();
    $scope.sender_name_en = $scope.sender_names_en[0];
    $scope.sender_name_el = $scope.sender_names_el[0];
    $scope.offer_request.supplier_contacts = _underscore2.default.filter($scope.offer_request.supplier_contacts, function (c) {
      return !_underscore2.default.isEmpty(c.email);
    });
    _underscore2.default.each(window.offer_request.supplier_contacts, function (c) {
      c.recipient_mode = 0;
    });
    $scope.doc_details = true;
    $scope.doc_specs = true;
    $scope.item_view = 0;
    $scope.export_buyer_details = true;
  };

  $scope.init();
};

exports.default = OfferRequestItemTabs;


OfferRequestItemTabs.$inject = ['$scope', '$rootScope', '$timeout', 'OfferRequestService', 'OfferRequestItemService', 'EmailService', 'UiService'];

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferRequestItems = function OfferRequestItems($scope, OfferRequestService, FileUploader, GeoService) {
  _classCallCheck(this, OfferRequestItems);

  function load_data(selected_items, item_key) {
    OfferRequestService.get_offer_request_items($scope.offer_request.id).success(function (data) {
      $scope.items = data.items;
      console.log(data.items);
      $scope.fields = data.fields;
      $scope.request_fields = data.request_fields;
      $scope.quantity_type = data.quantity_type;
      if (selected_items) {
        _underscore2.default.each($scope.items, function (item) {
          item.checked = _underscore2.default.contains(selected_items, item[item_key]);
        });
      }
      $scope.order_confirmations = [];
      _underscore2.default.each(data.order_confirmations, function (c) {
        var order_confirmation = {
          id: c.id,
          doc_details: c.doc_details,
          doc_specs: c.doc_specs,
          order_id: c.order_id,
          show_offer_info: c.show_offer_info,
          show_item_prices: c.show_item_prices,
          notifications: c.notifications,
          items: []
        };
        _underscore2.default.each(c.items.items, function (i) {
          order_confirmation.items.push(_underscore2.default.findWhere($scope.items, {
            id: i
          }));
        });
        $scope.order_confirmations.push(order_confirmation);
      });
      $scope.$broadcast('update_offer_request_item_tabs', {});
    });
  }

  function load_details() {
    OfferRequestService.get_details_data().success(function (data) {
      $scope.delivery_terms = data.delivery_terms;
      $scope.delivery_methods = data.delivery_methods;
      $scope.payment_terms = data.payment_terms;
      $scope.currency_symbols = data.currency_symbols;
      $scope.quantity_types = data.quantity_types;
      $scope.layout_texts = data.layout_texts;
      $scope.series_texts = data.series_texts;
    });
  }

  function set_uploaders() {
    var uploaders = [{
      name: 'items_uploader',
      url: '/admin/marketplace/offer_requests/import_items/' + window.offer_request.id,
      element: 'items_file'
    }];
    _underscore2.default.each(uploaders, function (uploader) {
      var f = new FileUploader({
        url: uploader.url,
        formData: [{
          authenticity_token: window.token
        }],
        removeAfterUpload: true
      });
      f.file_element = uploader.element;
      f.onBeforeUploadItem = function () /*item*/{
        f.processing = true;
      };
      f.onCompleteItem = function (fileItem, response /*, status, headers*/) {
        if (response.success) {
          f.processing = false;
          f.clearQueue();
          (0, _jquery2.default)('input.' + f.file_element).val(null);
          load_data();
        }
      };
      $scope[uploader.name] = f;
    });
  }

  function get_buyer_address_options() {
    return {
      consignee_address: false,
      notify_address: false,
      docs_address: false
    };
  }

  $scope.$on('load_items', function (event, data) {
    load_data(data ? data.selected_items : [], data ? data.item_key : null);
  });

  $scope.$watch('offer_request.shipment_country_id', function () {
    if ($scope.offer_request && $scope.offer_request.shipment_country_id) {
      GeoService.get_cities($scope.offer_request.shipment_country_id).then(function (data) {
        $scope.shipment_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.offer_request.shipment_city_id })) $scope.offer_request.shipment_city_id = null;
      });
    }
  });

  $scope.$watch('offer_request.delivery_country_id', function () {
    if ($scope.offer_request && $scope.offer_request.delivery_country_id) {
      GeoService.get_cities($scope.offer_request.delivery_country_id).then(function (data) {
        $scope.delivery_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.offer_request.delivery_city_id })) $scope.offer_request.delivery_city_id = null;
      });
    }
  });

  $scope.$watch('offer_request.sc_series', function () {
    OfferRequestService.get_next_sc_id($scope.offer_request.id, $scope.offer_request.sc_series).then(function (data) {
      $scope.next_sc_id = data.data.sc_id;
    });
  });

  $scope.update_details = function () {
    var details = {
      id: $scope.offer_request.id,
      delivery_term_id: $scope.offer_request.delivery_term_id,
      shipment_country_id: $scope.offer_request.shipment_country_id,
      shipment_city_id: $scope.offer_request.shipment_city_id,
      delivery_country_id: $scope.offer_request.delivery_country_id,
      delivery_city_id: $scope.offer_request.delivery_city_id,
      origin_of_goods: $scope.offer_request.origin_of_goods,
      delivered_by: $scope.offer_request.delivered_by,
      acceptable_payment_term_id: $scope.offer_request.acceptable_payment_term_id,
      remarks: $scope.offer_request.remarks,
      buyer_address_options: $scope.offer_request.buyer_address_options,
      has_insurance: $scope.offer_request.has_insurance,
      currency_symbol: $scope.offer_request.currency_symbol,
      quantity_type: $scope.offer_request.quantity_type,
      commission_unit: $scope.offer_request.commission_unit,
      comments: $scope.offer_request.comments,
      layout: $scope.offer_request.layout,
      sc_series: $scope.offer_request.sc_series
    };
    $scope.updating_details = true;
    OfferRequestService.update(details).success(function (data) {
      if (data.success) $scope.updating_details = false;
    });
  };

  $scope.update_basic_info = function () {
    var info = {
      id: $scope.offer_request.id,
      title: $scope.offer_request.title,
      status: $scope.offer_request.status,
      order_id: $scope.offer_request.order_id
    };
    $scope.updating_basic_info = true;
    OfferRequestService.update(info).success(function (data) {
      if (data.success) $scope.updating_basic_info = false;
    });
  };

  $scope.$on('publish_data', function (event, data) {
    $scope.buyer = data;
  });

  $scope.update_buyer_details = function () {
    $scope.updating_buyer_details = true;
    var details = {
      id: window.offer_request.id,
      buyer_details: $scope.buyer
    };
    OfferRequestService.update(details).success(function (data) {
      if (data.success) $scope.updating_buyer_details = false;
    });
  };

  $scope.init = function () {
    $scope.offer_request = window.offer_request;
    if (!$scope.offer_request.buyer_address_options) $scope.offer_request.buyer_address_options = get_buyer_address_options();
    $scope.countries = _angular2.default.copy(window.countries);
    $scope.items = [];
    $scope.status_options = OfferRequestService.get_status_options();
    set_uploaders();
    load_data();
    load_details();
  };

  $scope.init();
};

exports.default = OfferRequestItems;


OfferRequestItems.$inject = ['$scope', 'OfferRequestService', 'FileUploader', 'GeoService'];

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferRequests = function OfferRequests($scope, OfferRequestService, PaginationService, UserService) {
  _classCallCheck(this, OfferRequests);

  function set_supplier_company_autocomplete(input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Seller', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.filter.supplier_id = ui.item.id;
        $scope.$apply();
      }
    });
  }

  function set_buyer_company_autocomplete(input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Buyer', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.filter.buyer_id = ui.item.id;
        $scope.$apply();
      }
    });
  }

  $scope.load_data = function () {
    $scope.loading = true;
    OfferRequestService.get($scope.filter).success(function (data) {
      _underscore2.default.each(data.offer_requests, function (r) {
        r.total_quantity = window.roundToTwo(_underscore2.default.reduce(_underscore2.default.pluck(r.items, 'quantity'), function (quantity, num) {
          return quantity + parseFloat(num);
        }, 0));
        r.selections_quantity = window.roundToTwo(_underscore2.default.reduce(_underscore2.default.pluck(_underscore2.default.filter(r.items, function (i) {
          return i.status < 2;
        }), 'quantity'), function (quantity, num) {
          return quantity + parseFloat(num);
        }, 0));
        r.reservations_quantity = window.roundToTwo(_underscore2.default.reduce(_underscore2.default.pluck(_underscore2.default.filter(r.items, function (i) {
          return i.status === 2;
        }), 'quantity'), function (quantity, num) {
          return quantity + parseFloat(num);
        }, 0));
        r.oc_total_quantity = window.roundToTwo(_underscore2.default.reduce(_underscore2.default.pluck(r.order_confirmations, 'quantity'), function (quantity, num) {
          return quantity + parseFloat(num);
        }, 0));
        _underscore2.default.each(r.order_confirmations, function (c) {
          c.quantity = parseFloat(c.quantity);
        });
      });
      $scope.offer_requests = data.offer_requests;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
      $scope.loading = false;
    });
  };

  $scope.init_filters = function () {
    $scope.supplier_company = null;
    $scope.buyer_company = null;
    $scope.filter = {
      page: 1,
      supplier_id: null,
      buyer_id: null,
      status: 1,
      order_status: 0,
      pref_status: 0
    };
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.load_data();
  };

  $scope.get_status_title = function (status) {
    return _underscore2.default.findWhere($scope.status_options, {
      id: status
    }).title;
  };

  $scope.delete = function (offer_request_id) {
    if (confirm('Are you sure you want to delete this offer request?')) {
      OfferRequestService.delete(offer_request_id).success(function (data) {
        if (data.success) $scope.load_data();
      });
    }
  };

  $scope.order_status_options = [{
    id: 0,
    title: 'No'
  }, {
    id: 1,
    title: 'Yes'
  }];

  $scope.pref_status_options = [{
    id: 0,
    title: 'All'
  }, {
    id: 1,
    title: 'Yes'
  }, {
    id: 2,
    title: 'No'
  }];

  $scope.init = function () {
    $scope.offer_campaigns = [];
    $scope.pagination = {};
    $scope.status_options = OfferRequestService.get_status_options();
    set_supplier_company_autocomplete((0, _jquery2.default)('input.supplier_company'));
    set_buyer_company_autocomplete((0, _jquery2.default)('input.buyer_company'));
    $scope.init_filters();
    $scope.load_data();
  };

  $scope.init();
};

exports.default = OfferRequests;


OfferRequests.$inject = ['$scope', 'OfferRequestService', 'PaginationService', 'UserService'];

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferSectionMenu = function OfferSectionMenu($scope) {
  _classCallCheck(this, OfferSectionMenu);

  $scope.menu = [{
    title: 'Main Details',
    action: 'edit_overview',
    pages: ['edit_overview', 'edit_main_title', 'edit_main_basic', 'edit_main_description', 'edit_main_stocklist', 'edit_main_connections', 'edit_sections_tags', 'edit_sections_specs', 'edit_sections_images', 'edit_sections_offers', 'edit_market']
  }, {
    title: 'Prices & Charges',
    action: 'edit_prices',
    pages: ['edit_prices', 'edit_ospp_users', 'edit_user_pricing', 'edit_supplier_pricing']
  }, {
    title: 'Matching',
    action: 'edit_matching',
    pages: ['edit_matching']
  }, {
    title: 'Advanced',
    action: 'edit_faq',
    pages: ['edit_faq', 'edit_themes', 'edit_requests', 'edit_orders', 'edit_reports', 'edit_notes']
  }, {
    title: 'Campaigns',
    action: 'edit_campaigns',
    pages: ['edit_campaigns']
  }, {
    title: 'Create General',
    action: 'edit_create_inventory',
    pages: []
  }, {
    title: 'Create Personal',
    action: 'edit_create_personalized_offer',
    pages: []
  }, {
    title: 'Copy',
    action: 'copy_offer',
    pages: []
  }];

  $scope.init = function () {
    $scope._ = _underscore2.default;
  };

  $scope.init();
};

exports.default = OfferSectionMenu;


OfferSectionMenu.$inject = ['$scope'];

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferSidebarMenu = function OfferSidebarMenu($scope, OfferSidebarService) {
  _classCallCheck(this, OfferSidebarMenu);

  var menu = [{
    group: 0,
    title: 'Overview',
    pages: [{
      title: 'Overview',
      action: 'edit_overview'
    }]
  }, {
    group: 0,
    title: 'Main Details',
    pages: [{
      title: 'Title & Synopsis',
      action: 'edit_main_title'
    }, {
      title: 'Basic Infos',
      action: 'edit_main_basic'
    }, {
      title: 'Description',
      action: 'edit_main_description'
    }, {
      title: 'Stocklist',
      action: 'edit_main_stocklist'
    }, {
      title: 'Connected/Related Offers',
      action: 'edit_main_connections'
    }]
  }, {
    group: 0,
    title: 'Special Sections',
    pages: [{
      title: 'Tags & Keywords',
      action: 'edit_sections_tags'
    }, {
      title: 'Specs & Attachments',
      action: 'edit_sections_specs'
    }, {
      title: 'Images',
      action: 'edit_sections_images'
    }, {
      title: 'Offers Combination',
      action: 'edit_sections_offers'
    }]
  }, {
    group: 0,
    title: 'Market Restrictions',
    pages: [{
      title: 'Market Restrictions',
      action: 'edit_market'
    }]
  }, {
    group: 1,
    title: 'Prices & Charges',
    pages: [{
      title: 'Prices & Charges',
      action: 'edit_prices'
    }]
  }, {
    group: 1,
    title: 'OSPP Users',
    pages: [{
      title: 'OSPP Users',
      action: 'edit_ospp_users'
    }]
  }, {
    group: 1,
    title: 'User Pricing',
    pages: [{
      title: 'User Pricing',
      action: 'edit_user_pricing'
    }]
  }, {
    group: 1,
    title: 'Supplier Pricing',
    pages: [{
      title: 'Supplier Pricing',
      action: 'edit_supplier_pricing'
    }]
  }, {
    group: 1,
    title: 'Cut Pricing',
    pages: [{
      title: 'Cut Pricing',
      action: 'edit_cut_pricing'
    }]
  }, {
    group: 2,
    title: 'Matching',
    pages: [{
      title: 'Matching',
      action: 'edit_matching'
    }]
  }, {
    group: 3,
    title: 'FAQs',
    pages: [{
      title: 'FAQ Items',
      action: 'edit_faq'
    }]
  }, {
    group: 3,
    title: 'Roll Bar Themes',
    pages: [{
      title: 'Roll Bar Themes',
      action: 'edit_themes'
    }]
  }, {
    group: 3,
    title: 'Requests & Orders',
    pages: [{
      title: 'Requests',
      action: 'edit_requests'
    }, {
      title: 'Orders',
      action: 'edit_orders'
    }]
  }, {
    group: 3,
    title: 'Reports & Stats',
    pages: [{
      title: 'Reports & Stats',
      action: 'edit_reports'
    }]
  }, {
    group: 3,
    title: 'Special Notes',
    pages: [{
      title: 'Special Notes',
      action: 'edit_notes'
    }]
  }, {
    group: 4,
    title: 'Campaigns',
    pages: [{
      title: 'Campaigns',
      action: 'edit_campaigns'
    }, {
      title: 'Campaign Settings',
      action: 'edit_campaign_settings'
    }, {
      title: 'Campaign Basic Infos',
      action: 'edit_campaign_basic_infos'
    }]
  }];

  $scope.set_page_data = function (section_index, page_index, data) {
    var section = $scope.menu[section_index];
    var page = section.pages[page_index];
    page.data = data;
  };

  $scope.$on('set_sidebar_data', function (event, data) {
    $scope.set_page_data(data[0], data[1], data[2]);
  });

  function set_menu() {
    var section = _underscore2.default.find(menu, function (section) {
      return _underscore2.default.contains(_underscore2.default.pluck(section.pages, 'action'), window.app_data.action);
    });

    if (section) {
      $scope.menu = _underscore2.default.where(menu, {
        group: section.group
      });
      var groups_with_data = [0];
      if (_underscore2.default.contains(groups_with_data, section.group)) {
        OfferSidebarService.get_sidebar_data(window.app_data.offer_id, section.group).success(function (data) {
          var sidebar_data = data.sidebar_data;
          if (section.group === 0) {
            $scope.set_page_data(1, 0, [{
              type: 'percentage',
              value: sidebar_data.title_percentage
            }, null]);
            $scope.set_page_data(1, 1, [{
              type: 'percentage',
              value: sidebar_data.basic_percentage
            }, null]);
            $scope.set_page_data(1, 2, [{
              type: 'percentage',
              value: sidebar_data.description_percentage
            }, null]);
            $scope.set_page_data(1, 3, [{
              type: 'icon',
              value: sidebar_data.stocklist_count
            }, {
              type: 'percentage',
              value: sidebar_data.stocklist_percentage,
              hide: sidebar_data.stocklist_count === 0
            }]);
            $scope.set_page_data(1, 4, [{
              type: 'counter',
              value: sidebar_data.connected.count,
              hide: sidebar_data.connected.count === 0
            }, {
              type: 'counter',
              value: sidebar_data.connected.general_count,
              hide: sidebar_data.connected.count === 0
            }, {
              type: 'counter',
              value: sidebar_data.connected.personalized_count,
              hide: sidebar_data.connected.count === 0
            }]);
            $scope.set_page_data(2, 0, [{
              type: 'percentage',
              value: sidebar_data.tags_percentage
            }, null]);
            $scope.set_page_data(2, 1, [{
              type: 'counter',
              value: sidebar_data.specs_count,
              hide: sidebar_data.specs_count === 0
            }, null]);
            $scope.set_page_data(2, 2, [{
              type: 'counter',
              value: sidebar_data.images_count,
              hide: sidebar_data.images_count === 0
            }, null]);
            $scope.set_page_data(3, 0, [{
              type: 'counter',
              value: sidebar_data.restrictions_count
            }, null]);
          }
        });
      }
    }
  }

  $scope.init = function () {
    $scope.menu = [];
    set_menu();
  };

  $scope.init();
};

exports.default = OfferSidebarMenu;


OfferSidebarMenu.$inject = ['$scope', 'OfferSidebarService'];

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferStockItemPriceDialog = function OfferStockItemPriceDialog($scope, OfferService) {
  _classCallCheck(this, OfferStockItemPriceDialog);

  $scope.$on('open_item_price_dialog', function (event, args) {
    $scope.item = args.item;
    $scope.open_dialog();
  });

  $scope.open_dialog = function () {
    $scope.item_ospp_price = null;
    $scope.item_ospp_incoterm = 3;
    window.openFancyboxDialog('div#item_price_dialog');
  };

  $scope.submit_item_ospp_price = function () {
    if ($scope.item_ospp_price && $scope.item_ospp_price > 0) {
      $scope.applying_ospp_price = true;
      OfferService.submit_ospp_price(window.offer_id, [$scope.item.id], window.user_id, $scope.filter.buyer_country_id, $scope.item_ospp_price, $scope.item_ospp_incoterm).then(function () {
        OfferService.get_matched_item(window.offer_id, window.user_id, $scope.filter, true, $scope.item.id).then(function (data) {
          $scope.item = data.items[0];
          var index = _underscore2.default.indexOf($scope.items, _underscore2.default.findWhere($scope.items, {
            id: $scope.item.id
          }));
          $scope.items[index] = data.items[0];
          $scope.applying_ospp_price = false;
        });
      });
    }
  };

  $scope.init = function () {
    $scope.item_ospp_incoterms = [{
      id: 3,
      name: 'FCA'
    }, {
      id: 1,
      name: 'CFR'
    }, {
      id: 2,
      name: 'DAP'
    }];
  };

  $scope.init();
};

exports.default = OfferStockItemPriceDialog;


OfferStockItemPriceDialog.$inject = ['$scope', 'OfferService'];

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferStocklistCriteria = function OfferStocklistCriteria($scope, $rootScope, ProductService, OfferService) {
  _classCallCheck(this, OfferStocklistCriteria);

  $scope.set_product_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        ProductService.search_products_by_title(request.term).then(function (data) {
          response(data.products);
        });
      },
      select: function select(event, ui) {
        if (!_underscore2.default.findWhere($scope.filter.epaper_products, { id: ui.item.id })) $scope.filter.epaper_products.push({
          id: ui.item.id,
          title: ui.item.value
        });
        (0, _jquery2.default)(this).val('');
        $scope.$apply();
        return false;
      }
    });
  };

  $scope.set_product_group_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        ProductService.search_product_groups_by_title(request.term).then(function (data) {
          response(data.groups);
        });
      },
      select: function select(event, ui) {
        if (!_underscore2.default.findWhere($scope.filter.groups, { id: ui.item.id })) $scope.filter.groups.push({
          id: ui.item.id,
          title: ui.item.value
        });
        (0, _jquery2.default)(this).val('');
        $scope.$apply();
        return false;
      }
    });
  };

  $scope.roundQuantity = function (quantity) {
    return window.roundToTwo(quantity);
  };

  $scope.dialog_quick_search = function () {
    window.filter_table('table#dialog_products', $scope.dialog_query);
  };

  $scope.clear_specs = function () {
    $scope.filter.substance_from = null;
    $scope.filter.substance_to = null;
    $scope.filter.rw_from = null;
    $scope.filter.rw_to = null;
    $scope.filter.diameter_from = null;
    $scope.filter.diameter_to = null;
    $scope.filter.core_from = null;
    $scope.filter.core_to = null;
    $scope.filter.length_from = null;
    $scope.filter.length_to = null;
    $scope.filter.width_from = null;
    $scope.filter.width_to = null;
  };

  $scope.add_product_name = function () {
    $scope.filter.product_names.push($scope.product_name);
    $scope.product_name = null;
  };

  $scope.remove_product_name = function (product_name) {
    $scope.filter.product_names = _underscore2.default.reject($scope.filter.product_names, function (name) {
      return name == product_name;
    });
  };

  $scope.remove_epaper_product = function (product_id) {
    $scope.filter.epaper_products = _underscore2.default.reject($scope.filter.epaper_products, function (product) {
      return product.id == product_id;
    });
    (0, _jquery2.default)('input.epaper_product').val('');
  };

  $scope.remove_group = function (group_id) {
    $scope.filter.groups = _underscore2.default.reject($scope.filter.groups, function (group) {
      return group.id == group_id;
    });
    (0, _jquery2.default)('input.group').val('');
  };

  $scope.check_dialog_products = function () {
    _angular2.default.forEach($scope.dialog_products, function (product) {
      product.checked = $scope.dialog_products_checked;
    });
  };

  $scope.open_dialog = function (dialog_id) {
    if ($scope.filter.supplier_id && $scope.filter.date_from && $scope.filter.date_to || window.offer) {
      $scope.load_dialog_products();
      _jquery2.default.fancybox((0, _jquery2.default)('div#' + dialog_id), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        scrolling: 'yes'
      });
    } else {
      alert('Please select a supplier and date period!');
    }
  };

  $scope.open_group_dialog = function () {
    var data = {
      categories: $scope.categories,
      selected_groups: $scope.filter.groups
    };

    $rootScope.$broadcast('show_product_category_groups', data);
  };

  $scope.$on('product_category_groups_update', function (event, data) {
    $scope.filter.groups = data.groups;
  });

  $scope.load_dialog_products = function () {
    $scope.dialog_products = [];
    $scope.dialog_products_checked = false;
    $scope.loading_dialog_products = true;
    ProductService.search_products_by_filter($scope.filter).then(function (data) {
      if (data.success) $scope.dialog_products = data.products;
      $scope.loading_dialog_products = false;
    });
  };

  $scope.add_selected_products = function () {
    var products = _underscore2.default.select($scope.dialog_products, function (p) {
      return p.checked === true;
    });
    if (products.length === 0) {
      alert('Please select at least one product!');
    } else {
      _angular2.default.forEach(products, function (product) {
        if (!_underscore2.default.findWhere($scope.filter.epaper_products, { id: product.id })) $scope.filter.epaper_products.push({
          id: product.id,
          title: product.name
        });
      });
      _jquery2.default.fancybox.close();
    }
  };

  $scope.set_filters = function () {
    $scope.filter.product_names = [];
    $scope.filter.epaper_products = [];
    $scope.filter.categories = [];
    $scope.filter.groups = [];
    $scope.filter.stock_type = 'reels';
    $scope.filter.substance_from = null;
    $scope.filter.substance_to = null;
    $scope.filter.rw_from = null;
    $scope.filter.rw_to = null;
    $scope.filter.diameter_from = null;
    $scope.filter.diameter_to = null;
    $scope.filter.core_from = null;
    $scope.filter.core_to = null;
    $scope.filter.length_from = null;
    $scope.filter.length_to = null;
    $scope.filter.width_from = null;
    $scope.filter.width_to = null;
  };

  $scope.update_criteria = function () {
    $scope.updating_criteria = true;
    OfferService.update_create_filters($scope.filter).then(function (data) {
      if (data.success) $scope.updating_criteria = false;
    });
  };

  $scope.search_items = function () {
    if (!$scope.filter.buyer_id) {
      alert('Please select a buyer first!');
      return false;
    }
    $scope.filter.buyer_user_products = [];
    $scope.filter.personal_search_mode = 2;
    $scope.searching_custom = true;
    $scope.tabs[0].offers = [];
    $scope.tabs[0].items = [];
    $scope.tabs[0].filter.offer_id = null;
    OfferService.search_for_inventories($scope.filter).then(function (data) {
      $scope.tabs[0].offers = [{
        id: window.offer.id,
        title: window.offer.titleEN + ' (' + window.offer.id + ')'
      }];
      $scope.tabs[0].items = data.items;
      $scope.set_tab_properties(0);
      $scope.searching_custom = false;
    });
  };

  function load_categories() {
    $scope.categories = [];
    ProductService.get_categories().then(function (response) {
      $scope.categories = response.data.categories;
      _underscore2.default.each($scope.filter.categories, function (category_id) {
        var category = _underscore2.default.findWhere($scope.categories, {
          id: category_id
        });
        if (category) {
          category.checked = true;
        }
      });
    });
  }

  $scope.update_categories = function (category) {
    if (category.checked) {
      if (!_underscore2.default.contains($scope.filter.categories, category.id)) {
        $scope.filter.categories.push(category.id);
      }
    } else {
      $scope.filter.categories = _underscore2.default.without($scope.filter.categories, category.id);
    }
  };

  $scope.init = function () {
    $scope.set_product_autocomplete((0, _jquery2.default)('input.epaper_product'));
    $scope.set_product_group_autocomplete((0, _jquery2.default)('input.group'));
    $scope.manage_criteria = window.manage_criteria;
    if (window.manage_criteria && window.offer.create_filters) {
      _jquery2.default.extend($scope.filter, window.offer.create_filters.filters);
      if (!$scope.filter.categories) {
        $scope.filter.categories = [];
      }
      if (!$scope.filter.groups) {
        $scope.filter.groups = [];
      }
    } else {
      $scope.set_filters();
    }
    load_categories();
  };

  $scope.init();
};

exports.default = OfferStocklistCriteria;


OfferStocklistCriteria.$inject = ['$scope', '$rootScope', 'ProductService', 'OfferService'];

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferStocklistMassUpdateDialog = function OfferStocklistMassUpdateDialog($scope, $rootScope, $q, OfferService) {
  _classCallCheck(this, OfferStocklistMassUpdateDialog);

  $scope.$on('show_mass_update_dialog', function (event, data) {
    window.openFancyboxDialog('div#offer_stocklist_mass_update_dialog');
    $scope.offers = _underscore2.default.sortBy(data.offers, 'id');
    $scope.updated_times = [];
    $scope.offers_length = $scope.offers.length;
    mass_update_stocklists();
  });

  $scope.steps = [{
    id: 1,
    title: 'Update Stocklists'
  }];

  function update_offer(offer, index, deferred) {
    $scope.steps[0].progress = Math.ceil((index + 1) / $scope.offers_length * 100);
    var t0 = performance.now();

    OfferService.update_stocklist_from_parent(offer).then(function () {
      deferred.resolve();
      var t1 = performance.now();
      $scope.updated_times.push((t1 - t0) / 1000);
    });
  }

  function update_offers() {
    return $scope.offers.reduce(function (promise, offer, index) {
      return promise.then(function () {
        var deferred = $q.defer();
        update_offer(offer.id, index, deferred);
        return deferred.promise;
      });
    }, $q.when());
  }

  function mass_update_stocklists() {
    _underscore2.default.each($scope.steps, function (step) {
      step.progress = 0;
      step.progress_started = true;
    });

    update_offers().then(function () {
      $scope.updating_stocklists = false;
      $scope.load_offers();
      _jquery2.default.fancybox.close();
      OfferService.send_updated_offers_email(_underscore2.default.pluck($scope.offers, 'id'), $scope.updated_times);
    });
  }
};

exports.default = OfferStocklistMassUpdateDialog;


OfferStocklistMassUpdateDialog.$inject = ['$scope', '$rootScope', '$q', 'OfferService'];

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferStocklist = function OfferStocklist($scope, $rootScope, OfferService) {
  _classCallCheck(this, OfferStocklist);

  function get_offer_date_options() {
    var options = [];
    options.push({
      id: 0,
      title: 'Updated (' + window.offer.updated_at.substring(0, 10) + ')'
    });
    if (window.offer.published_at) options.push({
      id: 1,
      title: 'Published (' + window.offer.published_at.substring(0, 10) + ')'
    });
    return options;
  }

  $scope.update_supplier_pricings = function () {
    $scope.updating_supplier_pricings = true;
    OfferService.update_supplier_pricings(window.offer.id, $scope.offer_date_mode).success(function (data) {
      if (data.success) $scope.updating_supplier_pricings = false;
    });
  };

  $scope.update_offer_version = function () {
    $scope.updating_offer_version = true;
    OfferService.update_offer_version(window.offer.id).success(function (data) {
      if (data.success) {
        $scope.offer_version = data.offer_version;
        $scope.updating_offer_version = false;
      }
    });
  };

  $scope.create_campaign = function (send) {
    var data = {
      offer_id: $scope.offer.id,
      campaign_settings: $scope.offer.offer_campaign_settings,
      total_count: 1,
      current_index: 0,
      send: send
    };
    $rootScope.$broadcast('show_create_campaign', data);
  };

  $scope.init = function () {
    $scope.offer = window.offer;
    $scope.offer_date_mode = 0;
    $scope.offer_date_options = get_offer_date_options();
    $scope.offer_version = window.offer_version;
  };

  $scope.init();
};

exports.default = OfferStocklist;


OfferStocklist.$inject = ['$scope', '$rootScope', 'OfferService'];

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferSupplierPricing = function OfferSupplierPricing($scope, OfferService) {
  _classCallCheck(this, OfferSupplierPricing);

  $scope.load_items = function () {
    $scope.loading = true;
    $scope.items = [];
    OfferService.get_supplier_pricing_stocklist(window.offer_id, $scope.country_id).success(function (data) {
      if (data.success) {
        $scope.items = data.items;
        $scope.fields = data.fields;
        $scope.has_reels = _underscore2.default.select(data.items, function (i) {
          return i.is_reels === true;
        }).length > 0;
        $scope.has_sheets = _underscore2.default.select(data.items, function (i) {
          return i.is_reels === false;
        }).length > 0;
        $scope.loading = false;
      }
    });
  };

  $scope.$watch('country_id', function () {
    $scope.supplier_freight_rates = [];
    $scope.country_extra_charge = null;
    if ($scope.country_id && $scope.country_id > 0) {
      OfferService.get_freight_rates_for_buyer(window.offer_id, $scope.country_id).then(function (data) {
        $scope.supplier_freight_rates = data.freight_rates;
        return OfferService.get_country_extra_charge(window.offer_id, window.supplier_id, $scope.country_id);
      }).then(function (data) {
        $scope.country_extra_charge = data.country_extra_charge;
      });
    }
  });

  $scope.check_items = function (is_reels) {
    _angular2.default.forEach($scope.items, function (item) {
      if (is_reels && item.is_reels) item.checked = $scope.reels_checked;else if (!is_reels && !item.is_reels) item.checked = $scope.sheets_checked;
    });
  };

  $scope.edit_item_price = function (item) {
    $scope.show_edit_price([item]);
  };

  $scope.edit_item_prices = function () {
    var items = [];
    _underscore2.default.each($scope.items, function (item) {
      if (item.checked) items.push(item);
    });
    if (items.length === 0) {
      alert('Please select at least one item!');
    } else {
      $scope.show_edit_price(items);
    }
  };

  $scope.show_edit_price = function (items) {
    $scope.edit_items = items;
    _jquery2.default.fancybox((0, _jquery2.default)('div#mass_edit_prices'), {
      padding: '5',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      topRatio: 0.15,
      scrolling: 'no'
    });
  };

  $scope.submit_edit_price = function () {
    if ($scope.edit_price > 0) {
      var items = _underscore2.default.pluck($scope.edit_items, 'id');
      $scope.submitting = true;
      OfferService.update_stock_items_price(window.offer_id, items, $scope.edit_price, $scope.edit_incoterm, $scope.country_id || null).success(function (data) {
        if (data.success) {
          _underscore2.default.each($scope.edit_items, function (item) {
            item.fca = data.prices.exw;
            item.cfr = data.prices.cfr;
            item.dap = data.prices.dap;
          });
          $scope.submitting = false;
          _jquery2.default.fancybox.close();
        }
      });
    }
  };

  $scope.quick_search = function () {
    window.filter_table('table#reels', $scope.query);
    window.filter_table('table#sheets', $scope.query);
  };

  $scope.show_row = function (item) {
    var offer = false;
    if ($scope.filter_offer == '0') {
      offer = true;
    } else if ($scope.filter_offer == '1' && (item.offer_fca || item.offer_cfr || item.offer_dap)) {
      offer = true;
    } else if ($scope.filter_offer == '2' && !item.offer_fca && !item.offer_cfr && !item.offer_dap) {
      offer = true;
    }

    var order = false;
    if ($scope.filter_order == '0') {
      order = true;
    } else if ($scope.filter_order == '1' && (item.order_fca || item.order_cfr || item.order_dap)) {
      order = true;
    } else if ($scope.filter_order == '2' && !item.order_fca && !item.order_cfr && !item.order_dap) {
      order = true;
    }

    var ospp = false;
    if ($scope.filter_ospp == '0') {
      ospp = true;
    } else if ($scope.filter_ospp == '1' && (item.ospp_fca || item.ospp_cfr || item.ospp_dap)) {
      ospp = true;
    } else if ($scope.filter_ospp == '2' && !item.ospp_fca && !item.ospp_cfr && !item.ospp_dap) {
      ospp = true;
    }

    var country_order = false;
    if ($scope.filter_country_order == '0') {
      country_order = true;
    } else if ($scope.filter_country_order == '1' && (item.order_country_fca || item.order_country_cfr || item.order_country_dap)) {
      country_order = true;
    } else if ($scope.filter_country_order == '2' && !item.order_country_fca && !item.order_country_cfr && !item.order_country_dap) {
      country_order = true;
    }

    var country_ospp = false;
    if ($scope.filter_country_ospp == '0') {
      country_ospp = true;
    } else if ($scope.filter_country_ospp == '1' && (item.ospp_country_fca || item.ospp_country_cfr || item.ospp_country_dap)) {
      country_ospp = true;
    } else if ($scope.filter_country_ospp == '2' && !item.ospp_country_fca && !item.ospp_country_cfr && !item.ospp_country_dap) {
      country_ospp = true;
    }

    return offer && order && ospp && country_order && country_ospp;
  };

  $scope.show_field = function (field) {
    if (field.id == 'fca') return $scope.show_fca;else if (field.id == 'cfr') return $scope.show_cfr;else if (field.id == 'dap') return $scope.show_dap;else return true;
  };

  $scope.edit_incoterms = [{
    id: 3,
    name: 'FCA'
  }, {
    id: 1,
    name: 'CFR'
  }, {
    id: 2,
    name: 'DAP'
  }];

  $scope.copy_to_fca = function (source) {
    var items = [];
    _underscore2.default.each($scope.items, function (item) {
      if (item.checked) items.push(item);
    });
    if (items.length === 0) {
      alert('Please select at least one item!');
    } else {
      var updated_items = [];
      _underscore2.default.each(items, function (item) {
        var exw = item[source] || null;
        if (exw && source == 'order_fca') {
          if (item.order_charge) exw = exw - item.order_charge;else exw = exw - $scope.order_charge;
        } else if (exw && source == 'order_country_fca') {
          exw = exw - $scope.order_charge;
        } else if (exw && source == 'ospp_fca') {
          if (item.ospp_charge) exw = exw - item.ospp_charge;else exw = exw - $scope.order_charge;
        }
        updated_items.push({
          id: item.id,
          exw: exw
        });
      });
      $scope.updating = true;
      OfferService.update_stock_items_fca(updated_items).success(function (data) {
        if (data.success) {
          $scope.load_items();
          $scope.updating = false;
        }
      });
    }
  };

  $scope.init = function () {
    $scope.supplier_id = window.supplier_id;
    $scope.load_items();
    $scope.countries = window.countries;
    $scope.edit_incoterm = 3;
    $scope.show_offer = true;
    $scope.show_order = true;
    $scope.show_ospp = true;
    $scope.show_ospp_country = false;
    $scope.show_fca = true;
    $scope.show_cfr = true;
    $scope.show_dap = true;
    $scope.filter_offer = '0';
    $scope.filter_order = '0';
    $scope.filter_ospp = '0';
    $scope.filter_country_order = '0';
    $scope.filter_country_ospp = '0';
    $scope.order_charge = 0;
  };

  $scope.init();
};

exports.default = OfferSupplierPricing;


OfferSupplierPricing.$inject = ['$scope', 'OfferService'];

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferUpload = function OfferUpload($scope, FileUploader) {
  _classCallCheck(this, OfferUpload);

  $scope.set_uploaders = function () {
    var uploaders = [{
      name: 'offers_uploader',
      url: '/admin/marketplace/offers/import_offers',
      element: 'offers_file'
    }, {
      name: 'items_uploader',
      url: '/admin/marketplace/offers/import_stock_items',
      element: 'items_file'
    }];
    _underscore2.default.each(uploaders, function (uploader) {
      var f = new FileUploader({
        url: uploader.url,
        formData: [{
          authenticity_token: window.token
        }],
        removeAfterUpload: true
      });
      f.file_element = uploader.element;
      f.onBeforeUploadItem = function () /*item*/{
        f.processing = true;
      };
      f.onCompleteItem = function (fileItem, response /*, status, headers*/) {
        if (response.success) {
          f.processing = false;
          f.clearQueue();
          (0, _jquery2.default)('input.' + f.file_element).val(null);
        }
      };
      $scope[uploader.name] = f;
    });
  };

  $scope.init = function () {
    $scope.set_uploaders();
  };

  $scope.init();
};

exports.default = OfferUpload;


OfferUpload.$inject = ['$scope', 'FileUploader'];

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Offers = function Offers($scope, $rootScope, $q, OfferCampaignService, OfferService, PaginationService, UserService) {
  _classCallCheck(this, Offers);

  function set_supplier_company_autocomplete(input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Seller', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.filter.supplier_id = ui.item.id;
        $scope.$apply();
      }
    });
  }

  function set_buyer_company_autocomplete(input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Buyer', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.filter.buyer_id = ui.item.id;
        $scope.$apply();
      }
    });
  }

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.load_data();
  };

  $scope.check_offers = function () {
    _underscore2.default.each($scope.offers, function (c) {
      c.checked = $scope.select_all;
    });
  };

  $scope.quick_search = function () {
    window.filter_table('table.data', $scope.quick_filter);
  };

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.load_data = function () {
    $scope.select_all = false;
    OfferService.get_manage_data($scope.filter).then(function (data) {
      $scope.offers = data.offers;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
    });
  };

  $scope.get_stocklist_percentage = function (offer) {
    if (offer.stocklist_count === 0 || offer.stocklist_product_count === 0) return 0;else return parseInt(offer.stocklist_product_count / offer.stocklist_count * 100);
  };

  $scope.get_description_percentage = function (offer) {
    var percentage = 0;
    if (offer.subtitleEN) percentage += 33;
    if (offer.full_description) percentage += 33;
    if (offer.notes) percentage += 34;
    return percentage;
  };

  $scope.get_status_css_class = function (offer) {
    if (offer.is_deleted) return 'red';else if (offer.visible && offer.is_active) return 'green';else if (!offer.visible && offer.is_active) return 'orange';else return '';
  };

  $scope.get_offer_ids = function () {
    return _underscore2.default.pluck($scope.offers, 'id').join(', ');
  };

  $scope.create_offer_campaigns = function () {
    var offers = _underscore2.default.where($scope.offers, {
      checked: true
    });
    if (offers.length === 0) {
      alert('Please select at least one offer!');
      return;
    }

    var campaigns = [];

    offers.reduce(function (promise, offer, index) {
      return promise.then(function (result) {
        if (result) {
          campaigns.push(result.campaign_id);
        }

        var deferred = $q.defer();

        var data = {
          offer_id: offer.id,
          campaign_settings: offer.offer_campaign_settings,
          deferred: deferred,
          total_count: offers.length,
          current_index: index
        };
        $rootScope.$broadcast('show_create_campaign', data);

        return deferred.promise;
      });
    }, $q.when()).then(function (result) {
      campaigns.push(result.campaign_id);

      OfferCampaignService.send_created_campaigns_email(campaigns);
    });
  };

  $scope.init_filter = function () {
    $scope.filter = {
      page: 1,
      per_page: 50,
      sort_by: null,
      sort_by_mode: 1,
      supplier_id: null,
      buyer_id: null,
      id: null,
      title: null,
      date_from: null,
      date_to: null,
      is_deleted: null,
      is_personalized: null,
      is_primary: true
    };
  };

  $scope.init = function () {
    $scope.offers = [];
    $scope.pagination = {};
    set_supplier_company_autocomplete((0, _jquery2.default)('input.supplier_company'));
    set_buyer_company_autocomplete((0, _jquery2.default)('input.buyer_company'));
    $scope.init_filter();
    $scope.load_data();
  };

  $scope.init();
};

exports.default = Offers;


Offers.$inject = ['$scope', '$rootScope', '$q', 'OfferCampaignService', 'OfferService', 'PaginationService', 'UserService'];

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderArrivals = function OrderArrivals($scope, OrderService, OrderBookingNoteService) {
  _classCallCheck(this, OrderArrivals);

  $scope.tabs = [{
    title: 'All',
    items: []
  }, {
    title: 'Need Attention',
    items: []
  }];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.get_orders = function () {
    $scope.loading = true;
    OrderService.get_arrivals_data($scope.filter).then(function (data) {
      $scope.tabs[0].items = data.booking_notes[0];
      $scope.tabs[1].items = data.booking_notes[1];
      $scope.loading = false;
    });
  };

  $scope.check_items = function (tab) {
    _underscore2.default.each($scope.tabs[tab].items, function (i) {
      i.checked = $scope.tabs[tab].checked;
    });
  };

  $scope.mass_update_status = function (tab) {
    var items = _underscore2.default.where($scope.tabs[tab].items, {
      checked: true
    });
    if (items.length === 0) {
      alert('Please select at least one item!');
    } else {
      $scope.mass_updating_status = true;
      OrderBookingNoteService.mass_update_delivery_status(_underscore2.default.pluck(items, 'id')).success(function (data) {
        if (data.success) {
          $scope.mass_updating_status = false;
          $scope.tabs[tab].checked = false;
          $scope.get_orders();
        }
      });
    }
  };

  $scope.init = function () {
    $scope.filter = {
      user_id: window.mode.user_id,
      is_buyer: window.mode.is_buyer
    };
    $scope.selected_tab = 0;
    $scope.get_orders();
  };

  $scope.init();
};

exports.default = OrderArrivals;


OrderArrivals.$inject = ['$scope', 'OrderService', 'OrderBookingNoteService'];

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderAttachments = function OrderAttachments($scope, $rootScope, OrderService, FileUploader) {
  _classCallCheck(this, OrderAttachments);

  function set_uploaders() {
    var uploaders = [{
      name: 'attachment_uploader',
      url: '/admin/marketplace/orders/upload_order_attachment/' + window.order.id,
      element: 'attachment_file'
    }];
    _underscore2.default.each(uploaders, function (uploader) {
      var f = new FileUploader({
        url: uploader.url,
        formData: [{
          authenticity_token: window.token,
          doc_type: $scope.doc_type
        }],
        removeAfterUpload: true
      });
      f.file_element = uploader.element;
      f.onBeforeUploadItem = function () /*item*/{
        f.processing = true;
      };
      f.onCompleteItem = function (fileItem, response /*, status, headers*/) {
        if (response.success) {
          f.processing = false;
          f.clearQueue();
          (0, _jquery2.default)('input.' + f.file_element).val(null);
          load_data();
        }
      };
      $scope[uploader.name] = f;
    });
  }

  function load_data() {
    OrderService.get_attachments(window.order.id, _underscore2.default.pluck($scope.doc_types, 'id')).success(function (data) {
      if (data.success) {
        $scope.attachments = data.attachments;
        _underscore2.default.each($scope.attachments, function (attachment) {
          attachment.doc_type_str = _underscore2.default.findWhere($scope.doc_types, {
            id: attachment.doc_type
          }).title;
        });
        $rootScope.$broadcast('publish_attachments', {
          attachments: $scope.attachments
        });
      }
    });
  }

  $scope.$watch('doc_type', function () {
    if ($scope.attachment_uploader) $scope.attachment_uploader.formData[0].doc_type = $scope.doc_type;
  });

  $scope.check_attachments = function () {
    _underscore2.default.each($scope.attachments, function (attachment) {
      attachment.checked = $scope.checked_all_attachments;
    });
  };

  $scope.delete_attachment = function (attachment) {
    if (confirm('Are you sure you want to delete this attachment?')) {
      attachment.deleting = true;
      OrderService.delete_attachment(attachment.id).success(function (data) {
        if (data.success) {
          attachment.deleting = false;
          load_data();
        }
      });
    }
  };

  $scope.init = function () {
    $scope.attachments = [];
    $scope.doc_types = _underscore2.default.where(window.document_types, {
      doc_type: window.document_type
    });
    $scope.doc_type = $scope.doc_types[0].id;
    set_uploaders();
    load_data();
  };

  $scope.init();
};

exports.default = OrderAttachments;


OrderAttachments.$inject = ['$scope', '$rootScope', 'OrderService', 'FileUploader'];

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderBookingNoteNotifications = function OrderBookingNoteNotifications($scope, OrderBookingNoteService) {
  _classCallCheck(this, OrderBookingNoteNotifications);

  function load_data() {
    OrderBookingNoteService.get_notifications(window.order.id).success(function (data) {
      if (data.success) $scope.notifications = data.notifications;
    });
  }

  $scope.resend_notification = function (notification) {
    if (confirm('Are you sure you want to resend this notification?')) {
      notification.resending = true;
      OrderBookingNoteService.resend_notification(notification.id).success(function (data) {
        if (data.success) {
          notification.resending = false;
          load_data();
        }
      });
    }
  };

  $scope.init = function () {
    load_data();
  };

  $scope.init();
};

exports.default = OrderBookingNoteNotifications;


OrderBookingNoteNotifications.$inject = ['$scope', 'OrderBookingNoteService'];

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderBookingNotes = function OrderBookingNotes($scope, OrderBookingNoteService, OrderSidebarService, UiService, EmailService) {
  _classCallCheck(this, OrderBookingNotes);

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.open_dialog = function (dialog_id) {
    window.openFancyboxDialog('div#' + dialog_id);
  };

  $scope.add_booking_note = function () {
    $scope.dialog_note = _angular2.default.copy(window.booking_note);
    $scope.open_dialog('booking_note_dialog');
  };

  $scope.edit_booking_note = function (booking_note) {
    $scope.dialog_note = booking_note;
    $scope.open_dialog('booking_note_dialog');
  };

  $scope.delete_booking_note = function (index) {
    if (confirm('Are you sure you want to delete this booking note?')) {
      OrderBookingNoteService.delete($scope.order.booking_notes[index].id).then(function (data) {
        if (data.success) {
          $scope.order.booking_notes.splice(index, 1);
          OrderSidebarService.set_booking_notes_data($scope.order.booking_notes.length > 0);
        }
      });
    }
  };

  $scope.save_booking_note = function () {
    $scope.updating_note = true;
    OrderBookingNoteService.save($scope.dialog_note).then(function (data) {
      if (data.success) {
        $scope.updating_note = false;
        _jquery2.default.fancybox.close();
        $scope.order.booking_notes = data.booking_notes;
        OrderSidebarService.set_booking_notes_data(data.booking_notes.length > 0);
      }
    });
  };

  $scope.send_booking_note = function (booking_note) {
    $scope.dialog_booking_note = booking_note;
    _jquery2.default.fancybox((0, _jquery2.default)('div#send_booking_note'), {
      padding: '5',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      topRatio: 0.15,
      scrolling: 'yes',
      afterShow: function afterShow() {
        $scope.$broadcast('$tinymce:refresh');
      }
    });
  };

  $scope.check_buyer_contacts = function () {
    _underscore2.default.each($scope.buyer_contacts, function (contact) {
      contact.checked = $scope.checked_all_buyer_contacts;
    });
  };

  $scope.send_booking_note_notification = function () {
    var contacts = _underscore2.default.where($scope.buyer_contacts, {
      checked: true
    });
    if (contacts.length === 0) {
      alert('Please select at least one buyer contact!');
      return false;
    }
    $scope.sending_booking_note_notification = true;
    OrderBookingNoteService.send_notification($scope.dialog_booking_note.id, $scope.buyer_custom_text, contacts, $scope.sender_name_en, $scope.sender_name_el, $scope.test_send, $scope.test_send_email).success(function (data) {
      if (data.success) {
        $scope.sending_booking_note_notification = false;
        _jquery2.default.fancybox.close();
      }
    });
  };

  $scope.get_delivery_status_title = function (status) {
    return _underscore2.default.findWhere($scope.delivery_statuses, {
      id: status
    }).title;
  };

  $scope.init = function () {
    $scope.order = window.order;
    $scope.dialog_note = _angular2.default.copy(window.booking_note);
    $scope.tinymceOptions = UiService.tinymceOptions();
    $scope.tinymceOptions.height = 100;
    $scope.custom_text = '';
    $scope.test_send = true;
    $scope.test_send_email = 'p.tsolpagas@epsilon-paper.com';
    $scope.recipient_modes = EmailService.get_recipient_modes();
    $scope.sender_names_en = EmailService.get_sender_names_en();
    $scope.sender_names_el = EmailService.get_sender_names_el();
    $scope.sender_name_en = $scope.sender_names_en[0];
    $scope.sender_name_el = $scope.sender_names_el[0];
    $scope.buyer_contacts = _underscore2.default.filter(window.buyer_contacts, function (c) {
      return !_underscore2.default.isEmpty(c.email);
    });
    _underscore2.default.each($scope.buyer_contacts, function (c) {
      c.recipient_mode = 0;
    });
    $scope.delivery_statuses = window.delivery_statuses;
  };

  $scope.init();
};

exports.default = OrderBookingNotes;


OrderBookingNotes.$inject = ['$scope', 'OrderBookingNoteService', 'OrderSidebarService', 'UiService', 'EmailService'];

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderBuyerDetails = function OrderBuyerDetails($scope, OrderService) {
  _classCallCheck(this, OrderBuyerDetails);

  $scope.$on('publish_data', function (event, data) {
    $scope.buyer = data;
  });

  $scope.save = function () {
    $scope.saving = true;
    $scope.form_error = '';
    var order = {
      id: window.order_id,
      buyer_details: $scope.buyer
    };
    OrderService.save(order).then(function (data) {
      if (!data.success) $scope.form_error = data.message;
      $scope.saving = false;
    });
  };
};

exports.default = OrderBuyerDetails;


OrderBuyerDetails.$inject = ['$scope', 'OrderService'];

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderCreate = function OrderCreate($scope, $filter, UserService, GeoService, OrderService, OfferService) {
  _classCallCheck(this, OrderCreate);

  $scope.tabs = ['1. Title & Basic Infos', '2. Delivery Infos', '3. Payment Infos', '4. Necessary Documents'];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.set_buyer_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Buyer', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.order.buyer_id = ui.item.id;
        $scope.order.buyer_user_contact_id = null;
        $scope.buyer_company = ui.item.value;
        $scope.$apply();
        $scope.update_buyer_data(ui.item.id);
      }
    });
  };

  $scope.update_buyer_data = function (user_id) {
    UserService.get_contacts(user_id).success(function (data) {
      $scope.buyer_contacts = data.contacts;
    });
    UserService.get_order_data(user_id).then(function (data) {
      $scope.buyer_incoterms = data.delivery_terms;
      $scope.set_delivery_info();
      $scope.export_docs = _angular2.default.copy(window.export_docs);
      _angular2.default.forEach(data.export_docs, function (id) {
        var export_doc = _underscore2.default.find($scope.export_docs, function (d) {
          return d.id == id;
        });
        if (export_doc) export_doc.checked = true;
      });
    });
  };

  $scope.set_delivery_info = function () {
    if ($scope.buyer_incoterms) {
      var term = _underscore2.default.find($scope.buyer_incoterms, function (t) {
        return t.delivery_term_id == $scope.order.incoterms;
      });
      if (term && term.country_id) {
        $scope.order.delivery_country_id = term.country_id;
      }
      if (term && term.city_id) {
        $scope.order.delivery_city_id = term.city_id;
      }
    }
  };

  $scope.$watch('order.incoterms', function () {
    $scope.set_delivery_info();
  });

  $scope.set_supplier_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Seller', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.order.supplier_id = ui.item.id;
        $scope.order.supplier_user_contact_id = null;
        $scope.supplier_company = ui.item.value;
        $scope.$apply();
        $scope.update_supplier_data(ui.item.id);
      }
    });
  };

  $scope.update_supplier_data = function (user_id) {
    UserService.get_contacts(user_id).success(function (data) {
      $scope.supplier_contacts = data.contacts;
    });
    OfferService.get_offer_ids(user_id).then(function (data) {
      $scope.offer_ids = data.offer_ids;
    });
    UserService.get_order_data(user_id).then(function (data) {
      $scope.order.origin_of_goods = data.origin_of_goods;
      if (data.shipment_country_id) $scope.order.shipment_country_id = data.shipment_country_id;
      if (data.shipment_city_id) $scope.order.shipment_city_id = data.shipment_city_id;
    });
  };

  $scope.$watch('order.shipment_country_id', function () {
    if ($scope.order.shipment_country_id) {
      GeoService.get_cities($scope.order.shipment_country_id).then(function (data) {
        $scope.shipment_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.order.shipment_city_id })) $scope.order.shipment_city_id = null;
      });
    }
  });

  $scope.$watch('order.delivery_country_id', function () {
    if ($scope.order.delivery_country_id) {
      GeoService.get_cities($scope.order.delivery_country_id).then(function (data) {
        $scope.delivery_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.order.delivery_city_id })) $scope.order.delivery_city_id = null;
      });
    }
  });

  $scope.create_order = function () {
    $scope.creating_order = true;
    if (!$scope.order.supplier_id) {
      $scope.form_error = 'Please select a supplier!';
      $scope.creating_order = false;
    } else if (!$scope.order.buyer_id) {
      $scope.form_error = 'Please select a buyer!';
      $scope.creating_order = false;
    } else if (!($scope.order.pi_id || $scope.order.oc_id || $scope.order.commercial_invoice)) {
      $scope.form_error = 'Please select PI or OC or Invoice ID!';
      $scope.creating_order = false;
    } else {
      $scope.form_error = '';
      var docs = [];
      _angular2.default.forEach($scope.export_docs, function (doc) {
        if (doc.checked) docs.push(doc.id);
      });
      $scope.order.export_docs = {
        docs: docs
      };
      OrderService.save($scope.order).then(function (data) {
        if (data.success) {
          $scope.created_order_id = data.order_id;
          $scope.create_mode = false;
        } else {
          $scope.form_error = data.message;
        }
        $scope.creating_order = false;
      });
    }
  };

  $scope.create_new_order = function () {
    $scope.order = _angular2.default.copy(window.order);
    $scope.selected_tab = 0;
    $scope.create_mode = true;
    $scope.order.status = 0;
    $scope.order.delivery_status = 0;
    $scope.order.payment_status = 0;
    $scope.order.incoterms = 1;
    $scope.order.delivered_by = 0;
    $scope.buyer_company = '';
    $scope.supplier_company = '';
    (0, _jquery2.default)('.supplier_company, .buyer_company').val('');
    $scope.export_docs = _angular2.default.copy(window.export_docs);
  };

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.create_mode = true;
    $scope.create_new_order();
    $scope.set_buyer_autocomplete((0, _jquery2.default)('input.buyer_company'));
    $scope.set_supplier_autocomplete((0, _jquery2.default)('input.supplier_company'));
    $scope.order_statuses = window.order_statuses;
    $scope.delivery_statuses = window.delivery_statuses;
    $scope.payment_statuses = window.payment_statuses;
    $scope.order_incoterms = window.incoterms;
    $scope.order_deliveries = window.deliveries;
  };

  $scope.init();
};

exports.default = OrderCreate;


OrderCreate.$inject = ['$scope', '$filter', 'UserService', 'GeoService', 'OrderService', 'OfferService'];

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderDeliveryGeneral = function OrderDeliveryGeneral($scope, GeoService, OrderService, OrderSidebarService, UserDeliveryTermService) {
  _classCallCheck(this, OrderDeliveryGeneral);

  $scope.$watch('order.shipment_country_id', function () {
    if ($scope.order.shipment_country_id) {
      GeoService.get_cities($scope.order.shipment_country_id).then(function (data) {
        $scope.shipment_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.order.shipment_city_id })) $scope.order.shipment_city_id = null;
      });
    }
  });

  $scope.$watch('order.delivery_country_id', function () {
    if ($scope.order.delivery_country_id) {
      GeoService.get_cities($scope.order.delivery_country_id).then(function (data) {
        $scope.delivery_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.order.delivery_city_id })) $scope.order.delivery_city_id = null;
      });
    }
  });

  $scope.update_order = function () {
    $scope.updating_order = true;
    $scope.form_error = '';
    OrderService.save($scope.order).then(function (data) {
      if (!data.success) $scope.form_error = data.message;
      $scope.updating_order = false;
      OrderSidebarService.set_delivery_general_data(data.delivery_general_percentage);
    });
  };

  $scope.update_buyer = function (delivery_term_id, country_id, city_id) {
    $scope.updating_buyer = true;
    $scope.update_buyer_error = '';
    UserDeliveryTermService.update_buyer_terms($scope.order.buyer_id, delivery_term_id, country_id, city_id).then(function (data) {
      if (!data.success) $scope.update_buyer_error = data.message;
      $scope.updating_buyer = false;
    });
  };

  $scope.init = function () {
    $scope.countries = window.countries;
    $scope.order = window.order;
    $scope.delivery_statuses = window.delivery_statuses;
    $scope.order_incoterms = window.incoterms;
    $scope.order_deliveries = window.deliveries;
  };

  $scope.init();
};

exports.default = OrderDeliveryGeneral;


OrderDeliveryGeneral.$inject = ['$scope', 'GeoService', 'OrderService', 'OrderSidebarService', 'UserDeliveryTermService'];

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderDocumentsContacts = function OrderDocumentsContacts($scope, $rootScope, UserService) {
  _classCallCheck(this, OrderDocumentsContacts);

  function load_data(user_id) {
    $scope.contacts = [];
    UserService.get_contacts(user_id).success(function (data) {
      $scope.contacts = _underscore2.default.filter(data.contacts, function (c) {
        return !_underscore2.default.isEmpty(c.email);
      });
      $rootScope.$broadcast('publish_contacts', {
        contacts: $scope.contacts
      });
    });
  }

  $scope.check_contacts = function () {
    _underscore2.default.each($scope.contacts, function (contact) {
      contact.checked = $scope.checked_all_contacts;
    });
  };

  $scope.init = function (user_id) {
    load_data(user_id);
  };

  $scope.init();
};

exports.default = OrderDocumentsContacts;


OrderDocumentsContacts.$inject = ['$scope', '$rootScope', 'UserService'];

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderDocuments = function OrderDocuments($scope, OrderService, UiService, EmailService) {
  _classCallCheck(this, OrderDocuments);

  $scope.$on('publish_attachments', function (event, data) {
    $scope.attachments = data.attachments;
  });

  $scope.$on('publish_contacts', function (event, data) {
    $scope.contacts = data.contacts;
    _underscore2.default.each($scope.contacts, function (c) {
      c.recipient_mode = 0;
    });
  });

  $scope.send_notification = function () {
    var attachments = _underscore2.default.where($scope.attachments, {
      checked: true
    });
    var contacts = _underscore2.default.where($scope.contacts, {
      checked: true
    });
    if (attachments.length === 0) {
      alert('Please select at least one document!');
      return false;
    }
    if (contacts.length === 0) {
      alert('Please select at least one contact!');
      return false;
    }
    $scope.sending_notification = true;
    OrderService.send_notification(window.order.id, $scope.custom_title, $scope.custom_text, attachments, contacts, $scope.sender_name_en, $scope.sender_name_el, $scope.test_send, $scope.test_send_email).success(function (data) {
      if (data.success) {
        $scope.sending_notification = false;
      }
    });
  };

  $scope.edit_custom_text = function () {
    _jquery2.default.fancybox((0, _jquery2.default)('div#edit_template'), {
      padding: '5',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      topRatio: 0.15,
      scrolling: 'no',
      afterShow: function afterShow() {
        $scope.$broadcast('$tinymce:refresh');
      }
    });
  };

  $scope.save_custom_text = function () {
    _jquery2.default.fancybox.close();
  };

  $scope.init = function () {
    $scope.order_id = window.order.id;
    $scope.use_buyer_contacts = window.use_buyer_contacts;
    $scope.user_id = window.use_buyer_contacts ? window.order.buyer_id : window.order.supplier_id;
    $scope.tinymceOptions = UiService.tinymceOptions();
    $scope.custom_title = '';
    $scope.custom_text = '';
    $scope.test_send = true;
    $scope.test_send_email = 'p.tsolpagas@epsilon-paper.com';
    $scope.recipient_modes = EmailService.get_recipient_modes();
    $scope.sender_names_en = EmailService.get_sender_names_en();
    $scope.sender_names_el = EmailService.get_sender_names_el();
    $scope.sender_name_en = $scope.sender_names_en[0];
    $scope.sender_name_el = $scope.sender_names_el[0];
  };

  $scope.init();
};

exports.default = OrderDocuments;


OrderDocuments.$inject = ['$scope', 'OrderService', 'UiService', 'EmailService'];

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderMainDocs = function OrderMainDocs($scope, OrderService) {
  _classCallCheck(this, OrderMainDocs);

  $scope.update_order = function () {
    $scope.updating_order = true;
    $scope.form_error = '';
    var docs = [];
    _angular2.default.forEach($scope.export_docs, function (doc) {
      if (doc.checked) docs.push(doc.id);
    });
    var order = {
      id: window.order_id,
      export_docs: {
        docs: docs
      }
    };
    OrderService.save(order).then(function (data) {
      if (!data.success) $scope.form_error = data.message;
      $scope.updating_order = false;
    });
  };

  $scope.init = function () {
    $scope.export_docs = window.export_docs;
  };

  $scope.init();
};

exports.default = OrderMainDocs;


OrderMainDocs.$inject = ['$scope', 'OrderService'];

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderMainInfos = function OrderMainInfos($scope, $filter, UserService, GeoService, OrderService, OfferService, OrderSidebarService) {
  _classCallCheck(this, OrderMainInfos);

  $scope.set_buyer_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Buyer', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.order.buyer_id = ui.item.id;
        $scope.order.buyer_user_contact_id = null;
        $scope.buyer_company = ui.item.value;
        $scope.$apply();
        $scope.update_buyer_data(ui.item.id);
      }
    });
  };

  $scope.update_buyer_data = function (user_id) {
    UserService.get_contacts(user_id).success(function (data) {
      $scope.buyer_contacts = data.contacts;
    });
  };

  $scope.set_supplier_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Seller', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.order.supplier_id = ui.item.id;
        $scope.order.supplier_user_contact_id = null;
        $scope.supplier_company = ui.item.value;
        $scope.$apply();
        $scope.update_supplier_data(ui.item.id);
      }
    });
  };

  $scope.update_supplier_data = function (user_id) {
    UserService.get_contacts(user_id).success(function (data) {
      $scope.supplier_contacts = data.contacts;
    });
    OfferService.get_offer_ids(user_id).then(function (data) {
      $scope.offer_ids = data.offer_ids;
    });
  };

  $scope.update_order = function () {
    $scope.updating_order = true;
    if (!$scope.order.supplier_id) {
      $scope.form_error = 'Please select a supplier!';
      $scope.updating_order = false;
    } else if (!$scope.order.buyer_id) {
      $scope.form_error = 'Please select a buyer!';
      $scope.updating_order = false;
    } else if (!($scope.order.pi_id || $scope.order.oc_id || $scope.order.commercial_invoice)) {
      $scope.form_error = 'Please select PI or OC or Invoice ID!';
      $scope.updating_order = false;
    } else {
      $scope.form_error = '';
      OrderService.save($scope.order).then(function (data) {
        if (!data.success) $scope.form_error = data.message;
        $scope.updating_order = false;
        OrderSidebarService.set_main_infos_data(data.main_infos_percentage);
      });
    }
  };

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.init = function () {
    $scope.order = window.order;
    $scope.supplier_company = window.supplier_company;
    $scope.buyer_company = window.buyer_company;
    $scope.update_supplier_data(window.order.supplier_id);
    $scope.update_buyer_data(window.order.buyer_id);
    $scope.set_buyer_autocomplete((0, _jquery2.default)('input.buyer_company'));
    $scope.set_supplier_autocomplete((0, _jquery2.default)('input.supplier_company'));
    $scope.order_statuses = window.order_statuses;
  };

  $scope.init();
};

exports.default = OrderMainInfos;


OrderMainInfos.$inject = ['$scope', '$filter', 'UserService', 'GeoService', 'OrderService', 'OfferService', 'OrderSidebarService'];

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderManage = function OrderManage($scope, OrderService, PaginationService, UserService, DateService) {
  _classCallCheck(this, OrderManage);

  $scope.quick_search = function () {
    window.filter_table('table#orders', $scope.query);
  };

  $scope.update_website_stats = function () {
    $scope.updating_website_stats = true;
    OrderService.update_website_stats().then(function (data) {
      if (data.success) {
        $scope.updating_website_stats = false;
      }
    });
  };

  $scope.set_supplier_company_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Seller', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.filter.supplier_id = ui.item.id;
        $scope.$apply();
      }
    });
  };

  $scope.set_buyer_company_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Buyer', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.filter.buyer_id = ui.item.id;
        $scope.$apply();
      }
    });
  };

  $scope.get_orders = function () {
    $scope.searching = true;
    OrderService.get_manage_data($scope.filter).then(function (data) {
      $scope.orders = data.orders;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
      $scope.searching = false;
    });
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.get_orders();
  };

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.issued_columns = [{
    id: 'date_issued_pi',
    title: 'PI'
  }, {
    id: 'date_issued_oc',
    title: 'OC'
  }, {
    id: 'date_issued_commercial_invoice',
    title: 'CI'
  }];

  $scope.get_status_title = function (status) {
    return _underscore2.default.find($scope.order_statuses, function (s) {
      return s.id == status;
    }).title;
  };

  $scope.get_payment_status_title = function (status) {
    return _underscore2.default.find($scope.payment_statuses, function (s) {
      return s.id == status;
    }).title;
  };

  $scope.get_delivery_status_title = function (status) {
    return _underscore2.default.find($scope.delivery_statuses, function (s) {
      return s.id == status;
    }).title;
  };

  $scope.get_need_attention = function () {
    $scope.init_filters();
    var now = new Date();
    var date_from = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 60);
    var date_to = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 21);
    $scope.filter.date_from = DateService.get_date_str(date_from);
    $scope.filter.date_to = DateService.get_date_str(date_to);
    $scope.filter.status = 0;
    $scope.filter.has_booking_notes = 'no';
    $scope.filter.sort_by = 0;
    $scope.get_orders();
  };

  $scope.get_recent_pi = function () {
    $scope.init_filters();
    var now = new Date();
    var date_from = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 60);
    $scope.filter.date_from = DateService.get_date_str(date_from);
    $scope.filter.date_to = DateService.get_date_str(now);
    $scope.filter.sort_by = 0;
    $scope.get_orders();
  };

  $scope.init_filters = function () {
    $scope.supplier_company = null;
    $scope.buyer_company = null;
    $scope.filter = {
      page: 1,
      per_page: 50,
      sort_by: null,
      sort_by_mode: 1,
      supplier_id: null,
      buyer_id: null,
      status: -1,
      delivery_status: -1,
      payment_status: -1,
      pi_id: null,
      oc_id: null,
      commercial_invoice: null,
      issued_column: 'date_issued_pi',
      date_from: null,
      date_to: null,
      has_stocklist: 'all',
      has_updated_pref: 'all',
      has_terms: 'all',
      has_booking_notes: 'all',
      buyer_country_id: null
    };
  };

  $scope.sort_by_modes = [{
    id: 0,
    title: 'ASC'
  }, {
    id: 1,
    title: 'DESC'
  }];

  $scope.init = function () {
    $scope.order_statuses = window.order_statuses;
    $scope.delivery_statuses = window.delivery_statuses;
    $scope.payment_statuses = window.payment_statuses;
    $scope.order_statuses.splice(0, 0, {
      id: -1,
      title: 'All'
    });
    $scope.delivery_statuses.splice(0, 0, {
      id: -1,
      title: 'All'
    });
    $scope.payment_statuses.splice(0, 0, {
      id: -1,
      title: 'All'
    });
    $scope.sort_by_options = window.sort_by_options;
    $scope.countries = window.countries;
    $scope.set_supplier_company_autocomplete((0, _jquery2.default)('input.supplier_company'));
    $scope.set_buyer_company_autocomplete((0, _jquery2.default)('input.buyer_company'));
    $scope.get_recent_pi();
  };

  $scope.init();
};

exports.default = OrderManage;


OrderManage.$inject = ['$scope', 'OrderService', 'PaginationService', 'UserService', 'DateService'];

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderNotifications = function OrderNotifications($scope, OrderService) {
  _classCallCheck(this, OrderNotifications);

  function load_data() {
    OrderService.get_notifications(window.order.id).success(function (data) {
      if (data.success) {
        $scope.notifications = data.notifications;
        _underscore2.default.each($scope.notifications, function (notification) {
          _underscore2.default.each(notification.attachments, function (attachment) {
            attachment.doc_type_str = _underscore2.default.findWhere($scope.doc_types, {
              id: attachment.doc_type
            }).title;
          });
        });
      }
    });
  }

  $scope.resend_notification = function (notification) {
    if (confirm('Are you sure you want to resend this notification?')) {
      notification.resending = true;
      OrderService.resend_notification(notification.id).success(function (data) {
        if (data.success) {
          notification.resending = false;
          load_data();
        }
      });
    }
  };

  $scope.init = function () {
    $scope.doc_types = window.document_types;
    load_data();
  };

  $scope.init();
};

exports.default = OrderNotifications;


OrderNotifications.$inject = ['$scope', 'OrderService'];

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderOverview = function OrderOverview($scope, OrderService) {
  _classCallCheck(this, OrderOverview);

  $scope.update_order = function () {
    $scope.updating_order = true;
    $scope.form_error = '';
    OrderService.save($scope.order).then(function (data) {
      if (!data.success) $scope.form_error = data.message;
      $scope.updating_order = false;
    });
  };

  $scope.init = function () {
    $scope.order = window.order;
    $scope.order_statuses = window.order_statuses;
    $scope.payment_statuses = window.payment_statuses;
    $scope.delivery_statuses = window.delivery_statuses;
  };

  $scope.init();
};

exports.default = OrderOverview;


OrderOverview.$inject = ['$scope', 'OrderService'];

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderPaymentGeneral = function OrderPaymentGeneral($scope, OrderService, OrderSidebarService) {
  _classCallCheck(this, OrderPaymentGeneral);

  $scope.update_order = function () {
    $scope.updating_order = true;
    $scope.form_error = '';
    OrderService.save($scope.order).then(function (data) {
      if (!data.success) $scope.form_error = data.message;
      $scope.updating_order = false;
      OrderSidebarService.set_payment_general_data(data.payment_general_percentage);
    });
  };

  $scope.init = function () {
    $scope.order = window.order;
    $scope.payment_statuses = window.payment_statuses;
  };

  $scope.init();
};

exports.default = OrderPaymentGeneral;


OrderPaymentGeneral.$inject = ['$scope', 'OrderService', 'OrderSidebarService'];

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderPayments = function OrderPayments($scope, OrderPaymentService) {
  _classCallCheck(this, OrderPayments);

  function open_dialog(dialog_id) {
    window.openFancyboxDialog('div#' + dialog_id);
  }

  function load_order_payments() {
    $scope.loading_order_payments = true;
    OrderPaymentService.get_order_payments(window.order.id).success(function (data) {
      if (data.success) {
        $scope.order_payments = data.order_payments;
        $scope.loading_order_payments = false;
      }
    });
  }

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.add_order_payment = function () {
    $scope.dialog_payment = _angular2.default.copy(window.order_payment);
    open_dialog('order_payment_dialog');
  };

  $scope.edit_order_payment = function (payment) {
    $scope.dialog_payment = payment;
    open_dialog('order_payment_dialog');
  };

  $scope.delete_order_payment = function (payment) {
    if (confirm('Are you sure you want to delete this order payment?')) {
      OrderPaymentService.delete(payment.id).success(function (data) {
        if (data.success) {
          load_order_payments();
        }
      });
    }
  };

  $scope.save_order_payment = function () {
    $scope.saving_order_payment = true;
    OrderPaymentService.save($scope.dialog_payment).success(function (data) {
      if (data.success) {
        $scope.saving_order_payment = false;
        _jquery2.default.fancybox.close();
        load_order_payments();
      }
    });
  };

  $scope.get_payment_type_title = function (payment_type) {
    if (!payment_type) return null;else return _underscore2.default.findWhere($scope.order_payment_types, {
      id: payment_type
    }).title;
  };

  $scope.get_payment_status_title = function (status) {
    if (!status) return null;else return _underscore2.default.findWhere($scope.order_payment_statuses, {
      id: status
    }).title;
  };

  $scope.init = function () {
    $scope.order_payment_types = window.order_payment_types;
    $scope.order_payment_statuses = window.order_payment_statuses;
    load_order_payments();
  };

  $scope.init();
};

exports.default = OrderPayments;


OrderPayments.$inject = ['$scope', 'OrderPaymentService'];

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderSellerDetails = function OrderSellerDetails($scope, OrderService, GeoService) {
  _classCallCheck(this, OrderSellerDetails);

  $scope.tabs = ['General', 'Bank Details'];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.$watch('seller.address.country_id', function () {
    if ($scope.seller.address.country_id) {
      GeoService.get_cities($scope.seller.address.country_id).then(function (data) {
        $scope.address_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.seller.address.city_id })) $scope.seller.address.city_id = null;
      });
    }
  });

  $scope.$watch('seller.bank.country_id', function () {
    if ($scope.seller.bank.country_id) {
      GeoService.get_cities($scope.seller.bank.country_id).then(function (data) {
        $scope.bank_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.seller.bank.city_id })) $scope.seller.bank.city_id = null;
      });
    }
  });

  $scope.get_address = function () {
    return {
      company_title: null,
      vat: null,
      address_line_1: null,
      address_line_2: null,
      post_code: null,
      country_id: null,
      city_id: null,
      email: null,
      phone: null,
      fax: null
    };
  };

  $scope.get_bank = function () {
    return {
      title: null,
      branch: null,
      address_line_1: null,
      address_line_2: null,
      post_code: null,
      country_id: null,
      city_id: null,
      email: null,
      phone: null,
      fax: null,
      account_details: null,
      contact_person: null
    };
  };

  $scope.get_seller_details = function () {
    return {
      address: $scope.get_address(),
      bank: $scope.get_bank()
    };
  };

  $scope.clear_address = function () {
    $scope.seller.address = $scope.get_address();
  };

  $scope.clear_bank = function () {
    $scope.seller.bank = $scope.get_bank();
  };

  $scope.autofill_address = function () {
    if (window.main_address) {
      $scope.seller.address.company_title = window.main_address.company_title;
      $scope.seller.address.vat = window.main_address.vat;
      $scope.seller.address.address_line_1 = window.main_address.address_line_1;
      $scope.seller.address.address_line_2 = window.main_address.address_line_2;
      $scope.seller.address.post_code = window.main_address.post_code;
      $scope.seller.address.country_id = window.main_address.country_id;
      $scope.seller.address.city_id = window.main_address.city_id;
      $scope.seller.address.email = window.main_address.email;
      $scope.seller.address.phone = window.main_address.phone;
      $scope.seller.address.fax = window.main_address.fax;
    } else {
      $scope.seller.address = $scope.get_address();
    }
  };

  $scope.autofill_bank = function () {
    if (window.trading_bank) {
      $scope.seller.bank.title = window.trading_bank.title;
      $scope.seller.bank.branch = window.trading_bank.branch;
      $scope.seller.bank.address_line_1 = window.trading_bank.address_line_1;
      $scope.seller.bank.address_line_2 = window.trading_bank.address_line_2;
      $scope.seller.bank.post_code = window.trading_bank.post_code;
      $scope.seller.bank.country_id = window.trading_bank.country_id;
      $scope.seller.bank.city_id = window.trading_bank.city_id;
      $scope.seller.bank.email = window.trading_bank.email;
      $scope.seller.bank.phone = window.trading_bank.phone;
      $scope.seller.bank.fax = window.trading_bank.fax;
      $scope.seller.bank.account_details = window.trading_bank.account_details;
      $scope.seller.bank.contact_person = window.trading_bank.contact_person;
    } else {
      $scope.seller.bank = $scope.get_bank();
    }
  };

  $scope.save = function () {
    $scope.saving = true;
    $scope.form_error = '';
    var order = {
      id: window.order_id,
      seller_details: $scope.seller
    };
    OrderService.save(order).then(function (data) {
      if (!data.success) $scope.form_error = data.message;
      $scope.saving = false;
    });
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.address_countries = _angular2.default.copy(window.countries);
    $scope.bank_countries = _angular2.default.copy(window.countries);
    $scope.seller = window.seller_details ? window.seller_details : $scope.get_seller_details();
  };

  $scope.init();
};

exports.default = OrderSellerDetails;


OrderSellerDetails.$inject = ['$scope', 'OrderService', 'GeoService'];

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderSidebar = function OrderSidebar($scope, OrderSidebarService) {
  _classCallCheck(this, OrderSidebar);

  $scope.update_stocklist_data = function (value) {
    OrderSidebarService.set_stocklist_data(value > 0);
  };

  $scope.init = function () {
    $scope.update_stocklist_data(window.order_stock_items_count);
    $scope.stocklist_data = OrderSidebarService.get_stocklist_data();

    OrderSidebarService.set_booking_notes_data(window.order_booking_notes_count > 0);
    $scope.booking_notes_data = OrderSidebarService.get_booking_notes_data();

    OrderSidebarService.set_payment_general_data(window.payment_general_percentage);
    $scope.payment_general_data = OrderSidebarService.get_payment_general_data();

    OrderSidebarService.set_delivery_general_data(window.delivery_general_percentage);
    $scope.delivery_general_data = OrderSidebarService.get_delivery_general_data();

    OrderSidebarService.set_main_infos_data(window.main_infos_percentage);
    $scope.main_infos_data = OrderSidebarService.get_main_infos_data();
  };

  $scope.init();
};

exports.default = OrderSidebar;


OrderSidebar.$inject = ['$scope', 'OrderSidebarService'];

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderStocklist = function OrderStocklist($scope, OrderService) {
  _classCallCheck(this, OrderStocklist);

  $scope.update_supplier_user_products = function (order_id, user_id) {
    $scope.updating_user_products = true;
    OrderService.update_supplier_user_products(order_id, user_id).then(function (data) {
      if (data.success) $scope.updating_user_products = false;
    });
  };

  $scope.update_buyer_user_products = function (order_id, user_id) {
    $scope.updating_user_products = true;
    OrderService.update_buyer_user_products(order_id, user_id).then(function (data) {
      if (data.success) $scope.updating_user_products = false;
    });
  };

  $scope.update_supplier_pricings = function () {
    $scope.updating_supplier_pricings = true;
    OrderService.update_supplier_pricings(window.order.id).success(function (data) {
      if (data.success) $scope.updating_supplier_pricings = false;
    });
  };

  $scope.init = function () {
    $scope.order = window.order;
  };

  $scope.init();
};

exports.default = OrderStocklist;


OrderStocklist.$inject = ['$scope', 'OrderService'];

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderUpload = function OrderUpload($scope, FileUploader) {
  _classCallCheck(this, OrderUpload);

  $scope.set_uploaders = function () {
    var uploaders = [{
      name: 'orders_uploader',
      url: '/admin/marketplace/orders/import_orders',
      element: 'orders_file'
    }, {
      name: 'items_uploader',
      url: '/admin/marketplace/orders/import_stock_items',
      element: 'items_file'
    }];
    _underscore2.default.each(uploaders, function (uploader) {
      var f = new FileUploader({
        url: uploader.url,
        formData: [{
          authenticity_token: window.token
        }],
        removeAfterUpload: true
      });
      f.file_element = uploader.element;
      f.onBeforeUploadItem = function () /*item*/{
        f.processing = true;
      };
      f.onCompleteItem = function (fileItem, response /*, status, headers*/) {
        if (response.success) {
          f.processing = false;
          f.clearQueue();
          (0, _jquery2.default)('input.' + f.file_element).val(null);
        }
      };
      $scope[uploader.name] = f;
    });
  };

  $scope.init = function () {
    $scope.set_uploaders();
  };

  $scope.init();
};

exports.default = OrderUpload;


OrderUpload.$inject = ['$scope', 'FileUploader'];

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PendingImportCheck = function PendingImportCheck($scope, UserService) {
  _classCallCheck(this, PendingImportCheck);

  $scope.similarity_tabs = UserService.get_similar_tabs();

  $scope.compare_tabs = UserService.get_similar_dialog_tabs();

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
    $scope.filtered_similar_users = $scope.get_filtered_similar_users(index);
    $scope.quick_search();
  };

  $scope.set_selected_compare_tab = function (index) {
    $scope.selected_compare_tab = index;
  };

  $scope.get_filtered_similar_users_length = function (index) {
    if (index === 0) return $scope.similar_users.length;else return $scope.get_filtered_similar_users(index).length;
  };

  $scope.get_filtered_similar_users = function (index) {
    return UserService.get_filtered_similar_users($scope.similar_users, index);
  };

  $scope.mark_as_not_similar = function () {
    $scope.similar_users.splice($scope.similar_users.indexOf($scope.compare_user), 1);
    $scope.filtered_similar_users = $scope.get_filtered_similar_users($scope.selected_tab);
    _jquery2.default.fancybox.close();
  };

  $scope.create_from_pending = function () {
    UserService.create_from_pending_import(window.pending_import.id).then(function (data) {
      if (data.success) {
        $scope.created_user_id = data.user_id;
        $scope.create_mode = false;
        $scope.form_error = data.message;
        _jquery2.default.fancybox.close();
      } else {
        $scope.form_error = data.message;
      }
    });
  };

  $scope.open_dialog = function (dialog_id) {
    window.openFancyboxDialog('div#' + dialog_id);
  };

  $scope.compare_users = function (user) {
    $scope.compare_user = user;
    $scope.open_dialog('compare_user_dialog');
  };

  $scope.set_update_mode = function (value) {
    $scope.update_mode = value;
    $scope.updating_user = '';
  };

  $scope.update_field = function (value, property) {
    $scope.updating_user = true;
    var update_data = {
      id: $scope.compare_user.id
    };

    if (property == 'email') update_data.company_email = value;else if (property == 'vat') update_data.ssn = value;else if (property == 'country_id') update_data.country_id = value;else if (property == 'city_id') update_data.city_id = value;else if (property == 'phone') update_data.phone = value;else if (property == 'fax') update_data.fax = value;

    UserService.update(update_data, null, null).then(function (data) {
      if (data.success) {
        $scope.update_error = '';
        $scope.compare_user[property] = value;
      } else {
        $scope.update_error = data.message;
      }
      $scope.updating_user = false;
    });
  };

  $scope.quick_search = function () {
    window.filter_table('table#similar_users', $scope.query);
  };

  $scope.init = function () {
    $scope.create_mode = true;
    $scope.update_mode = false;
    $scope.selected_tab = 0;
    $scope.selected_compare_tab = 0;
    $scope.similar_users = window.similar_users;
    $scope.filtered_similar_users = window.similar_users;
    $scope.user = window.pending_import.data.user;
    $scope.business_relations = window.business_relations;
  };

  $scope.init();
};

exports.default = PendingImportCheck;


PendingImportCheck.$inject = ['$scope', 'UserService'];

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PendingRegistrationCheck = function PendingRegistrationCheck($scope, UserService, UserContactService) {
  _classCallCheck(this, PendingRegistrationCheck);

  $scope.similarity_tabs = UserService.get_similar_tabs();

  $scope.compare_tabs = UserService.get_similar_dialog_tabs();

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
    $scope.filtered_similar_users = $scope.get_filtered_similar_users(index);
  };

  $scope.set_selected_compare_tab = function (index) {
    $scope.selected_compare_tab = index;
  };

  $scope.get_filtered_similar_users_length = function (index) {
    if (index == 0) return $scope.similar_users.length;else return $scope.get_filtered_similar_users(index).length;
  };

  $scope.get_filtered_similar_users = function (index) {
    return UserService.get_filtered_similar_users($scope.similar_users, index);
  };

  $scope.mark_as_not_similar = function () {
    $scope.similar_users.splice($scope.similar_users.indexOf($scope.compare_user), 1);
    $scope.filtered_similar_users = $scope.get_filtered_similar_users($scope.selected_tab);
    _jquery2.default.fancybox.close();
  };

  $scope.create_from_pending = function () {
    UserService.create_from_pending(window.pending_registration.pending_registration.id).then(function (data) {
      if (data.success) {
        $scope.created_user_id = data.user_id;
        $scope.create_mode = false;
        $scope.form_error = '';
        _jquery2.default.fancybox.close();
      } else {
        $scope.form_error = data.message;
      }
    });
  };

  $scope.open_dialog = function (dialog_id) {
    window.openFancyboxDialog('div#' + dialog_id);
  };

  $scope.compare_users = function (user) {
    $scope.compare_user = user;
    $scope.open_dialog('compare_user_dialog');
  };

  $scope.set_update_mode = function (value) {
    $scope.update_mode = value;
    $scope.updating_user = '';
  };

  $scope.update_field = function (value, property) {
    $scope.updating_user = true;
    var update_data = {
      id: $scope.compare_user.id
    };

    if (property == 'email') update_data['company_email'] = value;else if (property == 'vat') update_data['ssn'] = value;else if (property == 'country_id') update_data['country_id'] = value;else if (property == 'city_id') update_data['city_id'] = value;else if (property == 'phone') update_data['phone'] = value;else if (property == 'fax') update_data['fax'] = value;

    UserService.update(update_data, null, null).then(function (data) {
      if (data.success) {
        $scope.update_error = '';
        $scope.compare_user[property] = value;
      } else {
        $scope.update_error = data.message;
      }
      $scope.updating_user = false;
    });
  };

  $scope.add_contact_to_similar = function () {
    $scope.updating_user = true;
    var contact = $scope.user.user_contacts_attributes[0];
    contact['user_id'] = $scope.compare_user.id;
    contact['account'] = $scope.account;
    contact['account']['status'] = 'pending';
    UserContactService.save(contact).then(function (data) {
      if (data.success) {
        $scope.update_error = 'Contact added!';
      } else {
        $scope.update_error = 'Contact: ' + data.message;
      }
      if (data.account_success) {
        $scope.update_error += ', Account added!';
      } else {
        $scope.update_error += ', Account: ' + data.account_message;
      }
      $scope.updating_user = false;
    });
  };

  $scope.update_contact = function (contact) {
    $scope.updating_user = true;
    UserContactService.update_similar_contact($scope.user.user_contacts_attributes[0], $scope.account, contact.id).then(function (data) {
      if (data.success) {
        $scope.update_error = 'Contact updated!';
      } else {
        $scope.update_error = 'Contact: ' + data.message;
      }
      if (data.account_success) {
        $scope.update_error += ', Account added!';
      } else {
        $scope.update_error += ', Account: ' + data.account_message;
      }
      $scope.updating_user = false;
    });
  };

  $scope.init = function () {
    $scope.create_mode = true;
    $scope.update_mode = false;
    $scope.selected_tab = 0;
    $scope.selected_compare_tab = 0;
    $scope.similar_users = window.similar_users;
    $scope.filtered_similar_users = window.similar_users;
    $scope.user = window.pending_registration.pending_registration.data.user;
    $scope.account = window.pending_registration.pending_registration.data.account;
    $scope.business_relations = window.business_relations;
  };

  $scope.init();
};

exports.default = PendingRegistrationCheck;


PendingRegistrationCheck.$inject = ['$scope', 'UserService', 'UserContactService'];

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PendingRegistrationView = function PendingRegistrationView($scope) {
  _classCallCheck(this, PendingRegistrationView);

  $scope.tabs = ['1. Account Details', '2. Company Details', '3. Personal Details', '4. Role Details', '5. Product Categories & Groups'];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.get_department_title = function () {
    var department_id = parseInt($scope.pending_registration.data.user.user_contacts_attributes[0].department_id);
    var department = _underscore2.default.find($scope.departments, function (object) {
      return object.department.id == department_id;
    });
    if (department) return department.department.title;else return '';
  };

  $scope.get_business_types = function () {
    var user_business_types = [];
    _angular2.default.forEach($scope.pending_registration.data.user.user_business_types_attributes, function (user_business_type) {
      var business_type = _underscore2.default.find($scope.business_types, function (object) {
        return object.id == user_business_type.business_type_id;
      });
      if (business_type) user_business_types.push(business_type.title);
    });
    return user_business_types.join(', ');
  };

  $scope.get_product_categories = function () {
    var user_product_categories = [];
    _angular2.default.forEach($scope.pending_registration.data.user.user_product_categories_attributes, function (user_product_category) {
      var product_category = _underscore2.default.find($scope.product_categories, function (object) {
        return object.id == user_product_category.product_category_id;
      });
      if (product_category) {
        var user_product_groups = [];
        _angular2.default.forEach(product_category.groups, function (group) {
          var user_product_group = _underscore2.default.find($scope.pending_registration.data.user.user_product_groups_attributes, function (object) {
            return object.product_group_id == group.id;
          });
          if (user_product_group) user_product_groups.push(group.title);
        });
        user_product_categories.push({
          title: product_category.title,
          groups: user_product_groups
        });
      }
    });
    return user_product_categories;
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.business_types = window.business_types;
    $scope.product_categories = window.product_categories;
    $scope.departments = window.departments;
    $scope.pending_registration = window.pending_registration.pending_registration;
    $scope.user_product_categories = $scope.get_product_categories();
    $scope._ = _underscore2.default;
  };

  $scope.init();
};

exports.default = PendingRegistrationView;


PendingRegistrationView.$inject = ['$scope'];

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductBrands = function ProductBrands($scope, ProductService, PaginationService) {
  _classCallCheck(this, ProductBrands);

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.quick_search = function (table, query) {
    if (query) window.filter_table(table, query);
  };

  $scope.get_brands = function (filter) {
    filter.searching = true;
    ProductService.get_brand_data(filter).then(function (data) {
      if (filter.is_specified == 'yes') $scope.specified_brands = data.brands;else $scope.unspecified_brands = data.brands;
      filter.pagination = PaginationService.get_pagination(data.pagination);
      filter.searching = false;
    });
  };

  $scope.get_page_data = function (filter, page) {
    filter.page = page;
    $scope.get_brands(filter);
  };

  $scope.init_specified_filter = function () {
    $scope.specified_filter = {
      page: 1,
      per_page: 50,
      category_id: null,
      group_id: null,
      has_end_uses: 'All',
      is_specified: 'yes',
      searching: false,
      is_visible_website: false,
      has_description: 'All',
      has_short_description: 'All'
    };
  };

  $scope.init_unspecified_filter = function () {
    $scope.unspecified_filter = {
      page: 1,
      per_page: 50,
      category_id: null,
      group_id: null,
      has_end_uses: 'All',
      is_specified: 'no',
      searching: false,
      is_visible_website: false,
      has_description: 'All',
      has_short_description: 'All'
    };
  };

  $scope.init_jquery_calls = function () {
    (0, _jquery2.default)(document).on('click', 'a.delete_brand', function (e) {
      if (!confirm('Are you sure you want to delete this Brand?')) {
        e.preventDefault();
      }
    });
    (0, _jquery2.default)('a#add_brands').click(function (e) {
      e.preventDefault();
      _jquery2.default.fancybox((0, _jquery2.default)('div#add_brands_dialog'), {
        padding: '5',
        scrolling: 'no',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15
      });
    });
    window.set_product_brand_mill_autocomplete((0, _jquery2.default)('input.mill'));
    (0, _jquery2.default)('button#add_brand_row').click(function (e) {
      e.preventDefault();
      var table = (0, _jquery2.default)(this).parents('table');
      var row = table.find('tbody tr').last();
      var clone = row.clone();
      clone.find('input, select:eq(0)').each(function () {
        (0, _jquery2.default)(this).val('').attr('name', (0, _jquery2.default)(this).attr('name').replace(/\d+/, function (n) {
          return ++n;
        }));
      });
      clone.find('select:gt(0)').each(function () {
        (0, _jquery2.default)(this).val('').attr('name', (0, _jquery2.default)(this).attr('name').replace(/\d+/, function (n) {
          return ++n;
        }));
        (0, _jquery2.default)(this).find('option:gt(0)').remove();
      });
      window.set_product_brand_mill_autocomplete(clone.find('input.mill'));
      table.find('tbody').append(clone);
    });
    (0, _jquery2.default)(document).on('change', 'select.category', function () {
      window.get_groups_by_category((0, _jquery2.default)(this).parent().next().find('select'), (0, _jquery2.default)(this).val());
    });
    (0, _jquery2.default)(document).on('change', 'select.group', function () {
      window.get_products_by_group_for_select((0, _jquery2.default)(this).parent().next().find('select'), (0, _jquery2.default)(this).val());
    });
    (0, _jquery2.default)('a.match_item_brand, a.match_user_brand').click(function (e) {
      e.preventDefault();
      var dialog = (0, _jquery2.default)('#match_brand_dialog');
      var brand = _jquery2.default.trim((0, _jquery2.default)(this).parents('tr').find('td:eq(0)').html());
      dialog.find('span.source_brand').html(brand);
      if ((0, _jquery2.default)(this).hasClass('match_item_brand')) {
        dialog.find('input[name="source_item_brand"]').val(brand);
        dialog.find('input[name="source_user_brand"]').val('');
      } else {
        dialog.find('input[name="source_item_brand"]').val('');
        dialog.find('input[name="source_user_brand"]').val((0, _jquery2.default)(this).data('brand_id'));
      }
      window.openFancyboxDialog('#match_brand_dialog');
    });
    (0, _jquery2.default)('form#match_brand_form').submit(function (e) {
      if ((0, _jquery2.default)(this).find('select#brand_id').val() == '') {
        e.preventDefault();
        alert('Please select the target Brand!');
      }
    });
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.init_specified_filter();
    $scope.init_unspecified_filter();
    $scope.specified_categories = _angular2.default.copy(window.categories);
    $scope.speficied_groups = _angular2.default.copy(window.groups);
    $scope.unspecified_categories = _angular2.default.copy(window.categories);
    $scope.unspeficied_groups = _angular2.default.copy(window.groups);
    $scope.get_brands($scope.specified_filter);
    $scope.get_brands($scope.unspecified_filter);
    $scope.init_jquery_calls();
  };

  $scope.init();
};

exports.default = ProductBrands;


ProductBrands.$inject = ['$scope', 'ProductService', 'PaginationService'];

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductCategoryGroupsDialog = function ProductCategoryGroupsDialog($scope, $rootScope, ProductService) {
  _classCallCheck(this, ProductCategoryGroupsDialog);

  $scope.$on('show_product_category_groups', function (event, data) {
    $scope.categories = data.categories;
    $scope.groups = [];
    $scope.selected_category = data.categories[0];
    $scope.selected_groups = _angular2.default.copy(data.selected_groups);

    $scope.load_groups();
    window.openFancyboxDialog('div#category_groups_dialog');
  });

  $scope.$on('show_product_category_specs_groups', function (event, data) {
    $scope.categories = data.categories;
    $scope.groups = [];
    $scope.selected_category = data.categories[0];
    $scope.selected_groups = _angular2.default.copy(data.selected_groups);

    $scope.load_groups();
    window.openFancyboxDialog('div#category_specs_groups_dialog');
  });

  $scope.load_groups = function () {
    ProductService.get_groups($scope.selected_category.id).then(function (data) {
      _underscore2.default.each(data.groups, function (group) {
        var selected_group = _underscore2.default.findWhere($scope.selected_groups, {
          id: group.id
        });
        if (selected_group) {
          group.checked = true;
        }
      });
      $scope.groups = data.groups;
    });
  };

  $scope.update_groups = function (group) {
    if (group.checked) {
      var selected_group = _underscore2.default.findWhere($scope.selected_groups, {
        id: group.id
      });
      if (!selected_group) {
        $scope.selected_groups.push({
          id: group.id,
          title: group.title
        });
      }
    } else {
      $scope.selected_groups = _underscore2.default.reject($scope.selected_groups, function (selected_group) {
        return selected_group.id === group.id;
      });
    }
  };

  $scope.update_specs_groups = function (group) {
    if (group.checked) {
      var selected_group = _underscore2.default.findWhere($scope.selected_groups, {
        id: group.id
      });
      if (!selected_group) {
        $scope.selected_groups.push({
          id: group.id,
          title: group.title
        });
      }
    } else {
      $scope.selected_groups = _underscore2.default.reject($scope.selected_groups, function (selected_group) {
        return selected_group.id === group.id;
      });
    }
  };

  $scope.remove_group = function (group_id) {
    $scope.selected_groups = _underscore2.default.reject($scope.selected_groups, function (group) {
      return group.id === group_id;
    });

    var group = _underscore2.default.findWhere($scope.groups, {
      id: group_id
    });
    if (group) {
      group.checked = false;
    }
  };

  $scope.remove_specs_group = function (group_id) {
    $scope.selected_groups = _underscore2.default.reject($scope.selected_groups, function (group) {
      return group.id === group_id;
    });

    var group = _underscore2.default.findWhere($scope.groups, {
      id: group_id
    });
    if (group) {
      group.checked = false;
    }
  };

  $scope.submit = function () {
    var data = {
      groups: $scope.selected_groups
    };
    $rootScope.$broadcast('product_category_groups_update', data);
    _jquery2.default.fancybox.close();
  };

  $scope.stocklist_spec_submit = function () {
    var data = {
      groups: $scope.selected_specs_groups
    };
    $rootScope.$broadcast('product_category_specs_groups_update', data);
    _jquery2.default.fancybox.close();
  };
};

exports.default = ProductCategoryGroupsDialog;


ProductCategoryGroupsDialog.$inject = ['$scope', '$rootScope', 'ProductService'];

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductCategorySpecsGroupsDialog = function ProductCategorySpecsGroupsDialog($scope, $rootScope, ProductService) {
  _classCallCheck(this, ProductCategorySpecsGroupsDialog);

  $scope.$on('show_product_category_specs_groups', function (event, data) {
    $scope.categories = data.categories;
    $scope.groups = [];
    $scope.selected_category = data.categories[0];
    $scope.selected_groups = _angular2.default.copy(data.selected_groups);

    $scope.load_groups();
    window.openFancyboxDialog('div#category_specs_groups_dialog');
  });

  $scope.load_groups = function () {
    ProductService.get_groups($scope.selected_category.id).then(function (data) {
      _underscore2.default.each(data.groups, function (group) {
        var selected_group = _underscore2.default.findWhere($scope.selected_groups, {
          id: group.id
        });
        if (selected_group) {
          group.checked = true;
        }
      });
      $scope.groups = data.groups;
    });
  };

  $scope.update_groups = function (group) {
    if (group.checked) {
      var selected_group = _underscore2.default.findWhere($scope.selected_groups, {
        id: group.id
      });
      if (!selected_group) {
        $scope.selected_groups.push({
          id: group.id,
          title: group.title
        });
      }
    } else {
      $scope.selected_groups = _underscore2.default.reject($scope.selected_groups, function (selected_group) {
        return selected_group.id === group.id;
      });
    }
  };

  $scope.remove_group = function (group_id) {
    $scope.selected_groups = _underscore2.default.reject($scope.selected_groups, function (group) {
      return group.id === group_id;
    });

    var group = _underscore2.default.findWhere($scope.groups, {
      id: group_id
    });
    if (group) {
      group.checked = false;
    }
  };

  $scope.submit = function () {
    var data = {
      groups: $scope.selected_groups
    };
    $rootScope.$broadcast('product_category_specs_groups_update', data);
    _jquery2.default.fancybox.close();
  };
};

exports.default = ProductCategorySpecsGroupsDialog;


ProductCategorySpecsGroupsDialog.$inject = ['$scope', '$rootScope', 'ProductService'];

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductEndUsesAddDialog = function () {
  function ProductEndUsesAddDialog($scope, ProductService) {
    _classCallCheck(this, ProductEndUsesAddDialog);

    $scope.$on('show_product_end_use_add_dialog', function (event, data) {
      $scope.product_categories = data.product_categories;
      if (!$scope.product_category_id) {
        $scope.product_category_id = data.product.product_category_id;
        $scope.product_group_id = data.product.product_group_id;
      }

      $scope.product_end_uses = data.product_end_uses;

      window.openFancyboxDialog('div#product_end_use_add_dialog');
    });

    $scope.select_all_products = this.select_all_products.bind(this);
    $scope.submit = this.submit.bind(this);

    $scope.$watch('product_category_id', this.load_groups.bind(this));
    $scope.$watch('product_group_id', this.load_products.bind(this));

    this.$scope = $scope;
    this.ProductService = ProductService;
  }

  _createClass(ProductEndUsesAddDialog, [{
    key: 'load_groups',
    value: function load_groups() {
      var _this = this;

      if (!this.$scope.product_category_id) {
        return;
      }

      this.$scope.products = [];

      this.ProductService.get_groups(this.$scope.product_category_id).then(function (data) {
        _this.$scope.product_groups = data.groups;
      });
    }
  }, {
    key: 'load_products',
    value: function load_products() {
      var _this2 = this;

      if (!this.$scope.product_group_id) {
        return;
      }

      this.ProductService.get_products(this.$scope.product_group_id).then(function (data) {
        _this2.$scope.products = data.products;
      });
    }
  }, {
    key: 'select_all_products',
    value: function select_all_products() {
      _underscore2.default.each(this.$scope.products, function (product) {
        if (!product.checked) {
          product.checked = true;
        }
      });
    }
  }, {
    key: 'submit',
    value: function submit() {
      var _this3 = this;

      var end_uses = _underscore2.default.where(this.$scope.product_end_uses, { checked: true });
      if (end_uses.length === 0) {
        alert('Please select at least one end use!');
        return;
      }

      var products = _underscore2.default.where(this.$scope.products, { checked: true });
      if (products.length === 0) {
        alert('Please select at least one product!');
        return;
      }

      this.$scope.updating = true;
      this.ProductService.add_end_uses_to_products(_underscore2.default.pluck(products, 'id'), _underscore2.default.pluck(end_uses, 'id')).then(function () {
        _this3.$scope.updating = false;
      });
    }
  }]);

  return ProductEndUsesAddDialog;
}();

exports.default = ProductEndUsesAddDialog;


ProductEndUsesAddDialog.$inject = ['$scope', 'ProductService'];

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductEndUses = function () {
  function ProductEndUses($scope, ProductService) {
    _classCallCheck(this, ProductEndUses);

    $scope.selected_products = [];
    $scope.product_categories = window.product_categories;
    $scope.product_end_uses = window.product_end_uses;
    this.ProductService = ProductService;

    $scope.quick_search_end_uses = this.quick_search_end_uses.bind(this);
    $scope.select_product = this.select_product.bind(this);
    $scope.remove_selected_product = this.remove_selected_product.bind(this);
    $scope.add_product_end_uses = this.add_product_end_uses.bind(this);
    $scope.clear_selected_products = this.clear_selected_products.bind(this);
    $scope.$watch('product_category_id', this.load_groups.bind(this));
    $scope.$watch('product_group_id', this.load_products.bind(this));

    this.$scope = $scope;
  }

  _createClass(ProductEndUses, [{
    key: 'load_groups',
    value: function load_groups() {
      var _this = this;

      if (this.$scope.product_category_id) {
        this.ProductService.get_groups(this.$scope.product_category_id).then(function (data) {
          _this.$scope.product_groups = data.groups;
          if (data.groups.length > 0) {
            _this.$scope.product_group_id = data.groups[0].id;
          }
        });
      }
    }
  }, {
    key: 'load_products',
    value: function load_products() {
      var _this2 = this;

      if (this.$scope.product_group_id) {
        this.ProductService.get_products(this.$scope.product_group_id).then(function (data) {
          _this2.$scope.products = data.products;
        });
      }
    }
  }, {
    key: 'select_product',
    value: function select_product(product) {
      var products = this.$scope.selected_products;

      if (product.checked) {
        products.push(product);
      } else {
        products.splice(_underscore2.default.indexOf(products, product), 1);
      }
    }
  }, {
    key: 'remove_selected_product',
    value: function remove_selected_product(selected_product) {
      var products = this.$scope.selected_products;
      products.splice(_underscore2.default.indexOf(products, selected_product), 1);

      var product = _underscore2.default.findWhere(this.$scope.products, { id: selected_product.id });
      if (product) {
        product.checked = false;
      }
    }
  }, {
    key: 'add_product_end_uses',
    value: function add_product_end_uses() {
      var _this3 = this;

      var end_uses = _underscore2.default.where(this.$scope.product_end_uses, { checked: true });
      if (end_uses.length === 0) {
        alert('Please select at least one end use!');
        return;
      }

      this.$scope.updating_products = true;
      this.ProductService.add_end_uses_to_products(_underscore2.default.pluck(this.$scope.selected_products, 'id'), _underscore2.default.pluck(end_uses, 'id')).then(function () {
        _this3.$scope.updating_products = false;
      });
    }
  }, {
    key: 'clear_selected_products',
    value: function clear_selected_products() {
      this.$scope.selected_products = [];
      _underscore2.default.each(this.$scope.products, function (product) {
        product.checked = false;
      });
    }
  }, {
    key: 'quick_search_end_uses',
    value: function quick_search_end_uses() {
      if (this.$scope.quick_filter) {
        var regex = new RegExp(this.$scope.quick_filter, 'i');
        _underscore2.default.each(this.$scope.product_end_uses, function (end_use) {
          end_use.visible = end_use.title.search(regex) > -1;
        });

        this.$scope.search_filter = {
          visible: true
        };
      } else {
        this.$scope.search_filter = {};
      }
    }
  }]);

  return ProductEndUses;
}();

exports.default = ProductEndUses;


ProductEndUses.$inject = ['$scope', 'ProductService'];

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductEndUsesManage = function () {
  function ProductEndUsesManage($scope, $rootScope, ProductService) {
    _classCallCheck(this, ProductEndUsesManage);

    $scope.product = window.product;
    $scope.product_categories = window.product_categories;
    $scope.product_end_uses = window.product_end_uses;

    $scope.quick_search = this.quick_search.bind(this);
    $scope.update = this.update.bind(this);
    $scope.open_add_dialog = this.open_add_dialog.bind(this);

    $scope.product_category_id = $scope.product.product_category_id;
    $scope.product_group_id = $scope.product.product_group_id;

    $scope.$watch('product_category_id', this.load_groups.bind(this));
    $scope.$watch('product_group_id', this.load_products.bind(this));
    $scope.$watch('product_id', this.load_suggested_product_end_uses.bind(this));

    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.ProductService = ProductService;

    this.load_product_end_uses();
  }

  _createClass(ProductEndUsesManage, [{
    key: 'load_groups',
    value: function load_groups() {
      var _this = this;

      if (!this.$scope.product_category_id) {
        return;
      }

      this.ProductService.get_groups(this.$scope.product_category_id).then(function (data) {
        _this.$scope.product_groups = data.groups;
      });
    }
  }, {
    key: 'load_products',
    value: function load_products() {
      var _this2 = this;

      if (!this.$scope.product_group_id) {
        return;
      }

      this.ProductService.get_products(this.$scope.product_group_id).then(function (data) {
        _this2.$scope.products = data.products;

        _this2.load_suggested_group_end_uses();
      });
    }
  }, {
    key: 'load_product_end_uses',
    value: function load_product_end_uses() {
      var _this3 = this;

      if (!this.$scope.product.id) {
        return;
      }

      this.ProductService.get_product_end_uses(this.$scope.product.id).then(function (data) {
        _underscore2.default.each(data.end_uses, function (end_use) {
          var product_end_use = _underscore2.default.findWhere(_this3.$scope.product_end_uses, {
            id: end_use.id
          });
          if (product_end_use) {
            product_end_use.checked = true;
          }
        });
      });
    }
  }, {
    key: 'load_suggested_group_end_uses',
    value: function load_suggested_group_end_uses() {
      var _this4 = this;

      if (!this.$scope.product_group_id) {
        return;
      }

      this.ProductService.get_product_group_end_uses(this.$scope.product_group_id).then(function (response) {
        _this4.clear_suggested_end_uses();

        _underscore2.default.each(response.data.end_uses, function (end_use) {
          var product_end_use = _underscore2.default.findWhere(_this4.$scope.product_end_uses, {
            id: end_use
          });
          if (product_end_use) {
            product_end_use.suggested = true;
          }
        });
      });
    }
  }, {
    key: 'load_suggested_product_end_uses',
    value: function load_suggested_product_end_uses(nextProductId, prevProductId) {
      var _this5 = this;

      if (!nextProductId) {
        if (prevProductId) {
          this.load_suggested_group_end_uses();
        }

        return;
      }

      this.ProductService.get_product_end_uses(nextProductId).then(function (data) {
        _this5.clear_suggested_end_uses();

        _underscore2.default.each(data.end_uses, function (end_use) {
          var product_end_use = _underscore2.default.findWhere(_this5.$scope.product_end_uses, {
            id: end_use.id
          });
          if (product_end_use) {
            product_end_use.suggested = true;
          }
        });
      });
    }
  }, {
    key: 'clear_suggested_end_uses',
    value: function clear_suggested_end_uses() {
      _underscore2.default.each(this.$scope.product_end_uses, function (end_use) {
        if (end_use.suggested) {
          end_use.suggested = false;
        }
      });
    }
  }, {
    key: 'quick_search',
    value: function quick_search() {
      if (this.$scope.quick_filter) {
        var regex = new RegExp(this.$scope.quick_filter, 'i');
        _underscore2.default.each(this.$scope.product_end_uses, function (end_use) {
          end_use.visible = end_use.title.search(regex) > -1;
        });

        this.$scope.search_filter = {
          visible: true
        };
      } else {
        this.$scope.search_filter = {};
      }
    }
  }, {
    key: 'update',
    value: function update() {
      var _this6 = this;

      this.$scope.updating = true;
      var product_end_uses = _underscore2.default.where(this.$scope.product_end_uses, {
        checked: true
      });
      product_end_uses = _underscore2.default.pluck(product_end_uses, 'id');
      this.ProductService.update_product_end_uses(this.$scope.product.id, product_end_uses).then(function () {
        _this6.$scope.updating = false;
      });
    }
  }, {
    key: 'open_add_dialog',
    value: function open_add_dialog() {
      var product_end_uses = _underscore2.default.where(this.$scope.product_end_uses, {
        checked: true
      });

      var data = {
        product_categories: this.$scope.product_categories,
        product_end_uses: _angular2.default.copy(product_end_uses),
        product: this.$scope.product
      };

      this.$rootScope.$broadcast('show_product_end_use_add_dialog', data);
    }
  }]);

  return ProductEndUsesManage;
}();

exports.default = ProductEndUsesManage;


ProductEndUsesManage.$inject = ['$scope', '$rootScope', 'ProductService'];

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductEndUses = function ProductEndUses($scope, ProductEndUseService) {
  _classCallCheck(this, ProductEndUses);

  $scope.product_end_uses = window.product_end_uses;

  $scope.update = function (end_use) {
    end_use.updating = true;
    ProductEndUseService.update(end_use).then(function () {
      end_use.updating = false;
      end_use.edit_mode = false;
      end_use.title = end_use.new_title;
    });
  };

  $scope.delete = function (end_use, hide_confirmation) {
    if (!hide_confirmation && !confirm('Are you sure you want to delete this end use?')) {
      return;
    }

    end_use.deleting = true;
    ProductEndUseService.delete(end_use.id).then(function () {
      $scope.product_end_uses.splice(_underscore2.default.indexOf($scope.product_end_uses, end_use), 1);
      end_use.deleting = false;
    });
  };

  $scope.add = function () {
    ProductEndUseService.add($scope.add_end_uses).then(function (res) {
      $scope.product_end_uses = $scope.product_end_uses.concat(res.data.end_uses);
      $scope.add_end_uses = null;
    });
  };

  $scope.mass_delete = function () {

    var end_uses = _underscore2.default.where($scope.product_end_uses, {
      checked: true
    });
    if (end_uses.length === 0) {
      alert('Please select at least one end use!');
      return false;
    } else {
      if (!confirm('Are you sure you want to delete the selected end uses?')) {
        return;
      }
    }

    _underscore2.default.each(end_uses, function (end_use) {
      $scope.delete(end_use, true);
    });
  };

  $scope.quick_search_end_uses = function () {
    if ($scope.quick_filter) {
      var regex = new RegExp($scope.quick_filter, 'i');
      _underscore2.default.each($scope.product_end_uses, function (end_use) {
        end_use.visible = end_use.title.search(regex) > -1;
      });

      $scope.search_filter = {
        visible: true
      };
    } else {
      $scope.search_filter = {};
    }
  };

  $scope.check_end_uses = function () {
    _underscore2.default.each($scope.product_end_uses, function (end_use) {
      end_use.checked = $scope.select_all;
    });
  };
};

exports.default = ProductEndUses;


ProductEndUses.$inject = ['$scope', 'ProductEndUseService'];

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductExport = function ProductExport($scope, $timeout) {
  _classCallCheck(this, ProductExport);

  $scope.export = function (mode) {
    $timeout(function () {
      (0, _jquery2.default)('form#getXLS input[name="mode"]').val(mode);
      (0, _jquery2.default)('form#getXLS').submit();
    }, 300);
  };
};

exports.default = ProductExport;


ProductExport.$inject = ['$scope', '$timeout'];

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductGroupSpecRanges = function ProductGroupSpecRanges($scope, ProductService) {
  _classCallCheck(this, ProductGroupSpecRanges);

  $scope.tabs = [{
    title: 'Groups with Ranges',
    groups: []
  }, {
    title: 'Groups without Ranges',
    groups: []
  }];

  $scope.dialog_tabs = [{
    title: 'Reels',
    ranges: []
  }, {
    title: 'Sheets',
    ranges: []
  }];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.set_selected_dialog_tab = function (index) {
    $scope.selected_dialog_tab = index;
  };

  $scope.load_groups = function () {
    $scope.loading = true;
    ProductService.get_groups_with_ranges().success(function (data) {
      _underscore2.default.each(data.groups, function (group) {
        var index = group.reel_ranges.length > 0 || group.sheet_ranges.length > 0 ? 0 : 1;
        $scope.tabs[index].groups.push(group);
      });
      $scope.loading = false;
    });
  };

  $scope.show_ranges = function (group) {
    $scope.dialog_group = group;
    $scope.dialog_tabs[0].ranges = group.reel_ranges;
    $scope.dialog_tabs[1].ranges = group.sheet_ranges;
    _jquery2.default.fancybox((0, _jquery2.default)('div#ranges'), {
      padding: '5',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      topRatio: 0.15,
      scrolling: 'no'
    });
  };

  $scope.add_reel_range = function () {
    $scope.dialog_group.reel_ranges.push($scope.get_reel_range());
  };

  $scope.get_reel_range = function () {
    return {
      id: null,
      substance_min: 0,
      substance_max: 0,
      rw_min: 0,
      rw_max: 0
    };
  };

  $scope.delete_reel_range = function (range) {
    $scope.dialog_group.reel_ranges.splice(_underscore2.default.indexOf($scope.dialog_group.reel_ranges, range), 1);
  };

  $scope.add_sheet_range = function () {
    $scope.dialog_group.sheet_ranges.push($scope.get_sheet_range());
  };

  $scope.get_sheet_range = function () {
    return {
      id: null,
      substance_min: 0,
      substance_max: 0
    };
  };

  $scope.delete_sheet_range = function (range) {
    $scope.dialog_group.sheet_ranges.splice(_underscore2.default.indexOf($scope.dialog_group.sheet_ranges, range), 1);
  };

  $scope.save_ranges = function () {
    $scope.saving_ranges = true;
    ProductService.update_group_ranges($scope.dialog_group).success(function (data) {
      if (data.success) {
        $scope.dialog_group.reel_ranges = data.reel_ranges;
        $scope.dialog_group.sheet_ranges = data.sheet_ranges;
        _underscore2.default.each($scope.tabs, function (tab) {
          var group = _underscore2.default.findWhere(tab.groups, {
            id: data.id
          });
          if (group) tab.groups.splice(_underscore2.default.indexOf(tab.groups, group), 1);
        });
        if (data.reel_ranges.length === 0 && data.sheet_ranges.length === 0) {
          $scope.tabs[1].groups.push($scope.dialog_group);
        } else {
          $scope.tabs[0].groups.push($scope.dialog_group);
        }
        $scope.saving_ranges = false;
        _jquery2.default.fancybox.close();
      }
    });
  };

  $scope.update_supplier_pricings = function (product_group) {
    product_group.updating_supplier_pricings = true;
    ProductService.update_range_supplier_pricings(product_group.id).success(function (data) {
      if (data.success) product_group.updating_supplier_pricings = false;
    });
  };

  $scope.update_buyer_pricings = function (product_group) {
    product_group.updating_buyer_pricings = true;
    ProductService.update_range_buyer_pricings(product_group.id).success(function (data) {
      if (data.success) product_group.updating_buyer_pricings = false;
    });
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.selected_dialog_tab = 0;
    $scope.load_groups();
  };

  $scope.init();
};

exports.default = ProductGroupSpecRanges;


ProductGroupSpecRanges.$inject = ['$scope', 'ProductService'];

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductGroupSpecsDialog = function ProductGroupSpecsDialog($scope, $rootScope, ProductService, UserProductService) {
  _classCallCheck(this, ProductGroupSpecsDialog);

  $scope.tabs = ['Reels Specs', 'Sheets Specs'];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.$on('open_product_group_specs_dialog', function (event, args) {
    $scope.product_group_id = args.product_group_id;
    $scope.load_specs(true);
  });

  $scope.load_specs = function (open_dialog) {
    ProductService.get_product_group_specs($scope.product_group_id, null).success(function (data) {
      $scope.specs = data.specs;
      if (open_dialog) $scope.open_dialog();
    });
  };

  $scope.set_edit_mode = function (index) {
    $scope.edit_modes[index].enabled = true;
    ProductService.get_product_group_specs($scope.product_group_id, $scope.edit_modes[index].filter).success(function (data) {
      $scope.edit_modes[index].specs = data.specs;
      if (data.specs.length === 0) $scope.add_spec(index);
    });
  };

  $scope.set_update_mode = function (index) {
    $scope.edit_modes[index].enabled = false;
    ProductService.update_product_group_specs($scope.product_group_id, $scope.edit_modes[index].specs).success(function (data) {
      if (data.success) {
        $scope.edit_modes[index].specs = [];
        $scope.load_specs(false);
      }
    });
  };

  $scope.add_spec = function (index) {
    var filter = $scope.edit_modes[index].filter;
    var spec = {
      id: null,
      is_reels: filter.is_reels,
      spec_type: filter.spec_type,
      is_accurate: filter.is_accurate
    };
    if (spec.is_accurate == 1) {
      spec.value = 0;
    } else {
      spec.value_min = 0;
      spec.value_max = 0;
    }
    $scope.edit_modes[index].specs.push(spec);
  };

  $scope.show_suggested = function (is_reels) {
    if (is_reels) {
      $scope.suggested_reels = [];
      $scope.loading_suggested_reels = true;
    } else {
      $scope.suggested_sheets = [];
      $scope.loading_suggested_sheets = true;
    }
    UserProductService.get_product_group_specs($scope.product_group_id, is_reels).success(function (data) {
      if (is_reels) {
        $scope.suggested_reels = data.specs;
        $scope.loading_suggested_reels = false;
      } else {
        $scope.suggested_sheets = data.specs;
        $scope.loading_suggested_sheets = false;
      }
    });
  };

  $scope.add_suggested = function (is_reels) {
    var specs = null;
    if (is_reels) specs = _underscore2.default.where($scope.suggested_reels, {
      checked: true
    });else specs = _underscore2.default.where($scope.suggested_sheets, {
      checked: true
    });

    if (specs.length === 0) {
      alert('Please select at least one spec!');
    } else {
      var edit_mode = _underscore2.default.find($scope.edit_modes, function (m) {
        return m.filter.is_reels === is_reels & m.filter.spec_type === specs[0].spec_type && m.filter.is_accurate === specs[0].is_accurate;
      });
      edit_mode.enabled = true;
      _underscore2.default.each(specs, function (s) {
        var spec = {
          id: null,
          is_reels: is_reels,
          spec_type: s.spec_type,
          is_accurate: s.is_accurate,
          value: s.value,
          value_min: s.value_min,
          value_max: s.value_max
        };
        edit_mode.specs.push(spec);
      });
    }
  };

  $scope.open_dialog = function () {
    _jquery2.default.fancybox((0, _jquery2.default)('div#product_group_specs_dialog'), {
      padding: '5',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      topRatio: 0.15,
      scrolling: 'yes',
      afterClose: function afterClose() {
        $rootScope.$broadcast('load_product_group_specs');
      }
    });
  };

  $scope.init_edit_modes = function () {
    $scope.edit_modes = [{
      enabled: false,
      specs: [],
      filter: {
        is_reels: true,
        is_accurate: true,
        spec_type: 1
      }
    }, {
      enabled: false,
      specs: [],
      filter: {
        is_reels: true,
        is_accurate: false,
        spec_type: 1
      }
    }, {
      enabled: false,
      specs: [],
      filter: {
        is_reels: true,
        is_accurate: true,
        spec_type: 2
      }
    }, {
      enabled: false,
      specs: [],
      filter: {
        is_reels: true,
        is_accurate: false,
        spec_type: 2
      }
    }, {
      enabled: false,
      specs: [],
      filter: {
        is_reels: true,
        is_accurate: false,
        spec_type: 3
      }
    }, {
      enabled: false,
      specs: [],
      filter: {
        is_reels: true,
        is_accurate: false,
        spec_type: 4
      }
    }, {
      enabled: false,
      specs: [],
      filter: {
        is_reels: false,
        is_accurate: true,
        spec_type: 1
      }
    }, {
      enabled: false,
      specs: [],
      filter: {
        is_reels: false,
        is_accurate: false,
        spec_type: 1
      }
    }, {
      enabled: false,
      specs: [],
      filter: {
        is_reels: false,
        is_accurate: false,
        spec_type: 5
      }
    }];
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.reels_substance_mode = 'both';
    $scope.reels_rw_mode = 'both';
    $scope.sheets_substance_mode = 'both';
    $scope.init_edit_modes();
  };

  $scope.init();
};

exports.default = ProductGroupSpecsDialog;


ProductGroupSpecsDialog.$inject = ['$scope', '$rootScope', 'ProductService', 'UserProductService'];

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductGroupSpecs = function ProductGroupSpecs($scope, $rootScope, ProductService) {
  _classCallCheck(this, ProductGroupSpecs);

  $scope.tabs = [{
    title: 'Groups with Specs',
    groups: []
  }, {
    title: 'Groups without Specs',
    groups: []
  }];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  function load_groups() {
    $scope.tabs[0].groups = [];
    $scope.tabs[1].groups = [];
    $scope.loading = true;
    ProductService.get_groups_with_specs().success(function (data) {
      _underscore2.default.each(data.groups, function (group) {
        var index = group.specs.length > 0 ? 0 : 1;
        $scope.tabs[index].groups.push(group);
      });
      $scope.loading = false;
    });
  }

  $scope.show_specs = function (group) {
    $rootScope.$broadcast('open_product_group_specs_dialog', {
      product_group_id: group.id
    });
  };

  $scope.$on('load_product_group_specs', function () /*event, args*/{
    load_groups();
  });

  $scope.init = function () {
    $scope.selected_tab = 0;
    load_groups();
  };

  $scope.init();
};

exports.default = ProductGroupSpecs;


ProductGroupSpecs.$inject = ['$scope', '$rootScope', 'ProductService'];

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductGroups = function ProductGroups($scope, ProductService, PaginationService) {
  _classCallCheck(this, ProductGroups);

  $scope.quick_search = function () {
    window.filter_table('table#groups', $scope.query);
  };

  $scope.get_groups = function () {
    $scope.searching = true;
    ProductService.get_group_data($scope.filter).then(function (data) {
      $scope.groups = data.groups;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
      $scope.searching = false;
    });
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.get_groups();
  };

  $scope.init_filter = function () {
    $scope.filter = {
      page: 1,
      per_page: 50,
      category_id: null,
      has_products: 'All',
      properties: 'All',
      is_website_visible: false,
      has_description: 'All',
      has_meta_tags: 'All',
      has_usp_vp: 'All'
    };
  };

  $scope.categories = window.categories;
  $scope.init_filter();
  $scope.get_groups();
};

exports.default = ProductGroups;


ProductGroups.$inject = ['$scope', 'ProductService', 'PaginationService'];

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductImport = function ProductImport($scope, $timeout, FileUploader) {
  _classCallCheck(this, ProductImport);

  $scope.set_uploaders = function () {
    var uploaders = [{
      name: 'items_uploader',
      url: '/admin/marketplace/products/import_unspecified_items',
      element: 'items_file'
    }, {
      name: 'stocklist_uploader',
      url: '/admin/marketplace/products/import_stocklist',
      element: 'stocklist_file'
    }, {
      name: 'stocklist_merge_uploader',
      url: '/admin/marketplace/products/import_stocklist_merge',
      element: 'stocklist_merge_file'
    }, {
      name: 'user_products_uploader',
      url: '/admin/marketplace/products/import_user_products',
      element: 'user_products_file'
    }];
    _underscore2.default.each(uploaders, function (uploader) {
      var f = new FileUploader({
        url: uploader.url,
        formData: [{
          authenticity_token: window.token
        }],
        removeAfterUpload: true
      });
      f.file_element = uploader.element;
      f.onBeforeUploadItem = function () /*item*/{
        f.processing = true;
      };
      f.onCompleteItem = function (fileItem, response /*, status, headers*/) {
        if (response.success) {
          f.processing = false;
          f.clearQueue();
          (0, _jquery2.default)('input.' + f.file_element).val(null);
        }
        if (response.items) {
          if (f.file_element == 'stocklist_file') {
            $timeout(function () {
              (0, _jquery2.default)('form#getItemsXLS input[name="items"]').val(JSON.stringify(response.items));
              (0, _jquery2.default)('form#getItemsXLS').submit();
            }, 300);
          } else if (f.file_element == 'stocklist_merge_file') {
            $timeout(function () {
              (0, _jquery2.default)('form#getMergedItemsXLS input[name="columns"]').val(JSON.stringify({
                columns: response.columns
              }));
              (0, _jquery2.default)('form#getMergedItemsXLS input[name="items"]').val(JSON.stringify(response.items));
              (0, _jquery2.default)('form#getMergedItemsXLS').submit();
            }, 300);
          } else {
            $timeout(function () {
              (0, _jquery2.default)('form#getUserProductsXLS input[name="items"]').val(JSON.stringify(response.items));
              (0, _jquery2.default)('form#getUserProductsXLS').submit();
            }, 300);
          }
        }
      };
      $scope[uploader.name] = f;
    });
  };

  $scope.init = function () {
    $scope.set_uploaders();
  };

  $scope.init();
};

exports.default = ProductImport;


ProductImport.$inject = ['$scope', '$timeout', 'FileUploader'];

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductPriceGroup = function ProductPriceGroup($scope, ProductService) {
  _classCallCheck(this, ProductPriceGroup);

  $scope.load_data = function () {
    $scope.loading = true;
    ProductService.get_price_group_members(window.price_group.id).then(function (response) {
      $scope.products = response.data.products;
      return ProductService.get_products_for_price_groups(window.price_group.product_group_id);
    }).then(function (data) {
      var diff = _underscore2.default.difference(_underscore2.default.pluck(data.products, 'id'), _underscore2.default.pluck($scope.products, 'id'));
      $scope.all_products = _underscore2.default.filter(data.products, function (p) {
        return diff.indexOf(p.id) >= 0;
      });
      $scope.selected_product = null;
      $scope.loading = false;
    });
  };

  $scope.add_product = function () {
    $scope.adding = true;
    ProductService.add_price_group_member(window.price_group.id, $scope.selected_product.id).success(function (data) {
      if (data.success) {
        $scope.load_data();
        $scope.adding = false;
      }
    });
  };

  $scope.remove_product = function (product) {
    ProductService.remove_price_group_member(window.price_group.id, product.id).success(function (data) {
      if (data.success) $scope.load_data();
    });
  };

  $scope.update_title = function () {
    $scope.updating = true;
    ProductService.update_price_group_title(window.price_group.id, $scope.updated_title).success(function (data) {
      if (data.success) {
        $scope.price_group.title = $scope.updated_title;
        $scope.updated_title = null;
        $scope.updating = false;
      }
    });
  };

  $scope.init = function () {
    $scope.price_group = window.price_group;
    $scope.load_data();
  };

  $scope.init();
};

exports.default = ProductPriceGroup;


ProductPriceGroup.$inject = ['$scope', 'ProductService'];

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductPriceGroups = function ProductPriceGroups($scope, ProductService, PaginationService) {
  _classCallCheck(this, ProductPriceGroups);

  $scope.load_data = function () {
    $scope.loading = true;
    ProductService.get_price_groups($scope.filter).success(function (data) {
      $scope.price_groups = data.price_groups;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
      $scope.loading = false;
    });
  };

  $scope.load_groups = function () {
    ProductService.get_all_groups().success(function (data) {
      $scope.groups = data.groups;
    });
  };

  $scope.init_filters = function () {
    $scope.filter = {
      page: 1,
      per_page: 100,
      product_group_id: null,
      product_id: null
    };
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.load_data();
  };

  $scope.create_group = function () {
    $scope.creating = true;
    ProductService.create_price_group($scope.selected_group.id, $scope.group_title).success(function (data) {
      if (data.success) {
        $scope.group_title = null;
        $scope.show_create_group = false;
        $scope.load_data();
      }
    });
  };

  $scope.update_supplier_pricings = function (price_group) {
    price_group.updating_supplier_pricings = true;
    ProductService.update_price_group_supplier_pricings(price_group.id).success(function (data) {
      if (data.success) price_group.updating_supplier_pricings = false;
    });
  };

  $scope.update_buyer_pricings = function (price_group) {
    price_group.updating_buyer_pricings = true;
    ProductService.update_price_group_buyer_pricings(price_group.id).success(function (data) {
      if (data.success) price_group.updating_buyer_pricings = false;
    });
  };

  $scope.delete_price_group = function (price_group) {
    if (confirm('Are you sure you want to delete this price group and all related members and prices?')) {
      price_group.deleting = true;
      ProductService.delete_price_group(price_group.id).success(function () /*data*/{
        price_group.deleting = false;
        $scope.load_data();
      });
    }
  };

  $scope.quick_search = function () {
    window.filter_table('table.data', $scope.quick_filter);
  };

  $scope.$watch('filter.product_group_id', function () {
    if ($scope.filter && $scope.filter.product_group_id) {
      ProductService.get_products($scope.filter.product_group_id).then(function (data) {
        $scope.products = data.products;
      });
    } else {
      $scope.products = [];
    }
  });

  $scope.init = function () {
    $scope.price_groups = [];
    $scope.pagination = {};
    $scope.init_filters();
    $scope.load_data();
    $scope.load_groups();
  };

  $scope.init();
};

exports.default = ProductPriceGroups;


ProductPriceGroups.$inject = ['$scope', 'ProductService', 'PaginationService'];

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StocklistSpecsEdit = function StocklistSpecsEdit($scope, $rootScope, ProductService) {
  _classCallCheck(this, StocklistSpecsEdit);

  function set_product_autocomplete(input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        ProductService.search_products_by_title(request.term).then(function (data) {
          response(data.products);
        });
      },
      select: function select(event, ui) {
        if (!_underscore2.default.findWhere($scope.spec.epaper_products, { id: ui.item.id })) $scope.spec.epaper_products.push({
          id: ui.item.id,
          title: ui.item.value
        });
        (0, _jquery2.default)(this).val('');
        $scope.$apply();
        return false;
      }
    });
  }

  function set_product_group_autocomplete(input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        ProductService.search_product_groups_by_title(request.term).then(function (data) {
          response(data.groups);
        });
      },
      select: function select(event, ui) {
        if (!_underscore2.default.findWhere($scope.spec.groups, { id: ui.item.id })) $scope.spec.groups.push({
          id: ui.item.id,
          title: ui.item.value
        });
        (0, _jquery2.default)(this).val('');
        $scope.$apply();
        return false;
      }
    });
  }

  $scope.add_product_name = function () {
    if (!_underscore2.default.contains($scope.spec.product_names, $scope.product_name)) {
      $scope.spec.product_names.push($scope.product_name);
    }
    $scope.product_name = null;
  };

  $scope.remove_product_name = function (product_name) {
    $scope.spec.product_names = _underscore2.default.reject($scope.spec.product_names, function (name) {
      return name == product_name;
    });
  };

  $scope.open_dialog = function (dialog_id) {
    if ($scope.filter.supplier_id && $scope.filter.date_from && $scope.filter.date_to || window.offer) {
      $scope.load_dialog_products();
      _jquery2.default.fancybox((0, _jquery2.default)('div#' + dialog_id), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        scrolling: 'yes'
      });
    } else {
      alert('Please select a supplier and date period!');
    }
  };

  $scope.load_dialog_products = function () {
    $scope.dialog_products = [];
    $scope.dialog_products_checked = false;
    $scope.loading_dialog_products = true;
    ProductService.search_products_by_filter($scope.filter).then(function (data) {
      if (data.success) $scope.dialog_products = data.products;
      $scope.loading_dialog_products = false;
    });
  };

  $scope.check_dialog_products = function () {
    _angular2.default.forEach($scope.dialog_products, function (product) {
      product.checked = $scope.dialog_products_checked;
    });
  };

  $scope.add_selected_products = function () {
    var products = _underscore2.default.select($scope.dialog_products, function (p) {
      return p.checked === true;
    });
    if (products.length === 0) {
      alert('Please select at least one product!');
    } else {
      _angular2.default.forEach(products, function (product) {
        if (!_underscore2.default.findWhere($scope.spec.epaper_products, { id: product.id })) $scope.spec.epaper_products.push({
          id: product.id,
          title: product.name
        });
      });
      _jquery2.default.fancybox.close();
    }
  };

  $scope.remove_epaper_product = function (product_id) {
    $scope.spec.epaper_products = _underscore2.default.reject($scope.spec.epaper_products, function (product) {
      return product.id == product_id;
    });
    (0, _jquery2.default)('input.epaper_product').val('');
  };

  $scope.dialog_quick_search = function () {
    window.filter_table('table#dialog_products', $scope.dialog_query);
  };

  $scope.roundQuantity = function (quantity) {
    return window.roundToTwo(quantity);
  };

  $scope.$watch('categories', function () {
    if (!$scope.categories_clone) {
      $scope.categories_clone = _angular2.default.copy($scope.categories);
      set_categories();
    }
  });

  function set_categories() {
    _underscore2.default.each($scope.spec.categories, function (category_id) {
      var category = _underscore2.default.findWhere($scope.categories_clone, {
        id: category_id
      });
      if (category) {
        category.checked = true;
      }
    });
  }

  $scope.update_categories = function (category) {
    if (category.checked) {
      if (!_underscore2.default.contains($scope.spec.categories, category.id)) {
        $scope.spec.categories.push(category.id);
      }
    } else {
      $scope.spec.categories = _underscore2.default.without($scope.spec.categories, category.id);
    }
  };

  $scope.open_group_dialog = function () {
    var data = {
      categories: $scope.categories_clone,
      selected_groups: $scope.spec.groups
    };

    $rootScope.$broadcast('show_product_category_specs_groups', data);
  };

  $scope.$on('product_category_specs_groups_update', function (event, data) {
    $scope.spec.groups = data.groups;
    console.log(data.groups);
  });

  $scope.remove_group = function (group_id) {
    $scope.spec.groups = _underscore2.default.reject($scope.spec.groups, function (group) {
      return group.id == group_id;
    });
    (0, _jquery2.default)('input.group').val('');
  };

  $scope.add_item_specs = function () {
    $scope.spec.item_specs.push({});
  };

  $scope.delete_item_spec = function (item_spec) {
    $scope.spec.item_specs.splice(_underscore2.default.indexOf($scope.spec.item_specs, item_spec), 1);
  };

  $scope.init = function () {
    if (!$scope.spec.product_names) {
      $scope.spec.product_names = [];
    }

    if (!$scope.spec.epaper_products) {
      $scope.spec.epaper_products = [];
    }

    if (!$scope.spec.categories) {
      $scope.spec.categories = [];
    }

    if (!$scope.spec.groups) {
      $scope.spec.groups = [];
    }

    if (!$scope.spec.item_specs) {
      $scope.spec.item_specs = [];
    }

    if (!$scope.categories_clone && $scope.categories && $scope.categories.length > 0) {
      $scope.categories_clone = _angular2.default.copy($scope.categories);
      set_categories();
    }

    set_product_autocomplete((0, _jquery2.default)('input.epaper_product'));
    set_product_group_autocomplete((0, _jquery2.default)('input.group'));
  };

  $scope.init();
};

exports.default = StocklistSpecsEdit;


StocklistSpecsEdit.$inject = ['$scope', '$rootScope', 'ProductService'];

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StocklistSpecs = function StocklistSpecs($scope, ProductService) {
  _classCallCheck(this, StocklistSpecs);

  function load_categories() {
    $scope.categories = [];
    ProductService.get_categories().then(function (response) {
      $scope.categories = response.data.categories;
    });
  }

  $scope.get_category = function (category_id) {
    var category = _underscore2.default.findWhere($scope.categories, category_id);
    if (category) {
      return category.title;
    } else {
      return null;
    }
  };

  $scope.add = function () {
    if (!$scope.filter.specs) {
      $scope.filter.specs = [];
    }

    var spec = {
      stock_type: 'reels',
      edit: true
    };
    $scope.filter.specs.push(spec);
  };

  $scope.save = function (spec) {
    delete spec.edit;
  };

  $scope.edit = function (spec) {
    spec.edit = true;
  };

  $scope.delete = function (spec) {
    if (confirm('Are you sure you want to delete these specs?')) {
      $scope.filter.specs.splice(_underscore2.default.indexOf($scope.filter.specs, spec), 1);
    }
  };

  $scope.get_spec_partial = function (spec) {
    if (spec.edit) {
      return 'spec_edit.html';
    } else {
      return 'spec_view.html';
    }
  };

  $scope.init = function () {
    load_categories();
  };

  $scope.init();
};

exports.default = StocklistSpecs;


StocklistSpecs.$inject = ['$scope', 'ProductService'];

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SupplierProductPricings = function SupplierProductPricings($scope, UserService) {
  _classCallCheck(this, SupplierProductPricings);

  $scope.tabs = [{
    title: 'Products',
    items: []
  }, {
    title: 'Price Groups',
    items: []
  }];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.load_data = function () {
    $scope.loading = true;
    UserService.get_supplier_product_pricings(window.user_id).success(function (data) {
      if (data.success) {
        $scope.set_products(data.product_prices);
        $scope.set_price_groups(data.price_group_prices);
        $scope.loading = false;
      }
    });
  };

  $scope.set_products = function (product_prices) {
    var products = _underscore2.default.groupBy(product_prices, 'product_id');
    var supplier_products = [];
    _underscore2.default.each(products, function (product) {
      var prices = _underscore2.default.values(product);

      var offer_prices = _underscore2.default.pluck(prices, 'offer_fca');
      var offer_fca_min = _underscore2.default.min(offer_prices);
      var offer_fca_max = _underscore2.default.max(offer_prices);

      var most_recent_offer_price = _underscore2.default.max(prices, function (price) {
        return price.offer_date_int;
      });

      var order_prices = _underscore2.default.pluck(prices, 'order_fca');
      var order_fca_min = _underscore2.default.min(order_prices);
      var order_fca_max = _underscore2.default.max(order_prices);

      var most_recent_order_price = _underscore2.default.max(prices, function (price) {
        return price.order_date_int;
      });

      var supplier_product = {
        id: prices[0].id,
        product_id: prices[0].product_id,
        epaper_title: prices[0].epaper_title,
        product_group: prices[0].product_group,
        offer: {
          id: most_recent_offer_price.offer_id,
          date: most_recent_offer_price.offer_date,
          fca_min: offer_fca_min,
          fca_max: offer_fca_max
        },
        order: {
          id: most_recent_order_price.order_id,
          date: most_recent_order_price.order_date,
          fca_min: order_fca_min,
          fca_max: order_fca_max
        },
        prices: []
      };

      _underscore2.default.each(prices, function (price) {
        supplier_product.prices.push({
          range: price.range,
          offer_fca: price.offer_fca,
          offer_id: price.offer_id,
          offer_date: price.offer_date,
          order_fca: price.order_fca,
          order_charge: price.order_charge,
          order_id: price.order_id,
          order_date: price.order_date
        });
      });

      supplier_products.push(supplier_product);
    });
    $scope.tabs[0].items = supplier_products;
  };

  $scope.set_price_groups = function (price_group_prices) {
    var price_groups = _underscore2.default.groupBy(price_group_prices, 'price_group_id');
    var supplier_price_groups = [];
    _underscore2.default.each(price_groups, function (price_group) {
      var prices = _underscore2.default.values(price_group);

      var offer_prices = _underscore2.default.pluck(prices, 'offer_fca');
      var offer_fca_min = _underscore2.default.min(offer_prices);
      var offer_fca_max = _underscore2.default.max(offer_prices);

      var most_recent_offer_price = _underscore2.default.max(prices, function (price) {
        return price.offer_date_int;
      });

      var order_prices = _underscore2.default.pluck(prices, 'order_fca');
      var order_fca_min = _underscore2.default.min(order_prices);
      var order_fca_max = _underscore2.default.max(order_prices);

      var most_recent_order_price = _underscore2.default.max(prices, function (price) {
        return price.order_date_int;
      });

      var supplier_price_group = {
        id: prices[0].id,
        price_group: prices[0].price_group,
        price_group_id: prices[0].price_group_id,
        product_group: prices[0].product_group,
        offer: {
          id: most_recent_offer_price.offer_id,
          date: most_recent_offer_price.offer_date,
          fca_min: offer_fca_min,
          fca_max: offer_fca_max
        },
        order: {
          id: most_recent_order_price.order_id,
          date: most_recent_order_price.order_date,
          fca_min: order_fca_min,
          fca_max: order_fca_max
        },
        prices: []
      };

      _underscore2.default.each(prices, function (price) {
        supplier_price_group.prices.push({
          range: price.range,
          offer_fca: price.offer_fca,
          offer_id: price.offer_id,
          offer_date: price.offer_date,
          order_fca: price.order_fca,
          order_charge: price.order_charge,
          order_id: price.order_id,
          order_date: price.order_date
        });
      });

      supplier_price_groups.push(supplier_price_group);
    });
    $scope.tabs[1].items = supplier_price_groups;
  };

  $scope.update_pricings = function () {
    $scope.updating_pricings = true;
    UserService.update_supplier_pricings(window.user_id).success(function (data) {
      if (data.success) {
        $scope.updating_pricings = false;
        $scope.load_data();
      }
    });
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.load_data();
  };

  $scope.init();
};

exports.default = SupplierProductPricings;


SupplierProductPricings.$inject = ['$scope', 'UserService'];

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserAcceptablePaymentTerms = function UserAcceptablePaymentTerms($scope, $rootScope, UserAcceptablePaymentTermService) {
  _classCallCheck(this, UserAcceptablePaymentTerms);

  $scope.save_terms = function () {
    $scope.updating_terms = true;

    var user_terms = [];
    _angular2.default.forEach($scope.terms, function (term) {
      if (term.checked) user_terms.push(term.id);
    });

    UserAcceptablePaymentTermService.update($scope.user_id, user_terms).then(function (data) {
      if (data.success) {
        $scope.updating_terms = false;
        var section = window.is_buyer ? 3 : 0;
        var page = window.is_buyer ? 3 : 5;
        $rootScope.$broadcast('set_sidebar_data', [section, page, [{
          type: 'counter',
          value: user_terms.length
        }]]);
      }
    });
  };

  $scope.init = function () {
    $scope.user_id = window.user_id;
    $scope.terms = window.terms;
  };

  $scope.init();
};

exports.default = UserAcceptablePaymentTerms;


UserAcceptablePaymentTerms.$inject = ['$scope', '$rootScope', 'UserAcceptablePaymentTermService'];

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserBuyerEdit = function UserBuyerEdit($scope) {
  _classCallCheck(this, UserBuyerEdit);

  var hide_pages = ['edit_orders', 'edit_orders_customers', 'offer_request_selections', 'offer_request_reservations'];
  $scope.show_sidebar = !_underscore2.default.contains(hide_pages, window.app_data.action);
};

exports.default = UserBuyerEdit;


UserBuyerEdit.$inject = ['$scope'];

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserBuyerSectionMenu = function UserBuyerSectionMenu($scope) {
  _classCallCheck(this, UserBuyerSectionMenu);

  $scope.menu = [{
    title: 'Preview',
    action: 'edit_preview',
    pages: ['edit_preview']
  }, {
    title: 'Overview',
    action: 'overview',
    pages: ['overview']
  }, {
    title: 'Accounts & Profiles',
    action: 'edit_company_details',
    pages: ['edit_company_details', 'edit_company_contacts']
  }, {
    title: 'Trading Infos',
    action: 'edit_trading_general',
    pages: ['edit_preferences_categories', 'edit_preferences_products', 'edit_preferences_product_groups', 'edit_preferences_specs', 'edit_preferences_brands', 'edit_preferences_volumes', 'edit_preferences_pricings', 'edit_preferences_target_pricings', 'edit_preferences_buyer', 'edit_preferences_preview', 'edit_spp_buyer_pricings', 'edit_spp_special_pricings', 'edit_spp_special_user_charges', 'edit_requests_spot', 'edit_requests_demands', 'edit_trading_general', 'edit_trading_order', 'edit_trading_delivery', 'edit_trading_payment', 'edit_trading_special_payment', 'edit_trading_restrictions']
  }, {
    title: 'Opportunities',
    action: 'edit_matched_my',
    pages: ['edit_matched_my', 'edit_matched_suppliers', 'edit_matched_favorite_offers', 'edit_matched_favorite_members', 'edit_matched_inventories']
  }, {
    title: 'Advanced Tools',
    action: 'edit_special_faqs',
    pages: ['edit_special_faqs', 'edit_special_roll_messages', 'edit_alerts', 'edit_reports', 'edit_create_spot', 'edit_create_demand', 'edit_create_spot_from_offer', 'edit_create_inventory']
  }, {
    title: 'Orders & Offers Requests',
    action: 'edit_orders',
    pages: ['edit_orders', 'edit_arrivals', 'offer_request_selections', 'offer_request_reservations', 'edit_orders_payment', 'edit_orders_customers']
  }];

  $scope.init = function () {
    $scope._ = _underscore2.default;
  };

  $scope.init();
};

exports.default = UserBuyerSectionMenu;


UserBuyerSectionMenu.$inject = ['$scope'];

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserBuyerSidebarMenu = function UserBuyerSidebarMenu($scope, UserSidebarService) {
  _classCallCheck(this, UserBuyerSidebarMenu);

  var menu = [{
    group: 0,
    title: 'Preview',
    pages: [{
      title: 'Preview',
      action: 'edit_preview'
    }]
  }, {
    group: 1,
    title: 'Overview',
    pages: [{
      title: 'Overview',
      action: 'overview'
    }]
  }, {
    group: 2,
    title: 'Accounts & Personal Data',
    pages: [{
      title: 'Manage Contacts',
      action: 'edit_company_contacts'
    }]
  }, {
    group: 2,
    title: 'Main Details - Company Profile',
    pages: [{
      title: 'Company Details',
      action: 'edit_company_details'
    }]
  }, {
    group: 3,
    title: 'Product Preferences',
    pages: [{
      title: 'Categories & Groups',
      action: 'edit_preferences_categories'
    }, {
      title: 'Product End Uses',
      action: 'product_end_uses'
    }, {
      title: 'Product Qualities',
      action: 'edit_preferences_products'
    }, {
      title: 'Product Group Settings',
      action: 'product_group_settings'
    }, {
      title: 'Product Quality Groups',
      action: 'edit_preferences_product_groups'
    }, {
      title: 'Product Specifications',
      action: 'edit_preferences_specs'
    }, {
      title: 'Product Brands',
      action: 'edit_preferences_brands'
    }, {
      title: 'Product Volumes & Uses',
      action: 'edit_preferences_volumes'
    }, {
      title: 'Product Pricings',
      action: 'edit_preferences_pricings'
    }, {
      title: 'Product Target Pricings',
      action: 'edit_preferences_target_pricings'
    }, {
      title: 'Buyer Preferences',
      action: 'edit_preferences_buyer'
    }, {
      title: 'Buyer Preference Preview',
      action: 'edit_preferences_preview',
      hidden: true
    }]
  }, {
    group: 3,
    title: 'Special Price Policy',
    pages: [{
      title: 'Buyer Special Pricings',
      action: 'edit_spp_buyer_pricings'
    }, {
      title: 'Special Pricings (USPP)',
      action: 'edit_spp_special_pricings'
    }, {
      title: 'Special Charges by User (USCP)',
      action: 'edit_spp_special_user_charges'
    }]
  }, {
    group: 3,
    title: 'Requests & Demands',
    pages: [{
      title: 'Spot Requests',
      action: 'edit_requests_spot'
    }, {
      title: 'Demands',
      action: 'edit_requests_demands'
    }]
  }, {
    group: 3,
    title: 'Usual Infos - Trading Terms',
    pages: [{
      title: 'General',
      action: 'edit_trading_general'
    }, {
      title: 'Order Details',
      action: 'edit_trading_order'
    }, {
      title: 'Delivery Terms',
      action: 'edit_trading_delivery'
    }, {
      title: 'Acceptable Payment Terms',
      action: 'edit_trading_payment'
    }, {
      title: 'Special Payment Terms',
      action: 'edit_trading_special_payment'
    }, {
      title: 'Market Restrictions',
      action: 'edit_trading_restrictions'
    }, {
      title: 'Restricted to...',
      action: 'show_trading_restrictions'
    }, {
      title: 'User Messages',
      action: 'edit_trading_messages'
    }]
  }, {
    group: 4,
    title: 'Matched Offers & Suppliers',
    pages: [{
      title: 'My Offers',
      action: 'edit_matched_my'
    }, {
      title: 'Matched Suppliers',
      action: 'edit_matched_suppliers'
    }, {
      title: 'Favorite Offers',
      action: 'edit_matched_favorite_offers'
    }, {
      title: 'Favorite Members',
      action: 'edit_matched_favorite_members'
    }, {
      title: 'Special Inventories',
      action: 'edit_matched_inventories'
    }]
  }, {
    group: 5,
    title: 'Special Section',
    pages: [{
      title: 'FAQs',
      action: 'edit_special_faqs'
    }, {
      title: 'Roll Messages',
      action: 'edit_special_roll_messages'
    }]
  }, {
    group: 5,
    title: 'Campaign Alerts & Notifications',
    pages: [{
      title: 'Campaign Alerts & Notifications',
      action: 'edit_alerts'
    }]
  }, {
    group: 5,
    title: 'Reports & Stats',
    pages: [{
      title: 'Reports & Stats',
      action: 'edit_reports'
    }]
  }, {
    group: 5,
    title: 'Create Options',
    pages: [{
      title: 'Create new Spot Request',
      action: 'edit_create_spot'
    }, {
      title: 'Create a Demand based on Preferences',
      action: 'edit_create_demand'
    }, {
      title: 'Create new Spot Request based on Offer Request',
      action: 'edit_create_spot_from_offer'
    }, {
      title: 'Create Personalized Inventory or Offer',
      action: 'edit_create_inventory'
    }]
  }, {
    group: 6,
    title: 'Orders & Offer Requests',
    pages: [{
      title: 'Selections',
      action: 'offer_request_selections'
    }, {
      title: 'Reservations',
      action: 'offer_request_reservations'
    }, {
      title: 'Orders',
      action: 'edit_orders'
    }, {
      title: 'Arrivals',
      action: 'edit_arrivals'
    }, {
      title: 'Payment Notifications',
      action: 'edit_orders_payment'
    }, {
      title: 'Corporate Suppliers',
      action: 'edit_orders_customers'
    }, {
      title: 'Sales Confirmations',
      action: 'edit_sales_confirmations'
    }]
  }];

  $scope.set_page_data = function (section_index, page_index, data) {
    var section = $scope.menu[section_index];
    var page = section.pages[page_index];
    page.data = data;
  };

  $scope.$on('set_sidebar_data', function (event, data) {
    $scope.set_page_data(data[0], data[1], data[2]);
  });

  function set_menu() {
    var section = _underscore2.default.find(menu, function (section) {
      return _underscore2.default.contains(_underscore2.default.pluck(section.pages, 'action'), window.app_data.action);
    });

    if (section) {
      $scope.menu = _underscore2.default.where(menu, {
        group: section.group
      });
      //var groups_with_data = [2, 3, 6];
      UserSidebarService.get_sidebar_data(window.app_data.user_id, section.group).success(function (data) {
        var sidebar_data = data.sidebar_data;
        if (section.group === 2) {
          $scope.set_page_data(0, 0, [{
            type: 'counter',
            value: sidebar_data.contacts_count
          }, {
            type: 'counter',
            value: sidebar_data.accounts_count
          }]);
          $scope.set_page_data(1, 0, [{
            type: 'percentage',
            value: sidebar_data.company_percentage
          }]);
        } else if (section.group === 3) {
          $scope.set_page_data(0, 0, [{
            type: 'counter',
            value: sidebar_data.categories_count
          }, {
            type: 'counter',
            value: sidebar_data.groups_count
          }]);
          $scope.set_page_data(0, 1, [{
            type: 'counter',
            value: sidebar_data.end_uses_count
          }]);
          $scope.set_page_data(0, 2, [{
            type: 'counter',
            value: sidebar_data.epaper_products_count
          }, {
            type: 'counter',
            value: sidebar_data.products_count
          }]);
          $scope.set_page_data(0, 5, [{
            type: 'counter',
            value: sidebar_data.product_specs.count
          }, {
            type: 'percentage',
            value: sidebar_data.product_specs.percentage
          }]);
          $scope.set_page_data(0, 6, [{
            type: 'counter',
            value: sidebar_data.brands_count
          }]);
          $scope.set_page_data(0, 7, [{
            type: 'counter',
            value: sidebar_data.product_volumes.count
          }, {
            type: 'percentage',
            value: sidebar_data.product_volumes.percentage
          }]);
          $scope.set_page_data(0, 8, [{
            type: 'counter',
            value: sidebar_data.product_pricings.count
          }, {
            type: 'percentage',
            value: sidebar_data.product_pricings.percentage
          }]);
          $scope.set_page_data(1, 0, [{
            type: 'counter',
            value: sidebar_data.spp_sellers_count
          }, {
            type: 'counter',
            value: sidebar_data.spp_count
          }, {
            type: 'counter',
            value: sidebar_data.spp_check_count
          }]);
          $scope.set_page_data(2, 1, [{
            type: 'counter',
            value: sidebar_data.demands_count
          }]);
          $scope.set_page_data(3, 0, [{
            type: 'percentage',
            value: sidebar_data.trading_percentage
          }]);
          $scope.set_page_data(3, 1, [{
            type: 'percentage',
            value: sidebar_data.order_percentage
          }]);
          $scope.set_page_data(3, 2, [{
            type: 'counter',
            value: sidebar_data.delivery_terms_count
          }]);
          $scope.set_page_data(3, 3, [{
            type: 'counter',
            value: sidebar_data.payment_terms_count
          }]);
          $scope.set_page_data(3, 4, [{
            type: 'counter',
            value: sidebar_data.special_payment_terms_count
          }]);
          $scope.set_page_data(3, 5, [{
            type: 'counter',
            value: sidebar_data.restrictions_count
          }]);
        } else if (section.group === 6) {
          $scope.set_page_data(0, 0, [{
            type: 'counter',
            value: sidebar_data.selections_count
          }]);
          $scope.set_page_data(0, 1, [{
            type: 'counter',
            value: sidebar_data.reservations_count
          }]);
          $scope.set_page_data(0, 2, [{
            type: 'counter',
            value: sidebar_data.orders_count
          }]);
        }
      });
    }
  }

  $scope.init = function () {
    $scope.menu = [];
    set_menu();
  };

  $scope.init();
};

exports.default = UserBuyerSidebarMenu;


UserBuyerSidebarMenu.$inject = ['$scope', 'UserSidebarService'];

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserContactNotificationsDialog = function UserContactNotificationsDialog($scope, $rootScope, $q, UserContactService) {
  _classCallCheck(this, UserContactNotificationsDialog);

  $scope.$on('show_user_contact_notifications', function (event, data) {
    window.openFancyboxDialog('div#user_contact_notifications_dialog');
    $scope.user_contact = data.user_contact;
    load_notifications();
  });

  function load_notifications() {
    $scope.finished = false;
    $scope.notifications = [];
    $scope.notificationIndex = null;
    $scope.notification = null;
    UserContactService.get_notifications($scope.user_contact.id).success(function (data) {
      $scope.notifications = data.notifications;
      if ($scope.notifications.length > 0) {
        $scope.display_notification(0);
      }
      $scope.finished = true;
    });
  }

  $scope.display_notification = function (index) {
    if (index < 0 || index >= $scope.notifications.length) {
      return;
    }

    $scope.notificationIndex = index;
    $scope.notification = $scope.notifications[index];
  };
};

exports.default = UserContactNotificationsDialog;


UserContactNotificationsDialog.$inject = ['$scope', '$rootScope', '$q', 'UserContactService'];

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserContacts = function UserContacts($scope, $rootScope, UserContactService, UserService) {
  _classCallCheck(this, UserContacts);

  $scope.manage_tabs = ['All', 'Pending Invitations', 'Pending Accounts', 'Accounts', 'Without Accounts'];

  $scope.edit_tabs = ['Contact General', 'Account General', 'Preferences', 'Newsletter Settings', 'Campaign Settings', 'ePrivacy', 'GDPR', 'Matching Options', 'Page Style', 'Welcome Notification'];

  $scope.$watch('dialog_contact.epr_marketing_permission', function () {
    if ($scope.dialog_contact.epr_marketing_permission.length > 0) {
      $scope.dialog_contact.epr_marketing_permission_title = $scope.dialog_contact.epr_marketing_permission + ' (admin)';
    }
  });

  $scope.$watch('dialog_contact.epr_based_to', function () {
    if ($scope.dialog_contact.epr_based_to.length > 0) {
      $scope.dialog_contact.epr_based_to_title = $scope.dialog_contact.epr_based_to + ' (admin)';
    }
  });

  $scope.set_selected_manage_tab = function (index) {
    $scope.selected_manage_tab = index;
  };

  $scope.set_selected_edit_tab = function (index) {
    $scope.selected_edit_tab = index;
  };

  $scope.open_dialog = function (dialog_id) {
    window.openFancyboxDialog('div#' + dialog_id);
  };

  $scope.get_new_account = function () {
    return {
      id: null,
      username: null,
      password: null,
      retype_password: null,
      status: 'activated'
    };
  };

  $scope.get_new_newsletter_settings = function () {
    return {
      categories: [],
      frequency: 0,
      filter: 0,
      greeting_line: window.user_country_id == 83 || window.user_country_id == 56 ? 'Αξιότιμοι Κύριοι και Κυρίες' : 'Dear Ladies and Gentlemen',
      message_type: 0
    };
  };

  $scope.get_new_matching_settings = function () {
    return {
      option: 0,
      percentage: 25,
      minimum_quantity: 0
    };
  };

  $scope.get_new_frontend_settings = function () {
    return {
      view_type: 0,
      welcome_notification: 0,
      welcome_notification_frequency: 0
    };
  };

  $scope.add_contact = function () {
    $scope.dialog_contact = _angular2.default.copy(window.contact);
    $scope.dialog_old_email = null;
    $scope.selected_edit_tab = 0;
    $scope.dialog_contact.account = $scope.get_new_account();
    $scope.dialog_contact.newsletter_settings = $scope.get_new_newsletter_settings();
    $scope.dialog_contact.matching_settings = $scope.get_new_matching_settings();
    $scope.dialog_contact.frontend_settings = $scope.get_new_frontend_settings();
    if (!$scope.dialog_contact.campaign_status_details) $scope.dialog_contact.campaign_status_details = {};
    $scope.open_dialog('user_contact_dialog');
  };

  $scope.edit_contact = function (contact) {
    $scope.dialog_contact = contact;
    $scope.dialog_old_email = contact.email;
    $scope.selected_edit_tab = 0;
    if (!contact.account) contact.account = $scope.get_new_account();
    $scope.dialog_old_username = contact.account.username;
    $scope.dialog_contact.account.password = '';
    $scope.dialog_contact.account.retype_password = '';
    if (!contact.newsletter_settings) contact.newsletter_settings = $scope.get_new_newsletter_settings();
    if (!contact.newsletter_settings.message_type) contact.newsletter_settings.message_type = 0;
    if (!contact.matching_settings) contact.matching_settings = $scope.get_new_matching_settings();
    if (!contact.frontend_settings) contact.frontend_settings = $scope.get_new_frontend_settings();
    $scope.set_contact_data();
    if (!$scope.dialog_contact.campaign_status_details) $scope.dialog_contact.campaign_status_details = {};
    $scope.open_dialog('user_contact_dialog');
  };

  $scope.delete_contact = function (index) {
    if (confirm('Are you sure you want to delete this contact?')) {
      UserContactService.delete($scope.user_contacts[index].id).then(function (data) {
        if (data.success) {
          $scope.user_contacts.splice(index, 1);
          $rootScope.$broadcast('set_sidebar_data', [0, 0, [{
            type: 'counter',
            value: $scope.user_contacts.length
          }, {
            type: 'counter',
            value: _underscore2.default.filter($scope.user_contacts, function (c) {
              return c.account && c.account.id;
            }).length
          }]]);
        }
      });
    }
  };

  $scope.save_contact = function () {
    $scope.updating_contact = true;
    if ($scope.dialog_contact.email === null || $scope.dialog_contact.email == $scope.dialog_old_email) {
      $scope.validate_account();
    } else {
      UserService.contact_email_exists($scope.dialog_contact.email, $scope.dialog_contact.user_id).then(function (data) {
        if (data.exists) {
          $scope.contact_error = 'Contact email already exists!';
          $scope.updating_contact = false;
        } else {
          $scope.contact_error = '';
          $scope.validate_account();
        }
      });
    }
  };

  $scope.validate_password = function (account) {
    var password = account.password;
    var password2 = account.retype_password;
    if (!(password || password2) || password.length === 0 || password != password2) {
      $scope.account_error = 'Account password empty or password mismatch!';
      $scope.updating_contact = false;
      return false;
    }
    $scope.account_error = '';
    return true;
  };

  $scope.validate_account = function () {
    var account = $scope.dialog_contact.account;
    if (!account.id) {
      var username = account.username;
      if (username && username.length > 0) {
        if ($scope.validate_password(account)) {
          UserService.account_email_exists(username).then(function (data) {
            if (data.exists) {
              $scope.account_error = 'Account email already exists!';
              $scope.updating_contact = false;
            } else {
              $scope.account_error = '';
              $scope.update_contact();
            }
          });
        }
      } else {
        $scope.update_contact();
      }
    } else {
      account.new_username = null;
      account.new_password = null;
      if (account.username && account.username.length > 0 && $scope.dialog_old_username != account.username) account.new_username = account.username;
      if (account.password && account.retype_password && $scope.validate_password(account)) account.new_password = account.password;
      if (account.new_username) {
        UserService.account_email_exists(account.new_username).then(function (data) {
          if (data.exists) {
            $scope.account_error = 'Account email already exists!';
            $scope.updating_contact = false;
          } else {
            $scope.account_error = '';
            $scope.update_contact();
          }
        });
      } else {
        $scope.update_contact();
      }
    }
  };

  $scope.set_contact_data = function () {
    _angular2.default.forEach($scope.newsletter_categories, function (category) {
      if ($scope.dialog_contact.newsletter_settings.categories) category.checked = $scope.dialog_contact.newsletter_settings.categories.indexOf(category.id) > -1;
    });
    _angular2.default.forEach($scope.product_categories, function (category) {
      if ($scope.dialog_contact.product_categories) category.checked = $scope.dialog_contact.product_categories.indexOf(category.id) > -1;
    });
  };

  $scope.get_contact_data = function () {
    var categories = [];
    _angular2.default.forEach($scope.newsletter_categories, function (category) {
      if (category.checked) categories.push(category.id);
    });
    $scope.dialog_contact.newsletter_settings.categories = categories;

    var product_categories = [];
    _angular2.default.forEach($scope.product_categories, function (category) {
      if (category.checked) product_categories.push(category.id);
    });
    $scope.dialog_contact.product_categories = product_categories;

    if ($scope.dialog_contact.campaign_status === 1) {
      $scope.dialog_contact.campaign_status_details = null;
    }

    if ($scope.dialog_contact.campaign_status !== 4) {
      $scope.dialog_contact.campaign_probation_start = null;
      $scope.dialog_contact.campaign_probation_end = null;
    } else {
      $scope.dialog_contact.campaign_probation_end = $scope.dialog_contact.campaign_probation_end + ' 23:59:59';
    }
  };

  $scope.update_contact = function () {
    $scope.get_contact_data();
    UserContactService.save($scope.dialog_contact).then(function (data) {
      if (data.success) {
        $scope.updating_contact = false;
        _jquery2.default.fancybox.close();
        $scope.user_contacts = data.user_contacts;
        $rootScope.$broadcast('set_sidebar_data', [0, 0, [{
          type: 'counter',
          value: $scope.user_contacts.length
        }, {
          type: 'counter',
          value: _underscore2.default.filter($scope.user_contacts, function (c) {
            return c.account && c.account.id;
          }).length
        }]]);
      }
    });
  };

  $scope.invite_contact = function (contact) {
    contact.invitation = true;
    UserContactService.add_invitation(contact.id).then(function (data) {
      if (data.success) $scope.user_contacts = data.user_contacts;
    });
  };

  $scope.cancel_invitation = function (invitation_id) {
    UserContactService.delete_invitation(invitation_id).then(function (data) {
      if (data.success) $scope.user_contacts = data.user_contacts;
    });
  };

  $scope.invitation_status = function (invitation) {
    if (invitation) return invitation.status === 0 ? 'Pending' : 'Accepted';else return '';
  };

  $scope.campaign_status = function (status) {
    return _underscore2.default.findWhere($scope.campaign_statuses, {
      id: status
    }).title;
  };

  $scope.get_pending_invitation_items = function () {
    return _underscore2.default.filter(window.user_contacts, function (contact) {
      return contact.invitation && contact.invitation.status === 0;
    });
  };

  $scope.has_pending_invitation = function (item) {
    return item.invitation && item.invitation.status === 0;
  };

  $scope.get_pending_account_items = function () {
    return _underscore2.default.filter(window.user_contacts, function (contact) {
      return contact.account && contact.account.status == 'pending';
    });
  };

  $scope.has_pending_account = function (item) {
    return item.account && item.account.status == 'pending';
  };

  $scope.update_account_status = function (contact, status) {
    if (contact.account) {
      UserContactService.update_account_status(contact.account.id, status).then(function (data) {
        if (data.success) $scope.user_contacts = data.user_contacts;
      });
    }
  };

  $scope.get_account_items = function () {
    return _underscore2.default.filter(window.user_contacts, function (contact) {
      return contact.account && contact.account.id;
    });
  };

  $scope.has_account = function (item) {
    return item.account && item.account.id;
  };

  $scope.get_no_account_items = function () {
    return _underscore2.default.filter(window.user_contacts, function (contact) {
      return !contact.account || !contact.account.id;
    });
  };

  $scope.message_types = [{
    id: 0,
    name: 'Typical'
  }, {
    id: 1,
    name: 'Personal'
  }];

  $scope.campaign_action_types = [{
    id: 0,
    name: 'Auto'
  }, {
    id: 1,
    name: 'Manual'
  }];

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.init = function () {
    $scope.departments = window.departments;
    $scope.user_contacts = window.user_contacts;
    $scope.dialog_contact = _angular2.default.copy(window.contact);
    $scope.selected_manage_tab = 0;
    $scope.account_statuses = window.account_statuses;
    $scope.newsletter_categories = window.newsletter_categories;
    $scope.newsletter_frequencies = window.newsletter_frequencies;
    $scope.newsletter_filters = window.newsletter_filters;
    $scope.matching_options = window.matching_options;
    $scope.matching_percentages = window.matching_percentages;
    $scope.frontend_views = window.frontend_views;
    $scope.notification_options = window.notification_options;
    $scope.notification_frequencies = window.notification_frequencies;
    $scope.product_categories = window.product_categories;
    $scope.campaign_statuses = window.campaign_statuses;
    $scope._ = _underscore2.default;
  };

  $scope.init();
};

exports.default = UserContacts;


UserContacts.$inject = ['$scope', '$rootScope', 'UserContactService', 'UserService'];

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserCountryCharges = function UserCountryCharges($scope, UserService) {
  _classCallCheck(this, UserCountryCharges);

  $scope.select2_options = {
    containerCssClass: 'multiselect2',
    dropdownCssClass: 'multiselect2',
    width: '600px'
  };

  $scope.$watch('continent', function () {
    $scope.selected_countries = [];
    if ($scope.continent && $scope.continent !== '') {
      var group = (0, _jquery2.default)('select#countries').find('optgroup[label="' + $scope.continent + '"]');
      group.find('option').each(function () {
        $scope.selected_countries.push((0, _jquery2.default)(this).attr('value'));
      });
    }
  });

  $scope.load_charges = function () {
    $scope.loading = true;
    UserService.get_country_charges(window.user_id).then(function (data) {
      $scope.charges = data.charges;
      $scope.loading = false;
    });
  };

  $scope.save_charge = function () {
    $scope.saving_charge = true;
    UserService.save_country_charges([$scope.charge]).then(function (data) {
      if (data.success) {
        $scope.saving_charge = false;
        _jquery2.default.fancybox.close();
        $scope.load_charges();
      }
    });
  };

  $scope.save_charges = function () {
    $scope.saving_countries_charge = true;
    var charges = [];
    _underscore2.default.each($scope.selected_countries, function (country) {
      var c = _angular2.default.copy(window.harge);
      c.country_id = country;
      c.charge = $scope.country_charge;
      charges.push(c);
    });
    if (charges.length > 0) {
      UserService.save_country_charges(charges).then(function (data) {
        if (data.success) {
          $scope.saving_charges = false;
          $scope.load_charges();
        }
      });
    }
  };

  $scope.edit_charge = function (charge) {
    $scope.charge = charge;
    window.openFancyboxDialog('div#charge_dialog');
  };

  $scope.delete_charge = function (charge_id) {
    if (confirm('Are you sure you want to delete this charge?')) {
      UserService.delete_country_charge(charge_id).then(function (data) {
        if (data.success) $scope.load_charges();
      });
    }
  };

  $scope.mass_delete_charges = function () {
    var charges = _underscore2.default.where($scope.charges, {
      checked: true
    });
    if (charges.length === 0) {
      alert('Please select at least one charge!');
    } else {
      $scope.processing = true;
      UserService.delete_country_charges(_underscore2.default.pluck(charges, 'id')).success(function (data) {
        if (data.success) {
          $scope.load_charges();
          $scope.processing = false;
        }
      });
    }
  };

  $scope.mass_edit_charges = function () {
    var charges = _underscore2.default.where($scope.charges, {
      checked: true
    });
    if (charges.length === 0) alert('Please select at least one charge!');else window.openFancyboxDialog('div#mass_charge_dialog');
  };

  $scope.mass_save_charges = function () {
    var charges = _underscore2.default.where($scope.charges, {
      checked: true
    });
    _underscore2.default.each(charges, function (charge) {
      if ($scope.mass_charge) charge.charge = $scope.mass_charge;
      if ($scope.mass_admin_expire_date) charge.admin_expire_date = $scope.mass_admin_expire_date;
    });
    $scope.saving_charges = true;
    UserService.save_country_charges(charges).then(function (data) {
      if (data.success) {
        $scope.load_charges();
        $scope.saving_charges = false;
        _jquery2.default.fancybox.close();
      }
    });
  };

  $scope.mass_renew_charges = function () {
    var charges = _underscore2.default.where($scope.charges, {
      checked: true
    });
    if (charges.length === 0) {
      alert('Please select at least one charge!');
    } else {
      $scope.processing = true;
      UserService.save_country_charges(charges).then(function (data) {
        if (data.success) {
          $scope.load_charges();
          $scope.processing = false;
        }
      });
    }
  };

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.set_charges_checked = function () {
    _underscore2.default.each($scope.charges, function (charge) {
      charge.checked = $scope.checked_all_charges;
    });
  };

  $scope.init = function () {
    $scope.load_charges();
    $scope.countries = window.countries;
  };

  $scope.init();
};

exports.default = UserCountryCharges;


UserCountryCharges.$inject = ['$scope', 'UserService'];

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserCreate = function UserCreate($scope, GeoService, UserService, UserContactService) {
  _classCallCheck(this, UserCreate);

  $scope.tabs = ['1. Company Details', '2. Personal Contact Details', '3. Account Type & Groups', '4. Product Categories & Groups'];

  $scope.similarity_tabs = UserService.get_similar_tabs();

  $scope.compare_tabs = UserService.get_similar_dialog_tabs();

  $scope.open_dialog = function (dialog_id) {
    window.openFancyboxDialog('div#' + dialog_id);
  };

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.set_selected_similarity_tab = function (index) {
    $scope.selected_similarity_tab = index;
    $scope.filtered_similar_users = $scope.get_filtered_similar_users(index);
  };

  $scope.set_selected_compare_tab = function (index) {
    $scope.selected_compare_tab = index;
  };

  $scope.get_filtered_similar_users_length = function (index) {
    if (index === 0) return $scope.similar_users.length;else return $scope.get_filtered_similar_users(index).length;
  };

  $scope.get_filtered_similar_users = function (index) {
    return UserService.get_filtered_similar_users($scope.similar_users, index);
  };

  $scope.$watch('user.country_id', function () {
    if ($scope.user.country_id) $scope.user_country_name = (0, _jquery2.default)('#country option[value="' + $scope.user.country_id + '"]').html();else $scope.user_country_name = '';
    if ($scope.user.country_id) {
      GeoService.get_cities($scope.user.country_id).then(function (data) {
        $scope.cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.user.city_id })) $scope.user.city_id = null;
      });
    }
  });

  $scope.$watch('user.city_id', function () {
    if ($scope.user.city_id) $scope.user_city_name = (0, _jquery2.default)('#city option:selected').text();else $scope.user_city_name = '';
  });

  $scope.find_similar_users = function () {
    $scope.processing = true;

    var data = {
      company_title: null,
      emails: [],
      phones: [],
      faxes: [],
      vat: null,
      last_names: [],
      post_codes: []
    };

    if ($scope.user.company_title) data.company_title = $scope.user.company_title;
    if ($scope.user.company_email) data.emails.push($scope.user.company_email);
    if ($scope.account.username) data.emails.push($scope.account.username);
    if ($scope.user.user_contacts_attributes[0].email) data.emails.push($scope.user.user_contacts_attributes[0].email);
    if ($scope.user.user_contacts_attributes[0].last_name) data.last_names.push($scope.user.user_contacts_attributes[0].last_name);
    if ($scope.user.phone) data.phones.push($scope.user.phone);
    if ($scope.user.user_contacts_attributes[0].phone) data.phones.push($scope.user.user_contacts_attributes[0].phone);
    if ($scope.user.fax) data.faxes.push($scope.user.fax);
    if ($scope.user.user_contacts_attributes[0].fax) data.faxes.push($scope.user.user_contacts_attributes[0].fax);
    if ($scope.user.ssn) data.vat = $scope.user.ssn;

    UserService.find_similar(data).then(function (data) {
      $scope.similar_users = data.users;
      $scope.selected_similarity_tab = 0;
      $scope.filtered_similar_users = data.users;
      $scope.processing = false;
    });
  };

  $scope.mark_as_not_similar = function () {
    $scope.similar_users.splice($scope.similar_users.indexOf($scope.compare_user), 1);
    $scope.filtered_similar_users = $scope.get_filtered_similar_users($scope.selected_tab);
    _jquery2.default.fancybox.close();
  };

  $scope.$watch('user.user_type', function () {
    $scope.business_types = _angular2.default.copy(window.business_types);
    $scope.user.user_business_types_attributes = [];
  });

  $scope.category_changed = function (category) {
    if (!category.checked) {
      for (var i = 0; i < category.groups.length; i++) {
        category.groups[i].checked = false;
      }
    }
  };

  $scope.group_changed = function (category, group) {
    if (group.checked && !category.checked) category.checked = true;
  };

  $scope.deselect_group = function (group_id) {
    var group = _underscore2.default.find($scope.groups, function (object) {
      return object.id == group_id;
    });
    group.checked = false;
  };

  $scope.set_user_data = function () {
    $scope.user.user_product_categories_attributes = [];
    $scope.user.user_product_groups_attributes = [];
    _angular2.default.forEach($scope.product_categories, function (category) {
      if (category.checked) $scope.user.user_product_categories_attributes.push({
        product_category_id: category.id
      });
      for (var i = 0; i < category.groups.length; i++) {
        if (category.groups[i].checked) $scope.user.user_product_groups_attributes.push({
          product_group_id: category.groups[i].id
        });
      }
    });

    $scope.user.user_business_types_attributes = [];
    _angular2.default.forEach($scope.business_types, function (business_type) {
      if (business_type.checked) $scope.user.user_business_types_attributes.push({
        business_type_id: business_type.id
      });
    });

    $scope.user.user_groups_attributes = [];
    _angular2.default.forEach($scope.groups, function (group) {
      if (group.checked) $scope.user.user_groups_attributes.push({
        group_id: group.id
      });
    });
  };

  $scope.validate_password = function () {
    var password = $scope.account.password;
    var password2 = $scope.account.retype_password;
    if (!(password || password2) || password.length === 0 || password != password2) {
      $scope.form_error = 'Account Data - Password empty or password mismatch!';
      return false;
    }
    $scope.form_error = '';
    return true;
  };

  $scope.get_new_user = function () {
    return {
      user_type: 'Buyer',
      company_title: null,
      company_email: null,
      country_id: null,
      city_id: null,
      phone: null,
      fax: null,
      ssn: null,
      business_relation: 0,
      last_name: '',
      market: 'global',
      user_contacts_attributes: [{
        department_id: null,
        email: null,
        first_name: null,
        last_name: null,
        gender: 0,
        position: null,
        phone: null,
        fax: null,
        newsletter_settings: null,
        matching_settings: null,
        frontend_settings: null,
        welcome_email_date: null
      }],
      user_groups_attributes: [],
      user_business_types_attributes: [],
      user_product_categories_attributes: [],
      user_product_groups_attributes: []
    };
  };

  $scope.get_new_account = function () {
    return {
      username: null,
      password: null,
      retype_password: null,
      status: 'activated'
    };
  };

  $scope.save_user = function () {
    $scope.set_user_data();
    if ($scope.user.user_product_categories_attributes.length === 0) {
      $scope.form_error = 'Please select at least one product category!';
      $scope.creating_user = false;
    } else if (!$scope.user.company_email || $scope.user.company_email.length === 0) {
      $scope.form_error = 'Please type the Corporate Email!';
      $scope.creating_user = false;
    } else {
      UserService.create($scope.user, $scope.account).then(function (data) {
        if (data.success) {
          $scope.created_user_id = data.user_id;
          $scope.create_mode = false;
          $scope.show_update = false;
          $scope.form_error = '';
        } else {
          $scope.form_error = data.message;
        }
        $scope.creating_user = false;
      });
    }
  };

  $scope.create_user = function () {
    $scope.creating_user = true;
    var username = $scope.account.username;
    if (username && username.length > 0) {
      if ($scope.validate_password()) {
        UserService.account_email_exists(username).then(function (data) {
          if (data.exists) {
            $scope.form_error = 'Account email already exists!';
            $scope.show_update = false;
          } else {
            $scope.form_error = '';
            $scope.save_user();
          }
        });
      }
    } else {
      $scope.save_user();
    }
  };

  $scope.create_new_user = function () {
    $scope.init();
  };

  $scope.compare_users = function (user) {
    $scope.compare_user = user;
    $scope.open_dialog('compare_user_dialog');
  };

  $scope.on_dialog_create_action = function () {
    $scope.deselect_group(2);
    $scope.similar_users = [];
    _jquery2.default.fancybox.close();
    $scope.create_user();
  };

  $scope.set_update_mode = function (value) {
    $scope.update_mode = value;
    $scope.updating_user = '';
  };

  $scope.update_field = function (value, property) {
    $scope.updating_user = true;
    var update_data = {
      id: $scope.compare_user.id
    };

    if (property == 'email') update_data.company_email = value;else if (property == 'vat') update_data.ssn = value;else if (property == 'country_id') update_data.country_id = value;else if (property == 'city_id') update_data.city_id = value;else if (property == 'phone') update_data.phone = value;else if (property == 'fax') update_data.fax = value;

    UserService.update(update_data, null, null).then(function (data) {
      if (data.success) {
        $scope.update_error = '';
        $scope.compare_user[property] = value;
      } else {
        $scope.update_error = data.message;
      }
      $scope.updating_user = false;
    });
  };

  $scope.add_contact_to_similar = function () {
    $scope.updating_user = true;
    var contact = $scope.user.user_contacts_attributes[0];
    contact.user_id = $scope.compare_user.id;
    contact.account = $scope.account;
    contact.account.status = 'pending';
    UserContactService.save(contact).then(function (data) {
      if (data.success) {
        $scope.update_error = 'Contact added!';
      } else {
        $scope.update_error = 'Contact: ' + data.message;
      }
      if (data.account_success) {
        $scope.update_error += ', Account added!';
      } else {
        $scope.update_error += ', Account: ' + data.account_message;
      }
      $scope.updating_user = false;
    });
  };

  $scope.update_contact = function (contact) {
    $scope.updating_user = true;
    UserContactService.update_similar_contact($scope.user.user_contacts_attributes[0], $scope.account, contact.id).then(function (data) {
      if (data.success) {
        $scope.update_error = 'Contact updated!';
      } else {
        $scope.update_error = 'Contact: ' + data.message;
      }
      if (data.account_success) {
        $scope.update_error += ', Account added!';
      } else {
        $scope.update_error += ', Account: ' + data.account_message;
      }
      $scope.updating_user = false;
    });
  };

  $scope.init = function () {
    $scope.create_mode = true;
    $scope.update_mode = false;
    $scope.selected_tab = 0;
    $scope.selected_similarity_tab = 0;
    $scope.selected_compare_tab = 0;
    $scope.similar_users = [];
    $scope.groups = _angular2.default.copy(window.groups);
    $scope.business_types = _angular2.default.copy(window.business_types);
    $scope.product_categories = _angular2.default.copy(window.product_categories);
    $scope.user = $scope.get_new_user();
    $scope.account = $scope.get_new_account();
    $scope.business_relations = window.business_relations;
  };

  $scope.init();
};

exports.default = UserCreate;


UserCreate.$inject = ['$scope', 'GeoService', 'UserService', 'UserContactService'];

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserDeliveryTerm = function UserDeliveryTerm($scope, GeoService) {
  _classCallCheck(this, UserDeliveryTerm);

  $scope.$watch('term.country_id', function () {
    if ($scope.term.country_id) {
      GeoService.get_cities($scope.term.country_id).then(function (data) {
        $scope.term.cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.term.city_id })) $scope.term.city_id = null;
      });
    }
  });
};

exports.default = UserDeliveryTerm;


UserDeliveryTerm.$inject = ['$scope', 'GeoService'];

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserDeliveryTerms = function UserDeliveryTerms($scope, $rootScope, UserDeliveryTermService, GeoService) {
  _classCallCheck(this, UserDeliveryTerms);

  $scope.open_dialog = function (dialog_id) {
    window.openFancyboxDialog('div#' + dialog_id);
  };

  $scope.$watch('seller_term.country_id', function () {
    if ($scope.seller_term) {
      if ($scope.seller_term.country_id) {
        GeoService.get_cities($scope.seller_term.country_id).then(function (data) {
          $scope.seller_term_cities = data.cities;
          if (!_underscore2.default.findWhere(data.cities, { id: $scope.seller_term.city_id })) $scope.seller_term.city_id = null;
        });
      }
    }
  });

  $scope.edit_delivery_terms = function (key, terms) {
    $scope.dialog_term = {
      key: key,
      delivery_term_id: terms[0].delivery_term_id,
      terms: _angular2.default.copy(terms)
    };
    $scope.open_dialog('user_delivery_term_dialog');
  };

  $scope.add_delivery_term = function (terms) {
    var term = _angular2.default.copy(window.delivery_term);
    term.delivery_term_id = $scope.dialog_term.delivery_term_id;
    terms.push(term);
  };

  $scope.save_delivery_term = function (term) {
    $scope.updating_term = true;
    UserDeliveryTermService.save(term).then(function (data) {
      if (data.success) {
        $scope.updating_term = false;
        _jquery2.default.fancybox.close();
        $scope.user_delivery_terms = data.user_delivery_terms;
        $rootScope.$broadcast('set_sidebar_data', [window.is_buyer ? 3 : 0, window.is_buyer ? 2 : 3, [{
          type: 'counter',
          value: $scope.user_delivery_terms.length
        }]]);
        if ($scope.role == 1) $scope.seller_term = $scope.user_delivery_terms[0];
      }
    });
  };

  $scope.delete_delivery_term = function (terms, index) {
    terms.splice(index, 1);
  };

  $scope.save_delivery_terms = function (user_id, terms) {
    $scope.updating_term = true;
    terms = _underscore2.default.map(terms, function (term) {
      return _underscore2.default.omit(term, 'cities');
    });
    UserDeliveryTermService.save_all(user_id, $scope.dialog_term.delivery_term_id, terms).then(function (data) {
      if (data.success) {
        $scope.updating_term = false;
        _jquery2.default.fancybox.close();
        $scope.user_delivery_terms = _underscore2.default.groupBy(data.user_delivery_terms, 'delivery_term_name');
        $scope.set_delivery_terms_count(data.user_delivery_terms);
      }
    });
  };

  $scope.set_delivery_terms_count = function (user_delivery_terms) {
    var count = 0;
    _angular2.default.forEach(user_delivery_terms, function (term) {
      if (term.country_id) count++;
    });
    $rootScope.$broadcast('set_sidebar_data', [window.is_buyer ? 3 : 0, window.is_buyer ? 2 : 3, [{
      type: 'counter',
      value: count
    }]]);
  };

  $scope.get_countries_str = function (terms) {
    var countries = _underscore2.default.uniq(_underscore2.default.map(terms, function (t) {
      return {
        country: t.country_name,
        country_id: t.country_id
      };
    }));
    var result = [];
    _angular2.default.forEach(countries, function (c) {
      if (c.country && c.country_id) result.push(c.country + ' (' + c.country_id + ')');
    });
    return result.join(', ');
  };

  $scope.get_cities_str = function (terms) {
    var cities = _underscore2.default.uniq(_underscore2.default.map(terms, function (t) {
      return {
        city: t.city_name,
        city_id: t.city_id
      };
    }));
    var result = [];
    _angular2.default.forEach(cities, function (c) {
      if (c.city && c.city_id) result.push(c.city + ' (' + c.city_id + ')');
    });
    return result.join(', ');
  };

  $scope.init = function () {
    $scope.delivery_terms = window.delivery_terms;
    $scope.countries = window.countries;
    $scope.user_id = window.user_id;
    $scope.role = window.role;
    if ($scope.role == 0) {
      $scope.user_delivery_terms = _underscore2.default.groupBy(window.user_delivery_terms, 'delivery_term_name');
    } else {
      $scope.user_delivery_terms = window.user_delivery_terms;
      $scope.seller_term = $scope.user_delivery_terms.length > 0 ? $scope.user_delivery_terms[0] : _angular2.default.copy(window.delivery_term);
    }
    $scope._ = _underscore2.default;
  };

  $scope.init();
};

exports.default = UserDeliveryTerms;


UserDeliveryTerms.$inject = ['$scope', '$rootScope', 'UserDeliveryTermService', 'GeoService'];

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserDetails = function UserDetails($scope, $rootScope, GeoService, UserService, UserAddressService, UserBankService, UiService) {
  _classCallCheck(this, UserDetails);

  $scope.tabs = ['Company Profile', 'Company Addresses', 'Company Intro', 'Financial Details', 'Banking Details'];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.get_selected_tab = function () {
    return $scope.selected_tab;
  };

  $scope.open_dialog = function (dialog_id) {
    window.openFancyboxDialog('div#' + dialog_id);
  };

  $scope.$watch('user.country_id', function () {
    if ($scope.user.country_id) {
      GeoService.get_cities($scope.user.country_id).then(function (data) {
        $scope.cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.user.city_id })) $scope.user.city_id = null;
      });
    }
  });

  $scope.$watch('dialog_address.country_id', function () {
    if ($scope.dialog_address.country_id) {
      GeoService.get_cities($scope.dialog_address.country_id).then(function (data) {
        $scope.dialog_address_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.dialog_address.city_id })) $scope.dialog_address.city_id = null;
      });
    }
  });

  $scope.$watch('dialog_bank.country_id', function () {
    if ($scope.dialog_bank.country_id) {
      GeoService.get_cities($scope.dialog_bank.country_id).then(function (data) {
        $scope.dialog_bank_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.dialog_bank.city_id })) $scope.dialog_bank.city_id = null;
      });
    }
  });

  $scope.$watch('user.user_type', function () {
    $scope.business_types = _angular2.default.copy(window.business_types);
    $scope.user.user_business_types_attributes = [];
  });

  $scope.yes_no_options = [{
    id: 0,
    title: 'No'
  }, {
    id: 1,
    title: 'Yes'
  }];

  $scope.add_address = function () {
    $scope.dialog_address = _angular2.default.copy(window.address);
    $scope.open_dialog('user_address_dialog');
  };

  $scope.edit_address = function (address) {
    $scope.dialog_address = address;
    $scope.open_dialog('user_address_dialog');
  };

  $scope.delete_address = function (index) {
    if (confirm('Are you sure you want to delete this address?')) {
      UserAddressService.delete($scope.user_addresses[index].id).then(function (data) {
        if (data.success) {
          $scope.user_addresses.splice(index, 1);
          $rootScope.$broadcast('set_sidebar_data', [1, 0, [{
            type: 'percentage',
            value: data.company_details_percentage
          }]]);
        }
      });
    }
  };

  $scope.save_address = function () {
    $scope.updating_address = true;
    UserAddressService.save($scope.dialog_address).then(function (data) {
      if (data.success) {
        $scope.updating_address = false;
        _jquery2.default.fancybox.close();
        $scope.user_addresses = data.user_addresses;
        $rootScope.$broadcast('set_sidebar_data', [1, 0, [{
          type: 'percentage',
          value: data.company_details_percentage
        }]]);
      }
    });
  };

  $scope.add_bank = function () {
    $scope.dialog_bank = _angular2.default.copy(window.bank);
    $scope.open_dialog('user_bank_dialog');
  };

  $scope.edit_bank = function (bank) {
    $scope.dialog_bank = bank;
    $scope.open_dialog('user_bank_dialog');
  };

  $scope.delete_bank = function (index) {
    if (confirm('Are you sure you want to delete this bank?')) {
      UserBankService.delete($scope.user_banks[index].id).then(function (data) {
        if (data.success) {
          $scope.user_banks.splice(index, 1);
          $rootScope.$broadcast('set_sidebar_data', [1, 0, [{
            type: 'percentage',
            value: data.company_details_percentage
          }]]);
        }
      });
    }
  };

  $scope.save_bank = function () {
    $scope.updating_bank = true;
    UserBankService.save($scope.dialog_bank).then(function (data) {
      if (data.success) {
        $scope.updating_bank = false;
        _jquery2.default.fancybox.close();
        $scope.user_banks = data.user_banks;
        $rootScope.$broadcast('set_sidebar_data', [1, 0, [{
          type: 'percentage',
          value: data.company_details_percentage
        }]]);
      }
    });
  };

  $scope.set_user_data = function () {
    $scope.user_business_types = [];
    _angular2.default.forEach($scope.business_types, function (business_type) {
      if (business_type.checked) $scope.user_business_types.push(business_type.id);
    });

    $scope.user_groups = [];
    _angular2.default.forEach($scope.groups, function (group) {
      if (group.checked) $scope.user_groups.push(group.id);
    });
  };

  $scope.update_user = function () {
    $scope.updating_user = true;
    $scope.set_user_data();
    UserService.update($scope.user, $scope.user_groups, $scope.user_business_types).then(function (data) {
      if (data.success) {
        $scope.business_relation_title = data.business_relation_title;
        $scope.eprivacy_title = data.eprivacy_title;
        $scope.epr_marketing_permission_title = data.epr_marketing_permission_title;
        $scope.epr_marketing_campaigns_title = data.epr_marketing_campaigns_title;
        $scope.gdpr_compliance_title = data.gdpr_compliance_title;
        $scope.updating_user = false;
        $scope.set_financial_details_badge();
        $scope.set_company_introduction_badge();
        $scope.set_company_profile_badge();
        $rootScope.$broadcast('set_sidebar_data', [1, 0, [{
          type: 'percentage',
          value: data.company_details_percentage
        }]]);
      }
    });
  };

  $scope.set_financial_details_badge = function () {
    var percentage = 0;
    if ($scope.user.founded_on) percentage += 20;
    if ($scope.user.managing_director && $scope.user.managing_director.length > 0) percentage += 20;
    if ($scope.user.num_employees) percentage += 20;
    if ($scope.user.annual_turnover) percentage += 20;
    if ($scope.user.annual_imports) percentage += 20;
    $scope.financial_details = {
      css: UiService.get_count_css_class(percentage),
      percentage: percentage
    };
  };

  $scope.set_company_introduction_badge = function () {
    var percentage = 0;
    if ($scope.user.company_introduction) percentage += 34;
    if ($scope.user.company_notes) percentage += 33;
    if ($scope.user.epaper_introduction) percentage += 33;
    $scope.company_introduction = {
      css: UiService.get_count_css_class(percentage),
      percentage: percentage
    };
  };

  $scope.set_company_profile_badge = function () {
    $scope.set_user_data();
    var percentage = 0;
    if ($scope.user.company_title) percentage += 12.5;
    if ($scope.user.ssn) percentage += 12.5;
    if ($scope.user.country_id) percentage += 12.5;
    if ($scope.user.city_id) percentage += 12.5;
    if ($scope.user.phone) percentage += 12.5;
    if ($scope.user.fax) percentage += 12.5;
    if ($scope.user_groups.length > 0) percentage += 12.5;
    if ($scope.user_business_types.length > 0) percentage += 12.5;
    percentage = Math.floor(percentage);
    $scope.company_profile = {
      css: UiService.get_counter_css_class(percentage),
      percentage: percentage
    };
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.countries = window.countries;
    $scope.groups = _angular2.default.copy(window.groups);
    $scope.business_types = _angular2.default.copy(window.business_types);
    $scope.user = window.user;
    $scope.user_groups = [];
    $scope.user_business_types = [];
    $scope.user_addresses = window.user_addresses;
    $scope.user_banks = window.user_banks;
    $scope.dialog_address = _angular2.default.copy(window.address);
    $scope.dialog_bank = _angular2.default.copy(window.bank);
    $scope.business_relation_title = window.business_relation_title;
    $scope.eprivacy_title = window.eprivacy_title;
    $scope.epr_marketing_permission_title = window.epr_marketing_permission_title;
    $scope.epr_marketing_campaigns_title = window.epr_marketing_campaigns_title;
    $scope.gdpr_compliance_title = window.gdpr_compliance_title;
    $scope.offer_campaign_criteria_statuses = window.offer_campaign_criteria_statuses;
    $scope.set_financial_details_badge();
    $scope.set_company_introduction_badge();
    $scope.set_company_profile_badge();
  };

  $scope.init();
};

exports.default = UserDetails;


UserDetails.$inject = ['$scope', '$rootScope', 'GeoService', 'UserService', 'UserAddressService', 'UserBankService', 'UiService'];

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserEditCampaigns = function UserEditCampaigns($scope, OfferCampaignService, UserService, PaginationService) {
  _classCallCheck(this, UserEditCampaigns);

  $scope.tabs = [{
    title: 'All',
    status: null,
    campaigns: [],
    loading: false,
    page: 1
  }, {
    title: 'Pending',
    status: 2,
    campaigns: [],
    loading: false,
    page: 1
  }, {
    title: 'Sent',
    status: 1,
    campaigns: [],
    loading: false,
    page: 1
  }];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.load_data = function (tab) {
    $scope.loading = true;
    tab.loading = true;
    var filters = $scope.common_filters();
    filters.page = tab.page;
    filters.status = tab.status;
    filters.date_from = $scope.filter.date_from;
    filters.date_to = $scope.filter.date_to;
    OfferCampaignService.get(filters).success(function (data) {
      tab.campaigns = data.campaigns;
      tab.pagination = PaginationService.get_pagination(data.pagination);
      $scope.loading = false;
      tab.loading = false;
    });
  };

  $scope.load_all_data = function () {
    _angular2.default.forEach($scope.tabs, function (tab) {
      $scope.load_data(tab);
    });
  };

  $scope.common_filters = function () {
    if (window.user_type == 'Seller') return {
      supplier_id: window.user_id
    };else return {
      buyer_id: window.user_id
    };
  };

  $scope.init = function () {
    $scope.filter = {};
    $scope.stocklists = {};
    $scope.selected_tab = 0;
    $scope.filter.date_from = new Date(new Date().getFullYear(), 0, 1);
    $scope.load_all_data();
    UserService.get_stocklists(window.user_id).then(function (data) {
      _angular2.default.forEach(data.stocklists, function (entry) {
        $scope.stocklists[entry.campaign_id] = entry;
      });
    });
  };

  $scope.init();
};

exports.default = UserEditCampaigns;


UserEditCampaigns.$inject = ['$scope', 'OfferCampaignService', 'UserService', 'PaginationService'];

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserExport = function UserExport($scope, $filter, $timeout) {
  _classCallCheck(this, UserExport);

  $scope.export_options = [{
    id: 'users',
    title: 'Users'
  }, {
    id: 'contacts',
    title: 'Contacts'
  }, {
    id: 'addresses',
    title: 'Addresses'
  }, {
    id: 'user_categories',
    title: 'User Product Categories'
  }, {
    id: 'contact_categories',
    title: 'Contact Product Categories'
  }];

  $scope.user_roles = [{
    id: 0,
    name: 'Buyer'
  }, {
    id: 1,
    name: 'Seller'
  }, {
    id: 2,
    name: 'Both'
  }];

  $scope.init_filter = function () {
    $scope.filter = {
      role_id: 0,
      countries: [],
      date_from: null,
      date_to: null
    };
  };

  $scope.select2_options = {
    containerCssClass: 'multiselect2',
    dropdownCssClass: 'multiselect2',
    width: '600px'
  };

  $scope.select2_options_447 = {
    containerCssClass: 'multiselect2',
    dropdownCssClass: 'multiselect2',
    width: '447px'
  };

  $scope.export = function () {
    $timeout(function () {
      (0, _jquery2.default)('form#getXLS input[name="filter"]').val(JSON.stringify($scope.filter));
      (0, _jquery2.default)('form#getXLS input[name="mode"]').val($scope.export_option);
      (0, _jquery2.default)('form#getXLS').submit();
    }, 300);
  };

  $scope.toggleEUcountries = function toggleEUcountries(check_eu_countries) {
    if (check_eu_countries) {
      if (!$scope.filter.countries) {
        $scope.filter.countries = [];
      }
      $scope.filter.countries = $scope.filter.countries.concat($scope.eu_countries);
    } else {
      $scope.filter.countries = _underscore2.default.difference($scope.filter.countries, $scope.eu_countries);
    }
    (0, _jquery2.default)('#countries').select2('val', $scope.filter.countries);
  };

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.init = function () {
    $scope.export_option = $scope.export_options[0].id;
    $scope.eu_countries = window.eu.countries.map(function (a) {
      return String(a.id);
    });
    $scope.init_filter();
    if (_underscore2.default.difference($scope.eu_countries, $scope.filter.countries).length === 0) {
      $scope.check_eu_countries = true;
    }
  };

  $scope.init();
};

exports.default = UserExport;


UserExport.$inject = ['$scope', '$filter', '$timeout'];

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserFaqs = function UserFaqs($scope, UserService) {
  _classCallCheck(this, UserFaqs);

  $scope.set_selected_tab = function (index) {
    $scope.loading = true;
    $scope.selected_tab = index;
    var section_id = $scope.tabs[index].id;
    UserService.get_faqs($scope.user_id, section_id).then(function (data) {
      $scope.loading = false;
      $scope.faqs = data.faqs;
      $scope.apply_filter();
      $scope.set_select_all();
    });
  };

  $scope.faq_filters = [{
    id: 'All',
    title: 'All'
  }, {
    id: '1',
    title: 'Selected'
  }, {
    id: '0',
    title: 'Not Selected'
  }];

  $scope.$watch('faq_filter', function () {
    $scope.apply_filter();
  });

  $scope.apply_filter = function () {
    _angular2.default.forEach($scope.faqs, function (faq) {
      if ($scope.faq_filter == 'All') faq.show = true;else faq.show = $scope.faq_filter == faq.is_selected;
    });
  };

  $scope.set_select_all = function () {
    var selected_count = 0;
    _angular2.default.forEach($scope.faqs, function (faq) {
      if (parseInt(faq.is_selected) == 1) selected_count++;
    });
    if (selected_count > 0 && selected_count == $scope.faqs.length) $scope.tabs[$scope.selected_tab].select_all = '1';else $scope.tabs[$scope.selected_tab].select_all = '0';
  };

  $scope.open_dialog = function (dialog_id) {
    window.openFancyboxDialog('div#' + dialog_id);
  };

  $scope.edit_user_faq = function (faq) {
    $scope.dialog_faq = faq;
    $scope.open_dialog('user_faq_dialog');
  };

  $scope.save_user_faq = function () {
    $scope.updating = true;
    UserService.save_faq($scope.user_id, $scope.dialog_faq).then(function (data) {
      if (data.success) {
        $scope.updating = false;
        _jquery2.default.fancybox.close();
        $scope.set_selected_tab($scope.selected_tab);
      }
    });
  };

  $scope.set_faq_state = function (faq) {
    faq.updating = true;
    UserService.save_faq($scope.user_id, faq).then(function (data) {
      if (data.success) {
        faq.updating = false;
        $scope.set_select_all();
        if (parseInt(faq.is_selected) == 0) faq.custom_answer = null;
      }
    });
  };

  $scope.set_faq_mass_state = function (select_all) {
    var faqs = [];
    _angular2.default.forEach($scope.faqs, function (faq) {
      if (select_all != faq.is_selected) faqs.push(faq.id);
    });
    if (faqs.length > 0) {
      $scope.mass_updating = true;
      UserService.mass_save_faqs($scope.user_id, faqs, select_all).then(function (data) {
        if (data.success) {
          $scope.mass_updating = false;
          $scope.set_selected_tab($scope.selected_tab);
        }
      });
    }
  };

  $scope.init = function () {
    $scope.user_id = window.user_id;
    $scope.faq_sections = window.faq_sections;
    $scope.tabs = [{
      id: 0,
      title: 'All',
      select_all: '0'
    }];
    _angular2.default.forEach($scope.faq_sections, function (section) {
      $scope.tabs.push({
        id: section.id,
        title: section.title,
        select_all: '0'
      });
    });
    $scope.dialog_faq = null;
    $scope.faq_filter = 'All';
    $scope.set_selected_tab(0);
  };

  $scope.init();
};

exports.default = UserFaqs;


UserFaqs.$inject = ['$scope', 'UserService'];

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserFreightRatesExport = function UserFreightRatesExport($scope, $timeout) {
  _classCallCheck(this, UserFreightRatesExport);

  $scope.export = function () {
    $timeout(function () {
      (0, _jquery2.default)('form#getXLS').submit();
    }, 300);
  };
};

exports.default = UserFreightRatesExport;


UserFreightRatesExport.$inject = ['$scope', '$timeout'];

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserFreightRatesImport = function UserFreightRatesImport($scope, $rootScope, FileUploader) {
  _classCallCheck(this, UserFreightRatesImport);

  $scope.set_uploaders = function () {
    var f = new FileUploader({
      url: '/admin/marketplace/users/import_user_freight_rates',
      formData: [{
        authenticity_token: window.token,
        user_id: window.user_id
      }],
      removeAfterUpload: true
    });
    f.file_element = 'upload_file';
    f.onBeforeUploadItem = function () /*item*/{
      f.processing = true;
    };
    f.onCompleteItem = function (fileItem, response /*, status, headers*/) {
      if (response.success) {
        f.processing = false;
        f.clearQueue();
        (0, _jquery2.default)('input.' + f.file_element).val(null);
        $rootScope.$broadcast('load_freight_rates');
      }
    };
    $scope.uploader = f;
  };

  $scope.init = function () {
    $scope.set_uploaders();
  };

  $scope.init();
};

exports.default = UserFreightRatesImport;


UserFreightRatesImport.$inject = ['$scope', '$rootScope', 'FileUploader'];

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserFreightRates = function UserFreightRates($scope, $rootScope, UserFreightRateService, GeoService) {
  _classCallCheck(this, UserFreightRates);

  function load_data() {
    $scope.user_freight_rates = [];
    UserFreightRateService.get_user_freight_rates(window.user_id).success(function (data) {
      if (data.success) $scope.user_freight_rates = data.user_freight_rates;
    });
  }

  $scope.open_dialog = function (dialog_id) {
    window.openFancyboxDialog('div#' + dialog_id);
  };

  $scope.$watch('dialog_rate.shipment_country_id', function () {
    if ($scope.dialog_rate.shipment_country_id) {
      GeoService.get_cities($scope.dialog_rate.shipment_country_id).then(function (data) {
        $scope.dialog_rate_shipment_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.dialog_rate.shipment_city_id })) $scope.dialog_rate.shipment_city_id = null;
      });
    }
  });

  $scope.$watch('dialog_rate.delivery_country_id', function () {
    if ($scope.dialog_rate.delivery_country_id) {
      GeoService.get_cities($scope.dialog_rate.delivery_country_id).then(function (data) {
        $scope.dialog_rate_delivery_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.dialog_rate.delivery_city_id })) $scope.dialog_rate.delivery_city_id = null;
      });
    }
  });

  $scope.add_freight_rate = function () {
    $scope.dialog_rate = _angular2.default.copy(window.freight_rate);
    $scope.open_dialog('user_freight_rate_dialog');
  };

  $scope.copy_freight_rate = function (rate) {
    $scope.dialog_rate = _angular2.default.copy(rate);
    $scope.dialog_rate.id = null;
    $scope.open_dialog('user_freight_rate_dialog');
  };

  $scope.edit_freight_rate = function (freight_rate) {
    $scope.dialog_rate = freight_rate;
    $scope.open_dialog('user_freight_rate_dialog');
  };

  $scope.delete_freight_rate = function (index) {
    if (confirm('Are you sure you want to delete this freight rate?')) {
      UserFreightRateService.delete($scope.user_freight_rates[index].id).then(function (data) {
        if (data.success) {
          $scope.user_freight_rates.splice(index, 1);
          $rootScope.$broadcast('set_sidebar_data', [0, 4, [{
            type: 'counter',
            value: $scope.user_freight_rates.length
          }]]);
        }
      });
    }
  };

  $scope.save_freight_rate = function () {
    $scope.updating_rate = true;
    UserFreightRateService.save($scope.dialog_rate).then(function (data) {
      if (data.success) {
        $scope.updating_rate = false;
        _jquery2.default.fancybox.close();
        $scope.user_freight_rates = data.user_freight_rates;
        $rootScope.$broadcast('set_sidebar_data', [0, 4, [{
          type: 'counter',
          value: $scope.user_freight_rates.length
        }]]);
      }
    });
  };

  $scope.$on('load_freight_rates', function () {
    load_data();
  });

  $scope.init = function () {
    $scope.delivery_terms = window.delivery_terms;
    $scope.countries = window.countries;
    $scope.currencies = window.currencies;
    $scope.user_id = window.user_id;
    $scope.dialog_rate = _angular2.default.copy(window.freight_rate);
    load_data();
  };

  $scope.init();
};

exports.default = UserFreightRates;


UserFreightRates.$inject = ['$scope', '$rootScope', 'UserFreightRateService', 'GeoService'];

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserImport = function UserImport($scope, FileUploader) {
  _classCallCheck(this, UserImport);

  $scope.set_uploaders = function () {
    var uploaders = [{
      name: 'users_uploader',
      url: '/admin/marketplace/users/import_users',
      element: 'users_file'
    }, {
      name: 'contacts_uploader',
      url: '/admin/marketplace/users/import_contacts',
      element: 'contacts_file'
    }, {
      name: 'addresses_uploader',
      url: '/admin/marketplace/users/import_addresses',
      element: 'addresses_file'
    }, {
      name: 'user_categories_uploader',
      url: '/admin/marketplace/users/import_user_categories',
      element: 'user_categories_file'
    }, {
      name: 'contact_categories_uploader',
      url: '/admin/marketplace/users/import_contact_categories',
      element: 'contact_categories_file'
    }];
    _underscore2.default.each(uploaders, function (uploader) {
      var f = new FileUploader({
        url: uploader.url,
        formData: [{
          authenticity_token: window.token
        }],
        removeAfterUpload: true
      });
      f.file_element = uploader.element;
      f.onBeforeUploadItem = function () /*item*/{
        f.processing = true;
      };
      f.onCompleteItem = function (fileItem, response /*, status, headers*/) {
        if (response.success) {
          f.processing = false;
          f.clearQueue();
          (0, _jquery2.default)('input.' + f.file_element).val(null);
        }
      };
      $scope[uploader.name] = f;
    });
  };

  $scope.init = function () {
    $scope.set_uploaders();
  };

  $scope.init();
};

exports.default = UserImport;


UserImport.$inject = ['$scope', 'FileUploader'];

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserIncotermCharges = function UserIncotermCharges($scope, UserService) {
  _classCallCheck(this, UserIncotermCharges);

  $scope.load_charges = function () {
    $scope.loading = true;
    UserService.get_incoterm_charges(window.user_id).then(function (data) {
      $scope.charges = data.charges;
      $scope.loading = false;
    });
  };

  $scope.save_charge = function () {
    $scope.saving_charge = true;
    UserService.save_incoterm_charge($scope.charge).then(function (data) {
      if (data.success) {
        $scope.saving_charge = false;
        _jquery2.default.fancybox.close();
        $scope.load_charges();
      }
    });
  };

  $scope.add_charge = function () {
    $scope.charge = _angular2.default.copy(window.charge);
    window.openFancyboxDialog('div#charge_dialog');
  };

  $scope.edit_charge = function (charge) {
    $scope.charge = charge;
    window.openFancyboxDialog('div#charge_dialog');
  };

  $scope.delete_charge = function (charge_id) {
    if (confirm('Are you sure you want to delete this charge?')) {
      UserService.delete_incoterm_charge(charge_id).then(function (data) {
        if (data.success) $scope.load_charges();
      });
    }
  };

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.init = function () {
    $scope.load_charges();
  };

  $scope.init();
};

exports.default = UserIncotermCharges;


UserIncotermCharges.$inject = ['$scope', 'UserService'];

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserManageCities = function UserManageCities($scope, GeoService) {
  _classCallCheck(this, UserManageCities);

  $scope.$watch('country_id', function () {
    $scope.edit_city = '';
    if ($scope.country_id) {
      GeoService.get_cities($scope.country_id).then(function (data) {
        $scope.cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.city })) $scope.city = null;
      });
    }
  });

  $scope.$watch('city', function () {
    $scope.edit_city = $scope.city ? $scope.city.title : '';
  });

  $scope.update_city = function () {
    $scope.updating = true;
    $scope.update_error = '';
    var city = {
      id: $scope.city.id,
      title: $scope.edit_city
    };
    GeoService.save_city(city).then(function (data) {
      if (data.success) {
        $scope.city.title = city.title;
      } else {
        $scope.update_error = data.message;
      }
      $scope.updating = false;
    });
  };

  $scope.add_city = function () {
    $scope.adding = true;
    $scope.add_error = '';
    var city = {
      country_id: $scope.country_id,
      title: $scope.new_city
    };
    GeoService.save_city(city).then(function (data) {
      if (data.success) {
        $scope.add_error = 'City added!';
        GeoService.get_cities($scope.country_id).then(function (data) {
          $scope.cities = data.cities;
          if (!_underscore2.default.findWhere(data.cities, { id: $scope.city })) $scope.city = null;
        });
      } else {
        $scope.add_error = data.message;
      }
      $scope.adding = false;
    });
  };

  $scope.get_country_label = function (country) {
    return country.titleEN + ' (' + country.id + ')';
  };

  $scope.get_city_label = function (city) {
    return city.title + ' (' + city.id + ')';
  };

  $scope.init = function () {
    $scope.countries = window.countries;
  };

  $scope.init();
};

exports.default = UserManageCities;


UserManageCities.$inject = ['$scope', 'GeoService'];

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserManageCompanies = function UserManageCompanies($scope, UserService, PaginationService) {
  _classCallCheck(this, UserManageCompanies);

  $scope.tabs = [{
    title: 'All',
    user_type: null,
    users: [],
    page: 1
  }, {
    title: 'Buyers',
    user_type: 'Buyer',
    users: [],
    page: 1
  }, {
    title: 'Sellers',
    user_type: 'Seller',
    users: [],
    page: 1
  }];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
    $scope.query = '';
  };

  $scope.quick_search = function () {
    window.filter_table('table#users', $scope.query);
  };

  $scope.common_filters = function () {
    return {
      per_page: 50
    };
  };

  $scope.load_users = function (tab) {
    $scope.query = '';
    var filters = $scope.common_filters();
    filters.page = tab.page;
    filters.user_type = tab.user_type;
    UserService.search(filters).then(function (data) {
      tab.users = data.users;
      tab.pagination = PaginationService.get_pagination(data.pagination);
    });
  };

  $scope.load_pending_imports = function () {
    $scope.pending_imports = [];
    UserService.get_pending_imports().then(function (data) {
      $scope.pending_imports = data.pending_imports;
    });
  };

  $scope.open_dialog = function (dialog_id) {
    window.openFancyboxDialog('div#' + dialog_id);
  };

  $scope.view_pending_import = function (pending_import) {
    $scope.dialog = pending_import;
    $scope.open_dialog('pending_import_dialog');
  };

  $scope.delete_pending_import = function () {
    if (confirm('Are you sure you want to delete this pending import?')) {
      $scope.deleting = true;
      UserService.delete_pending_import($scope.dialog.id).then(function (data) {
        if (data.success) {
          var index = $scope.pending_imports.indexOf($scope.dialog);
          $scope.pending_imports.splice(index, 1);
          $scope.deleting = false;
          _jquery2.default.fancybox.close();
        }
      });
    }
  };

  $scope.check_pending_imports = function () {
    _underscore2.default.each($scope.pending_imports, function (i) {
      i.checked = $scope.pending_imports_checked;
    });
  };

  $scope.mass_create_users = function () {
    var imports = _underscore2.default.where($scope.pending_imports, {
      checked: true
    });
    if (imports.length === 0) {
      alert('Please select at least one Pending Import!');
    } else {
      $scope.mass_creating_users = true;
      UserService.mass_create_from_pending_imports(_underscore2.default.pluck(imports, 'id')).success(function (data) {
        if (data.success) {
          $scope.mass_creating_users = false;
          $scope.load_pending_imports();
        }
      });
    }
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.pending_imports = [];
    _angular2.default.forEach($scope.tabs, function (tab) {
      $scope.load_users(tab);
    });
    $scope.load_pending_imports();
  };

  $scope.init();
};

exports.default = UserManageCompanies;


UserManageCompanies.$inject = ['$scope', 'UserService', 'PaginationService'];

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserManageContacts = function UserManageContacts($scope, UserContactService, UserService, PaginationService) {
  _classCallCheck(this, UserManageContacts);

  $scope.select2_options = {
    containerCssClass: 'multiselect2',
    dropdownCssClass: 'multiselect2',
    width: '800px'
  };

  function set_user_company_autocomplete(input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company(null, request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.filter.user_id = ui.item.id;
        $scope.$apply();
      }
    });
  }

  $scope.load_data = function () {
    $scope.select_all = false;
    $scope.loading = true;
    UserContactService.get($scope.filter).success(function (data) {
      $scope.contacts = data.contacts;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
      $scope.loading = false;
    });
  };

  $scope.load_count_data = function () {
    UserContactService.get_campaign_status_counts().success(function (data) {
      $scope.active = data.active;
      $scope.unregistered = data.unregistered;
      $scope.bounced = data.bounced;
      $scope.on_probation = data.on_probation;
      $scope.on_probation_expired = data.on_probation_expired;
    });
  };

  $scope.mass_update_status = function (campaign_status) {
    var contacts = _underscore2.default.where($scope.contacts, {
      checked: true
    });

    if (contacts.length === 0) {
      alert('Please select at least one contact!');
      return;
    }

    UserContactService.mass_update_contact_campaign_status(_underscore2.default.pluck(contacts, 'id'), campaign_status).success(function (data) {
      if (data.success) {
        $scope.load_data();
        $scope.load_count_data();
      }
    });
  };

  $scope.init_filter = function () {
    $scope.user_company = null;
    $scope.filter = {
      page: 1,
      per_page: 50,
      user_id: null,
      email: null,
      first_name: null,
      last_name: null,
      phone: null,
      campaign_status: null,
      probation_expire_status: null,
      business_relation: null,
      has_categories: null,
      countries: [],
      date_from: null,
      date_to: null
    };
  };

  $scope.set_preset_filter = function (campaign_status, probation_expired) {
    $scope.filter.campaign_status = campaign_status;
    if (probation_expired) {
      $scope.filter.probation_expire_status = 1;
    } else if (campaign_status !== 4 || !probation_expired) {
      $scope.filter.probation_expire_status = null;
    }
  };

  $scope.show_contact_details = function (user_contact) {
    $scope.$broadcast('show_user_contact_notifications', {
      user_contact: user_contact
    });
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.load_data();
  };

  $scope.check_contacts = function () {
    _underscore2.default.each($scope.contacts, function (c) {
      c.checked = $scope.select_all;
    });
  };

  $scope.quick_search = function () {
    window.filter_table('table.data', $scope.quick_filter);
  };

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.business_relations = [{
    id: 0,
    title: 'Unqualified Lead'
  }, {
    id: 1,
    title: 'Qualified Lead'
  }, {
    id: 2,
    title: 'Contact'
  }, {
    id: 3,
    title: 'Customer'
  }, {
    id: 4,
    title: 'Corporate Supplier'
  }];

  $scope.has_categories_options = [{
    id: 1,
    title: 'Yes'
  }, {
    id: 2,
    title: 'No'
  }];

  $scope.probation_end_options = [{
    id: 1,
    title: 'Yes'
  }, {
    id: 2,
    title: 'No'
  }];

  $scope.init = function () {
    $scope.contacts = [];
    $scope.pagination = {};
    $scope.campaign_statuses = window.campaign_statuses;
    set_user_company_autocomplete((0, _jquery2.default)('input.user_company'));
    $scope.init_filter();
    $scope.load_data();
    $scope.load_count_data();
  };

  $scope.init();
};

exports.default = UserManageContacts;


UserManageContacts.$inject = ['$scope', 'UserContactService', 'UserService', 'PaginationService'];

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserManageEmailHostnames = function UserManageEmailHostnames($scope, EmailService) {
  _classCallCheck(this, UserManageEmailHostnames);

  $scope.add_email_hostname = function () {
    $scope.adding = true;
    $scope.add_error = '';
    var email_hostname = {
      id: null,
      name: $scope.email_hostname
    };
    EmailService.save_email_hostname(email_hostname).then(function (data) {
      if (data.success) {
        $scope.add_error = 'Hostname added!';
        $scope.push_hostname(data.id, email_hostname.name);
      } else {
        $scope.add_error = data.message;
      }
      $scope.adding = false;
    });
  };

  $scope.push_hostname = function (id, name) {
    var hostname = {
      email_hostname: {
        id: id,
        name: name
      }
    };
    $scope.email_hostnames.push(hostname);
  };

  $scope.init = function () {
    $scope.email_hostnames = window.email_hostnames;
  };

  $scope.init();
};

exports.default = UserManageEmailHostnames;


UserManageEmailHostnames.$inject = ['$scope', 'EmailService'];

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserManageMembers = function UserManageMembers($scope, UserContactService) {
  _classCallCheck(this, UserManageMembers);

  $scope.tabs = [{
    title: 'Pending Registrations',
    count: 0
  }, {
    title: 'Pending Accounts',
    count: 0
  }, {
    title: 'Pending Invitations',
    count: 0
  }, {
    title: 'Activated Accounts',
    count: 0
  }, {
    title: 'Deactivated Accounts',
    count: 0
  }, {
    title: 'No Accounts',
    count: 0
  }];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.invitation_status = function (invitation) {
    if (invitation) return invitation.status == 0 ? 'Pending' : 'Accepted';else return '';
  };

  $scope.cancel_invitation = function (contact) {
    UserContactService.delete_invitation(contact.invitation.id).then(function (data) {
      if (data.success) {
        $scope.pending_invitations.splice(window.pending_invitations.indexOf(contact), 1);
        $scope.tabs[2].count = window.pending_invitations.length;
        alert('Invitation is now cancelled!');
      } else {
        alert('Error while cancelling invitation!');
      }
    });
  };

  $scope.set_account_status = function (account, status, tab_index) {
    UserContactService.update_account_status(account.account_id, status).then(function (data) {
      if (data.success) {
        if (tab_index == 1) {
          $scope.pending_accounts.splice(window.pending_accounts.indexOf(account), 1);
          $scope.tabs[1].count = window.pending_accounts.length;
        } else if (tab_index == 3) {
          $scope.activated_accounts.splice(window.activated_accounts.indexOf(account), 1);
          $scope.tabs[3].count = window.activated_accounts.length;
        } else if (tab_index == 4) {
          $scope.deactivated_accounts.splice(window.deactivated_accounts.indexOf(account), 1);
          $scope.tabs[4].count = window.deactivated_accounts.length;
        }
        alert('Account is now ' + status + '!');
      } else {
        alert('Error while changing account status!');
      }
    });
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope._ = _underscore2.default;
    $scope.pending_registrations = window.pending_registrations;
    $scope.pending_accounts = window.pending_accounts;
    $scope.pending_invitations = window.pending_invitations;
    $scope.activated_accounts = window.activated_accounts;
    $scope.deactivated_accounts = window.deactivated_accounts;
    $scope.tabs[0].count = window.pending_registrations.length;
    $scope.tabs[1].count = window.pending_accounts.length;
    $scope.tabs[2].count = window.pending_invitations.length;
    $scope.tabs[3].count = window.activated_accounts.length;
    $scope.tabs[4].count = window.deactivated_accounts.length;
  };

  $scope.init();
};

exports.default = UserManageMembers;


UserManageMembers.$inject = ['$scope', 'UserContactService'];

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserMarketRestrictions = function UserMarketRestrictions($scope, $rootScope, UserMarketRestrictionService, UserService) {
  _classCallCheck(this, UserMarketRestrictions);

  $scope.tabs = ['Country Restrictions', 'Group Restrictions', 'Member Restrictions'];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.get_selected_tab = function () {
    return $scope.selected_tab;
  };

  $scope.open_dialog = function (dialog_id) {
    window.openFancyboxDialog('div#' + dialog_id);
  };

  $scope.select2_options = {
    containerCssClass: 'multiselect2',
    dropdownCssClass: 'multiselect2',
    width: '500px'
  };

  $scope.update_continent_countries = function (continent) {
    _angular2.default.forEach(continent.countries, function (country) {
      country.checked = continent.checked;
    });
  };

  $scope.update_data = function () {
    $scope.user.country_restrictions = [];
    _angular2.default.forEach(window.continents, function (continent) {
      _angular2.default.forEach(continent.countries, function (country) {
        if (country.checked) $scope.user.country_restrictions.push(country.id);
      });
    });

    $scope.user.group_restrictions = [];
    _angular2.default.forEach(window.groups, function (group) {
      if (group.checked) $scope.user.group_restrictions.push(group.id);
    });
  };

  $scope.update_restrictions = function () {
    $scope.updating = true;
    $scope.update_data();
    UserMarketRestrictionService.update($scope.user).then(function (data) {
      if (data.success) {
        $scope.updating = false;
        $rootScope.$broadcast('set_sidebar_data', [window.is_buyer ? 3 : 0, window.is_buyer ? 5 : 7, [{
          type: 'counter',
          value: data.user_restrictions_count
        }]]);
      }
    });
  };

  $scope.set_user_company_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company(null, request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.dialog_member_restriction.member_id = ui.item.id;
        $scope.dialog_member_restriction.member_company = ui.item.value;
        $scope.$apply();
      }
    });
  };

  $scope.add_member_restriction = function () {
    $scope.dialog_member_restriction = _angular2.default.copy(window.member_restriction);
    $scope.user_company = '';
    $scope.open_dialog('user_member_restriction_dialog');
  };

  $scope.edit_member_restriction = function (member_restriction) {
    $scope.dialog_member_restriction = member_restriction;
    $scope.user_company = '';
    $scope.open_dialog('user_member_restriction_dialog');
  };

  $scope.delete_member_restriction = function (index) {
    if (confirm('Are you sure you want to delete this member restriction?')) {
      UserMarketRestrictionService.delete_member_restriction($scope.user.member_restrictions[index].id).then(function (data) {
        if (data.success) {
          $scope.user.member_restrictions.splice(index, 1);
          $rootScope.$broadcast('set_sidebar_data', [window.is_buyer ? 3 : 0, window.is_buyer ? 5 : 7, [{
            type: 'counter',
            value: data.user_restrictions_count
          }]]);
        }
      });
    }
  };

  $scope.save_member_restriction = function () {
    $scope.updating_member_restriction = true;
    UserMarketRestrictionService.save_member_restriction($scope.dialog_member_restriction).then(function (data) {
      if (data.success) {
        $scope.updating_member_restriction = false;
        _jquery2.default.fancybox.close();
        $scope.user.member_restrictions = data.user_member_restrictions;
        $rootScope.$broadcast('set_sidebar_data', [window.is_buyer ? 3 : 0, window.is_buyer ? 5 : 7, [{
          type: 'counter',
          value: data.user_restrictions_count
        }]]);
      }
    });
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.user = window.user;
    $scope.continents = window.continents;
    $scope.groups = window.groups;
    $scope.dialog_member_restriction = _angular2.default.copy(window.member_restriction);
    $scope.set_user_company_autocomplete((0, _jquery2.default)('input.user_company'));
  };

  $scope.init();
};

exports.default = UserMarketRestrictions;


UserMarketRestrictions.$inject = ['$scope', '$rootScope', 'UserMarketRestrictionService', 'UserService'];

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserOfferMatching = function UserOfferMatching($scope, UserService, OfferService) {
  _classCallCheck(this, UserOfferMatching);

  $scope.tabs = [{
    title: 'Matched Offers',
    offers: [],
    loading: false,
    checked: false
  }];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
    $scope.query = '';
  };

  $scope.get_supplier_label = function (supplier) {
    return supplier.company + ' (' + supplier.id + ')';
  };

  $scope.quick_search = function () {
    window.filter_table('table#offers', $scope.query);
  };

  $scope.get_matched_offers = function () {
    var tab = 0;
    $scope.query = '';
    $scope.tabs[tab].offers = [];
    $scope.tabs[tab].loading = true;
    $scope.tabs[tab].checked = false;
    UserService.get_matched_offers($scope.user_id, $scope.filter).then(function (data) {
      $scope.tabs[tab].offers = data.offers;
      $scope.tabs[tab].loading = false;
    });
  };

  $scope.check_offers = function () {
    var tab = $scope.tabs[$scope.selected_tab];
    _angular2.default.forEach(tab.offers, function (offer) {
      offer.checked = tab.checked;
    });
  };

  $scope.get_offer_matched_items = function (index) {
    var offer = $scope.analysis_offers[index];
    OfferService.get_matched_items(offer.id, $scope.user_id, $scope.filter, false).then(function (data) {
      console.log(data);
      offer.items = data.items;
      offer.items_quantity = window.roundToTwo(_underscore2.default.reduce(_underscore2.default.pluck(data.items, 'quantity'), function (quantity, num) {
        return quantity + num;
      }, 0));
      offer.items_quality_accuracy = Math.floor(_underscore2.default.reduce(_underscore2.default.pluck(data.items, 'quality_accuracy'), function (accuracy, num) {
        return accuracy + num;
      }, 0) / data.items.length);
      offer.items_specs_accuracy = Math.floor(_underscore2.default.reduce(_underscore2.default.pluck(data.items, 'specs_accuracy'), function (accuracy, num) {
        return accuracy + num;
      }, 0) / data.items.length);
      offer.unique_products = _underscore2.default.uniq(_underscore2.default.compact(_underscore2.default.pluck(data.items, 'product_id')));
      offer.accurate_items = _underscore2.default.filter(data.items, function (item) {
        return item.specs_accuracy >= 80;
      });
      offer.accurate_items_quantity = window.roundToTwo(_underscore2.default.reduce(_underscore2.default.pluck(offer.accurate_items, 'quantity'), function (quantity, num) {
        return quantity + num;
      }, 0));
      if (index < $scope.analysis_offers.length - 1) $scope.get_offer_matched_items(index + 1);
    });
  };

  $scope.standard_analysis = function () {
    var tab = $scope.tabs[0];
    $scope.analysis_offers = [];
    _angular2.default.forEach(tab.offers, function (offer) {
      if (offer.checked) {
        offer.items = null;
        offer.items_quantity = null;
        offer.items_quality_accuracy = null;
        offer.items_specs_accuracy = null;
        offer.unique_products = null;
        offer.accurate_items = null;
        offer.accurate_items_quantity = null;
        $scope.analysis_offers.push(offer);
      }
    });
    $scope.get_offer_matched_items(0);
  };

  $scope.get_analysis_url = function (offer_id) {
    return '/admin/marketplace/offers/edit_user_pricing/' + offer_id + '?user_id=' + window.user_id;
  };

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.show_by_min_quantity = function (offer) {
    var min_quantity = parseInt($scope.filter.min_quantity);
    if (!isNaN(min_quantity) && offer.items_quantity) return offer.items_quantity >= min_quantity;else return true;
  };

  $scope.filter = {
    buyer_id: window.user_id,
    supplier_id: null,
    date_from: null,
    date_to: null,
    user_countries: [],
    has_specs: 'all',
    user_group: 'all',
    business_relation: -1,
    pre_min_quality_accuracy: 1,
    pre_min_specs_accuracy: 1,
    min_quality_accuracy: 1,
    min_specs_accuracy: 1,
    specs_method_standard: true,
    specs_method_relative: false,
    specs_method_special: false,
    specs_method_advanced: false,
    specs_matching_accurate: true,
    specs_matching_flexible: true,
    specs_matching_basic_only: false,
    min_quantity: 0
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.user_id = window.user_id;
    $scope.suppliers = window.suppliers;
  };

  $scope.init();
};

exports.default = UserOfferMatching;


UserOfferMatching.$inject = ['$scope', 'UserService', 'OfferService'];

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserOfferRequestItems = function UserOfferRequestItems($scope, OfferRequestService, OfferRequestItemService, PaginationService) {
  _classCallCheck(this, UserOfferRequestItems);

  $scope.quick_search = function () {
    window.filter_table('table#items', $scope.query);
  };

  $scope.get_offer_request_items = function () {
    $scope.searching = true;
    OfferRequestService.find_offer_request_items($scope.filter).success(function (data) {
      $scope.offer_requests = data.offer_requests;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
      $scope.searching = false;
    });
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.get_offer_request_items();
  };

  $scope.init_filters = function () {
    $scope.filter = {
      page: 1,
      per_page: 10,
      supplier_id: null,
      buyer_id: null,
      status: window.item_statuses
    };
  };

  $scope.get_offer_request_status_title = function (status) {
    return _underscore2.default.findWhere($scope.offer_request_statuses, {
      id: status
    }).title;
  };

  $scope.get_item_status_title = function (status) {
    return _underscore2.default.findWhere($scope.item_statuses, {
      id: status
    }).title;
  };

  $scope.get_fields = function (fields) {
    return _underscore2.default.filter(fields, function (f) {
      return $scope.item_view === 1 || f.standard !== false;
    });
  };

  $scope.get_request_fields = function (offer_request) {
    return _underscore2.default.filter(offer_request.request_fields, function (f) {
      return $scope.item_view === 1 || f.standard !== false;
    });
  };

  /*function price_incoterm_match(offer_request, request_field) {
    if (!request_field.is_price || !offer_request.delivery_term_id)
      return true;
    else if (request_field.is_price)
      return request_field.name === offer_request.delivery_term;
  }*/

  $scope.item_views = [{
    id: 0,
    title: 'Standard View'
  }, {
    id: 1,
    title: 'Full View'
  }];

  $scope.init = function () {
    $scope.init_filters();
    if (window.user_type == 'Buyer') $scope.filter.buyer_id = window.user_id;else $scope.filter.supplier_id = window.user_id;
    $scope.offer_request_statuses = OfferRequestService.get_status_options();
    $scope.item_statuses = OfferRequestItemService.get_status_options();
    $scope.get_offer_request_items();
    $scope.item_view = 0;
    $scope._ = _underscore2.default;
  };

  $scope.init();
};

exports.default = UserOfferRequestItems;


UserOfferRequestItems.$inject = ['$scope', 'OfferRequestService', 'OfferRequestItemService', 'PaginationService'];

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserOffers = function UserOffers($scope, OfferService, PaginationService) {
  _classCallCheck(this, UserOffers);

  $scope.quick_search = function () {
    window.filter_table('table#offers', $scope.query);
  };

  $scope.get_offers = function () {
    $scope.searching = true;
    OfferService.get_manage_data($scope.filter).then(function (data) {
      $scope.offers = data.offers;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
      $scope.searching = false;
    });
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.get_offers();
  };

  $scope.init_filters = function () {
    $scope.filter = {
      page: 1,
      per_page: 50,
      sort_by: null,
      sort_by_mode: 1
    };
    if (window.is_buyer) $scope.filter.buyer_id = window.user_id;else $scope.filter.supplier_id = window.user_id;
  };

  $scope.getDescriptionPercentage = function (offer) {
    var percentage = 0;
    if (offer.subtitleEN) percentage += 33;
    if (offer.full_description) percentage += 33;
    if (offer.notes) percentage += 34;
    return percentage;
  };

  $scope.init = function () {
    $scope.init_filters();
    $scope.get_offers();
  };

  $scope.init();
};

exports.default = UserOffers;


UserOffers.$inject = ['$scope', 'OfferService', 'PaginationService'];

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserOrders = function UserOrders($scope, OrderService, PaginationService, UserService, DateService) {
  _classCallCheck(this, UserOrders);

  $scope.quick_search = function () {
    window.filter_table('table#orders', $scope.query);
  };

  function set_supplier_company_autocomplete(input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Seller', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.filter.supplier_id = ui.item.id;
        $scope.$apply();
      }
    });
  }

  $scope.get_orders = function () {
    $scope.searching = true;
    OrderService.get_manage_data($scope.filter).then(function (data) {
      $scope.orders = data.orders;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
      $scope.searching = false;
    });
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.get_orders();
  };

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.get_status_title = function (status) {
    return _underscore2.default.find($scope.order_statuses, function (s) {
      return s.id == status;
    }).title;
  };

  $scope.get_payment_status_title = function (status) {
    return _underscore2.default.find($scope.payment_statuses, function (s) {
      return s.id == status;
    }).title;
  };

  $scope.get_delivery_status_title = function (status) {
    return _underscore2.default.find($scope.delivery_statuses, function (s) {
      return s.id == status;
    }).title;
  };

  $scope.get_need_attention = function () {
    var now = new Date();
    var date_from = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 60);
    var date_to = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 21);
    $scope.filter.date_from = DateService.get_date_str(date_from);
    $scope.filter.date_to = DateService.get_date_str(date_to);
    $scope.filter.status = 0;
    $scope.filter.has_booking_notes = 'no';
    $scope.filter.sort_by = 0;
    $scope.get_orders();
  };

  $scope.show_all = function () {
    $scope.filter.date_from = null;
    $scope.filter.date_to = null;
    $scope.filter.status = -1;
    $scope.filter.has_booking_notes = 'all';
    $scope.filter.sort_by = null;
    $scope.get_orders();
  };

  $scope.init_filters = function () {
    $scope.filter = {
      page: 1,
      per_page: 50,
      sort_by: null,
      sort_by_mode: 1,
      supplier_id: null,
      buyer_id: null,
      status: -1,
      delivery_status: -1,
      payment_status: -1,
      issued_column: 'date_issued_pi',
      has_stocklist: 'all',
      has_updated_pref: 'all',
      has_terms: 'all',
      date_from: null,
      date_to: null,
      has_booking_notes: 'all'
    };
  };

  $scope.init = function () {
    set_supplier_company_autocomplete((0, _jquery2.default)('input.supplier_company'));
    $scope.order_statuses = window.order_statuses;
    $scope.delivery_statuses = window.delivery_statuses;
    $scope.payment_statuses = window.payment_statuses;
    $scope.init_filters();
    if (window.user_type == 'Buyer') {
      $scope.filter.buyer_id = window.user_id;
    } else {
      $scope.filter.supplier_id = window.user_id;
    }
    $scope.user_type = window.user_type;
    $scope.get_orders();
  };

  $scope.init();
};

exports.default = UserOrders;


UserOrders.$inject = ['$scope', 'OrderService', 'PaginationService', 'UserService', 'DateService'];

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserOverview = function () {
  function UserOverview($scope, UserService) {
    _classCallCheck(this, UserOverview);

    $scope.user_id = window.user_id;
    $scope.selected_tab = 0;
    $scope.set_selected_tab = this.set_selected_tab.bind(this);

    this.UserService = UserService;
    this.$scope = $scope;
    this.load_data();
  }

  _createClass(UserOverview, [{
    key: 'set_selected_tab',
    value: function set_selected_tab(index) {
      this.$scope.selected_tab = index;
    }
  }, {
    key: 'load_data',
    value: function load_data() {
      var _this = this;

      this.$scope.user = {};
      this.$scope.notes = [];
      this.$scope.notes_count = 0;
      this.$scope.loading = true;

      this.UserService.get_overview_data(this.$scope.user_id).then(function (res) {
        _this.$scope.user = res.data.user;
        _this.$scope.notes = res.data.notes;
        _this.$scope.notes_count = _underscore2.default.reduce(res.data.notes, function (memo, note) {
          return memo + note.value;
        }, 0);
        _this.$scope.loading = false;
      });
    }
  }]);

  return UserOverview;
}();

exports.default = UserOverview;


UserOverview.$inject = ['$scope', 'UserService'];

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProductBrandPricing = function UserProductBrandPricing($scope, GeoService) {
  _classCallCheck(this, UserProductBrandPricing);

  $scope.$watch('$parent.pricing.user_product_brand_pricing.country_id', function () {
    if ($scope.$parent.pricing.user_product_brand_pricing.country_id) {
      GeoService.get_cities($scope.$parent.pricing.user_product_brand_pricing.country_id).then(function (data) {
        $scope.pricing_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.pricing.user_product_brand_pricing.city_id })) $scope.pricing.user_product_brand_pricing.city_id = null;
      });
    }
  });

  $scope.product_types = [{
    id: 1,
    title: 'Reels'
  }, {
    id: 0,
    title: 'Sheets'
  }];

  $scope.init = function () {
    $scope.countries = _angular2.default.copy(window.countries);
  };

  $scope.init();
};

exports.default = UserProductBrandPricing;


UserProductBrandPricing.$inject = ['$scope', 'GeoService'];

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProductCopyFromUserDialog = function () {
  function UserProductCopyFromUserDialog($scope, UserService, UserProductService, UiService) {
    var _this = this;

    _classCallCheck(this, UserProductCopyFromUserDialog);

    $scope.copy_mode = 1;
    $scope.copy_modes = this.get_copy_modes();

    $scope.$on('show_user_products_copy_from_user_dialog', function (event, data) {
      _this.target_user_id = data.user_id;

      UiService.open_fancybox_dialog('div#user_product_copy_from_user_dialog');
    });

    $scope.$watch('source_user_id', this.load_user_products.bind(this));
    $scope.submit = this.submit.bind(this);

    this.$scope = $scope;
    this.UserService = UserService;
    this.UserProductService = UserProductService;
    this.UiService = UiService;
    this.set_buyer_company_autocomplete((0, _jquery2.default)('input.buyer_company'));
  }

  _createClass(UserProductCopyFromUserDialog, [{
    key: 'get_copy_modes',
    value: function get_copy_modes() {
      return [{ id: 1, title: 'Copy Product Quality' }, { id: 2, title: 'Copy Product Quality & Specs' }, { id: 3, title: 'Copy Product Quality & Full Specs' }];
    }
  }, {
    key: 'set_buyer_company_autocomplete',
    value: function set_buyer_company_autocomplete(input) {
      var _this2 = this;

      input.autocomplete({
        delay: 300,
        source: function source(request, response) {
          _this2.UserService.search_by_company('Buyer', request.term).then(function (data) {
            response(data.users);
          });
        },
        select: function select(event, ui) {
          _this2.$scope.source_user_id = ui.item.id;
          _this2.$scope.$apply();
        }
      });
    }
  }, {
    key: 'load_user_products',
    value: function load_user_products(source_user_id) {
      var _this3 = this;

      this.$scope.user_products = [];

      if (!source_user_id) {
        return;
      }

      this.UserProductService.get_user_products_for_copy_from_user(source_user_id).then(function (res) {
        _this3.$scope.user_products = res.data.user_products;
      });
    }
  }, {
    key: 'submit',
    value: function submit() {
      var _this4 = this;

      var user_products = _underscore2.default.pluck(_underscore2.default.where(this.$scope.user_products, { checked: true }), 'id');

      if (user_products.length === 0) {
        alert('Please select at least one user product!');
        return;
      }

      this.$scope.submitting = true;

      this.UserProductService.copy_user_products_from_user(this.target_user_id, user_products, this.$scope.copy_mode).then(function () {
        _this4.$scope.submitting = false;
        _this4.UiService.close_fancybox_dialog();
      });
    }
  }]);

  return UserProductCopyFromUserDialog;
}();

exports.default = UserProductCopyFromUserDialog;


UserProductCopyFromUserDialog.$inject = ['$scope', 'UserService', 'UserProductService', 'UiService'];

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProductCopySpecs = function UserProductCopySpecs($scope, UserProductService) {
  _classCallCheck(this, UserProductCopySpecs);

  $scope.copy_specs = function () {
    if ($scope.copy.product_from == $scope.copy.product_to) {
      alert('Source and destination product cannot be the same!');
    } else {
      $scope.copying_specs = true;
      UserProductService.copy_user_product_specs($scope.copy).then(function (data) {
        if (data.success) {
          $scope.copying_specs = false;
          _jquery2.default.fancybox.close();
          $scope.load_user_products();
        }
      });
    }
  };

  $scope.load_products = function () {
    $scope.loading_products = true;
    $scope.products = [];
    UserProductService.get_user_products_for_copy_specs(window.user_id).then(function (data) {
      $scope.products = data.user_products;
      $scope.loading_products = false;
    });
  };

  $scope.copy = {
    product_from: null,
    product_to: null,
    reels_substance: true,
    reels_rw: true,
    reels_core: true,
    reels_diameter: true,
    reels_combinations: true,
    sheets_substance: true,
    sheets_size: true,
    sheets_combinations: true
  };

  $scope.$watch('copy', function () {
    if (!($scope.copy.reels_substance && $scope.copy.reels_rw)) $scope.copy.reels_combinations = false;
    if (!($scope.copy.sheets_substance && $scope.copy.sheets_size)) $scope.copy.sheets_combinations = false;
  }, true);

  $scope.init = function () {
    $scope.load_products();
  };

  $scope.init();
};

exports.default = UserProductCopySpecs;


UserProductCopySpecs.$inject = ['$scope', 'UserProductService'];

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProductEditSpecs = function UserProductEditSpecs($scope, UserProductService) {
  _classCallCheck(this, UserProductEditSpecs);

  $scope.tabs = ['Reels Specs', 'Sheets Specs'];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.$on('open_edit_specs_dialog', function (event, args) {
    $scope.product_group_id = args.product_group_id;
    $scope.edit_specs(args.user_product_id, true);
    $scope.suggested_reels = [];
  });

  $scope.edit_specs = function (user_product_id, open_dialog) {
    UserProductService.get_specs_for_admin_view(user_product_id).then(function (data) {
      $scope.dialog_edit_specs_id = user_product_id;
      $scope.dialog_edit_specs = data.specs;
      $scope.dialog_edit_combinations = data.combinations;
      if (open_dialog) {
        $scope.open_dialog('edit_specs_dialog');
        $scope.init_edit_modes();
        $scope.init_edit_basic_modes();
      }
    });
  };

  $scope.set_edit_mode = function (index) {
    $scope.edit_modes[index].enabled = true;
    UserProductService.get_user_product_specs($scope.dialog_edit_specs_id, $scope.edit_modes[index].filter).then(function (data) {
      $scope.edit_modes[index].specs = data.specs;
      if (data.specs.length === 0) $scope.add_spec(index);
    });
  };

  $scope.set_edit_basic_mode = function (index) {
    $scope.edit_basic_modes[index].enabled = true;
    UserProductService.get_user_product_specs($scope.dialog_edit_specs_id, $scope.edit_basic_modes[index].filter).then(function (data) {
      $scope.edit_basic_modes[index].specs = data.specs;
    });
  };

  $scope.set_update_mode = function (index) {
    $scope.edit_modes[index].enabled = false;
    UserProductService.update_user_product_specs($scope.dialog_edit_specs_id, $scope.edit_modes[index].specs).then(function (data) {
      if (data.success) {
        $scope.edit_modes[index].specs = [];
        $scope.edit_specs($scope.dialog_edit_specs_id, false);
      }
    });
  };

  $scope.set_basic_update_mode = function (index) {
    $scope.edit_basic_modes[index].enabled = false;
    UserProductService.update_user_product_specs($scope.dialog_edit_specs_id, $scope.edit_basic_modes[index].specs).then(function (data) {
      if (data.success) {
        $scope.edit_basic_modes[index].specs = [];
        $scope.edit_specs($scope.dialog_edit_specs_id, false);
      }
    });
  };

  $scope.delete_spec = function (index, spec) {
    spec.deleting = true;
    UserProductService.delete_spec(spec.id).then(function (data) {
      if (data.success) {
        var spec_index = $scope.edit_modes[index].specs.indexOf(spec);
        $scope.edit_modes[index].specs.splice(spec_index, 1);
        spec.deleting = false;
      }
    });
  };

  $scope.set_combination_edit_mode = function (index) {
    $scope.edit_modes[index].enabled = true;
    UserProductService.get_user_product_combinations($scope.dialog_edit_specs_id, $scope.edit_modes[index].filter).then(function (data) {
      $scope.edit_modes[index].combinations = data.combinations;
    });
  };

  $scope.set_combination_update_mode = function (index) {
    $scope.edit_modes[index].enabled = false;
    UserProductService.update_user_product_combinations($scope.dialog_edit_specs_id, $scope.edit_modes[index].combinations).then(function (data) {
      if (data.success) {
        $scope.edit_modes[index].combinations = [];
        $scope.edit_specs($scope.dialog_edit_specs_id, false);
      }
    });
  };

  $scope.add_spec = function (index) {
    var filter = $scope.edit_modes[index].filter;
    var spec = {
      id: null,
      is_reels: filter.is_reels,
      spec_type: filter.spec_type,
      is_accurate: filter.is_accurate,
      source: 2
    };
    if (spec.is_accurate == 1) {
      spec.value = 0;
    } else {
      spec.value_min = 0;
      spec.value_max = 0;
    }
    $scope.edit_modes[index].specs.push(spec);
  };

  $scope.show_suggested = function (is_reels) {
    if (is_reels) {
      $scope.suggested_reels = [];
      $scope.loading_suggested_reels = true;
    } else {
      $scope.suggested_sheets = [];
      $scope.loading_suggested_sheets = true;
    }
    UserProductService.get_product_group_specs($scope.product_group_id, is_reels).success(function (data) {
      if (is_reels) {
        $scope.suggested_reels = data.specs;
        $scope.loading_suggested_reels = false;
      } else {
        $scope.suggested_sheets = data.specs;
        $scope.loading_suggested_sheets = false;
      }
    });
  };

  $scope.add_suggested = function (is_reels) {
    var specs = null;
    if (is_reels) specs = _underscore2.default.where($scope.suggested_reels, {
      checked: true
    });else specs = _underscore2.default.where($scope.suggested_sheets, {
      checked: true
    });

    if (specs.length === 0) {
      alert('Please select at least one spec!');
    } else {
      is_reels = Number(is_reels);
      specs[0].is_accurate = Number(specs[0].is_accurate);
      var edit_mode = _underscore2.default.find($scope.edit_modes, function (m) {
        return m.filter.is_reels === is_reels && m.filter.spec_type === specs[0].spec_type && m.filter.is_accurate === specs[0].is_accurate;
      });
      edit_mode.enabled = true;
      _underscore2.default.each(specs, function (s) {
        var spec = {
          id: null,
          is_reels: is_reels,
          spec_type: s.spec_type,
          is_accurate: s.is_accurate,
          value: s.value,
          value_min: s.value_min,
          value_max: s.value_max,
          source: 2
        };
        edit_mode.specs.push(spec);
      });
    }
  };

  $scope.init_edit_modes = function () {
    $scope.edit_modes = [{
      enabled: false,
      specs: [],
      filter: {
        is_reels: 1,
        is_accurate: 1,
        spec_type: 1
      }
    }, {
      enabled: false,
      specs: [],
      filter: {
        is_reels: 1,
        is_accurate: 0,
        spec_type: 1
      }
    }, {
      enabled: false,
      specs: [],
      filter: {
        is_reels: 1,
        is_accurate: 1,
        spec_type: 2
      }
    }, {
      enabled: false,
      specs: [],
      filter: {
        is_reels: 1,
        is_accurate: 0,
        spec_type: 2
      }
    }, {
      enabled: false,
      specs: [],
      filter: {
        is_reels: 1,
        is_accurate: 0,
        spec_type: 3
      }
    }, {
      enabled: false,
      specs: [],
      filter: {
        is_reels: 1,
        is_accurate: 0,
        spec_type: 4
      }
    }, {
      enabled: false,
      specs: [],
      filter: {
        is_reels: 0,
        is_accurate: 1,
        spec_type: 1
      }
    }, {
      enabled: false,
      specs: [],
      filter: {
        is_reels: 0,
        is_accurate: 0,
        spec_type: 1
      }
    }, {
      enabled: false,
      specs: [],
      filter: {
        is_reels: 0,
        is_accurate: 0,
        spec_type: 5
      }
    }, {
      enabled: false,
      combinations: [],
      filter: {
        is_reels: 1,
        source: 2
      }
    }, {
      enabled: false,
      combinations: [],
      filter: {
        is_reels: 0,
        source: 2
      }
    }];
  };

  $scope.init_edit_basic_modes = function () {
    $scope.edit_basic_modes = [{
      enabled: false,
      specs: [],
      filter: {
        is_reels: 1,
        is_accurate: 1,
        spec_type: 2
      }
    }, {
      enabled: false,
      specs: [],
      filter: {
        is_reels: 0,
        is_accurate: 0,
        spec_type: 5
      }
    }];
  };

  $scope.select_all = function (objects) {
    _underscore2.default.each(objects, function (object) {
      object.checked = true;
    });
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.reels_substance_mode = 'both';
    $scope.reels_rw_mode = 'both';
    $scope.sheets_substance_mode = 'both';
    $scope._ = _underscore2.default;
  };

  $scope.init();
};

exports.default = UserProductEditSpecs;


UserProductEditSpecs.$inject = ['$scope', 'UserProductService'];

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProductEndUses = function UserProductEndUses($scope, $rootScope, UserProductEndUseService) {
  _classCallCheck(this, UserProductEndUses);

  function load_product_end_uses() {
    $scope.loading = true;
    UserProductEndUseService.get(window.user_id).success(function (data) {
      _underscore2.default.each(data.product_end_uses, function (end_use) {
        var product_end_use = _underscore2.default.findWhere($scope.product_end_uses, {
          id: end_use
        });
        if (product_end_use) {
          product_end_use.checked = true;
        }
      });

      _underscore2.default.each(data.suggested_product_end_uses, function (end_use) {
        var product_end_use = _underscore2.default.findWhere($scope.product_end_uses, {
          id: end_use
        });
        if (product_end_use) {
          product_end_use.suggested = true;
        }
      });
      $scope.loading = false;
    });
  }

  $scope.update = function () {
    $scope.updating = true;
    var product_end_uses = _underscore2.default.where($scope.product_end_uses, {
      checked: true
    });
    product_end_uses = _underscore2.default.pluck(product_end_uses, 'id');
    UserProductEndUseService.update(window.user_id, product_end_uses).success(function () {
      $scope.updating = false;
      $rootScope.$broadcast('set_sidebar_data', [0, 1, [{
        type: 'counter',
        value: product_end_uses.length
      }]]);
    });
  };

  $scope.quick_search = function () {
    if ($scope.quick_filter) {
      var regex = new RegExp($scope.quick_filter, 'i');
      _underscore2.default.each($scope.product_end_uses, function (end_use) {
        end_use.visible = end_use.title.search(regex) > -1;
      });

      $scope.search_filter = {
        visible: true
      };
    } else {
      $scope.search_filter = {};
    }
  };

  $scope.init = function () {
    $scope.show_all = false;
    load_product_end_uses();
    $scope.product_end_uses = window.product_end_uses;
  };

  $scope.init();
};

exports.default = UserProductEndUses;


UserProductEndUses.$inject = ['$scope', '$rootScope', 'UserProductEndUseService'];

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProductGroupCharges = function UserProductGroupCharges($scope, UserProductService, UserService) {
  _classCallCheck(this, UserProductGroupCharges);

  $scope.parseInt = function (value) {
    return parseInt(value);
  };

  $scope.set_user_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Buyer', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.charge.buyer_id = ui.item.id;
        $scope.buyer_user_company = ui.item.value;
        (0, _jquery2.default)(this).val('');
        $scope.$apply();
        $scope.load_buyer_product_groups(ui.item.id);
      }
    });
  };

  $scope.load_buyer_product_groups = function (buyer_id) {
    $scope.product_groups = [];
    UserService.get_user_product_groups(buyer_id).then(function (data) {
      var existing_product_groups = _underscore2.default.pluck($scope.buyer_charges[buyer_id], 'product_group_id');
      _underscore2.default.each(data.product_groups, function (product_group) {
        if ($scope.charge.id && $scope.charge.product_group_id === product_group.id || !_underscore2.default.contains(existing_product_groups, product_group.id)) $scope.product_groups.push(product_group);
      });
    });
  };

  $scope.remove_user = function () {
    $scope.charge.buyer_id = null;
    $scope.buyer_user_company = null;
    (0, _jquery2.default)('input.user_company').val('');
    $scope.product_groups = [];
    $scope.charge.product_group_id = null;
  };

  $scope.load_charges = function () {
    $scope.loading = true;
    UserProductService.get_user_product_group_charges(window.user_id).then(function (data) {
      $scope.charges = data.charges;
      $scope.buyer_charges = _underscore2.default.groupBy(data.charges, 'buyer_id');
      $scope.buyers = data.buyers;
      $scope.loading = false;
    });
  };

  $scope.save_charge = function () {
    if (!$scope.charge.buyer_id || !$scope.charge.product_group_id) {
      alert('Please select a buyer and a product group!');
    } else {
      $scope.saving_charge = true;
      UserProductService.save_user_product_group_charge($scope.charge).then(function (data) {
        if (data.success) {
          $scope.saving_charge = false;
          _jquery2.default.fancybox.close();
          $scope.load_charges();
        }
      });
    }
  };

  $scope.add_charge = function () {
    $scope.charge = _angular2.default.copy(window.charge);
    $scope.charge.user_id = null;
    $scope.buyer_user_company = null;
    $scope.product_groups = [];
    (0, _jquery2.default)('input.user_company').val('');
    window.openFancyboxDialog('div#charge_dialog');
  };

  $scope.mass_add_charges = function () {
    $scope.charge = _angular2.default.copy(window.charge);
    $scope.charge.user_id = null;
    $scope.buyer_user_company = null;
    $scope.product_groups = [];
    (0, _jquery2.default)('input.user_company').val('');
    window.openFancyboxDialog('div#mass_charge_dialog');
  };

  $scope.mass_save_charges = function () {
    $scope.charge.product_groups = _underscore2.default.pluck(_underscore2.default.where($scope.product_groups, {
      checked: true
    }), 'id');
    if (!$scope.charge.buyer_id || $scope.charge.product_groups.length === 0) {
      alert('Please select a buyer and at least one product group!');
    } else {
      $scope.saving_charges = true;
      UserProductService.mass_save_user_product_group_charge($scope.charge).then(function (data) {
        if (data.success) {
          $scope.saving_charges = false;
          _jquery2.default.fancybox.close();
          $scope.load_charges();
        }
      });
    }
  };

  $scope.mass_renew_charges = function () {
    var selected_charges = [];
    _underscore2.default.each($scope.buyer_charges, function (charges) {
      if (charges[0].checked) {
        _underscore2.default.each(charges, function (charge) {
          selected_charges.push(charge.id);
        });
      }
    });

    if (selected_charges.length === 0) {
      alert('Please select at least one buyer!');
    } else {
      $scope.processing = true;
      UserProductService.mass_renew_user_product_group_charges(selected_charges).success(function (data) {
        if (data.success) {
          $scope.processing = false;
          $scope.load_charges();
        }
      });
    }
  };

  $scope.edit_charge = function (charge) {
    $scope.charge = _angular2.default.copy(charge);
    $scope.buyer_user_company = $scope.charge.buyer_user_company;
    _jquery2.default.fancybox((0, _jquery2.default)('div#charge_dialog'), {
      padding: '5',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      scrolling: 'no',
      afterShow: function afterShow() {
        $scope.load_buyer_product_groups($scope.charge.buyer_id);
        $scope.$apply();
      }
    });
  };

  $scope.delete_charge = function (charge_id) {
    if (confirm('Are you sure you want to delete this charge?')) {
      UserProductService.delete_user_product_group_charge(charge_id).then(function (data) {
        if (data.success) $scope.load_charges();
      });
    }
  };

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.set_charges_checked = function () {
    _underscore2.default.each($scope.buyer_charges, function (charges) {
      charges[0].checked = $scope.checked_all_charges;
    });
  };

  $scope.init = function () {
    $scope.load_charges();
    $scope.set_user_autocomplete((0, _jquery2.default)('input.user_company'));
    $scope.user_type = window.user_type;
    $scope._ = _underscore2.default;
  };

  $scope.init();
};

exports.default = UserProductGroupCharges;


UserProductGroupCharges.$inject = ['$scope', 'UserProductService', 'UserService'];

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProductGroupSettings = function UserProductGroupSettings($scope, UserProductService) {
  _classCallCheck(this, UserProductGroupSettings);

  function load_product_group_settings() {
    $scope.loading = true;
    UserProductService.get_product_group_settings(window.user_id).success(function (data) {
      _underscore2.default.each(data.product_groups, function (g) {
        g.settings = _underscore2.default.find(data.product_group_settings, {
          product_group_id: g.id
        }) || {
          spec_group_enabled: false,
          general_specs_enabled: false
        };
      });
      $scope.product_groups = data.product_groups;
      $scope.mixed_spec_groups = data.mixed_spec_groups;
      $scope.loading = false;
    });
  }

  $scope.tabs = [{
    title: 'Product Groups'
  }, {
    title: 'Mixed Spec Groups'
  }];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.update_settings = function (group, loader) {
    group[loader] = true;
    UserProductService.update_product_group_settings(window.user_id, group.id, group.settings).success(function (data) {
      group.settings = data.settings;
      group[loader] = false;
    });
  };

  $scope.update_auto_extend = function (group) {
    group.updating_auto_extend = true;
    var data = {
      id: group.id,
      auto_extend: group.auto_extend
    };
    UserProductService.update_spec_group(data).success(function (data) {
      if (data.success) group.updating_auto_extend = false;
    });
  };

  $scope.update_group_products = function (group) {
    group.updating_products = true;
    UserProductService.update_spec_group_products(window.user_id, group.id).success(function (data) {
      if (data.success) group.updating_products = false;
    });
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    load_product_group_settings();
  };

  $scope.init();
};

exports.default = UserProductGroupSettings;


UserProductGroupSettings.$inject = ['$scope', 'UserProductService'];

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProductGroupSpecs = function UserProductGroupSpecs($scope, UserProductService) {
  _classCallCheck(this, UserProductGroupSpecs);

  function open_dialog(dialog_id) {
    _jquery2.default.fancybox((0, _jquery2.default)('div#' + dialog_id), {
      padding: '5',
      scrolling: 'yes',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      topRatio: 0.15
    });
  }

  $scope.tabs = ['Reels Specs', 'Sheets Specs'];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.$on('open_group_specs_dialog', function (event, args) {
    $scope.get_group_specs(args.group_id);
  });

  $scope.get_group_specs = function (group_id) {
    UserProductService.get_group_specs_for_admin_view(group_id).then(function (data) {
      $scope.dialog_specs = data.specs;
      $scope.dialog_combinations = data.combinations;
      open_dialog('group_specs_dialog');
    });
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.reels_substance_mode = 'both';
    $scope.reels_rw_mode = 'both';
    $scope.sheets_substance_mode = 'both';
    $scope._ = _underscore2.default;
  };

  $scope.init();
};

exports.default = UserProductGroupSpecs;


UserProductGroupSpecs.$inject = ['$scope', 'UserProductService'];

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProductMassSpecs = function UserProductMassSpecs($scope, UserProductService) {
  _classCallCheck(this, UserProductMassSpecs);

  $scope.tabs = ['Selected Products', 'Add Reels Specs', 'Add Sheets Specs'];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.add_mass_specs = function () {
    var products = _underscore2.default.filter($scope.products_without_specs, function (p) {
      return p.checked == true;
    });
    if (products.length == 0) {
      alert('Please select at least one product!');
    } else {
      $scope.adding_mass_specs = true;
      UserProductService.save_mass_specs(_underscore2.default.pluck(products, 'id'), $scope.specs).then(function () {
        $scope.adding_mass_specs = false;
        _jquery2.default.fancybox.close();
        $scope.$parent.load_user_products();
      });
    }
  };

  $scope.get_specs = function () {
    $scope.specs = [];
    $scope.add_spec(true, 1, true, 0);
    $scope.add_spec(true, 1, false, {
      from: 0,
      to: 0
    });
    $scope.add_spec(true, 2, true, 0);
    $scope.add_spec(true, 2, false, {
      from: 0,
      to: 0
    });
    $scope.add_spec(true, 3, false, {
      from: 0,
      to: 0
    });
    $scope.add_spec(true, 4, false, {
      from: 0,
      to: 0
    });
    $scope.add_spec(false, 1, true, 0);
    $scope.add_spec(false, 1, false, {
      from: 0,
      to: 0
    });
    $scope.add_spec(false, 5, false, {
      from: 0,
      to: 0
    });
  };

  $scope.add_spec = function (is_reels, spec_type, is_accurate, value) {
    var spec = {
      is_reels: is_reels,
      spec_type: spec_type,
      is_accurate: is_accurate,
      value: value
    };
    if (spec_type == 1 && is_accurate) spec['combinations'] = [];
    $scope.specs.push(spec);
  };

  $scope.update_combinations = function (substance, spec) {
    var index = substance.combinations.indexOf(spec);
    if (index > -1) substance.combinations.splice(index, 1);else substance.combinations.push(spec);
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.get_specs();
  };

  $scope.init();
};

exports.default = UserProductMassSpecs;


UserProductMassSpecs.$inject = ['$scope', 'UserProductService'];

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProductPreview = function UserProductPreview($scope, $rootScope, UserProductService) {
  _classCallCheck(this, UserProductPreview);

  var ko_product_model = new window.UserProductModel(window.user_id);
  var ko_product_volume_model = new window.UserProductVolumeModel(window.user_id);

  $scope.load_user_product = function () {
    UserProductService.get_preview_data(window.user_product_id).then(function (data) {
      $scope.user_product = data.user_product;
    });
  };

  $scope.edit_properties = function () {
    var dialog = (0, _jquery2.default)('div#edit_user_product_dialog');
    dialog.find('input[name="user_product_id"]').val(window.user_product_id);
    UserProductService.get(window.user_product_id).then(function (data) {
      ko_product_model.populateEditDialog(dialog, data.user_product);
      _jquery2.default.fancybox(dialog, {
        padding: '5',
        scrolling: 'no',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        afterClose: function afterClose() {
          $scope.load_user_product();
        }
      });
    });
  };

  $scope.edit_volumes = function () {
    var dialog = (0, _jquery2.default)('div#edit_volumes_dialog');
    ko_product_volume_model.populateEditVolumes(dialog, $scope.user_product);
    _jquery2.default.fancybox(dialog, {
      padding: '5',
      scrolling: 'no',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      afterClose: function afterClose() {
        $scope.load_user_product();
      }
    });
  };
  $scope.edit_pricings = function () {
    $scope.set_pricings_selected_tab(0);
    var dialog = (0, _jquery2.default)('div#edit_pricings_dialog');
    _jquery2.default.fancybox(dialog, {
      padding: '5',
      scrolling: 'no',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      topRatio: 0.15,
      afterShow: function afterShow() {
        UserProductService.get_user_product_pricings(window.user_product_id).then(function (data) {
          $scope.dialog_user_product = data.user_product;
        });
      },
      afterClose: function afterClose() {
        $scope.dialog_user_product = null;
        $scope.load_user_product();
      }
    });
  };
  $scope.add_product_row = function (delivery_term_id) {
    var pricing = {
      user_product_pricing: _angular2.default.copy(window.product_pricing)
    };
    pricing.user_product_pricing.user_product_id = $scope.dialog_user_product.id;
    pricing.user_product_pricing.delivery_term_id = delivery_term_id;
    $scope.dialog_user_product.pricings.push(pricing);
  };

  $scope.add_product_brand_row = function (brand, delivery_term_id) {
    var pricing = {
      user_product_brand_pricing: _angular2.default.copy(window.product_brand_pricing)
    };
    pricing.user_product_brand_pricing.user_product_brand_id = brand.id;
    pricing.user_product_brand_pricing.delivery_term_id = delivery_term_id;
    brand.pricings.push(pricing);
  };
  $scope.pricing_tabs = [{
    title: 'CFR',
    delivery_term_id: 1
  }, {
    title: 'FCA',
    delivery_term_id: 3
  }, {
    title: 'DAP',
    delivery_term_id: 2
  }];
  $scope.set_pricings_selected_tab = function (index) {
    $scope.pricings_selected_tab = index;
  };
  $scope.set_product_pricings = function () {
    var count = 0;
    _angular2.default.forEach($scope.user_products, function (p) {
      if (p.has_pricings) count++;
    });
    var percentage = Math.floor(count / $scope.user_products.length * 100.0);
    $rootScope.$broadcast('set_sidebar_data', [0, 6, [{
      type: 'counter',
      value: count
    }, {
      type: 'percentage',
      value: percentage
    }]]);
  };

  $scope.save_pricings = function () {
    $scope.saving_pricings = true;
    UserProductService.save_pricings($scope.dialog_user_product).then(function () /*data*/{
      $scope.saving_pricings = false;
    });
  };

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.open_dialog = function (dialog_id) {
    _jquery2.default.fancybox((0, _jquery2.default)('div#' + dialog_id), {
      padding: '5',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      topRatio: 0.15,
      afterClose: function afterClose() {
        $scope.load_user_product();
      }
    });
  };

  $scope.open_edit_specs_dialog = function () {
    $scope.$broadcast('open_edit_specs_dialog', {
      user_product_id: window.user_product_id
    });
  };

  $scope.init = function () {
    $scope.load_user_product();
    window.setGroupTabsAction();
    (0, _jquery2.default)('select[name="category_id"]').change(function () {
      window.get_groups_by_category((0, _jquery2.default)(this).parents('form').find('select[name="group_id"]'), (0, _jquery2.default)(this).val());
      window.get_product_properties_by_category((0, _jquery2.default)(this).parents('form'), (0, _jquery2.default)(this).val());
    });
    (0, _jquery2.default)('select[name="group_id"]').change(function () {
      window.get_products_by_group((0, _jquery2.default)(this).parents('form'), (0, _jquery2.default)(this).val());
      if ((0, _jquery2.default)(this).val() !== '') window.get_product_properties_by_group((0, _jquery2.default)(this).parents('form'), (0, _jquery2.default)(this).val());
    });
    (0, _jquery2.default)('select[name="product_id"]').change(function () {
      window.set_user_product_properties((0, _jquery2.default)(this).parents('form'), (0, _jquery2.default)(this));
    });
    (0, _jquery2.default)('select[name="product_printing_methods[]"], select[name="product_colors[]"]').select2({
      containerCssClass: 'multiselect2',
      dropdownCssClass: 'multiselect2',
      width: '150px'
    });
    window.ko.applyBindings(ko_product_model, (0, _jquery2.default)('#ko_container')[0]);
    window.ko.applyBindings(ko_product_volume_model, (0, _jquery2.default)('#edit_volumes_dialog')[0]);
    window.init_volumes_dialog();
  };
  $scope.init();
};

exports.default = UserProductPreview;


UserProductPreview.$inject = ['$scope', '$rootScope', 'UserProductService'];

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProductPricing = function UserProductPricing($scope, GeoService) {
  _classCallCheck(this, UserProductPricing);

  $scope.$watch('$parent.pricing.user_product_pricing.country_id', function () {
    if ($scope.$parent.pricing.user_product_pricing.country_id) {
      GeoService.get_cities($scope.$parent.pricing.user_product_pricing.country_id).then(function (data) {
        $scope.pricing_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.pricing.user_product_pricing.city_id })) $scope.pricing.user_product_pricing.city_id = null;
      });
    }
  });

  $scope.product_types = [{
    id: 1,
    title: 'Reels'
  }, {
    id: 0,
    title: 'Sheets'
  }];

  $scope.init = function () {
    $scope.countries = _angular2.default.copy(window.countries);
  };

  $scope.init();
};

exports.default = UserProductPricing;


UserProductPricing.$inject = ['$scope', 'GeoService'];

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProductPricings = function UserProductPricings($scope, $rootScope, UserProductService) {
  _classCallCheck(this, UserProductPricings);

  $scope.pricing_tabs = [{
    title: 'CFR',
    delivery_term_id: 1
  }, {
    title: 'FCA',
    delivery_term_id: 3
  }, {
    title: 'DAP',
    delivery_term_id: 2
  }, {
    title: 'FOB',
    delivery_term_id: 5
  }];

  $scope.load_pricings = function () {
    $scope.loading = true;
    UserProductService.get_user_products_pricings(window.user_id).then(function (data) {
      $scope.user_products = data.user_products;
      $scope.loading = false;
      $scope.set_product_pricings();
    });
  };

  $scope.set_product_pricings = function () {
    var count = 0;
    _angular2.default.forEach($scope.user_products, function (p) {
      if (p.has_pricings) count++;
    });
    var percentage = Math.floor(count / $scope.user_products.length * 100.0);
    $rootScope.$broadcast('set_sidebar_data', [window.is_buyer ? 0 : 1, window.is_buyer ? 6 : 5, [{
      type: 'counter',
      value: count
    }, {
      type: 'percentage',
      value: percentage
    }]]);
  };

  $scope.set_pricings_selected_tab = function (index) {
    $scope.pricings_selected_tab = index;
  };

  $scope.edit_pricings = function (user_product_id) {
    $scope.set_pricings_selected_tab(0);
    var dialog = (0, _jquery2.default)('div#edit_pricings_dialog');
    _jquery2.default.fancybox(dialog, {
      padding: '5',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      topRatio: 0.15,
      scrolling: 'yes',
      afterShow: function afterShow() {
        UserProductService.get_user_product_pricings(user_product_id).then(function (data) {
          $scope.dialog_user_product = data.user_product;
        });
      },
      afterClose: function afterClose() {
        $scope.dialog_user_product = null;
        $scope.user_products = [];
        $scope.load_pricings();
      }
    });
  };

  $scope.add_product_row = function (delivery_term_id) {
    var pricing = {
      user_product_pricing: _angular2.default.copy(window.product_pricing)
    };
    pricing.user_product_pricing.user_product_id = $scope.dialog_user_product.id;
    pricing.user_product_pricing.delivery_term_id = delivery_term_id;
    $scope.dialog_user_product.pricings.push(pricing);
  };

  $scope.add_product_brand_row = function (brand, delivery_term_id) {
    var pricing = {
      user_product_brand_pricing: _angular2.default.copy(window.product_brand_pricing)
    };
    pricing.user_product_brand_pricing.user_product_brand_id = brand.id;
    pricing.user_product_brand_pricing.delivery_term_id = delivery_term_id;
    brand.pricings.push(pricing);
  };

  $scope.save_pricings = function () {
    $scope.saving_pricings = true;
    UserProductService.save_pricings($scope.dialog_user_product).then(function () {
      $scope.saving_pricings = false;
    });
  };

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.init = function () {
    $scope.load_pricings();
  };

  $scope.init();
};

exports.default = UserProductPricings;


UserProductPricings.$inject = ['$scope', '$rootScope', 'UserProductService'];

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProductSpecGroups = function UserProductSpecGroups($scope, UserProductService) {
  _classCallCheck(this, UserProductSpecGroups);

  function init_group() {
    $scope.group = {
      title: ''
    };
  }

  function load_groups() {
    $scope.loading_groups = true;
    UserProductService.get_spec_groups(window.user_id).success(function (data) {
      if (data.success) {
        $scope.groups = data.groups;
        $scope.loading_groups = false;
      }
    });
  }

  function load_user_products() {
    UserProductService.get_user_products_without_groups(window.user_id).success(function (data) {
      $scope.user_products = data.user_products;
    });
  }

  $scope.create_group = function () {
    if ($scope.group.title.length === 0) return false;
    $scope.creating_group = true;
    UserProductService.create_spec_group(window.user_id, $scope.group.title).then(function (data) {
      if (data.success) {
        $scope.creating_group = false;
        init_group();
        load_groups();
      }
    });
  };

  $scope.add_product_to_group = function (group, user_product) {
    if (!user_product) {
      alert('Please select a user product!');
    } else {
      group.adding_product = true;
      UserProductService.add_user_product_to_spec_group(window.user_id, group.id, user_product.id).then(function (data) {
        if (data.success) {
          group.add_product = null;
          group.adding_product = false;
          load_groups();
          load_user_products();
        }
      });
    }
  };

  $scope.delete_product_from_group = function (group, user_product) {
    UserProductService.delete_user_product_from_spec_group(window.user_id, group.id, user_product.id).then(function (data) {
      if (data.success) {
        load_groups();
        load_user_products();
      }
    });
  };

  $scope.show_group_specs = function (group) {
    $scope.$broadcast('open_group_specs_dialog', {
      group_id: group.id
    });
  };

  $scope.sync_group_specs = function (group) {
    group.syncing_specs = true;
    UserProductService.sync_spec_group(group.id).then(function (data) {
      if (data.success) group.syncing_specs = false;
    });
  };

  $scope.get_group_user_products = function (group) {
    var group_product_ids = [];
    if (group.product_group_id) {
      group_product_ids = _underscore2.default.pluck(group.products, 'id');
      return _underscore2.default.filter($scope.user_products, function (p) {
        return p.product_group_id == group.product_group_id && !_underscore2.default.contains(group_product_ids, p.id);
      });
    } else {
      var mixed_groups = _underscore2.default.where($scope.groups, {
        product_group_id: null
      });
      _underscore2.default.each(mixed_groups, function (g) {
        group_product_ids = _underscore2.default.union(group_product_ids, _underscore2.default.pluck(g.products, 'id'));
      });
      return _underscore2.default.filter($scope.user_products, function (p) {
        return !_underscore2.default.contains(group_product_ids, p.id);
      });
    }
  };

  $scope.init = function () {
    $scope.groups = [];
    $scope.user_products = [];
    init_group();
    load_groups();
    load_user_products();
  };

  $scope.init();
};

exports.default = UserProductSpecGroups;


UserProductSpecGroups.$inject = ['$scope', 'UserProductService'];

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProductSpecialPricings = function UserProductSpecialPricings($scope, UserProductService, GeoService, UserService) {
  _classCallCheck(this, UserProductSpecialPricings);

  $scope.parseInt = function (value) {
    return parseInt(value);
  };

  $scope.$watch('pricing.country_id', function () {
    if ($scope.pricing && $scope.pricing.country_id) {
      GeoService.get_cities($scope.pricing.country_id).then(function (data) {
        $scope.dialog_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.pricing.city_id })) $scope.pricing.city_id = null;
      });
    }
  });

  $scope.set_user_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Buyer', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.pricing.buyer_id = ui.item.id;
        $scope.buyer_user_company = ui.item.value;
        (0, _jquery2.default)(this).val('');
        $scope.$apply();
        $scope.load_buyer_user_products(ui.item.id);
      }
    });
  };

  $scope.load_buyer_user_products = function (buyer_id) {
    UserProductService.get_user_products(buyer_id).then(function (data) {
      _underscore2.default.each(data.user_products, function (user_product) {
        if (user_product.product) {
          $scope.user_products.push({
            id: user_product.id,
            title: user_product.product.title
          });
        }
      });
    });
  };

  $scope.remove_user = function () {
    $scope.pricing.buyer_id = null;
    $scope.buyer_user_company = null;
    (0, _jquery2.default)('input.user_company').val('');
    $scope.user_products = [];
    $scope.pricing.user_product_id = null;
  };

  $scope.load_special_pricings = function () {
    $scope.loading = true;
    UserProductService.get_user_products_special_pricings(window.user_id).then(function (data) {
      $scope.pricings = data.pricings;
      $scope.buyer_pricings = _underscore2.default.groupBy(data.pricings, 'buyer_id');
      $scope.buyers = data.buyers;
      $scope.loading = false;
    });
  };

  $scope.save_pricing = function () {
    if (!$scope.pricing.buyer_id || !$scope.pricing.user_product_id) {
      alert('Please select a buyer and a user product!');
    } else {
      $scope.saving_pricing = true;
      UserProductService.save_special_pricing($scope.pricing).then(function (data) {
        if (data.success) {
          $scope.saving_pricing = false;
          _jquery2.default.fancybox.close();
          $scope.load_special_pricings();
        }
      });
    }
  };

  $scope.add_pricing = function () {
    $scope.pricing = _angular2.default.copy(window.pricing);
    $scope.pricing.user_id = null;
    $scope.buyer_user_company = null;
    $scope.user_products = [];
    (0, _jquery2.default)('input.user_company').val('');
    window.openFancyboxDialog('div#pricing_dialog');
  };

  $scope.edit_pricing = function (pricing) {
    $scope.pricing = pricing;
    $scope.buyer_user_company = pricing.buyer_user_company;
    window.openFancyboxDialog('div#pricing_dialog');
    $scope.user_products = [];
    $scope.load_buyer_user_products($scope.pricing.buyer_id);
  };

  $scope.delete_pricing = function (pricing_id) {
    if (confirm('Are you sure you want to delete this pricing?')) {
      UserProductService.delete_special_pricing(pricing_id).then(function (data) {
        if (data.success) $scope.load_special_pricings();
      });
    }
  };

  $scope.stock_types = [{
    id: 1,
    title: 'Reels'
  }, {
    id: 0,
    title: 'Sheets'
  }];

  $scope.delivery_terms = [{
    id: 3,
    title: 'FCA'
  }, {
    id: 1,
    title: 'CFR'
  }, {
    id: 2,
    title: 'DAP'
  }];

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.init = function () {
    $scope.load_special_pricings();
    $scope.user_products = [];
    $scope.countries = window.countries;
    $scope.set_user_autocomplete((0, _jquery2.default)('input.user_company'));
    $scope.user_type = window.user_type;
    $scope._ = _underscore2.default;
  };

  $scope.init();
};

exports.default = UserProductSpecialPricings;


UserProductSpecialPricings.$inject = ['$scope', 'UserProductService', 'GeoService', 'UserService'];

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProductSpecs = function UserProductSpecs($scope, $rootScope, UserProductService, UserSidebarService, UserService) {
  _classCallCheck(this, UserProductSpecs);

  $scope.load_user_products = function () {
    $scope.loading = true;
    UserProductService.get_user_products(window.user_id).then(function (data) {
      $scope.user_products = data.user_products;
      $scope.loading = false;
      $scope.set_sidebar_specs();
    });
  };

  $scope.set_sidebar_specs = function () {
    var count = 0;
    _angular2.default.forEach($scope.user_products, function (p) {
      if (p.has_reels_specs || p.has_sheets_specs) count++;
    });
    var percentage = Math.floor(count / $scope.user_products.length * 100.0);
    $rootScope.$broadcast('set_sidebar_data', [0, 3, [{
      type: 'counter',
      value: count
    }, {
      type: 'percentage',
      value: percentage
    }]]);
  };

  $scope.delete_specs = function (user_product) {
    if (confirm('Are you sure you want to delete the specs?')) {
      UserProductService.delete_specs(user_product.id).then(function (data) {
        if (data.success) {
          var index = $scope.user_products.indexOf(user_product);
          $scope.user_products.splice(index, 1);
          $scope.set_sidebar_specs();
        }
      });
    }
  };

  $scope.open_view_specs_dialog = function (user_product_id) {
    $scope.$broadcast('open_view_specs_dialog', {
      user_product_id: user_product_id
    });
  };

  $scope.open_edit_specs_dialog = function (user_product_id, product_group_id) {
    $scope.$broadcast('open_edit_specs_dialog', {
      user_product_id: user_product_id,
      product_group_id: product_group_id
    });
  };

  $scope.open_dialog = function (dialog_id) {
    _jquery2.default.fancybox((0, _jquery2.default)('div#' + dialog_id), {
      padding: '5',
      openEffect: 'elastic',
      closeEffect: 'elastic',
      openSpeed: '700',
      closeSpeed: '300',
      topRatio: 0.15,
      scrolling: 'yes',
      afterClose: function afterClose() {
        $scope.load_user_products();
        $scope.load_specs_statuses();
      }
    });
  };

  $scope.add_multiple_specs = function () {
    UserProductService.get_user_products_without_specs(window.user_id).then(function (data) {
      $scope.products_without_specs = data.user_products;
      $scope.open_dialog('mass_edit_specs_dialog');
    });
  };

  $scope.copy_specs = function () {
    $scope.open_dialog('copy_specs_dialog');
  };

  $scope.update_specs_statuses = function () {
    $scope.updating_specs_statuses = true;
    UserService.update_specs_statuses(window.user_id, $scope.reel_specs_status, $scope.sheet_specs_status, $scope.rw_cutting_specs_status).success(function (data) {
      if (data.success) $scope.updating_specs_statuses = false;
    });
  };

  $scope.load_specs_statuses = function () {
    UserService.load_specs_statuses(window.user_id).success(function (data) {
      if (data.success) {
        $scope.reel_specs_status = data.reel_specs_status;
        $scope.sheet_specs_status = data.sheet_specs_status;
        $scope.rw_cutting_specs_status = data.rw_cutting_specs_status;
      }
    });
  };

  $scope.update_matching_settings = function () {
    $scope.updating_matching_settings = true;
    UserService.update_matching_settings(window.user_id, $scope.matching_settings).success(function (data) {
      if (data.success) {
        $scope.updating_matching_settings = false;
      }
    });
  };

  $scope.load_matching_settings = function () {
    UserService.load_matching_settings(window.user_id).success(function (data) {
      if (data.success) {
        $scope.matching_settings = data.matching_settings;
        if ($scope.matching_settings.enabled == undefined) {
          $scope.matching_settings.enabled = 0;
        }
      }
    });
  };

  $scope.update_campaign_settings = function () {
    $scope.updating_campaign_settings = true;
    UserService.update_campaign_settings(window.user_id, $scope.campaign_settings).success(function (data) {
      if (data.success) {
        $scope.updating_campaign_settings = false;
      }
    });
  };

  $scope.load_campaign_settings = function () {
    UserService.load_campaign_settings(window.user_id).success(function (data) {
      if (data.success) {
        $scope.campaign_settings = data.campaign_settings;
      }
    });
  };

  $scope.criterias = [{
    value: 0,
    title: 'No'
  }, {
    value: 1,
    title: 'Yes'
  }];

  $scope.percentages = [{
    value: 0,
    title: '0%'
  }, {
    value: 1,
    title: '1%'
  }, {
    value: 20,
    title: '20%'
  }, {
    value: 40,
    title: '40%'
  }, {
    value: 60,
    title: '60%'
  }, {
    value: 80,
    title: '80%'
  }, {
    value: 100,
    title: '100%'
  }];

  $scope.operators = [{
    value: 1,
    title: '+'
  }, {
    value: 2,
    title: '+/-'
  }];

  $scope.specs = [{
    value: 0,
    title: 'ALL'
  }, {
    value: 1,
    title: 'Only Yes'
  }, {
    value: 2,
    title: 'Unknown or Yes'
  }];

  $scope.cuts = [{
    value: 1,
    title: '1'
  }, {
    value: 2,
    title: '2'
  }, {
    value: 3,
    title: '3'
  }];

  $scope.wastes = [{
    value: 0,
    title: '0'
  }, {
    value: 1,
    title: '1'
  }, {
    value: 2,
    title: '2'
  }];

  $scope.ranges = [{
    value: 0,
    title: '0'
  }, {
    value: 1,
    title: '+-0.5'
  }, {
    value: 2,
    title: '+-1'
  }];

  $scope.specs_status_options = [{
    id: 0,
    title: 'All'
  }, {
    id: 1,
    title: 'Reels'
  }, {
    id: 2,
    title: 'Sheets'
  }];

  $scope.init = function () {
    $scope.reel_specs_status = window.reel_specs_status;
    $scope.sheet_specs_status = window.sheet_specs_status;
    $scope.rw_cutting_specs_status = window.rw_cutting_specs_status;
    $scope.reel_specs_statuses = UserService.get_specs_statuses();
    $scope.sheet_specs_statuses = UserService.get_specs_statuses();
    $scope.rw_cutting_specs_statuses = UserService.get_specs_statuses();
    $scope.products_without_specs = [];
    $scope.load_user_products();
    $scope.load_matching_settings();
    $scope.load_campaign_settings();
  };

  $scope.init();
};

exports.default = UserProductSpecs;


UserProductSpecs.$inject = ['$scope', '$rootScope', 'UserProductService', 'UserSidebarService', 'UserService'];

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProductTargetPricings = function UserProductTargetPricings($scope, UserProductService, GeoService) {
  _classCallCheck(this, UserProductTargetPricings);

  $scope.load_target_pricings = function () {
    $scope.loading = true;
    UserProductService.get_user_products_target_pricings(window.user_id).then(function (data) {
      $scope.pricings = data.pricings;
      $scope.loading = false;
    });
  };

  $scope.add_pricing = function () {
    $scope.pricing = _angular2.default.copy(window.pricing);
    window.openFancyboxDialog('div#pricing_dialog');
  };

  $scope.edit_pricing = function (pricing) {
    $scope.pricing = pricing;
    window.openFancyboxDialog('div#pricing_dialog');
  };

  $scope.copy_pricing = function (pricing) {
    $scope.pricing = _angular2.default.copy(pricing);
    $scope.pricing.id = null;
    $scope.pricing.last_order_price_avg = 0;
    $scope.pricing.last_order_id = null;
    $scope.pricing.last_order_date = null;
    $scope.pricing.last_import_price_avg = 0;
    $scope.pricing.last_import_date = null;
    window.openFancyboxDialog('div#pricing_dialog');
  };

  $scope.save_pricing = function () {
    $scope.saving_pricing = true;
    UserProductService.save_target_pricing($scope.pricing).then(function (data) {
      if (data.success) {
        $scope.saving_pricing = false;
        _jquery2.default.fancybox.close();
        $scope.load_target_pricings();
      }
    });
  };

  $scope.delete_pricing = function (pricing_id) {
    if (confirm('Are you sure you want to delete this pricing?')) {
      UserProductService.delete_target_pricing(pricing_id).then(function (data) {
        if (data.success) $scope.load_target_pricings();
      });
    }
  };

  $scope.stock_types = [{
    id: 1,
    title: 'Reels'
  }, {
    id: 0,
    title: 'Sheets'
  }];

  $scope.delivery_terms = [{
    id: 3,
    title: 'FCA'
  }, {
    id: 1,
    title: 'CFR'
  }, {
    id: 2,
    title: 'DAP'
  }];

  $scope.date_options = {
    changeMonth: true,
    changeYear: true,
    dateFormat: 'dd/mm/yy'
  };

  $scope.$watch('pricing.country_id', function () {
    if ($scope.pricing && $scope.pricing.country_id) {
      GeoService.get_cities($scope.pricing.country_id).then(function (data) {
        $scope.dialog_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.pricing.city_id })) $scope.pricing.city_id = null;
      });
    }
  });

  $scope.update_from_last_order = function () {
    $scope.updating = true;
    UserProductService.update_target_pricings_from_last_order(window.user_id).then(function (data) {
      if (data.success) {
        $scope.updating = false;
        $scope.load_target_pricings();
      }
    });
  };

  $scope.init = function () {
    $scope.load_target_pricings();
    $scope.user_products = window.user_products;
    $scope.countries = window.countries;
  };

  $scope.init();
};

exports.default = UserProductTargetPricings;


UserProductTargetPricings.$inject = ['$scope', 'UserProductService', 'GeoService'];

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProductViewSpecs = function UserProductViewSpecs($scope, UserProductService) {
  _classCallCheck(this, UserProductViewSpecs);

  $scope.$on('open_view_specs_dialog', function (event, args) {
    load_specs(args.user_product_id);
  });

  function load_specs(user_product_id) {
    UserProductService.get_multi_specs_for_admin_view(user_product_id).then(function (data) {
      _underscore2.default.each(data.specs, function (spec) {
        if (!spec.source) {
          spec.source = 6;
          spec.is_accurate = spec.is_accurate === true ? 1 : 0;
          spec.is_reels = spec.is_reels === true ? 1 : 0;
        }
      });
      $scope.dialog_specs = data.specs;
      $scope.dialog_combinations = data.combinations;
      $scope.open_dialog('view_specs_dialog');
    });
  }

  $scope.tabs = ['Reels Specs', 'Sheets Specs'];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.reels_substance_mode = 'both';
    $scope.reels_rw_mode = 'both';
    $scope.sheets_substance_mode = 'both';
    $scope._ = _underscore2.default;
  };

  $scope.init();
};

exports.default = UserProductViewSpecs;


UserProductViewSpecs.$inject = ['$scope', 'UserProductService'];

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProducts = function () {
  function UserProducts($scope, $rootScope) {
    _classCallCheck(this, UserProducts);

    $scope.copy_from_user = this.copy_from_user.bind(this);

    this.user_id = window.user_id;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
  }

  _createClass(UserProducts, [{
    key: 'copy_from_user',
    value: function copy_from_user() {
      var data = {
        user_id: this.user_id
      };

      this.$rootScope.$broadcast('show_user_products_copy_from_user_dialog', data);
    }
  }]);

  return UserProducts;
}();

exports.default = UserProducts;


UserProducts.$inject = ['$scope', '$rootScope'];

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserRegister = function UserRegister($scope, GeoService, UserService) {
  _classCallCheck(this, UserRegister);

  $scope.tabs = ['1. Account Details', '2. Company Details', '3. Personal Details', '4. Role Details', '5. Product Categories & Groups'];

  $scope.get_new_user = function () {
    return {
      user_type: 'Buyer',
      company_title: null,
      company_email: null,
      country_id: null,
      city_id: null,
      phone: null,
      fax: null,
      ssn: null,
      business_relation: 0,
      last_name: '',
      market: 'global',
      is_past_customer: 0,
      user_contacts_attributes: [{
        department_id: null,
        email: null,
        first_name: null,
        last_name: null,
        gender: 0,
        position: null,
        phone: null,
        fax: null,
        newsletter_settings: null,
        matching_settings: null,
        frontend_settings: null,
        welcome_email_date: null
      }],
      user_groups_attributes: [],
      user_business_types_attributes: [],
      user_product_categories_attributes: [],
      user_product_groups_attributes: []
    };
  };

  $scope.get_new_account = function () {
    return {
      username: null,
      password: null,
      retype_password: null,
      status: 'pending'
    };
  };

  $scope.$watch('user.country_id', function () {
    if ($scope.user.country_id) {
      GeoService.get_cities($scope.user.country_id).then(function (data) {
        $scope.cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.user.city_id })) $scope.user.city_id = null;
      });
    }
  });

  $scope.$watch('user.user_type', function () {
    $scope.business_types = _angular2.default.copy(window.business_types);
    $scope.user.user_business_types_attributes = [];
  });

  $scope.category_changed = function (category) {
    if (!category.checked) {
      for (var i = 0; i < category.groups.length; i++) {
        category.groups[i].checked = false;
      }
    }
  };

  $scope.group_changed = function (category, group) {
    if (group.checked && !category.checked) category.checked = true;
  };

  $scope.show_next_tab = function () {
    $scope.processing = true;
    $scope.reset_errors();
    $scope.validate_step();
  };

  $scope.validate_step = function () {
    if ($scope.selected_tab == 0) {
      if ($scope.validate_username() && $scope.validate_password()) {
        UserService.register_account_email_exists($scope.account.username).then(function (data) {
          if (data.exists) {
            $scope.account_email_error = 'Email already exists!';
          } else {
            $scope.selected_tab++;
          }
          $scope.processing = false;
        });
      }
    } else if ($scope.selected_tab == 1) {
      if ($scope.validate_company() && $scope.validate_country() && $scope.validate_email()) {
        $scope.selected_tab++;
        $scope.processing = false;
      }
    } else if ($scope.selected_tab == 2) {
      if ($scope.validate_department() && $scope.validate_first_name() && $scope.validate_last_name() && $scope.validate_contact_email()) {
        $scope.selected_tab++;
        $scope.processing = false;
      }
    } else if ($scope.selected_tab == 3) {
      $scope.get_business_types();
      if ($scope.user.user_business_types_attributes.length > 0) {
        $scope.selected_tab++;
      } else {
        $scope.business_type_error = 'Please select at least one business type!';
      }
      $scope.processing = false;
    } else if ($scope.selected_tab == 4) {
      $scope.get_product_data();
      if ($scope.user.user_product_categories_attributes.length > 0) {
        $scope.save_data();
      } else {
        $scope.categories_error = 'Please select at least one product category!';
        $scope.processing = false;
      }
    }
  };

  $scope.save_data = function () {
    UserService.save_register_data($scope.user, $scope.account).then(function (data) {
      if (data.success) {
        //to-do
      } else {
          //to-do
        }
      $scope.processing = false;
    });
  };

  $scope.reset_errors = function () {
    $scope.account_email_error = null;
    $scope.account_password_error = null;
    $scope.user_company_error = null;
    $scope.user_country_error = null;
    $scope.user_email_error = null;
    $scope.user_department_error = null;
    $scope.user_first_name_error = null;
    $scope.user_last_name_error = null;
    $scope.user_contact_email_error = null;
    $scope.business_type_error = null;
    $scope.categories_error = null;
  };

  $scope.validate_username = function () {
    if ($scope.account.username && $scope.account.username.length > 6) {
      return true;
    } else {
      $scope.account_email_error = 'Missing or invalid email!';
      $scope.processing = false;
      return false;
    }
  };

  $scope.validate_password = function () {
    var password = $scope.account.password;
    var password2 = $scope.account.retype_password;
    if (!(password || password2) || password.length == 0 || password != password2) {
      $scope.account_password_error = 'Password empty or password mismatch!';
      $scope.processing = false;
      return false;
    }
    return true;
  };

  $scope.validate_company = function () {
    if ($scope.user.company_title && $scope.user.company_title.length > 1) {
      return true;
    } else {
      $scope.user_company_error = 'Missing or invalid company title!';
      $scope.processing = false;
      return false;
    }
  };

  $scope.validate_country = function () {
    if ($scope.user.country_id) {
      return true;
    } else {
      $scope.user_country_error = 'Missing country!';
      $scope.processing = false;
      return false;
    }
  };

  $scope.validate_email = function () {
    if ($scope.user.company_email && $scope.user.company_email.length > 6) {
      return true;
    } else {
      $scope.user_email_error = 'Missing or invalid email!';
      $scope.processing = false;
      return false;
    }
  };

  $scope.validate_contact_email = function () {
    if ($scope.user.user_contacts_attributes[0].email && $scope.user.user_contacts_attributes[0].email.length > 6) {
      return true;
    } else {
      $scope.user_contact_email_error = 'Missing or invalid email!';
      $scope.processing = false;
      return false;
    }
  };

  $scope.validate_department = function () {
    if ($scope.user.user_contacts_attributes[0].department_id) {
      return true;
    } else {
      $scope.user_department_error = 'Missing department!';
      $scope.processing = false;
      return false;
    }
  };

  $scope.validate_first_name = function () {
    if ($scope.user.user_contacts_attributes[0].first_name && $scope.user.user_contacts_attributes[0].first_name.length > 0) {
      return true;
    } else {
      $scope.user_first_name_error = 'Missing or invalid first name!';
      $scope.processing = false;
      return false;
    }
  };

  $scope.validate_last_name = function () {
    if ($scope.user.user_contacts_attributes[0].last_name && $scope.user.user_contacts_attributes[0].last_name.length > 0) {
      return true;
    } else {
      $scope.user_last_name_error = 'Missing or invalid last name!';
      $scope.processing = false;
      return false;
    }
  };

  $scope.get_business_types = function () {
    $scope.user.user_business_types_attributes = [];
    _angular2.default.forEach($scope.business_types, function (business_type) {
      if (business_type.checked) $scope.user.user_business_types_attributes.push({
        business_type_id: business_type.id
      });
    });
  };

  $scope.get_product_data = function () {
    $scope.user.user_product_categories_attributes = [];
    $scope.user.user_product_groups_attributes = [];
    _angular2.default.forEach($scope.product_categories, function (category) {
      if (category.checked) $scope.user.user_product_categories_attributes.push({
        product_category_id: category.id
      });
      for (var i = 0; i < category.groups.length; i++) {
        if (category.groups[i].checked) $scope.user.user_product_groups_attributes.push({
          product_group_id: category.groups[i].id
        });
      }
    });
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.user = $scope.get_new_user();
    $scope.account = $scope.get_new_account();
    $scope.business_types = _angular2.default.copy(window.business_types);
    $scope.product_categories = _angular2.default.copy(window.product_categories);
  };

  $scope.init();
};

exports.default = UserRegister;


UserRegister.$inject = ['$scope', 'GeoService', 'UserService'];

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserRestrictedTo = function UserRestrictedTo($scope) {
  _classCallCheck(this, UserRestrictedTo);

  $scope.open_dialog = function (dialog_id) {
    window.openFancyboxDialog('div#' + dialog_id);
  };

  $scope.init = function () {
    $scope.user = window.user;
  };

  $scope.init();
};

exports.default = UserRestrictedTo;


UserRestrictedTo.$inject = ['$scope'];

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserRollMessages = function UserRollMessages($scope, UserRollMessageService) {
  _classCallCheck(this, UserRollMessages);

  $scope.open_dialog = function (dialog_id) {
    window.openFancyboxDialog('div#' + dialog_id);
  };

  $scope.add_message = function () {
    $scope.dialog_message = _angular2.default.copy(window.admin_message);
    $scope.open_dialog('user_roll_message_dialog');
  };

  $scope.edit_message = function (message) {
    $scope.dialog_message = message;
    $scope.open_dialog('user_roll_message_dialog');
  };

  $scope.delete_message = function (index) {
    if (confirm('Are you sure you want to delete this message?')) {
      UserRollMessageService.delete($scope.user_roll_messages[index].id).then(function (data) {
        if (data.success) $scope.user_roll_messages.splice(index, 1);
      });
    }
  };

  $scope.save_message = function () {
    $scope.updating_message = true;
    UserRollMessageService.save($scope.dialog_message).then(function (data) {
      if (data.success) {
        $scope.updating_message = false;
        _jquery2.default.fancybox.close();
        $scope.user_roll_messages = data.user_roll_messages;
      }
    });
  };

  $scope.init = function () {
    $scope.user_roll_messages = window.user_roll_messages;
    $scope.dialog_message = _angular2.default.copy(window.admin_message);
  };

  $scope.init();
};

exports.default = UserRollMessages;


UserRollMessages.$inject = ['$scope', 'UserRollMessageService'];

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserSellerEdit = function UserSellerEdit($scope) {
  _classCallCheck(this, UserSellerEdit);

  var hide_pages = ['edit_orders', 'edit_orders_customers', 'offer_request_selections', 'offer_request_reservations'];
  $scope.show_sidebar = !_underscore2.default.contains(hide_pages, window.app_data.action);
};

exports.default = UserSellerEdit;


UserSellerEdit.$inject = ['$scope'];

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserSellerSectionMenu = function UserSellerSectionMenu($scope) {
  _classCallCheck(this, UserSellerSectionMenu);

  $scope.menu = [{
    title: 'Preview',
    action: 'edit_preview',
    pages: ['edit_preview']
  }, {
    title: 'Overview',
    action: 'overview',
    pages: ['overview']
  }, {
    title: 'Accounts & Profiles',
    action: 'edit_company_details',
    pages: ['edit_company_details', 'edit_company_contacts']
  }, {
    title: 'Trading Infos',
    action: 'edit_trading_general',
    pages: ['edit_trading_general', 'edit_trading_offer', 'edit_trading_order', 'edit_trading_delivery', 'edit_trading_freight', 'edit_trading_payment', 'edit_trading_special_payment', 'edit_trading_restrictions', 'edit_preferences_categories', 'edit_preferences_products', 'edit_preferences_product_groups', 'edit_preferences_brands', 'edit_preferences_volumes', 'edit_spp_buyer_pricings', 'edit_spp_special_pricings', 'edit_spp_special_user_charges', 'edit_spp_special_country_charges', 'edit_spp_special_incoterm_charges', 'edit_offer_spot', 'edit_offer_inventories']
  }, {
    title: 'Opportunities',
    action: 'edit_matched_my',
    pages: ['edit_matched_my', 'edit_matched_buyers', 'edit_matched_favorite_requests', 'edit_matched_favorite_buyers']
  }, {
    title: 'Advanced Tools',
    action: 'edit_special_faqs',
    pages: ['edit_special_faqs', 'edit_special_roll_messages', 'edit_alerts', 'edit_reports', 'edit_create_spot', 'edit_create_offer']
  }, {
    title: 'Orders & Offers Requests',
    action: 'edit_orders',
    pages: ['edit_orders', 'edit_arrivals', 'offer_request_selections', 'offer_request_reservations', 'edit_orders_payment', 'edit_orders_customers']
  }];

  $scope.init = function () {
    $scope._ = _underscore2.default;
  };

  $scope.init();
};

exports.default = UserSellerSectionMenu;


UserSellerSectionMenu.$inject = ['$scope'];

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserSellerSidebarMenu = function UserSellerSidebarMenu($scope, UserSidebarService) {
  _classCallCheck(this, UserSellerSidebarMenu);

  var menu = [{
    group: 0,
    title: 'Preview',
    pages: [{
      title: 'Preview',
      action: 'edit_preview'
    }]
  }, {
    group: 1,
    title: 'Overview',
    pages: [{
      title: 'Overview',
      action: 'overview'
    }]
  }, {
    group: 2,
    title: 'Accounts & Personal Data',
    pages: [{
      title: 'Manage Contacts',
      action: 'edit_company_contacts'
    }]
  }, {
    group: 2,
    title: 'Main Details - Company Profile',
    pages: [{
      title: 'Company Details',
      action: 'edit_company_details'
    }]
  }, {
    group: 3,
    title: 'Usual Infos - Trading Terms',
    pages: [{
      title: 'General',
      action: 'edit_trading_general'
    }, {
      title: 'Offer Details',
      action: 'edit_trading_offer'
    }, {
      title: 'Order Details',
      action: 'edit_trading_order'
    }, {
      title: 'Delivery Terms',
      action: 'edit_trading_delivery'
    }, {
      title: 'Freight Rates',
      action: 'edit_trading_freight'
    }, {
      title: 'Acceptable Payment Terms',
      action: 'edit_trading_payment'
    }, {
      title: 'Special Payment Terms',
      action: 'edit_trading_special_payment'
    }, {
      title: 'Market Restrictions',
      action: 'edit_trading_restrictions'
    }]
  }, {
    group: 3,
    title: 'Product Preferences',
    pages: [{
      title: 'Categories & Groups',
      action: 'edit_preferences_categories'
    }, {
      title: 'Product Qualities',
      action: 'edit_preferences_products'
    }, {
      title: 'Product Quality Groups',
      action: 'edit_preferences_product_groups'
    }, {
      title: 'Product Brands',
      action: 'edit_preferences_brands'
    }, {
      title: 'Product Volumes & Uses',
      action: 'edit_preferences_volumes'
    }, {
      title: 'Product Pricings',
      action: 'edit_preferences_pricings'
    }]
  }, {
    group: 3,
    title: 'Special Price Policy',
    pages: [{
      title: 'Buyer Special Pricings',
      action: 'edit_spp_buyer_pricings'
    }, {
      title: 'Special Pricings (USPP)',
      action: 'edit_spp_special_pricings'
    }, {
      title: 'Special Charges by User (USCP)',
      action: 'edit_spp_special_user_charges'
    }, {
      title: 'Special Charges by Country (SCCP)',
      action: 'edit_spp_special_country_charges'
    }, {
      title: 'Special Charges by Incoterm (SCIP)',
      action: 'edit_spp_special_incoterm_charges'
    }]
  }, {
    group: 3,
    title: 'Offers & Inventories',
    pages: [{
      title: 'Spot Offers',
      action: 'edit_offer_spot'
    }, {
      title: 'Inventories',
      action: 'edit_offer_inventories'
    }]
  }, {
    group: 4,
    title: 'Matched Demands & Buyers',
    pages: [{
      title: 'My Matched Requests/Demands',
      action: 'edit_matched_my'
    }, {
      title: 'Matched Buyers',
      action: 'edit_matched_buyers'
    }, {
      title: 'Favorite Requests/Demands',
      action: 'edit_matched_favorite_requests'
    }, {
      title: 'Favorite Buyers',
      action: 'edit_matched_favorite_buyers'
    }]
  }, {
    group: 5,
    title: 'Special Section',
    pages: [{
      title: 'FAQs',
      action: 'edit_special_faqs'
    }, {
      title: 'Roll Messages',
      action: 'edit_special_roll_messages'
    }]
  }, {
    group: 5,
    title: 'Campaign Alerts & Notifications',
    pages: [{
      title: 'Campaign Alerts & Notifications',
      action: 'edit_alerts'
    }]
  }, {
    group: 5,
    title: 'Reports & Stats',
    pages: [{
      title: 'Reports & Stats',
      action: 'edit_reports'
    }]
  }, {
    group: 5,
    title: 'Create Options',
    pages: [{
      title: 'Create new Spot Offer or Inventory',
      action: 'edit_create_spot'
    }, {
      title: 'Create new Offers based to others',
      action: 'edit_create_offer'
    }]
  }, {
    group: 6,
    title: 'Orders & Offer Requests',
    pages: [{
      title: 'Selections',
      action: 'offer_request_selections'
    }, {
      title: 'Reservations',
      action: 'offer_request_reservations'
    }, {
      title: 'Orders',
      action: 'edit_orders'
    }, {
      title: 'Arrivals',
      action: 'edit_arrivals'
    }, {
      title: 'Payment Notifications',
      action: 'edit_orders_payment'
    }, {
      title: 'Customers',
      action: 'edit_orders_customers'
    }, {
      title: 'Sales Confirmations',
      action: 'edit_sales_confirmations'
    }]
  }];

  $scope.set_page_data = function (section_index, page_index, data) {
    var section = $scope.menu[section_index];
    var page = section.pages[page_index];
    page.data = data;
  };

  $scope.$on('set_sidebar_data', function (event, data) {
    $scope.set_page_data(data[0], data[1], data[2]);
  });

  function set_menu() {
    var section = _underscore2.default.find(menu, function (section) {
      return _underscore2.default.contains(_underscore2.default.pluck(section.pages, 'action'), window.app_data.action);
    });

    if (section) {
      $scope.menu = _underscore2.default.where(menu, {
        group: section.group
      });
      var groups_with_data = [2, 3, 6];
      if (_underscore2.default.contains(groups_with_data, section.group)) {
        UserSidebarService.get_sidebar_data(window.app_data.user_id, section.group).success(function (data) {
          var sidebar_data = data.sidebar_data;
          if (section.group === 2) {
            $scope.set_page_data(0, 0, [{
              type: 'counter',
              value: sidebar_data.contacts_count
            }, {
              type: 'counter',
              value: sidebar_data.accounts_count
            }]);
            $scope.set_page_data(1, 0, [{
              type: 'percentage',
              value: sidebar_data.company_percentage
            }]);
          } else if (section.group === 3) {
            $scope.set_page_data(0, 0, [{
              type: 'percentage',
              value: sidebar_data.trading_percentage
            }]);
            $scope.set_page_data(0, 1, [{
              type: 'percentage',
              value: sidebar_data.offer_percentage
            }]);
            $scope.set_page_data(0, 2, [{
              type: 'percentage',
              value: sidebar_data.order_percentage
            }]);
            $scope.set_page_data(0, 3, [{
              type: 'counter',
              value: sidebar_data.delivery_terms_count
            }]);
            $scope.set_page_data(0, 4, [{
              type: 'counter',
              value: sidebar_data.freight_rates_count
            }]);
            $scope.set_page_data(0, 5, [{
              type: 'counter',
              value: sidebar_data.payment_terms_count
            }]);
            $scope.set_page_data(0, 6, [{
              type: 'counter',
              value: sidebar_data.special_payment_terms_count
            }]);
            $scope.set_page_data(0, 7, [{
              type: 'counter',
              value: sidebar_data.restrictions_count
            }]);
            $scope.set_page_data(1, 0, [{
              type: 'counter',
              value: sidebar_data.categories_count
            }, {
              type: 'counter',
              value: sidebar_data.groups_count
            }]);
            $scope.set_page_data(1, 1, [{
              type: 'counter',
              value: sidebar_data.epaper_products_count
            }, {
              type: 'counter',
              value: sidebar_data.products_count
            }]);
            $scope.set_page_data(1, 3, [{
              type: 'counter',
              value: sidebar_data.brands_count
            }]);
            $scope.set_page_data(1, 4, [{
              type: 'counter',
              value: sidebar_data.product_volumes.count
            }, {
              type: 'percentage',
              value: sidebar_data.product_volumes.percentage
            }]);
            $scope.set_page_data(1, 5, [{
              type: 'counter',
              value: sidebar_data.supplier_product_count
            }, {
              type: 'counter',
              value: sidebar_data.supplier_group_count
            }]);
            $scope.set_page_data(2, 0, [{
              type: 'counter',
              value: sidebar_data.spp_buyers_count
            }, {
              type: 'counter',
              value: sidebar_data.spp_count
            }, {
              type: 'counter',
              value: sidebar_data.spp_check_count
            }]);
            $scope.set_page_data(2, 2, [{
              type: 'counter',
              value: sidebar_data.special_charges_count
            }]);
          } else if (section.group === 6) {
            $scope.set_page_data(0, 0, [{
              type: 'counter',
              value: sidebar_data.selections_count
            }]);
            $scope.set_page_data(0, 1, [{
              type: 'counter',
              value: sidebar_data.reservations_count
            }]);
            $scope.set_page_data(0, 2, [{
              type: 'counter',
              value: sidebar_data.orders_count
            }]);
          }
        });
      }
    }
  }

  $scope.init = function () {
    $scope.menu = [];
    set_menu();
  };

  $scope.init();
};

exports.default = UserSellerSidebarMenu;


UserSellerSidebarMenu.$inject = ['$scope', 'UserSidebarService'];

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserSpecialPaymentTerms = function UserSpecialPaymentTerms($scope, $rootScope, UserService, UserSpecialPaymentTermService) {
  _classCallCheck(this, UserSpecialPaymentTerms);

  $scope.set_user_company_autocomplete = function (input) {
    input.autocomplete({
      delay: 300,
      source: function source(request, response) {
        UserService.search_by_company('Buyer', request.term).then(function (data) {
          response(data.users);
        });
      },
      select: function select(event, ui) {
        $scope.dialog_term.buyer_id = ui.item.id;
        $scope.dialog_term.buyer_company = ui.item.value;
        $scope.$apply();
      }
    });
  };

  $scope.open_dialog = function (dialog_id) {
    window.openFancyboxDialog('div#' + dialog_id);
  };

  $scope.add_term = function () {
    $scope.dialog_term = _angular2.default.copy(window.term);
    $scope.user_company = '';
    $scope.open_dialog('user_term_dialog');
  };

  $scope.edit_term = function (term) {
    $scope.dialog_term = term;
    $scope.user_company = '';
    $scope.open_dialog('user_term_dialog');
  };

  $scope.delete_term = function (index) {
    if (confirm('Are you sure you want to delete this term?')) {
      UserSpecialPaymentTermService.delete($scope.user_terms[index].id).then(function (data) {
        if (data.success) {
          $scope.user_terms.splice(index, 1);
          $rootScope.$broadcast('set_sidebar_data', [window.is_buyer ? 3 : 0, window.is_buyer ? 4 : 6, [{
            type: 'counter',
            value: $scope.user_terms.length
          }]]);
        }
      });
    }
  };

  $scope.save_term = function () {
    $scope.updating_term = true;
    UserSpecialPaymentTermService.save($scope.dialog_term).then(function (data) {
      if (data.success) {
        $scope.updating_term = false;
        _jquery2.default.fancybox.close();
        $scope.user_terms = data.user_terms;
        $rootScope.$broadcast('set_sidebar_data', [window.is_buyer ? 3 : 0, window.is_buyer ? 4 : 6, [{
          type: 'counter',
          value: $scope.user_terms.length
        }]]);
      }
    });
  };

  $scope.init = function () {
    $scope.user_id = window.user_id;
    if (window.role == 1) {
      $scope.currencies = window.currencies;
      $scope.dialog_term = _angular2.default.copy(window.term);
    }
    $scope.user_terms = window.user_terms;
    $scope.set_user_company_autocomplete((0, _jquery2.default)('input.user_company'));
  };

  $scope.init();
};

exports.default = UserSpecialPaymentTerms;


UserSpecialPaymentTerms.$inject = ['$scope', '$rootScope', 'UserService', 'UserSpecialPaymentTermService'];

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserTradingDetails = function UserTradingDetails($scope, UserService, UserAdminMessageService, UiService) {
  _classCallCheck(this, UserTradingDetails);

  $scope.tabs = ['General', 'Admin Messages', 'Newsletter Settings'];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.open_dialog = function (dialog_id) {
    window.openFancyboxDialog('div#' + dialog_id);
  };

  $scope.add_message = function () {
    $scope.dialog_message = _angular2.default.copy(window.admin_message);
    $scope.open_dialog('user_admin_message_dialog');
  };

  $scope.edit_message = function (message) {
    $scope.dialog_message = message;
    $scope.open_dialog('user_admin_message_dialog');
  };

  $scope.delete_message = function (index) {
    if (confirm('Are you sure you want to delete this message?')) {
      UserAdminMessageService.delete($scope.user_admin_messages[index].id).then(function (data) {
        if (data.success) $scope.user_admin_messages.splice(index, 1);
      });
    }
  };

  $scope.save_message = function () {
    $scope.updating_message = true;
    UserAdminMessageService.save($scope.dialog_message).then(function (data) {
      if (data.success) {
        $scope.updating_message = false;
        _jquery2.default.fancybox.close();
        $scope.user_admin_messages = data.user_admin_messages;
      }
    });
  };

  $scope.update_newsletter_settings = function () {
    $scope.updating_newsletter_settings = true;
    UserService.update_supplier_newsletter_settings(window.user_id, $scope.newsletter_settings).success(function (data) {
      if (data.success) $scope.updating_newsletter_settings = false;
    });
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.tinymceOptions = UiService.tinymceOptions();
    $scope.user_admin_messages = window.user_admin_messages;
    $scope.dialog_message = _angular2.default.copy(window.admin_message);
    $scope.newsletter_settings = window.newsletter_settings || {
      offer_campaign_text: null,
      offer_campaign_text_el: null,
      offer_campaign_text_el_per: null
    };
    $scope.is_buyer = window.is_buyer;
  };

  $scope.init();
};

exports.default = UserTradingDetails;


UserTradingDetails.$inject = ['$scope', 'UserService', 'UserAdminMessageService', 'UiService'];

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserTradingOffer = function UserTradingOffer($scope, $rootScope, UserService) {
  _classCallCheck(this, UserTradingOffer);

  $scope.update_user = function () {
    $scope.updating_user = true;
    UserService.update($scope.user, null, null).then(function (data) {
      if (data.success) {
        $scope.updating_user = false;
        $rootScope.$broadcast('set_sidebar_data', [0, 1, [{
          type: 'percentage',
          value: data.offer_details_percentage
        }]]);
      }
    });
  };

  $scope.init = function () {
    $scope.user = window.user;
  };

  $scope.init();
};

exports.default = UserTradingOffer;


UserTradingOffer.$inject = ['$scope', '$rootScope', 'UserService'];

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserTradingOrderBuyer = function UserTradingOrderBuyer($scope, $rootScope, UserService, GeoService, UiService) {
  _classCallCheck(this, UserTradingOrderBuyer);

  $scope.tabs = ['Consignee', 'Notify Party', 'Address for Receiving Docs', 'Bank Details', 'Necessary Export Docs'];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.$watch('custom_consignee_address.country_id', function () {
    if ($scope.custom_consignee_address.country_id) {
      GeoService.get_cities($scope.custom_consignee_address.country_id).then(function (data) {
        $scope.consignee_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.custom_consignee_address.city_id })) $scope.custom_consignee_address.city_id = null;
      });
    }
  });

  $scope.$watch('custom_notify_address.country_id', function () {
    if ($scope.custom_notify_address.country_id) {
      GeoService.get_cities($scope.custom_notify_address.country_id).then(function (data) {
        $scope.notify_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.custom_notify_address.city_id })) $scope.custom_notify_address.city_id = null;
      });
    }
  });

  $scope.$watch('custom_docs_address.country_id', function () {
    if ($scope.custom_docs_address.country_id) {
      GeoService.get_cities($scope.custom_docs_address.country_id).then(function (data) {
        $scope.docs_cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.custom_docs_address.city_id })) $scope.custom_docs_address.city_id = null;
      });
    }
  });

  $scope.show_custom_consignee_address = function (status) {
    if (status) {
      $scope.use_custom_consignee_address = status;
    } else {
      $scope.deleting_custom_consignee = true;
      UserService.delete_custom_consignee(window.user_id).then(function (data) {
        if (data.success) {
          $scope.custom_consignee_address = $scope.get_custom_address();
          $scope.use_custom_consignee_address = status;
          $scope.deleting_custom_consignee = false;
          $scope.set_consignee_badge();
          $rootScope.$broadcast('set_sidebar_data', [3, 1, [{
            type: 'percentage',
            value: data.order_details_percentage
          }]]);
        }
      });
    }
  };

  $scope.show_custom_notify_address = function (status) {
    if (status) {
      $scope.use_custom_notify_address = status;
    } else {
      $scope.deleting_custom_notify = true;
      UserService.delete_custom_notify(window.user_id).then(function (data) {
        if (data.success) {
          $scope.custom_notify_address = $scope.get_custom_address();
          $scope.use_custom_notify_address = status;
          $scope.deleting_custom_notify = false;
          $scope.set_notify_badge();
          $rootScope.$broadcast('set_sidebar_data', [3, 1, [{
            type: 'percentage',
            value: data.order_details_percentage
          }]]);
        }
      });
    }
  };

  $scope.save_custom_consignee = function () {
    $scope.saving_custom_consignee = true;
    UserService.save_custom_consignee(window.user_id, $scope.custom_consignee_address).then(function (data) {
      if (data.success) {
        $scope.saving_custom_consignee = false;
        $scope.set_consignee_badge();
        $rootScope.$broadcast('set_sidebar_data', [3, 1, [{
          type: 'percentage',
          value: data.order_details_percentage
        }]]);
      }
    });
  };

  $scope.save_custom_notify = function () {
    $scope.saving_custom_notify = true;
    UserService.save_custom_notify(window.user_id, $scope.custom_notify_address).then(function (data) {
      if (data.success) {
        $scope.saving_custom_notify = false;
        $scope.set_notify_badge();
        $rootScope.$broadcast('set_sidebar_data', [3, 1, [{
          type: 'percentage',
          value: data.order_details_percentage
        }]]);
      }
    });
  };

  $scope.get_custom_address = function () {
    return {
      company_title: null,
      vat: null,
      address_line_1: null,
      address_line_2: null,
      post_code: null,
      country_id: null,
      city_id: null,
      email: null,
      phone: null,
      fax: null
    };
  };

  $scope.get_custom_consignee_address = function () {
    return window.custom_consignee_address || $scope.get_custom_address();
  };

  $scope.get_custom_notify_address = function () {
    return window.custom_notify_address || $scope.get_custom_address();
  };

  $scope.delete_custom_docs = function () {
    $scope.deleting_custom_docs = true;
    UserService.delete_custom_docs(window.user_id).then(function (data) {
      if (data.success) {
        $scope.custom_docs_address = null;
        $scope.custom_docs_address = $scope.get_custom_docs_address();
        $scope.deleting_custom_docs = false;
        $scope.set_docs_address_badge();
        $rootScope.$broadcast('set_sidebar_data', [3, 1, [{
          type: 'percentage',
          value: data.order_details_percentage
        }]]);
      }
    });
  };

  $scope.save_custom_docs = function () {
    $scope.saving_custom_docs = true;
    UserService.save_custom_docs(window.user_id, $scope.custom_docs_address).then(function (data) {
      if (data.success) {
        $scope.saving_custom_docs = false;
        $scope.set_docs_address_badge();
        $rootScope.$broadcast('set_sidebar_data', [3, 1, [{
          type: 'percentage',
          value: data.order_details_percentage
        }]]);
      }
    });
  };

  $scope.save_export_docs = function () {
    var docs = [];
    _angular2.default.forEach($scope.export_docs, function (doc) {
      if (doc.checked) docs.push(doc.id);
    });
    $scope.saving_export_docs = true;
    UserService.save_export_docs(window.user_id, docs).then(function (data) {
      if (data.success) {
        $scope.saving_export_docs = false;
        $scope.set_export_docs_badge();
        $rootScope.$broadcast('set_sidebar_data', [3, 1, [{
          type: 'percentage',
          value: data.order_details_percentage
        }]]);
      }
    });
  };

  $scope.get_custom_docs_address = function () {
    return {
      contact_person: null,
      company_title: null,
      address_line_1: null,
      address_line_2: null,
      post_code: null,
      country_id: null,
      city_id: null,
      email: null,
      phone: null,
      fax: null
    };
  };

  $scope.set_export_docs_badge = function () {
    var count = 0;
    _angular2.default.forEach($scope.export_docs, function (doc) {
      if (doc.checked) count++;
    });
    $scope.export_docs_badge = {
      count: count,
      css: UiService.get_count_css_class(count)
    };
  };

  $scope.set_bank_badge = function (percentage) {
    $scope.bank_badge = {
      percentage: percentage,
      css: UiService.get_counter_css_class(percentage)
    };
  };

  $scope.set_docs_address_badge = function () {
    var percentage = 0;
    if ($scope.custom_docs_address.contact_person) percentage += 10;
    if ($scope.custom_docs_address.company_title) percentage += 10;
    if ($scope.custom_docs_address.address_line_1) percentage += 10;
    if ($scope.custom_docs_address.address_line_2) percentage += 10;
    if ($scope.custom_docs_address.post_code) percentage += 10;
    if ($scope.custom_docs_address.country_id) percentage += 10;
    if ($scope.custom_docs_address.city_id) percentage += 10;
    if ($scope.custom_docs_address.email) percentage += 10;
    if ($scope.custom_docs_address.phone) percentage += 10;
    if ($scope.custom_docs_address.fax) percentage += 10;
    $scope.docs_address_badge = {
      percentage: percentage,
      css: UiService.get_counter_css_class(percentage)
    };
  };

  $scope.set_notify_badge = function () {
    var percentage = 0;
    if ($scope.use_custom_notify_address) {
      if ($scope.custom_notify_address.vat) percentage += 10;
      if ($scope.custom_notify_address.company_title) percentage += 10;
      if ($scope.custom_notify_address.address_line_1) percentage += 10;
      if ($scope.custom_notify_address.address_line_2) percentage += 10;
      if ($scope.custom_notify_address.post_code) percentage += 10;
      if ($scope.custom_notify_address.country_id) percentage += 10;
      if ($scope.custom_notify_address.city_id) percentage += 10;
      if ($scope.custom_notify_address.email) percentage += 10;
      if ($scope.custom_notify_address.phone) percentage += 10;
      if ($scope.custom_notify_address.fax) percentage += 10;
    } else {
      percentage = window.notify_address_percentage;
    }
    $scope.notify_badge = {
      percentage: percentage,
      css: UiService.get_counter_css_class(percentage)
    };
  };

  $scope.set_consignee_badge = function () {
    var percentage = 0;
    if ($scope.use_custom_consignee_address) {
      if ($scope.custom_consignee_address.vat) percentage += 10;
      if ($scope.custom_consignee_address.company_title) percentage += 10;
      if ($scope.custom_consignee_address.address_line_1) percentage += 10;
      if ($scope.custom_consignee_address.address_line_2) percentage += 10;
      if ($scope.custom_consignee_address.post_code) percentage += 10;
      if ($scope.custom_consignee_address.country_id) percentage += 10;
      if ($scope.custom_consignee_address.city_id) percentage += 10;
      if ($scope.custom_consignee_address.email) percentage += 10;
      if ($scope.custom_consignee_address.phone) percentage += 10;
      if ($scope.custom_consignee_address.fax) percentage += 10;
    } else {
      percentage = window.consignee_address_percentage;
    }
    $scope.consignee_badge = {
      percentage: percentage,
      css: UiService.get_counter_css_class(percentage)
    };
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
    $scope.consignee_countries = _angular2.default.copy(window.countries);
    $scope.notify_countries = _angular2.default.copy(window.countries);
    $scope.docs_countries = _angular2.default.copy(window.countries);
    if (window.custom_consignee_address) $scope.use_custom_consignee_address = true;
    if (window.custom_notify_address) $scope.use_custom_notify_address = true;
    $scope.custom_consignee_address = $scope.get_custom_consignee_address();
    $scope.custom_notify_address = $scope.get_custom_notify_address();
    $scope.custom_docs_address = window.custom_docs_address || $scope.get_custom_docs_address();
    $scope.export_docs = window.export_docs;
    $scope.set_export_docs_badge();
    $scope.set_bank_badge(window.trading_bank_percentage);
    $scope.set_docs_address_badge();
    $scope.set_notify_badge();
    $scope.set_consignee_badge();
  };

  $scope.init();
};

exports.default = UserTradingOrderBuyer;


UserTradingOrderBuyer.$inject = ['$scope', '$rootScope', 'UserService', 'GeoService', 'UiService'];

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserTradingOrderSeller = function UserTradingOrderSeller($scope) {
  _classCallCheck(this, UserTradingOrderSeller);

  $scope.tabs = ['Bank Details'];

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
  };

  $scope.init = function () {
    $scope.selected_tab = 0;
  };

  $scope.init();
};

exports.default = UserTradingOrderSeller;


UserTradingOrderSeller.$inject = ['$scope'];

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserViewSimilar = function UserViewSimilar($scope, UserService) {
  _classCallCheck(this, UserViewSimilar);

  $scope.similarity_tabs = UserService.get_similar_tabs();

  $scope.compare_tabs = UserService.get_similar_dialog_tabs();

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
    $scope.filtered_similar_users = $scope.get_filtered_similar_users(index);
  };

  $scope.set_selected_compare_tab = function (index) {
    $scope.selected_compare_tab = index;
  };

  $scope.get_filtered_similar_users_length = function (index) {
    if (index == 0) return $scope.similar_users.length;else return $scope.get_filtered_similar_users(index).length;
  };

  $scope.get_filtered_similar_users = function (index) {
    return UserService.get_filtered_similar_users($scope.similar_users, index);
  };

  $scope.open_dialog = function (dialog_id) {
    window.openFancyboxDialog('div#' + dialog_id);
  };

  $scope.compare_users = function (user) {
    $scope.compare_user = user;
    $scope.open_dialog('compare_user_dialog');
  };

  $scope.set_update_mode = function (value) {
    $scope.update_mode = value;
    $scope.updating_user = '';
  };

  $scope.mark_as_not_similar = function () {
    $scope.similar_users.splice($scope.similar_users.indexOf($scope.compare_user), 1);
    $scope.filtered_similar_users = $scope.get_filtered_similar_users($scope.selected_tab);
    _jquery2.default.fancybox.close();
  };

  $scope.connect_users = function () {
    $scope.updating_user = true;
    var connection = {
      user1_id: $scope.user.id,
      user2_id: $scope.compare_user.id
    };
    UserService.connect_users(connection).then(function (data) {
      if (data.success) {
        $scope.compare_user.connection = data.connection;
        $scope.updating_user = false;
      }
    });
  };

  $scope.disconnect_users = function () {
    $scope.updating_user = true;
    UserService.disconnect_users($scope.compare_user.connection.user_connection).then(function (data) {
      if (data.success) {
        $scope.compare_user.connection = null;
        $scope.updating_user = false;
      }
    });
  };

  $scope.init = function () {
    $scope.update_mode = false;
    $scope.selected_tab = 0;
    $scope.selected_compare_tab = 0;
    $scope.similar_users = window.similar_users;
    $scope.filtered_similar_users = window.similar_users;
    $scope.business_relations = window.business_relations;
    $scope.user = window.user;
  };

  $scope.init();
};

exports.default = UserViewSimilar;


UserViewSimilar.$inject = ['$scope', 'UserService'];

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UsersByGroup = function UsersByGroup($scope, UserService, PaginationService) {
  _classCallCheck(this, UsersByGroup);

  $scope.get_tabs = function () {
    var tabs = [{
      title: 'Premium',
      filter: {
        key: 'is_premium',
        value: 1
      },
      users: [],
      page: 1
    }, {
      title: 'Suspended',
      filter: {
        key: 'user_groups',
        value: [2]
      },
      users: [],
      page: 1
    }, {
      title: 'Special',
      filter: {
        key: 'user_groups',
        value: [1]
      },
      users: [],
      page: 1
    }];
    return tabs;
  };

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
    $scope.query = '';
  };

  $scope.quick_search = function () {
    window.filter_table('table#users', $scope.query);
  };

  $scope.common_filters = function () {
    return {
      per_page: 50,
      user_type: window.user_type
    };
  };

  $scope.load_users = function (tab) {
    $scope.query = '';
    var filters = $scope.common_filters();
    filters['page'] = tab.page;
    filters[tab.filter.key] = tab.filter.value;
    UserService.search(filters).then(function (data) {
      tab.users = data.users;
      tab.pagination = PaginationService.get_pagination(data.pagination);
    });
  };

  $scope.init = function () {
    $scope.tabs = $scope.get_tabs();
    $scope.selected_tab = 0;
    _angular2.default.forEach($scope.tabs, function (tab) {
      $scope.load_users(tab);
    });
  };

  $scope.init();
};

exports.default = UsersByGroup;


UsersByGroup.$inject = ['$scope', 'UserService', 'PaginationService'];

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UsersByRelation = function UsersByRelation($scope, UserService, PaginationService) {
  _classCallCheck(this, UsersByRelation);

  $scope.get_tabs = function () {
    var tabs = [{
      title: 'Unqualified Leads',
      relation_id: 0,
      users: [],
      page: 1
    }, {
      title: 'Qualified Leads',
      relation_id: 1,
      users: [],
      page: 1
    }, {
      title: 'Contacts',
      relation_id: 2,
      users: [],
      page: 1
    }];
    if (window.user_type == 'buyer') tabs.push({
      title: 'Customers',
      relation_id: 3,
      users: [],
      page: 1
    });else tabs.push({
      title: 'Corporate Suppliers',
      relation_id: 4,
      users: [],
      page: 1
    });
    return tabs;
  };

  $scope.set_selected_tab = function (index) {
    $scope.selected_tab = index;
    $scope.query = '';
  };

  $scope.quick_search = function () {
    window.filter_table('table#users', $scope.query);
  };

  $scope.common_filters = function () {
    return {
      per_page: 50,
      user_type: window.user_type,
      countries: $scope.country_id ? [$scope.country_id] : []
    };
  };

  $scope.load_users = function (tab) {
    $scope.query = '';
    var filters = $scope.common_filters();
    filters['page'] = tab.page;
    filters['relation_id'] = tab.relation_id;
    UserService.search(filters).then(function (data) {
      tab.users = data.users;
      tab.pagination = PaginationService.get_pagination(data.pagination);
    });
  };

  $scope.reload_users = function () {
    _angular2.default.forEach($scope.tabs, function (tab) {
      $scope.load_users(tab);
    });
  };

  $scope.init = function () {
    $scope.country_id = null;
    $scope.countries = window.countries;
    $scope.tabs = $scope.get_tabs();
    $scope.selected_tab = 0;
    $scope.reload_users();
  };

  $scope.init();
};

exports.default = UsersByRelation;


UsersByRelation.$inject = ['$scope', 'UserService', 'PaginationService'];

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Users = function () {
  function Users($scope, UserService, UiService, PaginationService) {
    _classCallCheck(this, Users);

    $scope.users = [];
    $scope.pagination = {};
    $scope.user_types = UserService.get_user_types();
    $scope.user_groups = window.user_groups;
    $scope.offer_campaign_criteria_statuses = window.offer_campaign_criteria_statuses;
    $scope.categories = window.categories;
    $scope.business_relations = window.business_relations;

    $scope.date_options = UiService.date_options();
    $scope.select2_options = UiService.select2_options(600);

    $scope.init_filter = this.init_filter.bind(this);
    $scope.load_data = this.load_data.bind(this);
    $scope.quick_search = this.quick_search.bind(this);
    $scope.$watch('continent', this.update_countries.bind(this));

    this.$scope = $scope;
    this.UserService = UserService;
    this.PaginationService = PaginationService;

    this.init_filter();
    this.load_data();
  }

  _createClass(Users, [{
    key: 'init_filter',
    value: function init_filter() {
      this.$scope.filter = {
        page: 1,
        per_page: 50,
        user_id: null,
        user_type: null,
        user_groups: [],
        date_from: null,
        date_to: null,
        has_preferences: null,
        has_orders: null,
        contacts: null,
        countries: [],
        is_deleted: false,
        offer_campaign_criteria: null,
        product_category_id: null,
        business_relation: null
      };

      this.$scope.continent = null;
    }
  }, {
    key: 'update_countries',
    value: function update_countries() {
      var _this = this;

      this.$scope.countries = [];

      if (_underscore2.default.isEmpty(this.$scope.continent)) {
        return;
      }

      var group = (0, _jquery2.default)('select#countries').find('optgroup[label="' + this.$scope.continent + '"]');

      group.find('option').each(function (index, element) {
        _this.$scope.countries.push((0, _jquery2.default)(element).attr('value'));
      });
    }
  }, {
    key: 'quick_search',
    value: function quick_search() {
      window.filter_table('table.data', this.$scope.quick_filter);
    }
  }, {
    key: 'load_data',
    value: function load_data() {
      var _this2 = this;

      this.$scope.filter.user_groups = _underscore2.default.pluck(_underscore2.default.where(this.$scope.user_groups, { checked: true }), 'id');

      this.UserService.search(this.$scope.filter).then(function (data) {
        _this2.$scope.users = data.users;
        _this2.$scope.pagination = _this2.PaginationService.get_pagination(data.pagination);
      });
    }
  }]);

  return Users;
}();

exports.default = Users;


Users.$inject = ['$scope', 'UserService', 'UiService', 'PaginationService'];

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebEventsAdd = function WebEventsAdd($scope, $rootScope, GeoService) {
  _classCallCheck(this, WebEventsAdd);

  $scope.$watch('country_id', function () {
    if ($scope.country_id) $scope.web_event_country_name = (0, _jquery2.default)('#country option[value="' + $scope.country_id + '"]').html();else $scope.web_event_country_name = '';
    if ($scope.country_id) {
      GeoService.get_cities($scope.country_id).then(function (data) {
        $scope.cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.city_id })) $scope.city_id = null;
      });
    }
  });

  $scope.$watch('city_id', function () {
    if ($scope.city_id) $scope.web_event_city_name = (0, _jquery2.default)('#city option:selected').text();else $scope.web_event_city_name = '';
  });
};

exports.default = WebEventsAdd;


WebEventsAdd.$inject = ['$scope', '$rootScope', 'GeoService'];

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebEventsEdit = function WebEventsEdit($scope, $rootScope, GeoService) {
  _classCallCheck(this, WebEventsEdit);

  $scope.$watch('web_event.country_id', function () {
    if ($scope.web_event.country_id) {
      GeoService.get_cities($scope.web_event.country_id).then(function (data) {
        $scope.cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.web_event.city_id })) $scope.web_event.city_id = null;
      });
    }
  });

  $scope.init = function () {
    $scope.web_event = window.web_event;
    $scope.countries = window.countries;
  };

  $scope.init();
};

exports.default = WebEventsEdit;


WebEventsEdit.$inject = ['$scope', '$rootScope', 'GeoService'];

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebEvents = function WebEvents($scope, $rootScope, WebEventService, PaginationService) {
  _classCallCheck(this, WebEvents);

  $scope.load_data = function () {
    $scope.loading = true;
    WebEventService.get($scope.filter).success(function (data) {
      $scope.events = data.events;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
      if ($scope.selected_events) {
        _underscore2.default.each($scope.selected_sources, function (event_id) {
          var event = _underscore2.default.findWhere($scope.events, {
            id: event_id
          });
          if (event) event.checked = true;
        });
      }
      $scope.loading = false;
    });
  };

  $scope.init_filter = function () {
    $scope.filter = {
      page: 1,
      per_page: 40
    };
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.load_data();
  };

  $scope.quick_search = function () {
    window.filter_table('table.data', $scope.quick_filter);
  };

  $scope.init = function () {
    $scope.events = [];
    $scope.pagination = {};
    $scope.init_filter();
    $scope.load_data();
  };

  $scope.init();
};

exports.default = WebEvents;


WebEvents.$inject = ['$scope', '$rootScope', 'WebEventService', 'PaginationService'];

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebGlossaries = function WebGlossaries($scope, $rootScope, WebGlossaryService, PaginationService) {
  _classCallCheck(this, WebGlossaries);

  $scope.load_data = function () {
    $scope.loading = true;
    WebGlossaryService.get($scope.filter).success(function (data) {
      $scope.glossaries = data.glossaries;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
      if ($scope.selected_glossaries) {
        _underscore2.default.each($scope.selected_glossaries, function (glossary_id) {
          var glossary = _underscore2.default.findWhere($scope.glossaries, {
            id: glossary_id
          });
          if (glossary) glossary.checked = true;
        });
      }
      $scope.loading = false;
    });
  };

  $scope.init_filter = function () {
    $scope.filter = {
      page: 1,
      per_page: 40
    };
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.load_data();
  };

  $scope.check_glossaries = function () {
    _underscore2.default.each($scope.glossaries, function (c) {
      c.checked = $scope.select_all;
    });
  };

  $scope.quick_search = function () {
    window.filter_table('table.data', $scope.quick_filter);
  };

  $scope.mass_delete_glossaries = function () {
    var glossaries = _underscore2.default.where($scope.glossaries, {
      checked: true
    });
    if (glossaries.length === 0) {
      alert('Please select at least one glossary!');
      return false;
    }

    if (confirm('Are you sure you want to delete the selected glossaries?')) {
      WebGlossaryService.mass_delete(_underscore2.default.pluck(glossaries, 'id')).success(function (data) {
        if (data.success) $scope.load_data();
      });
    }

    $rootScope.$broadcast('show_mass_send_dialog', {
      glossaries: glossaries
    });
  };

  $scope.init = function () {
    $scope.glossaries = [];
    $scope.pagination = {};
    $scope.init_filter();
    $scope.load_data();
  };

  $scope.init();
};

exports.default = WebGlossaries;


WebGlossaries.$inject = ['$scope', '$rootScope', 'WebGlossaryService', 'PaginationService'];

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebNewsCategories = function WebNewsCategories($scope, WebNewService, PaginationService) {
  _classCallCheck(this, WebNewsCategories);

  $scope.quick_search = function () {
    window.filter_table('table#sub_categories', $scope.query);
  };

  $scope.get_sub_categories = function () {
    $scope.searching = true;
    WebNewService.get_sub_categories($scope.filter).then(function (data) {
      $scope.sub_categories = data.sub_categories;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
      $scope.searching = false;
    });
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.get_sub_categories();
  };

  $scope.init_filter = function () {
    $scope.filter = {
      page: 1,
      per_page: 50,
      category_id: null
    };
  };

  $scope.categories = window.categories;
  $scope.init_filter();
  $scope.get_sub_categories();
};

exports.default = WebNewsCategories;


WebNewsCategories.$inject = ['$scope', 'WebNewService', 'PaginationService'];

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebNews = function WebNews($scope, $rootScope, WebNewService, PaginationService) {
  _classCallCheck(this, WebNews);

  $scope.load_data = function () {
    $scope.loading = true;
    WebNewService.get($scope.filter).success(function (data) {
      $scope.news = data.news;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
      $scope.loading = false;
    });
  };

  $scope.init_filter = function () {
    $scope.filter = {
      page: 1,
      per_page: 40
    };
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.load_data();
  };

  $scope.quick_search = function () {
    window.filter_table('table.data', $scope.quick_filter);
  };

  $scope.init = function () {
    $scope.news = [];
    $scope.pagination = {};
    $scope.init_filter();
    $scope.load_data();
  };

  $scope.init();
};

exports.default = WebNews;


WebNews.$inject = ['$scope', '$rootScope', 'WebNewService', 'PaginationService'];

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebSourcesAdd = function WebSourcesAdd($scope, $compile, $rootScope, GeoService) {
  _classCallCheck(this, WebSourcesAdd);

  $scope.$watch('country_id', function () {
    if ($scope.country_id) $scope.web_source_country_name = (0, _jquery2.default)('#country option[value="' + $scope.country_id + '"]').html();else $scope.web_source_country_name = '';
    if ($scope.country_id) {
      GeoService.get_cities($scope.country_id).then(function (data) {
        $scope.cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.city_id })) $scope.city_id = null;
      });
    }
  });

  $scope.$watch('city_id', function () {
    if ($scope.city_id) $scope.web_source_city_name = (0, _jquery2.default)('#city option:selected').text();else $scope.web_source_city_name = '';
  });
};

exports.default = WebSourcesAdd;


WebSourcesAdd.$inject = ['$scope', '$compile', '$rootScope', 'GeoService'];

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebSourcesCategories = function WebSourcesCategories($scope, WebSourceService, PaginationService) {
  _classCallCheck(this, WebSourcesCategories);

  $scope.quick_search = function () {
    window.filter_table('table#sub_categories', $scope.query);
  };

  $scope.get_sub_categories = function () {
    $scope.searching = true;
    WebSourceService.get_sub_categories($scope.filter).then(function (data) {
      $scope.sub_categories = data.sub_categories;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
      $scope.searching = false;
    });
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.get_sub_categories();
  };

  $scope.init_filter = function () {
    $scope.filter = {
      page: 1,
      per_page: 50,
      category_id: null
    };
  };

  $scope.categories = window.categories;
  $scope.init_filter();
  $scope.get_sub_categories();
};

exports.default = WebSourcesCategories;


WebSourcesCategories.$inject = ['$scope', 'WebSourceService', 'PaginationService'];

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebSourcesEdit = function WebSourcesEdit($scope, $rootScope, GeoService) {
  _classCallCheck(this, WebSourcesEdit);

  $scope.$watch('web_source.country_id', function () {
    if ($scope.web_source.country_id) {
      GeoService.get_cities($scope.web_source.country_id).then(function (data) {
        $scope.cities = data.cities;
        if (!_underscore2.default.findWhere(data.cities, { id: $scope.web_source.city_id })) $scope.web_source.city_id = null;
      });
    }
  });

  $scope.init = function () {
    $scope.web_source = window.web_source;
    $scope.countries = window.countries;
  };

  $scope.init();
};

exports.default = WebSourcesEdit;


WebSourcesEdit.$inject = ['$scope', '$rootScope', 'GeoService'];

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebSources = function WebSources($scope, $rootScope, WebSourceService, PaginationService) {
  _classCallCheck(this, WebSources);

  $scope.load_data = function () {
    $scope.loading = true;

    console.log($scope.filter);
    WebSourceService.get($scope.filter).success(function (data) {
      $scope.sources = data.sources;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
      if ($scope.selected_sources) {
        _underscore2.default.each($scope.selected_sources, function (source_id) {
          var source = _underscore2.default.findWhere($scope.sources, {
            id: source_id
          });
          if (source) source.checked = true;
        });
      }
      $scope.loading = false;
    });
  };

  $scope.check_sources = function () {
    _underscore2.default.each($scope.sources, function (c) {
      c.checked = $scope.select_all;
    });
  };

  $scope.init_filter = function () {
    $scope.filter = {
      page: 1,
      per_page: 40
    };
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.load_data();
  };

  $scope.quick_search = function () {
    window.filter_table('table.data', $scope.quick_filter);
  };

  $scope.delete_sources = function () {
    var sources = _underscore2.default.where($scope.sources, {
      checked: true
    });
    if (sources.length === 0) {
      alert('Please select at least one source!');
      return;
    }

    if (confirm('Are you sure you want to delete these sources?')) {
      sources = _underscore2.default.pluck(sources, 'id');
      WebSourceService.delete_sources(sources).then(function (data) {
        if (data.success) {
          $scope.sources = _underscore2.default.filter($scope.sources, function (v) {
            return _underscore2.default.indexOf(sources, v.id) === -1;
          });
        }
      });
    }
  };

  $scope.init = function () {
    $scope.sources = [];
    $scope.pagination = {};
    $scope.init_filter();
    $scope.load_data();
  };

  $scope.init();
};

exports.default = WebSources;


WebSources.$inject = ['$scope', '$rootScope', 'WebSourceService', 'PaginationService'];

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebTopicsCategories = function WebTopicsCategories($scope, WebTopicService, PaginationService) {
  _classCallCheck(this, WebTopicsCategories);

  $scope.quick_search = function () {
    window.filter_table('table#sub_categories', $scope.query);
  };

  $scope.get_sub_categories = function () {
    $scope.searching = true;
    WebTopicService.get_sub_categories($scope.filter).then(function (data) {
      $scope.sub_categories = data.sub_categories;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
      $scope.searching = false;
    });
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.get_sub_categories();
  };

  $scope.init_filter = function () {
    $scope.filter = {
      page: 1,
      per_page: 50,
      category_id: null
    };
  };

  $scope.categories = window.categories;
  $scope.init_filter();
  $scope.get_sub_categories();
};

exports.default = WebTopicsCategories;


WebTopicsCategories.$inject = ['$scope', 'WebTopicService', 'PaginationService'];

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebTopics = function WebTopics($scope, $rootScope, WebTopicService, PaginationService) {
  _classCallCheck(this, WebTopics);

  $scope.load_data = function () {
    $scope.loading = true;
    WebTopicService.get($scope.filter).success(function (data) {
      $scope.topics = data.topics;
      $scope.pagination = PaginationService.get_pagination(data.pagination);
      if ($scope.selected_topics) {
        _underscore2.default.each($scope.selected_topics, function (topic_id) {
          var topic = _underscore2.default.findWhere($scope.topics, {
            id: topic_id
          });
          if (topic) topic.checked = true;
        });
      }
      $scope.loading = false;
    });
  };

  $scope.init_filter = function () {
    $scope.filter = {
      page: 1,
      per_page: 40
    };
  };

  $scope.get_page_data = function (page) {
    $scope.filter.page = page;
    $scope.load_data();
  };

  $scope.quick_search = function () {
    window.filter_table('table.data', $scope.quick_filter);
  };

  $scope.init = function () {
    $scope.topics = [];
    $scope.pagination = {};
    $scope.init_filter();
    $scope.load_data();
  };

  $scope.init();
};

exports.default = WebTopics;


WebTopics.$inject = ['$scope', '$rootScope', 'WebTopicService', 'PaginationService'];

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DateService = function () {
  function DateService() {
    _classCallCheck(this, DateService);
  }

  _createClass(DateService, [{
    key: 'get_date_str',
    value: function get_date_str(date) {
      return date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate();
    }
  }]);

  return DateService;
}();

exports.default = DateService;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DemandService = function () {
  function DemandService($http) {
    _classCallCheck(this, DemandService);

    this.$http = $http;
  }

  _createClass(DemandService, [{
    key: 'save',
    value: function save(demand) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/demands/save',
        data: { demand: demand, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_manage_data',
    value: function get_manage_data(filter) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/demands/get_manage_data',
        data: { filter: filter, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete',
    value: function _delete(demand_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/demands/delete',
        data: { demand_id: demand_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return DemandService;
}();

exports.default = DemandService;


DemandService.$inject = ['$http'];

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EmailService = function () {
  function EmailService($http) {
    _classCallCheck(this, EmailService);

    this.$http = $http;
  }

  _createClass(EmailService, [{
    key: 'save_email_hostname',
    value: function save_email_hostname(email_hostname) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_email_hostname',
        data: { email_hostname: email_hostname, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_recipient_modes',
    value: function get_recipient_modes() {
      return [{ id: 0, title: 'to' }, { id: 1, title: 'cc' }];
    }
  }, {
    key: 'get_sender_names_en',
    value: function get_sender_names_en() {
      return ['Petros Tsolpagas', 'Andriana Faka'];
    }
  }, {
    key: 'get_sender_names_el',
    value: function get_sender_names_el() {
      return ['Πέτρος Τσολπάγκας', 'Ανδριάνα Φάκα'];
    }
  }]);

  return EmailService;
}();

exports.default = EmailService;


EmailService.$inject = ['$http'];

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FaqService = function () {
  function FaqService($http) {
    _classCallCheck(this, FaqService);

    this.$http = $http;
  }

  _createClass(FaqService, [{
    key: 'get_section_faqs',
    value: function get_section_faqs(section) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/faqs/get_section_faqs',
        data: { type_id: section.faq_type_id, section_id: section.id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save',
    value: function save(faq) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/faqs/save',
        data: { faq: faq, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete',
    value: function _delete(faq_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/faqs/delete',
        data: { id: faq_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return FaqService;
}();

exports.default = FaqService;


FaqService.$inject = ['$http'];

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GeoService = function () {
  function GeoService($http) {
    _classCallCheck(this, GeoService);

    this.$http = $http;
  }

  _createClass(GeoService, [{
    key: 'get_cities',
    value: function get_cities(country_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_cities',
        params: { country_id: country_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save_city',
    value: function save_city(city) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_city',
        data: { city: city, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return GeoService;
}();

exports.default = GeoService;


GeoService.$inject = ['$http'];

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ItemService = function () {
  function ItemService($http) {
    _classCallCheck(this, ItemService);

    this.$http = $http;
  }

  _createClass(ItemService, [{
    key: 'get_dialog_data',
    value: function get_dialog_data() {
      return this.$http.get('/admin/marketplace/items/get_dialog_data');
    }
  }, {
    key: 'get_stock_types',
    value: function get_stock_types() {
      return [{ title: 'Reels', is_reels: true }, { title: 'Sheets', is_reels: false }];
    }
  }, {
    key: 'save',
    value: function save(item) {
      return this.$http.post('/admin/marketplace/items/save_item', { item: item, authenticity_token: window.token });
    }
  }, {
    key: 'mass_save',
    value: function mass_save(item, items) {
      return this.$http.post('/admin/marketplace/items/save_items', { item: item, items: items, authenticity_token: window.token });
    }
  }]);

  return ItemService;
}();

exports.default = ItemService;


ItemService.$inject = ['$http'];

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MessageCenterService = function () {
  function MessageCenterService($http) {
    _classCallCheck(this, MessageCenterService);

    this.$http = $http;
  }

  _createClass(MessageCenterService, [{
    key: 'get_data',
    value: function get_data() {
      return this.$http.get('/admin/marketplace/message_center/get_data');
    }
  }]);

  return MessageCenterService;
}();

exports.default = MessageCenterService;


MessageCenterService.$inject = ['$http'];

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MessageService = function () {
  function MessageService($http) {
    _classCallCheck(this, MessageService);

    this.$http = $http;
  }

  _createClass(MessageService, [{
    key: 'get',
    value: function get(filter) {
      return this.$http.post('/admin/marketplace/messages/get_messages', { filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'create',
    value: function create(message) {
      return this.$http.post('/admin/marketplace/messages/create_message', { message: message, authenticity_token: window.token });
    }
  }, {
    key: 'delete',
    value: function _delete(message_id) {
      return this.$http.post('/admin/marketplace/messages/delete_message', { message_id: message_id, authenticity_token: window.token });
    }
  }, {
    key: 'update',
    value: function update(message) {
      return this.$http.post('/admin/marketplace/messages/update_message', { message: message, authenticity_token: window.token });
    }
  }]);

  return MessageService;
}();

exports.default = MessageService;


MessageService.$inject = ['$http'];

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MillService = function () {
  function MillService($http) {
    _classCallCheck(this, MillService);

    this.$http = $http;
  }

  _createClass(MillService, [{
    key: 'get',
    value: function get(filter) {
      return this.$http.post('/admin/marketplace/mills/index', { filter: filter, authenticity_token: window.token });
    }
  }]);

  return MillService;
}();

exports.default = MillService;


MillService.$inject = ['$http'];

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NewsletterService = function () {
  function NewsletterService($http) {
    _classCallCheck(this, NewsletterService);

    this.$http = $http;
  }

  _createClass(NewsletterService, [{
    key: 'get',
    value: function get(filter) {
      return this.$http.post('/admin/marketplace/newsletters/get_newsletters', { filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'create',
    value: function create(newsletter) {
      return this.$http.post('/admin/marketplace/newsletters/create_newsletter', { newsletter: newsletter, authenticity_token: window.token });
    }
  }, {
    key: 'delete',
    value: function _delete(newsletter_id) {
      return this.$http.post('/admin/marketplace/newsletters/delete_newsletter', { newsletter_id: newsletter_id, authenticity_token: window.token });
    }
  }, {
    key: 'update',
    value: function update(newsletter) {
      return this.$http.post('/admin/marketplace/newsletters/update_newsletter', { newsletter: newsletter, authenticity_token: window.token });
    }
  }, {
    key: 'find_recipients',
    value: function find_recipients(newsletter_id, filter) {
      return this.$http.post('/admin/marketplace/newsletters/find_recipients', { newsletter_id: newsletter_id, filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'add_recipients',
    value: function add_recipients(newsletter_id, users) {
      return this.$http.post('/admin/marketplace/newsletters/add_recipients', { newsletter_id: newsletter_id, users: users, authenticity_token: window.token });
    }
  }, {
    key: 'find_and_add_recipients',
    value: function find_and_add_recipients(newsletter_id, filter) {
      return this.$http.post('/admin/marketplace/newsletters/find_and_add_offer_campaign_recipients', { newsletter_id: newsletter_id, filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'get_recipients',
    value: function get_recipients(newsletter_id, is_pending) {
      return this.$http.get('/admin/marketplace/newsletters/get_newsletter_recipients', { params: { newsletter_id: newsletter_id, is_pending: is_pending } });
    }
  }, {
    key: 'set_recipient_contacts',
    value: function set_recipient_contacts(recipient_id, contacts) {
      return this.$http.post('/admin/marketplace/newsletters/set_recipient_contacts', { recipient_id: recipient_id, contacts: contacts, authenticity_token: window.token });
    }
  }, {
    key: 'auto_select_contacts',
    value: function auto_select_contacts(recipient_id) {
      return this.$http.post('/admin/marketplace/campaigns/auto_select_recipient_contacts', { recipient_id: recipient_id, authenticity_token: window.token });
    }
  }, {
    key: 'send_email',
    value: function send_email(newsletter_id, recipient_id, test_send, test_send_email) {
      return this.$http.post('/admin/marketplace/newsletters/send_newsletter', { newsletter_id: newsletter_id, recipient_id: recipient_id, test_send: test_send, test_send_email: test_send_email, authenticity_token: window.token });
    }
  }, {
    key: 'set_recipient_pending',
    value: function set_recipient_pending(recipient_id, is_pending) {
      return this.$http.post('/admin/marketplace/newsletters/set_recipient_pending', { recipient_id: recipient_id, is_pending: is_pending, authenticity_token: window.token });
    }
  }, {
    key: 'get_fields',
    value: function get_fields() {
      return this.$http.get('/admin/marketplace/campaigns/get_offer_campaign_fields');
    }
  }, {
    key: 'update_field',
    value: function update_field(field) {
      return this.$http.post('/admin/marketplace/campaigns/update_offer_campaign_field', { field: field, authenticity_token: window.token });
    }
  }, {
    key: 'update_recipient_template_text',
    value: function update_recipient_template_text(recipient_id, template_text, template_text_per, is_done) {
      return this.$http.post('/admin/marketplace/campaigns/update_offer_campaign_recipient_template_text', { recipient_id: recipient_id, template_text: template_text, template_text_per: template_text_per, is_done: is_done, authenticity_token: window.token });
    }
  }, {
    key: 'copy_text_fields',
    value: function copy_text_fields(source_campaign_id, target_campaign_id) {
      return this.$http.post('/admin/marketplace/campaigns/copy_offer_campaign_text_fields', { source_campaign_id: source_campaign_id, target_campaign_id: target_campaign_id, authenticity_token: window.token });
    }
  }, {
    key: 'copy_basic_infos',
    value: function copy_basic_infos(source_campaign_id, target_campaign_id) {
      return this.$http.post('/admin/marketplace/campaigns/copy_offer_campaign_basic_infos', { source_campaign_id: source_campaign_id, target_campaign_id: target_campaign_id, authenticity_token: window.token });
    }
  }, {
    key: 'update_recipient_embed_pi',
    value: function update_recipient_embed_pi(recipient_id, embed_stocklist_pi) {
      return this.$http.post('/admin/marketplace/campaigns/update_recipient_embed_pi', { recipient_id: recipient_id, embed_stocklist_pi: embed_stocklist_pi, authenticity_token: window.token });
    }
  }, {
    key: 'update_recipient_embed_matched',
    value: function update_recipient_embed_matched(recipient_id, embed_stocklist_matched) {
      return this.$http.post('/admin/marketplace/campaigns/update_recipient_embed_matched', { recipient_id: recipient_id, embed_stocklist_matched: embed_stocklist_matched, authenticity_token: window.token });
    }
  }, {
    key: 'get_attachments',
    value: function get_attachments(offer_campaign_id) {
      return this.$http.get('/admin/marketplace/campaigns/get_offer_campaign_attachments', { params: { offer_campaign_id: offer_campaign_id } });
    }
  }, {
    key: 'save_attachments',
    value: function save_attachments(recipients, attachments) {
      return this.$http.post('/admin/marketplace/campaigns/save_offer_campaign_recipient_attachments', { recipients: recipients, attachments: attachments, authenticity_token: window.token });
    }
  }, {
    key: 'get_default_settings',
    value: function get_default_settings(offer_title) {
      var settings = {
        campaign_id: null,
        campaign_title: offer_title,
        min_quantity: 0,
        max_embedded_matched_rows: 12,
        embed_stocklist: false,
        product_group_specs: false,
        related_offer_id: null,
        related_offer_prices: false,
        hide_offer_prices: false,
        hide_cfr_prices: false,
        hide_dap_prices: false,
        currency_symbol: 0,
        use_product_name: false,
        sort_items: false,
        sort_items_by_parent_id: false,
        use_custom_template: false,
        general_text: null,
        general_text_el: null,
        supplier_text: null,
        supplier_text_el: null,
        supplier_text_el_per: null,
        sender_name: null,
        sender_name_el: null,
        filename_stocklist: null,
        filename_stocklist_pi: null,
        special_notes: null,
        target_recipients: null,
        filter: this.get_default_filter()
      };

      return settings;
    }
  }, {
    key: 'get_default_filter',
    value: function get_default_filter() {
      var filter = {
        user_countries: [],
        excluded_user_countries: [],
        excluded_user_groups: [],
        has_specs: 'all',
        user_group: 'all',
        epr_marketing_campaigns: 'all',
        business_relations: [],
        product_specs: [],
        pre_min_quality_accuracy: 1,
        pre_min_specs_accuracy: 1,
        min_quality_accuracy: 1,
        min_specs_accuracy: 1,
        specs_method_standard: true,
        specs_method_relative: false,
        specs_method_special: false,
        specs_method_advanced: false,
        specs_matching_accurate: true,
        specs_matching_flexible: true,
        specs_matching_basic_only: false,
        specs_status: 0,
        buyers: [],
        product_end_uses: [],
        match_specs_and_end_uses: false,
        specs_method_operator: 2,
        specs_method_percentage: 5,
        special_matching_method: 0, // 0 = quick, 1 = analytical
        special_matching_cuts: 1,
        special_matching_waste: 2,
        special_matching_range: 2
      };

      return filter;
    }
  }, {
    key: 'set_default_settings',
    value: function set_default_settings(settings) {
      if (!settings.filter.product_specs) {
        settings.filter.product_specs = [];
      }
      if (!settings.filter.buyers) {
        settings.filter.buyers = [];
      }
      if (settings.filter.product_specs.length === 0) {
        settings.filter.product_specs.push({
          product_category_id: null,
          product_group_id: null,
          product_id: null
        });
      }
      if (!settings.currency_symbol) {
        settings.currency_symbol = 0;
      }
      if (!settings.use_product_name) {
        settings.use_product_name = false;
      }

      if (!settings.sort_items) {
        settings.sort_items = false;
      }

      if (!settings.sort_items_by_parent_id) {
        settings.sort_items_by_parent_id = false;
      }

      if (!settings.use_custom_template) {
        settings.use_custom_template = false;
      }

      if (!settings.hide_offer_prices) {
        settings.hide_offer_prices = false;
      }

      if (!settings.hide_cfr_prices) {
        settings.hide_cfr_prices = false;
      }

      if (!settings.hide_dap_prices) {
        settings.hide_dap_prices = false;
      }

      if (!settings.filter.excluded_user_groups) {
        settings.filter.excluded_user_groups = [];
      }

      if (!settings.filter.business_relations) {
        settings.filter.business_relations = [];
      }

      if (!settings.filter.product_end_uses) {
        settings.filter.product_end_uses = [];
      }

      if (!settings.max_embedded_matched_rows) {
        settings.max_embedded_matched_rows = 0;
      }

      if (!settings.special_notes) {
        settings.special_notes = null;
      }

      if (!settings.target_recipients) {
        settings.target_recipients = null;
      }

      if (!settings.filter.match_specs_and_end_uses) {
        settings.filter.match_specs_and_end_uses = false;
      }

      if (!settings.filter.specs_method_operator) {
        settings.filter.specs_method_operator = 2;
      }

      if (!settings.filter.specs_method_percentage) {
        settings.filter.specs_method_percentage = 5;
      }

      if (!settings.filter.epr_marketing_campaigns) {
        settings.filter.epr_marketing_campaigns = 'all';
      }

      if (!settings.filter.special_matching_method) {
        settings.filter.special_matching_method = 0;
      }

      if (!settings.filter.special_matching_cuts) {
        settings.filter.special_matching_cuts = 1;
      }

      if (!settings.filter.special_matching_waste) {
        settings.filter.special_matching_waste = 2;
      }

      if (!settings.filter.special_matching_range) {
        settings.filter.special_matching_range = 2;
      }

      return settings;
    }
  }, {
    key: 'send_created_campaigns_email',
    value: function send_created_campaigns_email(campaigns) {
      return this.$http.post('/admin/marketplace/campaigns/send_created_campaigns_email', { campaigns: campaigns, authenticity_token: window.token });
    }
  }, {
    key: 'send_campaign_sent_email',
    value: function send_campaign_sent_email(campaign_id) {
      return this.$http.post('/admin/marketplace/campaigns/send_campaign_sent_email', { campaign_id: campaign_id, authenticity_token: window.token });
    }
  }, {
    key: 'get_groups',
    value: function get_groups() {
      return [{ id: 1, title: 'Special' }, { id: 4, title: 'R-Inventory' }];
    }
  }, {
    key: 'update_excluded_groups',
    value: function update_excluded_groups(groups, filter) {
      if (!filter.excluded_user_groups) {
        return;
      }

      _underscore2.default.each(filter.excluded_user_groups, function (group_id) {
        var group = _underscore2.default.findWhere(groups, { id: group_id });
        if (group) {
          group.checked = true;
        }
      });
    }
  }, {
    key: 'update_business_relations',
    value: function update_business_relations(business_relations, filter) {
      if (!filter.business_relations) {
        return;
      }

      if (filter.business_relations.length > 0) {
        _underscore2.default.each(business_relations, function (relation) {
          relation.checked = false;
        });
      }

      _underscore2.default.each(filter.business_relations, function (relation_id) {
        var relation = _underscore2.default.findWhere(business_relations, { id: relation_id });
        if (relation) {
          relation.checked = true;
        }
      });
    }
  }]);

  return NewsletterService;
}();

exports.default = NewsletterService;


NewsletterService.$inject = ['$http'];

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferCampaignService = function () {
  function OfferCampaignService($http) {
    _classCallCheck(this, OfferCampaignService);

    this.$http = $http;
  }

  _createClass(OfferCampaignService, [{
    key: 'get',
    value: function get(filter) {
      return this.$http.post('/admin/marketplace/campaigns/get_offer_campaigns', { filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'create',
    value: function create(campaign) {
      return this.$http.post('/admin/marketplace/campaigns/create_offer_campaign', { campaign: campaign, authenticity_token: window.token });
    }
  }, {
    key: 'delete',
    value: function _delete(offer_campaign_id) {
      return this.$http.post('/admin/marketplace/campaigns/delete_offer_campaign', { offer_campaign_id: offer_campaign_id, authenticity_token: window.token });
    }
  }, {
    key: 'update',
    value: function update(campaign) {
      return this.$http.post('/admin/marketplace/campaigns/update_offer_campaign', { campaign: campaign, authenticity_token: window.token });
    }
  }, {
    key: 'find_recipients',
    value: function find_recipients(offer_campaign_id, filter) {
      return this.$http.post('/admin/marketplace/campaigns/find_offer_campaign_recipients', { offer_campaign_id: offer_campaign_id, filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'add_recipients',
    value: function add_recipients(offer_campaign_id, general_buyers, special_buyers) {
      return this.$http.post('/admin/marketplace/campaigns/add_offer_campaign_recipients', { offer_campaign_id: offer_campaign_id, general_buyers: general_buyers, special_buyers: special_buyers, authenticity_token: window.token });
    }
  }, {
    key: 'find_and_add_recipients',
    value: function find_and_add_recipients(offer_campaign_id, filter) {
      return this.$http.post('/admin/marketplace/campaigns/find_and_add_offer_campaign_recipients', { offer_campaign_id: offer_campaign_id, filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'get_recipients',
    value: function get_recipients(offer_campaign_id, is_special, is_pending) {
      return this.$http.get('/admin/marketplace/campaigns/get_offer_campaign_recipients', { params: { offer_campaign_id: offer_campaign_id, is_special: is_special, is_pending: is_pending } });
    }
  }, {
    key: 'create_general_xls',
    value: function create_general_xls(offer_campaign_id, buyer_id, buyer_country_id) {
      return this.$http.post('/admin/marketplace/campaigns/create_offer_campaign_general_xls', { offer_campaign_id: offer_campaign_id, buyer_id: buyer_id, buyer_country_id: buyer_country_id, authenticity_token: window.token });
    }
  }, {
    key: 'create_special_xls',
    value: function create_special_xls(offer_campaign_id, buyer_id, buyer_country_id, create_stocklist_xls, create_pi_xls) {
      return this.$http.post('/admin/marketplace/campaigns/create_offer_campaign_special_xls', { offer_campaign_id: offer_campaign_id, buyer_id: buyer_id, buyer_country_id: buyer_country_id, create_stocklist_xls: create_stocklist_xls, create_pi_xls: create_pi_xls, authenticity_token: window.token });
    }
  }, {
    key: 'get_matched_quantity',
    value: function get_matched_quantity(offer_campaign_id, buyer_id, buyer_country_id, product_specs_for_all) {
      return this.$http.post('/admin/marketplace/campaigns/get_offer_campaign_matched_quantity', { offer_campaign_id: offer_campaign_id, buyer_id: buyer_id, buyer_country_id: buyer_country_id, product_specs_for_all: product_specs_for_all, authenticity_token: window.token });
    }
  }, {
    key: 'set_recipient_attachment',
    value: function set_recipient_attachment(recipient_id, attachments) {
      return this.$http.post('/admin/marketplace/campaigns/set_recipient_attachment', { recipient_id: recipient_id, attachments: attachments, authenticity_token: window.token });
    }
  }, {
    key: 'set_recipient_contacts',
    value: function set_recipient_contacts(recipient_id, contacts) {
      return this.$http.post('/admin/marketplace/campaigns/set_recipient_contacts', { recipient_id: recipient_id, contacts: contacts, authenticity_token: window.token });
    }
  }, {
    key: 'auto_select_contacts',
    value: function auto_select_contacts(recipient_id) {
      return this.$http.post('/admin/marketplace/campaigns/auto_select_recipient_contacts', { recipient_id: recipient_id, authenticity_token: window.token });
    }
  }, {
    key: 'send_email',
    value: function send_email(offer_campaign_id, recipient_id, test_send, test_send_email) {
      return this.$http.post('/admin/marketplace/campaigns/send_offer_campaign', { offer_campaign_id: offer_campaign_id, recipient_id: recipient_id, test_send: test_send, test_send_email: test_send_email, authenticity_token: window.token });
    }
  }, {
    key: 'send_email_and_test',
    value: function send_email_and_test(offer_campaign_id, recipient_id, test_send, test_send_email) {
      return this.$http.post('/admin/marketplace/campaigns/send_offer_campaign', { offer_campaign_id: offer_campaign_id, recipient_id: recipient_id, test_send: test_send, test_send_email: test_send_email, authenticity_token: window.token, send_both: true });
    }
  }, {
    key: 'set_recipient_pending',
    value: function set_recipient_pending(recipient_id, is_pending) {
      return this.$http.post('/admin/marketplace/campaigns/set_recipient_pending', { recipient_id: recipient_id, is_pending: is_pending, authenticity_token: window.token });
    }
  }, {
    key: 'get_fields',
    value: function get_fields() {
      return this.$http.get('/admin/marketplace/campaigns/get_offer_campaign_fields');
    }
  }, {
    key: 'update_field',
    value: function update_field(field) {
      return this.$http.post('/admin/marketplace/campaigns/update_offer_campaign_field', { field: field, authenticity_token: window.token });
    }
  }, {
    key: 'update_recipient_template_text',
    value: function update_recipient_template_text(recipient_id, template_text, template_text_per, is_done) {
      return this.$http.post('/admin/marketplace/campaigns/update_offer_campaign_recipient_template_text', { recipient_id: recipient_id, template_text: template_text, template_text_per: template_text_per, is_done: is_done, authenticity_token: window.token });
    }
  }, {
    key: 'copy_text_fields',
    value: function copy_text_fields(source_campaign_id, target_campaign_id) {
      return this.$http.post('/admin/marketplace/campaigns/copy_offer_campaign_text_fields', { source_campaign_id: source_campaign_id, target_campaign_id: target_campaign_id, authenticity_token: window.token });
    }
  }, {
    key: 'copy_basic_infos',
    value: function copy_basic_infos(source_campaign_id, target_campaign_id) {
      return this.$http.post('/admin/marketplace/campaigns/copy_offer_campaign_basic_infos', { source_campaign_id: source_campaign_id, target_campaign_id: target_campaign_id, authenticity_token: window.token });
    }
  }, {
    key: 'update_recipient_embed_pi',
    value: function update_recipient_embed_pi(recipient_id, embed_stocklist_pi) {
      return this.$http.post('/admin/marketplace/campaigns/update_recipient_embed_pi', { recipient_id: recipient_id, embed_stocklist_pi: embed_stocklist_pi, authenticity_token: window.token });
    }
  }, {
    key: 'update_recipient_embed_matched',
    value: function update_recipient_embed_matched(recipient_id, embed_stocklist_matched) {
      return this.$http.post('/admin/marketplace/campaigns/update_recipient_embed_matched', { recipient_id: recipient_id, embed_stocklist_matched: embed_stocklist_matched, authenticity_token: window.token });
    }
  }, {
    key: 'get_attachments',
    value: function get_attachments(offer_campaign_id) {
      return this.$http.get('/admin/marketplace/campaigns/get_offer_campaign_attachments', { params: { offer_campaign_id: offer_campaign_id } });
    }
  }, {
    key: 'save_attachments',
    value: function save_attachments(recipients, attachments) {
      return this.$http.post('/admin/marketplace/campaigns/save_offer_campaign_recipient_attachments', { recipients: recipients, attachments: attachments, authenticity_token: window.token });
    }
  }, {
    key: 'get_default_settings',
    value: function get_default_settings(offer_title) {
      var settings = {
        campaign_id: null,
        campaign_title: offer_title,
        min_quantity: 0,
        max_embedded_matched_rows: 12,
        embed_stocklist: false,
        product_group_specs: false,
        related_offer_id: null,
        related_offer_prices: false,
        hide_offer_prices: false,
        hide_cfr_prices: false,
        hide_dap_prices: false,
        currency_symbol: 0,
        use_product_name: false,
        sort_items: false,
        sort_items_by_parent_id: false,
        use_custom_template: false,
        enable_cta: false,
        cta_text: 'READY TO <br/> BOOST YOUR BUSINESS',
        cta_link: '',
        cta_button_text: 'Button',
        general_text: null,
        general_text_el: null,
        supplier_text: null,
        supplier_text_el: null,
        supplier_text_el_per: null,
        sender_name: null,
        sender_name_el: null,
        filename_stocklist: null,
        filename_stocklist_pi: null,
        special_notes: null,
        target_recipients: null,
        rw_cutting: null,
        filter: this.get_default_filter()
      };

      return settings;
    }
  }, {
    key: 'get_default_filter',
    value: function get_default_filter() {
      var filter = {
        user_countries: [],
        excluded_user_countries: [],
        excluded_user_groups: [],
        has_specs: 'all',
        user_group: 'all',
        epr_marketing_campaigns: 'all',
        has_campaign_settings: 'all',
        has_campaign_messages: 'all',
        business_relations: [],
        product_specs: [],
        pre_min_quality_accuracy: 1,
        pre_min_specs_accuracy: 1,
        min_quality_accuracy: 1,
        min_specs_accuracy: 1,
        specs_method_standard: true,
        specs_method_relative: false,
        specs_method_special: false,
        specs_method_advanced: false,
        specs_matching_accurate: true,
        specs_matching_flexible: true,
        specs_matching_basic_only: false,
        specs_status: 0,
        buyers: [],
        product_end_uses: [],
        match_specs_and_end_uses: false,
        specs_method_operator: 2,
        specs_method_percentage: 5,
        special_matching_method: 0, // 0 = quick, 1 = analytical
        special_matching_cuts: 1,
        special_matching_waste: 2,
        special_matching_range: 2,
        special_matching_spec: 1
      };

      return filter;
    }
  }, {
    key: 'set_default_settings',
    value: function set_default_settings(settings) {
      if (!settings.filter.product_specs) {
        settings.filter.product_specs = [];
      }
      if (!settings.filter.buyers) {
        settings.filter.buyers = [];
      }
      if (settings.filter.product_specs.length === 0) {
        settings.filter.product_specs.push({
          product_category_id: null,
          product_group_id: null,
          product_id: null
        });
      }
      if (!settings.currency_symbol) {
        settings.currency_symbol = 0;
      }
      if (!settings.use_product_name) {
        settings.use_product_name = false;
      }

      if (!settings.sort_items) {
        settings.sort_items = false;
      }

      if (!settings.sort_items_by_parent_id) {
        settings.sort_items_by_parent_id = false;
      }

      if (!settings.use_custom_template) {
        settings.use_custom_template = false;
      }

      if (!settings.hide_offer_prices) {
        settings.hide_offer_prices = false;
      }

      if (!settings.hide_cfr_prices) {
        settings.hide_cfr_prices = false;
      }

      if (!settings.hide_dap_prices) {
        settings.hide_dap_prices = false;
      }

      if (!settings.filter.excluded_user_groups) {
        settings.filter.excluded_user_groups = [];
      }

      if (!settings.filter.business_relations) {
        settings.filter.business_relations = [];
      }

      if (!settings.filter.product_end_uses) {
        settings.filter.product_end_uses = [];
      }

      if (!settings.max_embedded_matched_rows) {
        settings.max_embedded_matched_rows = 0;
      }

      if (!settings.special_notes) {
        settings.special_notes = null;
      }

      if (!settings.target_recipients) {
        settings.target_recipients = null;
      }

      if (!settings.filter.match_specs_and_end_uses) {
        settings.filter.match_specs_and_end_uses = false;
      }

      if (!settings.filter.specs_method_operator) {
        settings.filter.specs_method_operator = 2;
      }

      if (!settings.filter.specs_method_percentage) {
        settings.filter.specs_method_percentage = 5;
      }

      if (!settings.filter.epr_marketing_campaigns) {
        settings.filter.epr_marketing_campaigns = 'all';
      }

      if (!settings.filter.has_campaign_settings) {
        settings.filter.has_campaign_settings = 'all';
      }

      if (!settings.filter.has_campaign_messages) {
        settings.filter.has_campaign_messages = 'all';
      }

      if (!settings.filter.special_matching_method) {
        settings.filter.special_matching_method = 0;
      }

      if (!settings.filter.special_matching_cuts) {
        settings.filter.special_matching_cuts = 1;
      }

      if (!settings.filter.special_matching_waste) {
        settings.filter.special_matching_waste = 2;
      }

      if (!settings.filter.special_matching_range) {
        settings.filter.special_matching_range = 2;
      }

      if (!settings.filter.special_matching_spec && settings.filter.special_matching_spec != 0) {
        settings.filter.special_matching_spec = 1;
      }

      return settings;
    }
  }, {
    key: 'send_created_campaigns_email',
    value: function send_created_campaigns_email(campaigns, times) {
      return this.$http.post('/admin/marketplace/campaigns/send_created_campaigns_email', { campaigns: campaigns, times: times, authenticity_token: window.token });
    }
  }, {
    key: 'send_campaign_sent_email',
    value: function send_campaign_sent_email(campaign_id, times) {
      return this.$http.post('/admin/marketplace/campaigns/send_campaign_sent_email', { campaign_id: campaign_id, times: times, authenticity_token: window.token });
    }
  }, {
    key: 'send_campaigns_sent_email',
    value: function send_campaigns_sent_email(campaigns, times, created_times) {
      return this.$http.post('/admin/marketplace/campaigns/send_campaigns_sent_email', { campaigns: campaigns, times: times, created_times: created_times, authenticity_token: window.token });
    }
  }, {
    key: 'get_groups',
    value: function get_groups() {
      return [{ id: 1, title: 'Special' }, { id: 4, title: 'R-Inventory' }];
    }
  }, {
    key: 'update_excluded_groups',
    value: function update_excluded_groups(groups, filter) {
      if (!filter.excluded_user_groups) {
        return;
      }

      _underscore2.default.each(filter.excluded_user_groups, function (group_id) {
        var group = _underscore2.default.findWhere(groups, { id: group_id });
        if (group) {
          group.checked = true;
        }
      });
    }
  }, {
    key: 'update_business_relations',
    value: function update_business_relations(business_relations, filter) {
      if (!filter.business_relations) {
        return;
      }

      if (filter.business_relations.length > 0) {
        _underscore2.default.each(business_relations, function (relation) {
          relation.checked = false;
        });
      }

      _underscore2.default.each(filter.business_relations, function (relation_id) {
        var relation = _underscore2.default.findWhere(business_relations, { id: relation_id });
        if (relation) {
          relation.checked = true;
        }
      });
    }
  }]);

  return OfferCampaignService;
}();

exports.default = OfferCampaignService;


OfferCampaignService.$inject = ['$http'];

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferMarketRestrictionService = function () {
  function OfferMarketRestrictionService($http) {
    _classCallCheck(this, OfferMarketRestrictionService);

    this.$http = $http;
  }

  _createClass(OfferMarketRestrictionService, [{
    key: 'update',
    value: function update(offer) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/offers/save_offer_market_restrictions',
        data: { offer: offer, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save_member_restriction',
    value: function save_member_restriction(member_restriction) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/offers/save_offer_member_restriction',
        data: { member_restriction: member_restriction, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete_member_restriction',
    value: function delete_member_restriction(member_restriction_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/offers/delete_offer_member_restriction',
        data: { id: member_restriction_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete_member_restrictions',
    value: function delete_member_restrictions(restrictions) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/offers/delete_offer_member_restrictions',
        data: { restrictions: restrictions, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save_product_member_restrictions',
    value: function save_product_member_restrictions(restrictions) {
      return this.$http.post('/admin/marketplace/offers/save_product_member_restrictions', { restrictions: restrictions, authenticity_token: window.token });
    }
  }, {
    key: 'delete_product_member_restriction',
    value: function delete_product_member_restriction(offer_id, restriction_id) {
      return this.$http.post('/admin/marketplace/offers/delete_product_member_restriction', { offer_id: offer_id, restriction_id: restriction_id, authenticity_token: window.token });
    }
  }, {
    key: 'save_product_country_restrictions',
    value: function save_product_country_restrictions(restrictions) {
      return this.$http.post('/admin/marketplace/offers/save_product_country_restrictions', { restrictions: restrictions, authenticity_token: window.token });
    }
  }, {
    key: 'delete_product_country_restriction',
    value: function delete_product_country_restriction(offer_id, restriction_id) {
      return this.$http.post('/admin/marketplace/offers/delete_product_country_restriction', { offer_id: offer_id, restriction_id: restriction_id, authenticity_token: window.token });
    }
  }, {
    key: 'add_member_restrictions',
    value: function add_member_restrictions(offer_id, buyers) {
      return this.$http.post('/admin/marketplace/offers/add_offer_member_restrictions', { offer_id: offer_id, buyers: buyers, authenticity_token: window.token });
    }
  }]);

  return OfferMarketRestrictionService;
}();

exports.default = OfferMarketRestrictionService;


OfferMarketRestrictionService.$inject = ['$http'];

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferRequestItemService = function () {
  function OfferRequestItemService($http) {
    _classCallCheck(this, OfferRequestItemService);

    this.$http = $http;
  }

  _createClass(OfferRequestItemService, [{
    key: 'get_status_options',
    value: function get_status_options() {
      return [{ id: 0, title: 'Pending' }, { id: 1, title: 'Available' }, { id: 2, title: 'Reserved' }, { id: 3, title: 'PreOrdered' }, { id: 4, title: 'Ordered' }];
    }
  }, {
    key: 'delete',
    value: function _delete(item_id) {
      return this.$http.post('/admin/marketplace/offer_requests/delete_offer_request_item', { item_id: item_id, authenticity_token: window.token });
    }
  }, {
    key: 'mass_delete',
    value: function mass_delete(items) {
      return this.$http.post('/admin/marketplace/offer_requests/delete_offer_request_items', { items: items, authenticity_token: window.token });
    }
  }, {
    key: 'save',
    value: function save(item) {
      return this.$http.post('/admin/marketplace/offer_requests/save_offer_request_item', { item: item, authenticity_token: window.token });
    }
  }, {
    key: 'mass_save',
    value: function mass_save(item, items) {
      return this.$http.post('/admin/marketplace/offer_requests/save_offer_request_items', { item: item, items: items, authenticity_token: window.token });
    }
  }, {
    key: 'mass_update_prices',
    value: function mass_update_prices(offer_request_id, items) {
      return this.$http.post('/admin/marketplace/offer_requests/update_offer_request_item_prices', { offer_request_id: offer_request_id, items: items, authenticity_token: window.token });
    }
  }]);

  return OfferRequestItemService;
}();

exports.default = OfferRequestItemService;


OfferRequestItemService.$inject = ['$http'];

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferRequestService = function () {
  function OfferRequestService($http) {
    _classCallCheck(this, OfferRequestService);

    this.$http = $http;
  }

  _createClass(OfferRequestService, [{
    key: 'get',
    value: function get(filter) {
      return this.$http.post('/admin/marketplace/offer_requests/get_offer_requests', { filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'get_status_options',
    value: function get_status_options() {
      return [{ id: 1, title: 'Active' }, { id: 0, title: 'Cancelled' }];
    }
  }, {
    key: 'create',
    value: function create(offer_request) {
      return this.$http.post('/admin/marketplace/offer_requests/create_offer_request', { offer_request: offer_request, authenticity_token: window.token });
    }
  }, {
    key: 'delete',
    value: function _delete(offer_request_id) {
      return this.$http.post('/admin/marketplace/offer_requests/delete', { offer_request_id: offer_request_id, authenticity_token: window.token });
    }
  }, {
    key: 'get_offer_request_items',
    value: function get_offer_request_items(offer_request_id) {
      return this.$http.get('/admin/marketplace/offer_requests/get_offer_request_items/' + offer_request_id);
    }
  }, {
    key: 'get_details_data',
    value: function get_details_data() {
      return this.$http.get('/admin/marketplace/offer_requests/get_details_data');
    }
  }, {
    key: 'update',
    value: function update(offer_request) {
      return this.$http.post('/admin/marketplace/offer_requests/update', { offer_request: offer_request, authenticity_token: window.token });
    }
  }, {
    key: 'create_order_confirmation',
    value: function create_order_confirmation(offer_request_id, items) {
      return this.$http.post('/admin/marketplace/offer_requests/create_order_confirmation', { offer_request_id: offer_request_id, items: items, authenticity_token: window.token });
    }
  }, {
    key: 'get_next_sc_id',
    value: function get_next_sc_id(offer_request_id, series) {
      return this.$http.post('/admin/marketplace/offer_requests/get_next_sc_id', { offer_request_id: offer_request_id, series: series, authenticity_token: window.token });
    }
  }, {
    key: 'update_order_confirmation',
    value: function update_order_confirmation(order_confirmation_id, items) {
      return this.$http.post('/admin/marketplace/offer_requests/update_order_confirmation', { order_confirmation_id: order_confirmation_id, items: items, authenticity_token: window.token });
    }
  }, {
    key: 'remove_order_confirmation_items',
    value: function remove_order_confirmation_items(order_confirmation_id, items) {
      return this.$http.post('/admin/marketplace/offer_requests/remove_order_confirmation_items', { order_confirmation_id: order_confirmation_id, items: items, authenticity_token: window.token });
    }
  }, {
    key: 'create_order_confirmation_docs',
    value: function create_order_confirmation_docs(order_confirmation_id) {
      var sc_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      return this.$http.post('/admin/marketplace/offer_requests/create_order_confirmation_docs', { order_confirmation_id: order_confirmation_id, sc_id: sc_id, authenticity_token: window.token });
    }
  }, {
    key: 'create_order',
    value: function create_order(order_confirmation_id) {
      return this.$http.post('/admin/marketplace/offer_requests/create_order', { order_confirmation_id: order_confirmation_id, authenticity_token: window.token });
    }
  }, {
    key: 'connect_order',
    value: function connect_order(order_confirmation_id, order_id, copy_items) {
      return this.$http.post('/admin/marketplace/offer_requests/connect_order', { order_confirmation_id: order_confirmation_id, order_id: order_id, copy_items: copy_items, authenticity_token: window.token });
    }
  }, {
    key: 'send_order_confirmation_notification',
    value: function send_order_confirmation_notification(order_confirmation_id, doc_details, doc_specs, custom_text, contacts, sender_name_en, sender_name_el, test_send, test_send_email) {
      return this.$http.post('/admin/marketplace/offer_requests/send_order_confirmation_notification', { order_confirmation_id: order_confirmation_id, doc_details: doc_details, doc_specs: doc_specs, custom_text: custom_text, contacts: contacts, sender_name_en: sender_name_en, sender_name_el: sender_name_el, test_send: test_send, test_send_email: test_send_email, authenticity_token: window.token });
    }
  }, {
    key: 'update_order_confirmation_field',
    value: function update_order_confirmation_field(order_confirmation_id, field, field_value) {
      return this.$http.post('/admin/marketplace/offer_requests/update_order_confirmation_field', { order_confirmation_id: order_confirmation_id, field: field, field_value: field_value, authenticity_token: window.token });
    }
  }, {
    key: 'delete_order_confirmation',
    value: function delete_order_confirmation(order_confirmation_id) {
      return this.$http.post('/admin/marketplace/offer_requests/delete_order_confirmation', { order_confirmation_id: order_confirmation_id, authenticity_token: window.token });
    }
  }, {
    key: 'find_offer_request_items',
    value: function find_offer_request_items(filter) {
      return this.$http.post('/admin/marketplace/offer_requests/find_offer_request_items', { filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'update_buyer_preferences',
    value: function update_buyer_preferences(offer_request_id) {
      return this.$http.post('/admin/marketplace/offer_requests/update_buyer_preferences', { offer_request_id: offer_request_id, authenticity_token: window.token });
    }
  }, {
    key: 'create_from_offer_items',
    value: function create_from_offer_items(offer_id, buyer_id, items) {
      return this.$http.post('/admin/marketplace/offer_requests/create_from_offer_items', { offer_id: offer_id, buyer_id: buyer_id, items: items, authenticity_token: window.token });
    }
  }, {
    key: 'add_offer_items',
    value: function add_offer_items(offer_request_id, items) {
      return this.$http.post('/admin/marketplace/offer_requests/add_offer_items', { offer_request_id: offer_request_id, items: items, authenticity_token: window.token });
    }
  }]);

  return OfferRequestService;
}();

exports.default = OfferRequestService;


OfferRequestService.$inject = ['$http'];

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferSidebarService = function () {
  function OfferSidebarService($http) {
    _classCallCheck(this, OfferSidebarService);

    this.$http = $http;
  }

  _createClass(OfferSidebarService, [{
    key: 'get_sidebar_data',
    value: function get_sidebar_data(offer_id, group) {
      return this.$http.get('/admin/marketplace/offers/get_sidebar_data', { params: { offer_id: offer_id, group: group } });
    }
  }]);

  return OfferSidebarService;
}();

exports.default = OfferSidebarService;


OfferSidebarService.$inject = ['$http'];

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OfferService = function () {
  function OfferService($http) {
    _classCallCheck(this, OfferService);

    this.$http = $http;
  }

  _createClass(OfferService, [{
    key: 'get_offer_ids',
    value: function get_offer_ids(user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/offers/get_offer_ids',
        params: { user_id: user_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save',
    value: function save(offer) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/offers/save',
        data: { offer: offer, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_matched_buyers',
    value: function get_matched_buyers(offer_id, filter) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/offers/get_matched_buyers',
        data: { offer_id: offer_id, filter: filter, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_matched_items',
    value: function get_matched_items(offer_id, buyer_id, filter, return_stocklist) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/offers/get_matched_items',
        data: { offer_id: offer_id, buyer_id: buyer_id, filter: filter, return_stocklist: return_stocklist, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_matched_item',
    value: function get_matched_item(offer_id, buyer_id, filter, return_stocklist, item_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/offers/get_matched_items',
        data: { offer_id: offer_id, buyer_id: buyer_id, filter: filter, return_stocklist: return_stocklist, item_id: item_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'create_personalized_offer',
    value: function create_personalized_offer(offer_id, items, user_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/offers/create_personalized_offer',
        data: { offer_id: offer_id, items: items, user_id: user_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'create_offer_from_items',
    value: function create_offer_from_items(items, filter, offer_options) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/offers/create_offer_from_items',
        data: { items: items, filter: filter, offer_options: offer_options, authenticity_token: window.token }
      });
    }
  }, {
    key: 'create_offer_from_cut_analysis',
    value: function create_offer_from_cut_analysis(items, offer_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/offers/create_offer_from_cut_analysis',
        data: { items: items, offer_id: offer_id, authenticity_token: window.token }
      });
    }
  }, {
    key: 'get_manage_data',
    value: function get_manage_data(filter) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/offers/get_manage_data',
        data: { filter: filter, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_cut_pricing_results',
    value: function get_cut_pricing_results(offer_stock_item_ids, filter) {
      return this.$http.post('/admin/marketplace/offers/get_cut_pricing_results', { offer_stock_item_ids: offer_stock_item_ids, filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'get_cut_analysis_xls',
    value: function get_cut_analysis_xls(offer_stock_item_ids, results) {
      return this.$http.post('/admin/marketplace/offers/get_cut_analysis_xls', { offer_stock_item_ids: offer_stock_item_ids, results: results, authenticity_token: window.token });
    }
  }, {
    key: 'get_stocklist_for_charges',
    value: function get_stocklist_for_charges(offer_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/offers/get_stocklist_for_charges',
        data: { offer_id: offer_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'set_item_term_charges',
    value: function set_item_term_charges(offer_id, items) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/offers/set_item_term_charges',
        data: { offer_id: offer_id, items: items, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'set_offer_country_charges',
    value: function set_offer_country_charges(offer_id, country_charge, countries) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/offers/set_offer_country_charges',
        data: { offer_id: offer_id, country_charge: country_charge, countries: countries, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete_country_charge',
    value: function delete_country_charge(offer_id, charge_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/offers/delete_country_charge',
        data: { offer_id: offer_id, charge_id: charge_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'search_for_inventories',
    value: function search_for_inventories(filter) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/offers/search_for_inventories',
        data: { filter: filter, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_supplier_shipment_cities',
    value: function get_supplier_shipment_cities(supplier_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/offers/get_supplier_shipment_cities',
        params: { supplier_id: supplier_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_connections',
    value: function get_connections(offer_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/offers/get_connections',
        params: { offer_id: offer_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'update_create_filters',
    value: function update_create_filters(filter) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/offers/update_create_filters',
        data: { filter: filter, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'update_stocklist_from_parent',
    value: function update_stocklist_from_parent(offer_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/offers/update_stocklist_from_parent',
        data: { offer_id: offer_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'update_stocklists_from_parent',
    value: function update_stocklists_from_parent(offers) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/offers/update_stocklists_from_parent',
        data: { offers: offers, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'send_updated_offers_email',
    value: function send_updated_offers_email(offers, times) {
      return this.$http.post('/admin/marketplace/offers/send_updated_offers_email', { offers: offers, times: times, authenticity_token: window.token });
    }
  }, {
    key: 'get_freight_rates_for_buyer',
    value: function get_freight_rates_for_buyer(offer_id, delivery_country_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/offers/get_freight_rates_for_buyer',
        params: { offer_id: offer_id, country_id: delivery_country_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_delivery_terms_for_buyer',
    value: function get_delivery_terms_for_buyer(user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_delivery_terms_for_buyer',
        params: { user_id: user_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_country_extra_charge',
    value: function get_country_extra_charge(offer_id, supplier_id, country_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/offers/get_country_extra_charge',
        params: { offer_id: offer_id, supplier_id: supplier_id, country_id: country_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'submit_ospp_price',
    value: function submit_ospp_price(offer_id, items, buyer_id, buyer_country_id, price, incoterm) {
      return this.$http.post('/admin/marketplace/offers/submit_ospp_price', { offer_id: offer_id, items: items, buyer_id: buyer_id, buyer_country_id: buyer_country_id, price: price, incoterm: incoterm, authenticity_token: window.token });
    }
  }, {
    key: 'submit_ospp_price_charge',
    value: function submit_ospp_price_charge(offer_id, items, buyer_id, buyer_country_id, charge, incoterm) {
      return this.$http.post('/admin/marketplace/offers/submit_ospp_price_charge', { offer_id: offer_id, items: items, buyer_id: buyer_id, buyer_country_id: buyer_country_id, charge: charge, incoterm: incoterm, authenticity_token: window.token });
    }
  }, {
    key: 'get_prices_for_activation',
    value: function get_prices_for_activation(offer_id, supplier_id, buyer_id, country_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/offers/get_prices_for_activation',
        params: { offer_id: offer_id, supplier_id: supplier_id, buyer_id: buyer_id, country_id: country_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'set_uspp_activation',
    value: function set_uspp_activation(id, status) {
      return this.$http.post('/admin/marketplace/offers/set_uspp_activation', { id: id, status: status, authenticity_token: window.token });
    }
  }, {
    key: 'set_uspc_activation',
    value: function set_uspc_activation(id, status) {
      return this.$http.post('/admin/marketplace/offers/set_uspc_activation', { id: id, status: status, authenticity_token: window.token });
    }
  }, {
    key: 'get_ospp_users',
    value: function get_ospp_users(offer_id) {
      return this.$http.get('/admin/marketplace/offers/get_ospp_users', { params: { offer_id: offer_id } });
    }
  }, {
    key: 'get_buyer_matched_items',
    value: function get_buyer_matched_items(filter) {
      return this.$http.post('/admin/marketplace/offers/get_buyer_matched_items', { filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'delete',
    value: function _delete(offer_id) {
      return this.$http.post('/admin/marketplace/offers/delete_offer', { offer_id: offer_id, authenticity_token: window.token });
    }
  }, {
    key: 'update_supplier_pricings',
    value: function update_supplier_pricings(offer_id, offer_date_mode) {
      return this.$http.post('/admin/marketplace/offers/update_supplier_pricings', { offer_id: offer_id, offer_date_mode: offer_date_mode, authenticity_token: window.token });
    }
  }, {
    key: 'get_supplier_pricing_stocklist',
    value: function get_supplier_pricing_stocklist(offer_id, country_id) {
      return this.$http.get('/admin/marketplace/offers/get_supplier_pricing_stocklist', { params: { offer_id: offer_id, country_id: country_id } });
    }
  }, {
    key: 'update_stock_items_price',
    value: function update_stock_items_price(offer_id, items, price, incoterm, country_id) {
      return this.$http.post('/admin/marketplace/offers/update_stock_items_price', { offer_id: offer_id, items: items, price: price, incoterm: incoterm, country_id: country_id, authenticity_token: window.token });
    }
  }, {
    key: 'update_stock_items_fca',
    value: function update_stock_items_fca(items) {
      return this.$http.post('/admin/marketplace/offers/update_stock_items_fca', { items: items, authenticity_token: window.token });
    }
  }, {
    key: 'update_stock_items_user_fca',
    value: function update_stock_items_user_fca(items, user_id, offer_id, buyer_country_id) {
      return this.$http.post('/admin/marketplace/offers/update_stock_items_user_fca', { items: items, user_id: user_id, offer_id: offer_id, buyer_country_id: buyer_country_id, authenticity_token: window.token });
    }
  }, {
    key: 'update_offer_version',
    value: function update_offer_version(offer_id) {
      return this.$http.post('/admin/marketplace/offers/update_offer_version', { offer_id: offer_id, authenticity_token: window.token });
    }
  }, {
    key: 'send_matching_data',
    value: function send_matching_data(offer_id, users, custom_text, email_recipient) {
      return this.$http.post('/admin/marketplace/offers/send_matching_data', { offer_id: offer_id, users: users, custom_text: custom_text, email_recipient: email_recipient, authenticity_token: window.token });
    }
  }, {
    key: 'create_matching_data_xls',
    value: function create_matching_data_xls(offer_id, user_id, company_title, country_id, filter) {
      return this.$http.post('/admin/marketplace/offers/create_matching_data_xls', { offer_id: offer_id, user_id: user_id, company_title: company_title, country_id: country_id, filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'create_campaign_xls',
    value: function create_campaign_xls(offer_id, user_id, company_title, country_id, filter) {
      return this.$http.post('/admin/marketplace/offers/create_campaign_xls', { offer_id: offer_id, user_id: user_id, company_title: company_title, country_id: country_id, filter: filter, authenticity_token: window.token }).then(function (resp) {
        window.open(resp.data.xls);
      });
    }
  }, {
    key: 'add_users_to_offer_campaign',
    value: function add_users_to_offer_campaign(offer_id, users, filter) {
      return this.$http.post('/admin/marketplace/offers/add_users_to_offer_campaign', { offer_id: offer_id, users: users, filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'save_user_charge',
    value: function save_user_charge(user_charge) {
      return this.$http.post('/admin/marketplace/offers/save_user_charge', { user_charge: user_charge, authenticity_token: window.token });
    }
  }, {
    key: 'delete_user_charge',
    value: function delete_user_charge(charge_id) {
      return this.$http.post('/admin/marketplace/offers/delete_user_charge', { charge_id: charge_id, authenticity_token: window.token });
    }
  }, {
    key: 'save_offer_campaign_settings',
    value: function save_offer_campaign_settings(offer_id, campaign_settings) {
      return this.$http.post('/admin/marketplace/offers/save_offer_campaign_settings', { offer_id: offer_id, campaign_settings: campaign_settings, authenticity_token: window.token });
    }
  }, {
    key: 'find_campaign_recipients',
    value: function find_campaign_recipients(offer_id, filter) {
      return this.$http.post('/admin/marketplace/offers/find_campaign_recipients', { offer_id: offer_id, filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'copy_text_fields',
    value: function copy_text_fields(source_campaign_id, offer_id) {
      return this.$http.post('/admin/marketplace/offers/copy_offer_campaign_text_fields', { source_campaign_id: source_campaign_id, offer_id: offer_id, authenticity_token: window.token });
    }
  }]);

  return OfferService;
}();

exports.default = OfferService;


OfferService.$inject = ['$http'];

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderBookingNoteService = function () {
  function OrderBookingNoteService($http) {
    _classCallCheck(this, OrderBookingNoteService);

    this.$http = $http;
  }

  _createClass(OrderBookingNoteService, [{
    key: 'save',
    value: function save(booking_note) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/orders/save_booking_note',
        data: { booking_note: booking_note, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete',
    value: function _delete(booking_note_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/orders/delete_booking_note',
        data: { id: booking_note_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'send_notification',
    value: function send_notification(booking_note_id, custom_text, contacts, sender_name_en, sender_name_el, test_send, test_send_email) {
      return this.$http.post('/admin/marketplace/orders/send_booking_note_notification', { booking_note_id: booking_note_id, custom_text: custom_text, contacts: contacts, sender_name_en: sender_name_en, sender_name_el: sender_name_el, test_send: test_send, test_send_email: test_send_email, authenticity_token: window.token });
    }
  }, {
    key: 'get_notifications',
    value: function get_notifications(order_id) {
      return this.$http.get('/admin/marketplace/orders/get_order_booking_note_notifications/' + order_id);
    }
  }, {
    key: 'resend_notification',
    value: function resend_notification(notification_id) {
      return this.$http.post('/admin/marketplace/orders/resend_booking_note_notification', { notification_id: notification_id, authenticity_token: window.token });
    }
  }, {
    key: 'mass_update_delivery_status',
    value: function mass_update_delivery_status(booking_notes) {
      return this.$http.post('/admin/marketplace/orders/update_booking_notes_delivery_status', { booking_notes: booking_notes, authenticity_token: window.token });
    }
  }]);

  return OrderBookingNoteService;
}();

exports.default = OrderBookingNoteService;


OrderBookingNoteService.$inject = ['$http'];

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderPaymentService = function () {
  function OrderPaymentService($http) {
    _classCallCheck(this, OrderPaymentService);

    this.$http = $http;
  }

  _createClass(OrderPaymentService, [{
    key: 'get_order_payments',
    value: function get_order_payments(order_id) {
      return this.$http.get('/admin/marketplace/orders/get_order_payments/' + order_id);
    }
  }, {
    key: 'save',
    value: function save(order_payment) {
      return this.$http.post('/admin/marketplace/orders/save_order_payment', { order_payment: order_payment, authenticity_token: window.token });
    }
  }, {
    key: 'delete',
    value: function _delete(order_payment_id) {
      return this.$http.post('/admin/marketplace/orders/delete_order_payment', { order_payment_id: order_payment_id, authenticity_token: window.token });
    }
  }]);

  return OrderPaymentService;
}();

exports.default = OrderPaymentService;


OrderPaymentService.$inject = ['$http'];

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderSidebarService = function () {
  function OrderSidebarService(UiService) {
    _classCallCheck(this, OrderSidebarService);

    this.UiService = UiService;
    this.stocklist_data = { has_stocklist: false, css: 'error' };
    this.booking_notes_data = { has_booking_notes: false, css: 'error' };
    this.payment_general_data = { percentage: 0, css: 'red' };
    this.delivery_general_data = { percentage: 0, css: 'red' };
    this.main_infos_data = { percentage: 0, css: 'red' };
  }

  _createClass(OrderSidebarService, [{
    key: 'get_stocklist_data',
    value: function get_stocklist_data() {
      return this.stocklist_data;
    }
  }, {
    key: 'set_stocklist_data',
    value: function set_stocklist_data(value) {
      this.stocklist_data.has_stocklist = value;
      this.stocklist_data.css = this.UiService.get_icon_css_class(value);
    }
  }, {
    key: 'get_booking_notes_data',
    value: function get_booking_notes_data() {
      return this.booking_notes_data;
    }
  }, {
    key: 'set_booking_notes_data',
    value: function set_booking_notes_data(value) {
      this.booking_notes_data.has_booking_notes = value;
      this.booking_notes_data.css = this.UiService.get_icon_css_class(value);
    }
  }, {
    key: 'get_payment_general_data',
    value: function get_payment_general_data() {
      return this.payment_general_data;
    }
  }, {
    key: 'set_payment_general_data',
    value: function set_payment_general_data(value) {
      this.payment_general_data.percentage = value;
      this.payment_general_data.css = this.UiService.get_counter_css_class(value);
    }
  }, {
    key: 'get_delivery_general_data',
    value: function get_delivery_general_data() {
      return this.delivery_general_data;
    }
  }, {
    key: 'set_delivery_general_data',
    value: function set_delivery_general_data(value) {
      this.delivery_general_data.percentage = value;
      this.delivery_general_data.css = this.UiService.get_counter_css_class(value);
    }
  }, {
    key: 'get_main_infos_data',
    value: function get_main_infos_data() {
      return this.main_infos_data;
    }
  }, {
    key: 'set_main_infos_data',
    value: function set_main_infos_data(value) {
      this.main_infos_data.percentage = value;
      this.main_infos_data.css = this.UiService.get_counter_css_class(value);
    }
  }]);

  return OrderSidebarService;
}();

exports.default = OrderSidebarService;


OrderSidebarService.$inject = ['UiService'];

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderService = function () {
  function OrderService($http) {
    _classCallCheck(this, OrderService);

    this.$http = $http;
  }

  _createClass(OrderService, [{
    key: 'update_website_stats',
    value: function update_website_stats() {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/orders/update_website_stats',
        data: { authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save',
    value: function save(order) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/orders/save',
        data: { order: order, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_manage_data',
    value: function get_manage_data(filter) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/orders/get_manage_data',
        data: { filter: filter, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_arrivals_data',
    value: function get_arrivals_data(filter) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/orders/get_arrivals_data',
        data: { filter: filter, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'update_supplier_user_products',
    value: function update_supplier_user_products(order_id, user_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/orders/update_supplier_user_products',
        data: { id: order_id, user_id: user_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'update_buyer_user_products',
    value: function update_buyer_user_products(order_id, user_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/orders/update_buyer_user_products',
        data: { id: order_id, user_id: user_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'update_supplier_pricings',
    value: function update_supplier_pricings(order_id) {
      return this.$http.post('/admin/marketplace/orders/update_supplier_pricings', { order_id: order_id, authenticity_token: window.token });
    }
  }, {
    key: 'get_attachments',
    value: function get_attachments(order_id, doc_types) {
      return this.$http.post('/admin/marketplace/orders/get_order_attachments/', { order_id: order_id, doc_types: doc_types, authenticity_token: window.token });
    }
  }, {
    key: 'send_notification',
    value: function send_notification(order_id, custom_title, custom_text, attachments, contacts, sender_name_en, sender_name_el, test_send, test_send_email) {
      return this.$http.post('/admin/marketplace/orders/send_notification', { order_id: order_id, custom_title: custom_title, custom_text: custom_text, attachments: attachments, contacts: contacts, sender_name_en: sender_name_en, sender_name_el: sender_name_el, test_send: test_send, test_send_email: test_send_email, authenticity_token: window.token });
    }
  }, {
    key: 'get_notifications',
    value: function get_notifications(order_id) {
      return this.$http.get('/admin/marketplace/orders/get_order_notifications/' + order_id);
    }
  }, {
    key: 'delete_attachment',
    value: function delete_attachment(attachment_id) {
      return this.$http.post('/admin/marketplace/orders/delete_order_attachment', { attachment_id: attachment_id, authenticity_token: window.token });
    }
  }, {
    key: 'resend_notification',
    value: function resend_notification(notification_id) {
      return this.$http.post('/admin/marketplace/orders/resend_notification', { notification_id: notification_id, authenticity_token: window.token });
    }
  }]);

  return OrderService;
}();

exports.default = OrderService;


OrderService.$inject = ['$http'];

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaginationService = function () {
  function PaginationService() {
    _classCallCheck(this, PaginationService);
  }

  _createClass(PaginationService, [{
    key: "get_pagination",
    value: function get_pagination(data) {
      var per_page = 10;
      var pagination = {
        first_record: 0, last_record: 0,
        total_records: 0, pages: []
      };
      if (data.display_count > 0) {
        pagination.first_record = (data.page - 1) * per_page + 1;
        pagination.last_record = pagination.first_record + data.display_count - 1;
      }
      pagination.total_records = data.total_entries;
      for (var i = 1; i < data.total_pages + 1; i++) {
        pagination.pages.push(i);
      }return pagination;
    }
  }]);

  return PaginationService;
}();

exports.default = PaginationService;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductEndUseService = function () {
  function ProductEndUseService($http) {
    _classCallCheck(this, ProductEndUseService);

    this.$http = $http;
  }

  _createClass(ProductEndUseService, [{
    key: 'update',
    value: function update(product_end_use) {
      return this.$http.post('/admin/marketplace/products/update_product_end_use', { product_end_use: product_end_use, authenticity_token: window.token });
    }
  }, {
    key: 'delete',
    value: function _delete(product_end_use_id) {
      return this.$http.post('/admin/marketplace/products/delete_product_end_use', { product_end_use_id: product_end_use_id, authenticity_token: window.token });
    }
  }, {
    key: 'add',
    value: function add(end_uses) {
      return this.$http.post('/admin/marketplace/products/add_product_end_uses', { end_uses: end_uses, authenticity_token: window.token });
    }
  }]);

  return ProductEndUseService;
}();

exports.default = ProductEndUseService;


ProductEndUseService.$inject = ['$http'];

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductService = function () {
  function ProductService($http) {
    _classCallCheck(this, ProductService);

    this.$http = $http;
  }

  _createClass(ProductService, [{
    key: 'get_categories',
    value: function get_categories() {
      return this.$http.get('/admin/marketplace/products/get_categories');
    }
  }, {
    key: 'get_groups',
    value: function get_groups(category_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/products/get_groups_by_category',
        params: { category_id: category_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_products',
    value: function get_products(group_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/products/get_products_by_group',
        params: { group_id: group_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_products_for_price_groups',
    value: function get_products_for_price_groups(group_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/products/get_products_by_group_for_price_groups',
        params: { group_id: group_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_product_properties_by_category',
    value: function get_product_properties_by_category(category_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/products/get_product_properties_by_category',
        params: { category_id: category_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_product_properties_by_group',
    value: function get_product_properties_by_group(group_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/products/get_product_properties_by_group',
        params: { group_id: group_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_product_end_uses',
    value: function get_product_end_uses(product_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/products/get_product_end_uses',
        params: { product_id: product_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_group_data',
    value: function get_group_data(filter) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/products/get_group_data',
        data: { filter: filter, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_brand_data',
    value: function get_brand_data(filter) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/products/get_brand_data',
        data: { filter: filter, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'search_product_groups_by_title',
    value: function search_product_groups_by_title(title) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/products/search_product_groups_by_title',
        params: { title: title }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'search_products_by_title',
    value: function search_products_by_title(title) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/products/search_products_by_title',
        params: { title: title }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'search_products_by_filter',
    value: function search_products_by_filter(filter) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/products/search_products_by_filter',
        data: { filter: filter, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_price_groups',
    value: function get_price_groups(filter) {
      return this.$http.post('/admin/marketplace/products/get_price_groups', { filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'create_price_group',
    value: function create_price_group(product_group_id, title) {
      return this.$http.post('/admin/marketplace/products/create_price_group', { product_group_id: product_group_id, title: title, authenticity_token: window.token });
    }
  }, {
    key: 'get_price_group_members',
    value: function get_price_group_members(group_id) {
      return this.$http.get('/admin/marketplace/products/get_price_group_members/' + group_id);
    }
  }, {
    key: 'get_all_products',
    value: function get_all_products() {
      return this.$http.get('/admin/marketplace/products/get_all_products');
    }
  }, {
    key: 'add_price_group_member',
    value: function add_price_group_member(group_id, product_id) {
      return this.$http.post('/admin/marketplace/products/add_price_group_member', { group_id: group_id, product_id: product_id, authenticity_token: window.token });
    }
  }, {
    key: 'remove_price_group_member',
    value: function remove_price_group_member(group_id, product_id) {
      return this.$http.post('/admin/marketplace/products/remove_price_group_member', { group_id: group_id, product_id: product_id, authenticity_token: window.token });
    }
  }, {
    key: 'update_price_group_title',
    value: function update_price_group_title(group_id, title) {
      return this.$http.post('/admin/marketplace/products/update_price_group_title', { group_id: group_id, title: title, authenticity_token: window.token });
    }
  }, {
    key: 'get_all_groups',
    value: function get_all_groups() {
      return this.$http.get('/admin/marketplace/products/get_all_groups');
    }
  }, {
    key: 'get_groups_with_ranges',
    value: function get_groups_with_ranges() {
      return this.$http.get('/admin/marketplace/products/get_groups_with_ranges');
    }
  }, {
    key: 'get_groups_with_specs',
    value: function get_groups_with_specs() {
      return this.$http.get('/admin/marketplace/products/get_groups_with_specs');
    }
  }, {
    key: 'update_group_ranges',
    value: function update_group_ranges(group) {
      return this.$http.post('/admin/marketplace/products/update_group_ranges', { group: group, authenticity_token: window.token });
    }
  }, {
    key: 'update_range_supplier_pricings',
    value: function update_range_supplier_pricings(group_id) {
      return this.$http.post('/admin/marketplace/products/update_range_supplier_pricings', { group_id: group_id, authenticity_token: window.token });
    }
  }, {
    key: 'update_range_buyer_pricings',
    value: function update_range_buyer_pricings(group_id) {
      return this.$http.post('/admin/marketplace/products/update_range_buyer_pricings', { group_id: group_id, authenticity_token: window.token });
    }
  }, {
    key: 'update_price_group_supplier_pricings',
    value: function update_price_group_supplier_pricings(price_group_id) {
      return this.$http.post('/admin/marketplace/products/update_price_group_supplier_pricings', { price_group_id: price_group_id, authenticity_token: window.token });
    }
  }, {
    key: 'update_price_group_buyer_pricings',
    value: function update_price_group_buyer_pricings(price_group_id) {
      return this.$http.post('/admin/marketplace/products/update_price_group_buyer_pricings', { price_group_id: price_group_id, authenticity_token: window.token });
    }
  }, {
    key: 'get_product_group_ranges',
    value: function get_product_group_ranges(product_group_id, is_reels) {
      return this.$http.post('/admin/marketplace/products/get_product_group_ranges', { product_group_id: product_group_id, is_reels: is_reels, authenticity_token: window.token });
    }
  }, {
    key: 'get_product_group_specs',
    value: function get_product_group_specs(product_group_ids, filter) {
      return this.$http.post('/admin/marketplace/products/get_product_group_specs', { product_group_ids: product_group_ids, filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'update_product_group_specs',
    value: function update_product_group_specs(product_group_id, specs) {
      return this.$http.post('/admin/marketplace/products/update_product_group_specs', { product_group_id: product_group_id, specs: specs, authenticity_token: window.token });
    }
  }, {
    key: 'delete_price_group',
    value: function delete_price_group(price_group_id) {
      return this.$http.post('/admin/marketplace/products/delete_price_group', { price_group_id: price_group_id, authenticity_token: window.token });
    }
  }, {
    key: 'add_end_uses_to_products',
    value: function add_end_uses_to_products(products, end_uses) {
      return this.$http.post('/admin/marketplace/products/add_end_uses_to_products', { products: products, end_uses: end_uses, authenticity_token: window.token });
    }
  }, {
    key: 'update_product_end_uses',
    value: function update_product_end_uses(product_id, product_end_uses) {
      return this.$http.post('/admin/marketplace/products/update_product_end_uses', { product_id: product_id, product_end_uses: product_end_uses, authenticity_token: window.token });
    }
  }, {
    key: 'get_product_group_end_uses',
    value: function get_product_group_end_uses(product_group_id) {
      return this.$http.get('/admin/marketplace/products/get_product_group_end_uses', { params: { product_group_id: product_group_id } });
    }
  }]);

  return ProductService;
}();

exports.default = ProductService;


ProductService.$inject = ['$http'];

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UiService = function () {
  function UiService() {
    _classCallCheck(this, UiService);
  }

  _createClass(UiService, [{
    key: 'select2_options',
    value: function select2_options(width) {
      return {
        containerCssClass: 'multiselect2',
        dropdownCssClass: 'multiselect2',
        width: width + 'px'
      };
    }
  }, {
    key: 'date_options',
    value: function date_options() {
      return {
        changeMonth: true,
        changeYear: true,
        dateFormat: 'dd/mm/yy'
      };
    }
  }, {
    key: 'open_fancybox_dialog',
    value: function open_fancybox_dialog(element) {
      _jquery2.default.fancybox((0, _jquery2.default)(element), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: 700,
        closeSpeed: 300,
        topRatio: 0.15,
        scrolling: 'auto'
      });
    }
  }, {
    key: 'close_fancybox_dialog',
    value: function close_fancybox_dialog() {
      _jquery2.default.fancybox.close();
    }
  }, {
    key: 'get_counter_css_class',
    value: function get_counter_css_class(percentage) {
      if (percentage < 50) return 'red';else if (percentage >= 50 && percentage < 80) return 'black';else return 'green';
    }
  }, {
    key: 'get_icon_css_class',
    value: function get_icon_css_class(value) {
      return value ? 'success' : 'error';
    }
  }, {
    key: 'get_count_css_class',
    value: function get_count_css_class(count) {
      return count > 0 ? 'black' : 'red';
    }
  }, {
    key: 'tinymceOptions',
    value: function tinymceOptions() {
      return {
        entity_encoding: 'raw',
        body_class: 'epaper_tinymce',
        content_css: '/stylesheets/tinymce.css',
        height: 200,
        menubar: false,
        statusbar: false,
        plugins: ['link', 'preview', 'code', 'textcolor'],
        toolbar: 'undo redo | bold italic underline | forecolor backcolor | alignleft aligncenter alignright | bullist numlist | link unlink | preview | code'
      };
    }
  }]);

  return UiService;
}();

exports.default = UiService;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserAcceptablePaymentTermService = function () {
  function UserAcceptablePaymentTermService($http) {
    _classCallCheck(this, UserAcceptablePaymentTermService);

    this.$http = $http;
  }

  _createClass(UserAcceptablePaymentTermService, [{
    key: 'update',
    value: function update(user_id, terms) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/update_user_acceptable_payment_terms',
        data: { user_id: user_id, terms: terms, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return UserAcceptablePaymentTermService;
}();

exports.default = UserAcceptablePaymentTermService;


UserAcceptablePaymentTermService.$inject = ['$http'];

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserAddressService = function () {
  function UserAddressService($http) {
    _classCallCheck(this, UserAddressService);

    this.$http = $http;
  }

  _createClass(UserAddressService, [{
    key: 'save',
    value: function save(user_address) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_user_address',
        data: { user_address: user_address, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete',
    value: function _delete(user_address_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_user_address',
        data: { id: user_address_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return UserAddressService;
}();

exports.default = UserAddressService;


UserAddressService.$inject = ['$http'];

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserAdminMessageService = function () {
  function UserAdminMessageService($http) {
    _classCallCheck(this, UserAdminMessageService);

    this.$http = $http;
  }

  _createClass(UserAdminMessageService, [{
    key: 'save',
    value: function save(message) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_user_admin_message',
        data: { message: message, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete',
    value: function _delete(message_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_user_admin_message',
        data: { id: message_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return UserAdminMessageService;
}();

exports.default = UserAdminMessageService;


UserAdminMessageService.$inject = ['$http'];

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserBankService = function () {
  function UserBankService($http) {
    _classCallCheck(this, UserBankService);

    this.$http = $http;
  }

  _createClass(UserBankService, [{
    key: 'save',
    value: function save(user_bank) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_user_bank',
        data: { user_bank: user_bank, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete',
    value: function _delete(user_bank_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_user_bank',
        data: { id: user_bank_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return UserBankService;
}();

exports.default = UserBankService;


UserBankService.$inject = ['$http'];

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserContactService = function () {
  function UserContactService($http) {
    _classCallCheck(this, UserContactService);

    this.$http = $http;
  }

  _createClass(UserContactService, [{
    key: 'get',
    value: function get(filter) {
      return this.$http.post('/admin/marketplace/users/find_user_contacts', { filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'save',
    value: function save(user_contact) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_user_contact',
        data: { user_contact: user_contact, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete',
    value: function _delete(user_contact_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_user_contact',
        data: { id: user_contact_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'add_invitation',
    value: function add_invitation(user_contact_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/add_invitation',
        data: { user_contact_id: user_contact_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete_invitation',
    value: function delete_invitation(invitation_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_invitation',
        data: { invitation_id: invitation_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'update_account_status',
    value: function update_account_status(account_id, status) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/update_account_status',
        data: { account_id: account_id, status: status, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'find_similar',
    value: function find_similar(email) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/find_similar_contacts',
        params: { email: email }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'update_similar_contact',
    value: function update_similar_contact(user_contact, account, contact_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/update_similar_contact',
        data: { user_contact: user_contact, account: account, contact_id: contact_id, status: status, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_campaign_status_counts',
    value: function get_campaign_status_counts() {
      return this.$http.get('/admin/marketplace/users/get_campaign_status_counts');
    }
  }, {
    key: 'mass_update_contact_campaign_status',
    value: function mass_update_contact_campaign_status(contacts, campaign_status) {
      return this.$http.post('/admin/marketplace/users/mass_update_contact_campaign_status', { contacts: contacts, campaign_status: campaign_status, authenticity_token: window.token });
    }
  }, {
    key: 'get_notifications',
    value: function get_notifications(user_contact_id) {
      return this.$http.get('/admin/marketplace/users/get_user_contact_notifications', { params: { user_contact_id: user_contact_id } });
    }
  }]);

  return UserContactService;
}();

exports.default = UserContactService;


UserContactService.$inject = ['$http'];

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserDeliveryTermService = function () {
  function UserDeliveryTermService($http) {
    _classCallCheck(this, UserDeliveryTermService);

    this.$http = $http;
  }

  _createClass(UserDeliveryTermService, [{
    key: 'save',
    value: function save(user_delivery_term) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_user_delivery_term',
        data: { user_delivery_term: user_delivery_term, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save_all',
    value: function save_all(user_id, delivery_term_id, user_delivery_terms) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_user_delivery_terms',
        data: { user_id: user_id, delivery_term_id: delivery_term_id, user_delivery_terms: user_delivery_terms, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete',
    value: function _delete(user_delivery_term_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_user_delivery_term',
        data: { id: user_delivery_term_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'update_buyer_terms',
    value: function update_buyer_terms(user_id, delivery_term_id, country_id, city_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/update_buyer_terms',
        data: { user_id: user_id, delivery_term_id: delivery_term_id, country_id: country_id, city_id: city_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return UserDeliveryTermService;
}();

exports.default = UserDeliveryTermService;


UserDeliveryTermService.$inject = ['$http'];

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserFreightRateService = function () {
  function UserFreightRateService($http) {
    _classCallCheck(this, UserFreightRateService);

    this.$http = $http;
  }

  _createClass(UserFreightRateService, [{
    key: 'save',
    value: function save(user_freight_rate) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_user_freight_rate',
        data: { user_freight_rate: user_freight_rate, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete',
    value: function _delete(user_freight_rate_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_user_freight_rate',
        data: { id: user_freight_rate_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_user_freight_rates',
    value: function get_user_freight_rates(user_id) {
      return this.$http.get('/admin/marketplace/users/get_user_freight_rates/' + user_id);
    }
  }]);

  return UserFreightRateService;
}();

exports.default = UserFreightRateService;


UserFreightRateService.$inject = ['$http'];

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserMarketRestrictionService = function () {
  function UserMarketRestrictionService($http) {
    _classCallCheck(this, UserMarketRestrictionService);

    this.$http = $http;
  }

  _createClass(UserMarketRestrictionService, [{
    key: 'update',
    value: function update(user) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_user_market_restrictions',
        data: { user: user, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save_member_restriction',
    value: function save_member_restriction(member_restriction) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_user_member_restriction',
        data: { member_restriction: member_restriction, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete_member_restriction',
    value: function delete_member_restriction(member_restriction_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_user_member_restriction',
        data: { id: member_restriction_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return UserMarketRestrictionService;
}();

exports.default = UserMarketRestrictionService;


UserMarketRestrictionService.$inject = ['$http'];

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProductEndUseService = function () {
  function UserProductEndUseService($http) {
    _classCallCheck(this, UserProductEndUseService);

    this.$http = $http;
  }

  _createClass(UserProductEndUseService, [{
    key: 'get',
    value: function get(user_id) {
      return this.$http.get('/admin/marketplace/users/get_product_end_uses', { params: { user_id: user_id } });
    }
  }, {
    key: 'update',
    value: function update(user_id, product_end_uses) {
      return this.$http.post('/admin/marketplace/users/update_product_end_uses', { user_id: user_id, product_end_uses: product_end_uses, authenticity_token: window.token });
    }
  }]);

  return UserProductEndUseService;
}();

exports.default = UserProductEndUseService;


UserProductEndUseService.$inject = ['$http'];

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserProductService = function () {
  function UserProductService($http) {
    _classCallCheck(this, UserProductService);

    this.$http = $http;
  }

  _createClass(UserProductService, [{
    key: 'get_preview_data',
    value: function get_preview_data(user_product_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_user_product_preview',
        params: { user_product_id: user_product_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get',
    value: function get(user_product_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_user_product',
        params: { user_product_id: user_product_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_combination_str',
    value: function get_combination_str(value) {
      if (typeof value == 'number') {
        return value;
      } else if (_jquery2.default.isArray(value)) {
        var result = [];
        _angular2.default.forEach(value, function (o) {
          if (typeof o == 'number') result.push(o);else result.push(o.from + ' - ' + o.to);
        });
        return result.join(', ');
      } else {
        return value.from + ' - ' + value.to;
      }
    }
  }, {
    key: 'get_user_product_pricings',
    value: function get_user_product_pricings(user_product_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_user_product_pricings',
        params: { user_product_id: user_product_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_user_products_pricings',
    value: function get_user_products_pricings(user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_user_products_pricings',
        params: { user_id: user_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save_pricings',
    value: function save_pricings(user_product) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_pricings',
        data: { user_product: user_product, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save_special_pricing',
    value: function save_special_pricing(pricing) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_special_pricing',
        data: { pricing: pricing, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save_special_charge',
    value: function save_special_charge(charge) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_special_charge',
        data: { charge: charge, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save_user_product_group_charge',
    value: function save_user_product_group_charge(charge) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_user_product_group_charge',
        data: { charge: charge, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'mass_save_user_product_group_charge',
    value: function mass_save_user_product_group_charge(charge) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/mass_save_user_product_group_charge',
        data: { charge: charge, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'mass_renew_user_product_group_charges',
    value: function mass_renew_user_product_group_charges(charges) {
      return this.$http.post('/admin/marketplace/users/mass_renew_user_product_group_charges', { charges: charges, authenticity_token: window.token });
    }
  }, {
    key: 'save_target_pricing',
    value: function save_target_pricing(pricing) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_target_pricing',
        data: { pricing: pricing, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete_special_pricing',
    value: function delete_special_pricing(pricing_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_special_pricing',
        data: { pricing_id: pricing_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete_special_charge',
    value: function delete_special_charge(charge_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_special_charge',
        data: { charge_id: charge_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete_user_product_group_charge',
    value: function delete_user_product_group_charge(charge_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_user_product_group_charge',
        data: { charge_id: charge_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete_target_pricing',
    value: function delete_target_pricing(pricing_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_target_pricing',
        data: { pricing_id: pricing_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_user_products_special_pricings',
    value: function get_user_products_special_pricings(user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_user_products_special_pricings',
        params: { user_id: user_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_user_products_special_charges',
    value: function get_user_products_special_charges(user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_user_products_special_charges',
        params: { user_id: user_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_user_product_group_charges',
    value: function get_user_product_group_charges(user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_user_product_group_charges',
        params: { user_id: user_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_user_products_target_pricings',
    value: function get_user_products_target_pricings(user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_user_products_target_pricings',
        params: { user_id: user_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_user_products_with_specs',
    value: function get_user_products_with_specs(user_id, has_reels) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_user_products_with_specs',
        params: { user_id: user_id, has_reels: has_reels }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_user_products_without_specs',
    value: function get_user_products_without_specs(user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_user_products_without_specs',
        params: { user_id: user_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_user_products_without_groups',
    value: function get_user_products_without_groups(user_id) {
      return this.$http.get('/admin/marketplace/users/get_user_products_without_groups', { params: { user_id: user_id } });
    }
  }, {
    key: 'get_user_products_for_spec_groups',
    value: function get_user_products_for_spec_groups(user_id) {
      return this.$http.get('/admin/marketplace/users/get_user_products_for_spec_groups', { params: { user_id: user_id } });
    }
  }, {
    key: 'add_user_product_to_spec_group',
    value: function add_user_product_to_spec_group(user_id, group_id, user_product_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/add_user_product_to_spec_group',
        data: { user_id: user_id, group_id: group_id, user_product_id: user_product_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete_user_product_from_spec_group',
    value: function delete_user_product_from_spec_group(user_id, group_id, user_product_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_user_product_from_spec_group',
        data: { user_id: user_id, group_id: group_id, user_product_id: user_product_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_user_products',
    value: function get_user_products(user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_user_products',
        params: { user_id: user_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete_spec',
    value: function delete_spec(spec_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_user_product_spec',
        data: { spec_id: spec_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete_specs',
    value: function delete_specs(user_product_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_user_product_specs',
        data: { user_product_id: user_product_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save_mass_specs',
    value: function save_mass_specs(products, specs) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_mass_specs',
        data: { products: products, specs: specs, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_specs_for_admin_view',
    value: function get_specs_for_admin_view(user_product_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_specs_for_admin_view',
        params: { user_product_id: user_product_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_group_specs_for_admin_view',
    value: function get_group_specs_for_admin_view(group_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_group_specs_for_admin_view',
        params: { group_id: group_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_multi_specs_for_admin_view',
    value: function get_multi_specs_for_admin_view(user_product_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_multi_specs_for_admin_view',
        params: { user_product_id: user_product_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_user_product_specs',
    value: function get_user_product_specs(user_product_id, filter) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/get_user_product_specs',
        data: { user_product_id: user_product_id, filter: filter, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'sync_spec_group',
    value: function sync_spec_group(group_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/sync_spec_group',
        data: { group_id: group_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'update_user_product_specs',
    value: function update_user_product_specs(user_product_id, specs) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/update_user_product_specs',
        data: { user_product_id: user_product_id, specs: specs, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_user_product_combinations',
    value: function get_user_product_combinations(user_product_id, filter) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/get_user_product_combinations',
        data: { user_product_id: user_product_id, filter: filter, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'update_user_product_combinations',
    value: function update_user_product_combinations(user_product_id, combinations) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/update_user_product_combinations',
        data: { user_product_id: user_product_id, combinations: combinations, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_user_products_for_copy_specs',
    value: function get_user_products_for_copy_specs(user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_user_products_for_copy_specs',
        params: { user_id: user_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_user_products_for_copy_from_user',
    value: function get_user_products_for_copy_from_user(source_user_id) {
      return this.$http.get('/admin/marketplace/users/get_user_products_for_copy_from_user', {
        params: {
          source_user_id: source_user_id
        }
      });
    }
  }, {
    key: 'copy_user_products_from_user',
    value: function copy_user_products_from_user(target_user_id, user_products, copy_mode) {
      return this.$http.post('/admin/marketplace/users/copy_user_products_from_user', {
        target_user_id: target_user_id,
        user_products: user_products,
        copy_mode: copy_mode,
        authenticity_token: window.token
      });
    }
  }, {
    key: 'copy_user_product_specs',
    value: function copy_user_product_specs(copy) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/copy_user_product_specs',
        data: { copy: copy, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_spec_groups',
    value: function get_spec_groups(user_id) {
      return this.$http.get('/admin/marketplace/users/get_spec_groups', { params: { user_id: user_id } });
    }
  }, {
    key: 'create_spec_group',
    value: function create_spec_group(user_id, title) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/create_spec_group',
        data: { user_id: user_id, title: title, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'update_target_pricings_from_last_order',
    value: function update_target_pricings_from_last_order(user_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/update_target_pricings_from_last_order',
        data: { user_id: user_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_product_group_specs',
    value: function get_product_group_specs(product_group_ids, is_reels) {
      return this.$http.post('/admin/marketplace/users/get_product_group_specs', { product_group_ids: product_group_ids, is_reels: is_reels, authenticity_token: window.token });
    }
  }, {
    key: 'get_product_group_settings',
    value: function get_product_group_settings(user_id) {
      return this.$http.get('/admin/marketplace/users/get_product_group_settings/' + user_id);
    }
  }, {
    key: 'update_product_group_settings',
    value: function update_product_group_settings(user_id, product_group_id, settings) {
      return this.$http.post('/admin/marketplace/users/update_product_group_settings', { user_id: user_id, product_group_id: product_group_id, settings: settings, authenticity_token: window.token });
    }
  }, {
    key: 'update_spec_group',
    value: function update_spec_group(spec_group) {
      return this.$http.post('/admin/marketplace/users/update_spec_group', { spec_group: spec_group, authenticity_token: window.token });
    }
  }, {
    key: 'update_spec_group_products',
    value: function update_spec_group_products(user_id, product_group_id) {
      return this.$http.post('/admin/marketplace/users/update_spec_group_products', { user_id: user_id, product_group_id: product_group_id, authenticity_token: window.token });
    }
  }]);

  return UserProductService;
}();

exports.default = UserProductService;


UserProductService.$inject = ['$http'];

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserRollMessageService = function () {
  function UserRollMessageService($http) {
    _classCallCheck(this, UserRollMessageService);

    this.$http = $http;
  }

  _createClass(UserRollMessageService, [{
    key: 'save',
    value: function save(message) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_user_roll_message',
        data: { message: message, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete',
    value: function _delete(message_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_user_roll_message',
        data: { id: message_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return UserRollMessageService;
}();

exports.default = UserRollMessageService;


UserRollMessageService.$inject = ['$http'];

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserSidebarService = function () {
  function UserSidebarService($http) {
    _classCallCheck(this, UserSidebarService);

    this.$http = $http;
  }

  _createClass(UserSidebarService, [{
    key: 'get_sidebar_data',
    value: function get_sidebar_data(user_id, group) {
      return this.$http.get('/admin/marketplace/users/get_sidebar_data', { params: { user_id: user_id, group: group } });
    }
  }]);

  return UserSidebarService;
}();

exports.default = UserSidebarService;


UserSidebarService.$inject = ['$http'];

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserSpecialPaymentTermService = function () {
  function UserSpecialPaymentTermService($http) {
    _classCallCheck(this, UserSpecialPaymentTermService);

    this.$http = $http;
  }

  _createClass(UserSpecialPaymentTermService, [{
    key: 'save',
    value: function save(user_term) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_user_special_payment_term',
        data: { user_term: user_term, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete',
    value: function _delete(user_term_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_user_special_payment_term',
        data: { id: user_term_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return UserSpecialPaymentTermService;
}();

exports.default = UserSpecialPaymentTermService;


UserSpecialPaymentTermService.$inject = ['$http'];

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(0);

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserService = function () {
  function UserService($http) {
    _classCallCheck(this, UserService);

    this.$http = $http;
  }

  _createClass(UserService, [{
    key: 'get_stocklists',
    value: function get_stocklists(user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_stocklists/' + user_id
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get',
    value: function get(user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_user',
        params: { user_id: user_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'search_by_company',
    value: function search_by_company(user_type, company) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/user_company_autocomplete',
        params: { user_type: user_type, company_title: company }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_accounts',
    value: function get_accounts(user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_user_accounts',
        params: { user_id: user_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_contacts',
    value: function get_contacts(user_id) {
      return this.$http.get('/admin/marketplace/users/get_user_contacts_json', { params: { user_id: user_id } });
    }
  }, {
    key: 'get_demand_data',
    value: function get_demand_data(user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_demand_data',
        params: { user_id: user_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_order_data',
    value: function get_order_data(user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_order_data',
        params: { user_id: user_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_notes',
    value: function get_notes(user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_user_notes',
        params: { user_id: user_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'find_similar',
    value: function find_similar(company_data) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/find_similar',
        data: { company_data: company_data, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'create',
    value: function create(user, account) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save',
        data: { user: user, account: account, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'update',
    value: function update(user, user_groups, user_business_types) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save',
        data: { user: user, user_groups: user_groups, user_business_types: user_business_types, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'account_email_exists',
    value: function account_email_exists(email) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/account_email_exists',
        params: { email: email }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'contact_email_exists',
    value: function contact_email_exists(email, user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/contact_email_exists',
        params: { email: email, user_id: user_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'register_account_email_exists',
    value: function register_account_email_exists(email) {
      return this.$http({
        method: 'GET',
        url: '/registration/account_email_exists',
        params: { email: email }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_faqs',
    value: function get_faqs(user_id, section_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_faqs',
        params: { user_id: user_id, section_id: section_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save_faq',
    value: function save_faq(user_id, faq) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_faq',
        data: { user_id: user_id, faq: faq, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'mass_save_faqs',
    value: function mass_save_faqs(user_id, faqs, selected) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/mass_save_faqs',
        data: { user_id: user_id, faqs: faqs, selected: selected, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save_register_data',
    value: function save_register_data(user, account) {
      return this.$http({
        method: 'POST',
        url: '/registration/save_register_data',
        data: { user: user, account: account }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'create_from_pending',
    value: function create_from_pending(pending_registration_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/create_from_pending',
        data: { id: pending_registration_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'create_from_pending_import',
    value: function create_from_pending_import(pending_import_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/create_from_pending_import',
        data: { id: pending_import_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'mass_create_from_pending_imports',
    value: function mass_create_from_pending_imports(pending_imports) {
      return this.$http.post('/admin/marketplace/users/mass_create_from_pending_imports', { pending_imports: pending_imports, authenticity_token: window.token });
    }
  }, {
    key: 'get_similar_tabs',
    value: function get_similar_tabs() {
      return ['All', 'High', 'Medium', 'Low'];
    }
  }, {
    key: 'get_similar_dialog_tabs',
    value: function get_similar_dialog_tabs() {
      return ['Analysis', 'Similarity'];
    }
  }, {
    key: 'get_filtered_similar_users',
    value: function get_filtered_similar_users(similar_users, index) {
      if (index === 0) return similar_users;else if (index == 1) return _underscore2.default.filter(similar_users, function (user) {
        return user.similarity.level == 'High';
      });else if (index == 2) return _underscore2.default.filter(similar_users, function (user) {
        return user.similarity.level == 'Medium';
      });else if (index == 3) return _underscore2.default.filter(similar_users, function (user) {
        return user.similarity.level == 'Low';
      });
    }
  }, {
    key: 'get_filtered_users',
    value: function get_filtered_users(users, index) {
      if (index === 0) return users;else if (index == 1) return _underscore2.default.filter(users, function (user) {
        return user.type == 'Buyer';
      });else if (index == 2) return _underscore2.default.filter(users, function (user) {
        return user.type == 'Seller';
      });
    }
  }, {
    key: 'connect_users',
    value: function connect_users(connection) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/connect_users',
        data: { connection: connection, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'disconnect_users',
    value: function disconnect_users(connection) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/disconnect_users',
        data: { connection: connection, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'search',
    value: function search(filters) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/search_all',
        data: { filters: filters, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete_custom_consignee',
    value: function delete_custom_consignee(user_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_custom_consignee',
        data: { id: user_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete_custom_notify',
    value: function delete_custom_notify(user_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_custom_notify',
        data: { id: user_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete_custom_docs',
    value: function delete_custom_docs(user_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_custom_docs',
        data: { id: user_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save_custom_consignee',
    value: function save_custom_consignee(user_id, address) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_custom_consignee',
        data: { id: user_id, address: address, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save_custom_notify',
    value: function save_custom_notify(user_id, address) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_custom_notify',
        data: { id: user_id, address: address, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save_custom_docs',
    value: function save_custom_docs(user_id, address) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_custom_docs',
        data: { id: user_id, address: address, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save_export_docs',
    value: function save_export_docs(user_id, docs) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_export_docs',
        data: { id: user_id, docs: docs, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_seller_trading_data',
    value: function get_seller_trading_data(user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_seller_trading_data',
        params: { user_id: user_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save_company_common_word',
    value: function save_company_common_word(common_word) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_company_common_word',
        data: { common_word: common_word, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_pending_imports',
    value: function get_pending_imports() {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_pending_imports',
        params: {}
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete_pending_import',
    value: function delete_pending_import(pending_import_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_pending_import',
        data: { pending_import_id: pending_import_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_matched_offers',
    value: function get_matched_offers(user_id, filter) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/get_matched_offers',
        data: { user_id: user_id, filter: filter, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_country_charges',
    value: function get_country_charges(user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_country_charges',
        params: { user_id: user_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save_country_charges',
    value: function save_country_charges(charges) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_country_charges',
        data: { charges: charges, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete_country_charge',
    value: function delete_country_charge(charge_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_country_charge',
        data: { charge_id: charge_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete_country_charges',
    value: function delete_country_charges(charges) {
      this.$http.post('/admin/marketplace/users/delete_country_charges', { charges: charges, authenticity_token: window.token });
    }
  }, {
    key: 'get_incoterm_charges',
    value: function get_incoterm_charges(user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_incoterm_charges',
        params: { user_id: user_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'save_incoterm_charge',
    value: function save_incoterm_charge(charge) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/save_incoterm_charge',
        data: { charge: charge, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete_incoterm_charge',
    value: function delete_incoterm_charge(charge_id) {
      return this.$http({
        method: 'POST',
        url: '/admin/marketplace/users/delete_incoterm_charge',
        data: { charge_id: charge_id, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_user_product_groups',
    value: function get_user_product_groups(user_id) {
      return this.$http({
        method: 'GET',
        url: '/admin/marketplace/users/get_user_product_groups',
        params: { user_id: user_id }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'update_supplier_newsletter_settings',
    value: function update_supplier_newsletter_settings(user_id, settings) {
      return this.$http.post('/admin/marketplace/users/update_supplier_newsletter_settings', { user_id: user_id, settings: settings, authenticity_token: window.token });
    }
  }, {
    key: 'get_supplier_product_pricings',
    value: function get_supplier_product_pricings(user_id) {
      return this.$http.get('/admin/marketplace/users/get_supplier_product_pricings/' + user_id);
    }
  }, {
    key: 'update_supplier_pricings',
    value: function update_supplier_pricings(user_id) {
      return this.$http.post('/admin/marketplace/users/update_supplier_pricings', { user_id: user_id, authenticity_token: window.token });
    }
  }, {
    key: 'get_buyer_preference_products',
    value: function get_buyer_preference_products(user_id) {
      return this.$http.post('/admin/marketplace/users/get_buyer_preference_products', { user_id: user_id, authenticity_token: window.token });
    }
  }, {
    key: 'get_buyer_preference_price_groups',
    value: function get_buyer_preference_price_groups(user_id) {
      return this.$http.post('/admin/marketplace/users/get_buyer_preference_price_groups', { user_id: user_id, authenticity_token: window.token });
    }
  }, {
    key: 'save_buyer_price',
    value: function save_buyer_price(mode, price) {
      return this.$http.post('/admin/marketplace/users/save_buyer_price', { mode: mode, price: price, authenticity_token: window.token });
    }
  }, {
    key: 'get_buyer_prices',
    value: function get_buyer_prices(user_id) {
      return this.$http.get('/admin/marketplace/users/get_buyer_prices/' + user_id);
    }
  }, {
    key: 'delete_buyer_product_price',
    value: function delete_buyer_product_price(price_id) {
      return this.$http.post('/admin/marketplace/users/delete_buyer_product_price', { price_id: price_id, authenticity_token: window.token });
    }
  }, {
    key: 'delete_buyer_price_group_price',
    value: function delete_buyer_price_group_price(price_id) {
      return this.$http.post('/admin/marketplace/users/delete_buyer_price_group_price', { price_id: price_id, authenticity_token: window.token });
    }
  }, {
    key: 'get_specs_statuses',
    value: function get_specs_statuses() {
      return [{ id: 1, name: 'Yes (auto)' }, { id: 0, name: 'Unknown (auto)' }, { id: 3, name: 'Yes (manual)' }, { id: 2, name: 'Unknown (manual)' }, { id: 4, name: 'No (manual)' }];
    }
  }, {
    key: 'update_specs_statuses',
    value: function update_specs_statuses(user_id, reel_specs_status, sheet_specs_status, rw_cutting_specs_status) {
      return this.$http.post('/admin/marketplace/users/update_specs_statuses', { user_id: user_id, reel_specs_status: reel_specs_status, sheet_specs_status: sheet_specs_status, rw_cutting_specs_status: rw_cutting_specs_status, authenticity_token: window.token });
    }
  }, {
    key: 'load_specs_statuses',
    value: function load_specs_statuses(user_id) {
      return this.$http.get('/admin/marketplace/users/load_specs_statuses/' + user_id);
    }
  }, {
    key: 'update_matching_settings',
    value: function update_matching_settings(user_id, matching_settings) {
      return this.$http.post('/admin/marketplace/users/update_matching_settings', { user_id: user_id, matching_settings: matching_settings, authenticity_token: window.token });
    }
  }, {
    key: 'load_matching_settings',
    value: function load_matching_settings(user_id) {
      return this.$http.get('/admin/marketplace/users/load_matching_settings/' + user_id);
    }
  }, {
    key: 'update_campaign_settings',
    value: function update_campaign_settings(user_id, campaign_settings) {
      return this.$http.post('/admin/marketplace/users/update_campaign_settings', { user_id: user_id, campaign_settings: campaign_settings, authenticity_token: window.token });
    }
  }, {
    key: 'load_campaign_settings',
    value: function load_campaign_settings(user_id) {
      return this.$http.get('/admin/marketplace/users/load_campaign_settings/' + user_id);
    }
  }, {
    key: 'get_user_types',
    value: function get_user_types() {
      return [{ id: 'buyer', title: 'Buyer' }, { id: 'seller', title: 'Seller' }];
    }
  }, {
    key: 'get_overview_data',
    value: function get_overview_data(user_id) {
      return this.$http.get('/admin/marketplace/users/get_overview_data/' + user_id);
    }
  }]);

  return UserService;
}();

exports.default = UserService;


UserService.$inject = ['$http'];

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebEventService = function () {
  function WebEventService($http) {
    _classCallCheck(this, WebEventService);

    this.$http = $http;
  }

  _createClass(WebEventService, [{
    key: 'get',
    value: function get(filter) {
      return this.$http.post('/admin/eworld/events/index', { filter: filter, authenticity_token: window.token });
    }
  }]);

  return WebEventService;
}();

exports.default = WebEventService;


WebEventService.$inject = ['$http'];

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebGlossaryService = function () {
  function WebGlossaryService($http) {
    _classCallCheck(this, WebGlossaryService);

    this.$http = $http;
  }

  _createClass(WebGlossaryService, [{
    key: 'get',
    value: function get(filter) {
      return this.$http.post('/admin/eworld/glossaries/index', { filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'mass_delete',
    value: function mass_delete(glossaries) {
      return this.$http.post('/admin/eworld/glossaries/mass_delete', { glossaries: glossaries, authenticity_token: window.token });
    }
  }]);

  return WebGlossaryService;
}();

exports.default = WebGlossaryService;


WebGlossaryService.$inject = ['$http'];

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebNewService = function () {
  function WebNewService($http) {
    _classCallCheck(this, WebNewService);

    this.$http = $http;
  }

  _createClass(WebNewService, [{
    key: 'get',
    value: function get(filter) {
      return this.$http.post('/admin/eworld/news/index', { filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'get_categories',
    value: function get_categories(filter) {
      return this.$http({
        method: 'POST',
        url: '/admin/eworld/news/get_categories',
        data: { filter: filter, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_sub_categories',
    value: function get_sub_categories(filter) {
      return this.$http({
        method: 'POST',
        url: '/admin/eworld/news/get_sub_categories',
        data: { filter: filter, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return WebNewService;
}();

exports.default = WebNewService;


WebNewService.$inject = ['$http'];

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebSourceService = function () {
  function WebSourceService($http) {
    _classCallCheck(this, WebSourceService);

    this.$http = $http;
  }

  _createClass(WebSourceService, [{
    key: 'get',
    value: function get(filter) {
      return this.$http.post('/admin/eworld/sources/index', { filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'get_categories',
    value: function get_categories(filter) {
      return this.$http({
        method: 'POST',
        url: '/admin/eworld/sources/get_categories',
        data: { filter: filter, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_sub_categories',
    value: function get_sub_categories(filter) {
      return this.$http({
        method: 'POST',
        url: '/admin/eworld/sources/get_sub_categories',
        data: { filter: filter, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'delete_sources',
    value: function delete_sources(sources) {
      return this.$http({
        method: 'POST',
        url: '/admin/eworld/sources/multiple_delete',
        data: { web_sources: sources, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return WebSourceService;
}();

exports.default = WebSourceService;


WebSourceService.$inject = ['$http'];

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WebTopicService = function () {
  function WebTopicService($http) {
    _classCallCheck(this, WebTopicService);

    this.$http = $http;
  }

  _createClass(WebTopicService, [{
    key: 'get',
    value: function get(filter) {
      return this.$http.post('/admin/eworld/topics/index', { filter: filter, authenticity_token: window.token });
    }
  }, {
    key: 'get_categories',
    value: function get_categories(filter) {
      return this.$http({
        method: 'POST',
        url: '/admin/eworld/topics/get_categories',
        data: { filter: filter, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: 'get_sub_categories',
    value: function get_sub_categories(filter) {
      return this.$http({
        method: 'POST',
        url: '/admin/eworld/topics/get_sub_categories',
        data: { filter: filter, authenticity_token: window.token }
      }).then(function (response) {
        return response.data;
      });
    }
  }]);

  return WebTopicService;
}();

exports.default = WebTopicService;


WebTopicService.$inject = ['$http'];

/***/ }),
/* 251 */,
/* 252 */,
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = __webpack_require__(2);

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(15);
__webpack_require__(17);
__webpack_require__(16);

__webpack_require__(9);
__webpack_require__(10);
__webpack_require__(11);
__webpack_require__(12);
__webpack_require__(18);
__webpack_require__(20);
__webpack_require__(19);
__webpack_require__(5);
__webpack_require__(6);
__webpack_require__(21);
__webpack_require__(22);

var appRequires = ['angularFileUpload', 'ui.date', 'ui.select2', 'ui.tinymce'];

_angular2.default.module('app.admin', appRequires);

__webpack_require__(14);
__webpack_require__(13);

_jquery2.default.extend(_jquery2.default.expr[':'], {
  'contains-ci': function containsCi(elem, i, match) {
    return (elem.textContent || elem.innerText || (0, _jquery2.default)(elem).text() || '').toLowerCase().indexOf((match[3] || '').toLowerCase()) >= 0;
  }
});

(0, _jquery2.default)(document).ready(function () {
  var submenu = (0, _jquery2.default)('ul.sf-menu');
  if (submenu.length > 0) {
    submenu.superfish();
  }

  (0, _jquery2.default)('#top-nav li.login a.login_box').click(function (e) {
    e.preventDefault();
    (0, _jquery2.default)(this).parent().toggleClass('selected');
    (0, _jquery2.default)('#top-nav li.login > div').slideToggle('fast');
  });

  var button = (0, _jquery2.default)('a.left-hide-button');
  button.click(function (e) {
    e.preventDefault();
    (0, _jquery2.default)(this).next().toggleClass('expanded');
    (0, _jquery2.default)(this).next().next().toggle();
  });

  var userbar = (0, _jquery2.default)('div#userbar');
  userbar.find('a.quick-add').click(function (e) {
    e.preventDefault();
    var linkClass = (0, _jquery2.default)(this).prop('class');
    var shownSlider = userbar.find('div.slide-down.shown');
    shownSlider.animate({ height: 'toggle' }, 200).removeClass('shown');
    if (!shownSlider.hasClass(linkClass)) {
      var slider = userbar.find('div.' + (0, _jquery2.default)(this).prop('class'));
      slider.animate({ height: 'toggle' }, 200).addClass('shown');
    }
  });
});

/***/ })
],[253]);


// WEBPACK FOOTER //
// js/app.admin.4f6c74e3.js